
define('ui-helper/gtm-helper',['jquery',  'knockout', 'underscore', 'eteration/eteration-ajax','eteration/eteration-i18n', 'moment', 'constants/countryregion-constants', 'ui-helper/storage-helper','ui-helper/cookie-helper'],

    function($, ko, underscore, etrAjax, i18n, moment, countryRegionUtil, storageHelper, cookieHelper) {

        function buildFareType(paxList){
            return {
                'adult':paxList.ADULT ? paxList.ADULT : 0,
                'child': paxList.CHILD ? paxList.CHILD : 0,
                'infant':paxList.INFANT ? paxList.INFANT : 0,
                'disabled':paxList.DISABLED ? paxList.DISABLED : 0,
                'teacher':paxList.TEACHER ? paxList.TEACHER : 0,
                'soldier':paxList.SOLDIER ? paxList.SOLDIER : 0,
                'peacekeepingforce':paxList.PEACEKEEPINGFORCE ? paxList.PEACEKEEPINGFORCE : 0,
                'senior':paxList.SENIOR ? paxList.SENIOR : 0,
                'student':paxList.STUDENT ? paxList.STUDENT : 0
            };
        }

        function getPaxList(paxArray){
            paxArray = underscore.filter(paxArray, function(item){return item.count > 0;});
            return underscore.countBy(paxArray, 'code');
        }

		function isBeyond(originAirport, destinationAirport){
            return !originAirport.domestic && !destinationAirport.domestic;
        }

        function isDomestic(originAirport, destinationAirport){
            return originAirport.domestic && destinationAirport.domestic;
        }

        function getRouteType(isDomestic, selectedFlights, bookingRequest){
            if(isDomestic){
                return 'Domestic';
            }else{
                var isBeyond = underscore.any(selectedFlights, function(flight) { return flight.beyond;});
                if(isBeyond){
                    return "Beyond";

                } else{
                	var originAirport = bookingRequest ? bookingRequest.bookings[0].originAirport : selectedFlights[0].originAirport;
                	return originAirport.domestic ? 'International-Outbound':'International-Inbound';
                }
            }
        }

		function capitalizeWithLower(str){
		    return str.toLowerCase().replace(/(?:^|\s|_)\S/g, function(a) { return a.toUpperCase(); });
		}

		function toFixedNumber(num) {
			return Math.round(num * 1e2) / 1e2;
		}
		
		function timeToHours(millisec){
		  var minutes = Math.floor(millisec / 60000);
		  var hours = Math.round(minutes / 60);
		  var unit = "hours";
		  return hours + ' ' + unit;		 
		}		

		function getCabinTypeOfFlight(flight){
			var bookingClass = underscore.pluck(flight.segments,"bookingClass");
			var cabinTypes = underscore.pluck(underscore.pluck(bookingClass,'cabinType'),'name');
			return normalizeCabinTypes(cabinTypes);
		}
		
		function normalizeCabinTypes(cabinTypes) {
			return underscore.map(cabinTypes, function(cabinType) {
				var result = capitalizeWithLower(cabinType);
				return (result == "Coach") ? "Economy" : result;
			});
		}

		function getMainCabinType(cabinTypes){
			var uniqueCabinTypes = underscore.uniq(cabinTypes);

			var size = underscore.size(uniqueCabinTypes);
			if(size>1){
				return "Mix";
			}
			return uniqueCabinTypes[0];
		}
		
		function parseFlightFareClassArray(flight) {
			if(flight.priceForSelectedFareBasisCode){
                return flight.priceForSelectedFareBasisCode().flightClasses;
            }
			if(flight.bookingPriceTagForSelectedFareBasisCode){
                return flight.bookingPriceTagForSelectedFareBasisCode.flightClasses;
            }
			var brandCard = availabilityGTMUtil.getSelectedBrandCard(flight);
        	if(brandCard) {
        		return brandCard.fareClasses;
        	}
			if(flight.segments) {
    			var fareBase = underscore.pluck(flight.segments,"fareBase");
    			return underscore.pluck(fareBase,'code');
    		}
        	return [];
		}

        function getFlightTime(timeISO,dateTime,timeZoneRawOffset){
            if(timeISO){
                return timeISO.hourMinuteLocal;
            }
            else if(dateTime){
                return   moment.utc(dateTime + (timeZoneRawOffset ? timeZoneRawOffset : 0) ).format("HH:mm");
            }
        }

        function getDepartureFlightTime(segment){

            return getFlightTime(segment.departureDateTimeISO,segment.departureDateTime,segment.departureDateTimeTimeZoneRawOffset);
        }

        function getArrivalFlightTime(segment){
            return getFlightTime(segment.arrivalDateTimeISO,segment.arrivalDateTime,segment.arrivalDateTimeTimeZoneRawOffset);
        }

        function parseFlightData(selectedFlights){
            var flightData= {};

            flightData.operatingAirlines = [];
            flightData.flightNumberArray = [];
            flightData.equipments = [];
            flightData.departureTimeArray = [];
            flightData.arrivalTimeArray = [];
            flightData.flightClasses =[] ;
            flightData.departureDates = [];
            flightData.connectionPoints = [];
            flightData.routeArray = [];
            var spa = [];
            var codeShare = [];
            var index = 0;
            underscore.each(selectedFlights, function(sf){
                var flightNumber =  underscore.pluck(sf.segments,"flightNumber");
                flightData.flightNumberArray = underscore.union(flightData.flightNumberArray,flightNumber);

                var airlineShortName =  underscore.pluck(sf.airlinesBySegment,"shortName");
                flightData.operatingAirlines = flightData.operatingAirlines.concat(airlineShortName);

                var equipment =  underscore.pluck(sf.segments,"equipment");
                flightData.equipments = underscore.union(flightData.equipments,equipment);

                var flightClass = parseFlightFareClassArray(sf);
                
                flightData.flightClasses = flightData.flightClasses.concat(flightClass);



                flightData.departureTimeArray.push(getDepartureFlightTime(sf.segments[0]));
                flightData.arrivalTimeArray.push(getArrivalFlightTime(sf.segments[sf.segments.length -1]));

                flightData.departureDates.push(moment.utc(sf.segments[0].departureDateTime).format('YYYY-MM-DD'));
                
                underscore.each(sf.segments, function(segment){
                	index++;
                    if(segment.spa){
                        spa.push(segment.airline.shortName + "-" + index);
                    }
                    if(segment.codeShare){
                        codeShare.push((segment.otherAirline ? segment.otherAirline.shortName : segment.relevantAirline.shortName) + "-" + index);
                    }
                    if(segment.connected) {
                    	flightData.connectionPoints.push(segment.destinationAirport.code);
                    }
                    
                    flightData.routeArray.push(segment.originAirport.code + '-' + segment.destinationAirport.code);
                });
            });

            flightData.equipments = underscore.pluck(flightData.equipments,'airEquipType');



            flightData.firstFlightDate = moment.utc(selectedFlights[0].segments[0].departureDateTime).format('YYYY-MM-DD');//'20150917',
            flightData.lastFlightDate = moment.utc(underscore.last(selectedFlights).segments[0].departureDateTime).format('YYYY-MM-DD');//'20150917',
            flightData.spa = spa.length ? spa.join("|") : "None";
            flightData.codeShare = codeShare.length ? codeShare.join("|") : "None";

            return flightData;

        }

        function parseFlightDurationData(selectedFlights){
            var segmentDurationsAsHours =[] ;
            var flightDurationsAsHours =[] ;
            var flightDurationsAsMin =[] ;
            var flightDurationsAsHumanized =[] ;

            underscore.each(selectedFlights, function(sf){
                if (sf.flightInfo) sf = sf.flightInfo;
                var a =  moment.duration(sf.totalTravelDurationISO ? sf.totalTravelDurationISO : sf.totalTravelDuration).asMinutes();
                var c= humanizeDuration(sf.totalTravelDurationISO ? sf.totalTravelDurationISO : sf.totalTravelDuration, { spacer: "", delimiter: "", language : i18n.getUserLocale() });
                flightDurationsAsMin = flightDurationsAsMin.concat(a);
                flightDurationsAsHumanized = flightDurationsAsHumanized.concat(c);

                var flightDurations=[];
                underscore.each(underscore.pluck(sf.segments,"flightDuration"), function(duration){
                    flightDurations.push(moment.duration(duration).asHours());
                });

                segmentDurationsAsHours = segmentDurationsAsHours.concat(flightDurations);

                var hours = moment.duration(sf.totalTravelDurationISO ? sf.totalTravelDurationISO : sf.totalTravelDuration).asHours();
                flightDurationsAsHours.push(hours)
            });

            var durationData = {};

            durationData.flightDurationsAsHours = flightDurationsAsHours;
            durationData.flightDurationsAsMin = flightDurationsAsMin;
            durationData.flightDurationsAsHumanized = flightDurationsAsHumanized;
            durationData.segmentDurationsAsHours = segmentDurationsAsHours;


            return durationData;
        }

        function checkFlightRouteType(flights){
            if (underscore.isEmpty(flights)) {
                return false;
            }
            return underscore.every(flights, function(flight) { return flight.domestic });
        }

        function getRouteOnFlight(flight){
            var tempOriginAirports =  underscore.pluck(flight.segments,"originAirport");
            var tempDestinationAirports =  underscore.pluck(flight.segments,"destinationAirport");
            var operatingAirports = underscore.union(tempOriginAirports,tempDestinationAirports);
            return underscore.union(underscore.pluck(operatingAirports,'code'));
        }

        function getTripFullRoute(selectedFlights){
            var routeList = [];

            underscore.each(selectedFlights, function(flight){
                var route = getRouteOnFlight(flight);
                routeList.push(route.join('-'));
            });

            routeList = routeList.join(',');
            return routeList;
        }

		//Ancillary service	
        function getFirstFlightOriginCountry(selectedFlights){
            return selectedFlights[0].segments[0].originAirport.country.code;
        }

        function getFirstFlightOrigin(selectedFlights){
            return selectedFlights[0].segments[0].originAirport.code;
        }

		//Ancillary Service
        function getFirstFlightArrivalCountry(selectedFlights){
            return selectedFlights[0].segments[0].destinationAirport.country.code;
        }

        function getFirstFlightArrival(selectedFlights){

            return selectedFlights[0].segments.slice(-1)[0].destinationAirport.code;
        }


        function getRemainingSeats(selectedFlights){
            var remainingSeats = underscore.pluck(selectedFlights,"remainingSeatsInfoForSelectedFareBasisCode");

            var remainingSeatList=[];
            underscore.each(remainingSeats, function(seats){
                var seatCount = ko.utils.unwrapObservable(seats);
                remainingSeatList.push(seatCount);
            });
            return remainingSeatList;
        }

        function getFlightDurationType(segmentDurationsAsHours){
            var isLongHoul =  underscore.any(segmentDurationsAsHours, function(hour) { return hour>6 });
            return isLongHoul ? 'long haul':'short haul';
        }

        function getTripType(tripType){
            if(tripType == "ROUND_TRIP"){
                return "RoundTrip";
            }else if(tripType == "ONE_WAY"){
                return "OneWay";
            }else if(tripType == "MULTI_CITY"){
                return "MultiCity";
            }
            return "";
        }

        function getMSLevel(cardLevel) {

            if(!cardLevel){
                return 'None-Member';
            }

            if (cardLevel=="CC") {
                return "CLASSIC";
            } else if (cardLevel=="CP") {
                return 'CLASSIC_PLUS';
            } else if (cardLevel=="EC") {
                return 'ELITE';
            } else if (cardLevel=="EP") {
                return 'ELITE_PLUS';
            }

            return 'None-Member';
        }

        function getLoyaltyData(memberProfile){
            var profileInfo={
                cardType : 'None-Member'
            };
            try {
                if(memberProfile && memberProfile.milesProgramInfo){
                    profileInfo.cardType = getMSLevel(memberProfile.milesProgramInfo.cardType);
                }
            }catch (e) {
                console.log(e);
            }

            return profileInfo;
        }

        function getContactDetail(contactPassenger){
            var contactInfo={
                gender : '-',
                title : '-',
                age : '-'
            };
            try {
                if(contactPassenger && contactPassenger.personalInfo){
                    contactInfo.age = moment().diff(contactPassenger.personalInfo.birthday, 'years');
                    contactInfo.gender = contactPassenger.personalInfo.gender.code.charAt(0);
                    contactInfo.title = contactPassenger.personalInfo.title;
                }
            }catch (e) {
                console.log(e);
            }
            return contactInfo;
        }

        function getCreditCardType(cardInfo,cardDetail){

            if(cardInfo.installmentDTO){
                cardDetail.cd_cardCountry = cardInfo.installmentDTO.cardOrigin;
                cardDetail.cd_cardBank = cardInfo.installmentDTO.bankId;
                cardDetail.cd_cardBrand = cardInfo.installmentDTO.cardType;
                cardDetail.cd_cardProgram = cardInfo.installmentDTO.groupId;
            }else{
                cardDetail.cd_cardBrand = cardInfo.cardType;
            }
            return cardDetail;
        }

        function getSubPaymentType(paymentType){
            if(paymentType=="sofort" || paymentType=="ideal"){
                return "Global Collect";
            }
            else if(paymentType=="bkmExpress"){
                return "bkmExpress";
            }
            else if(paymentType=="unionPay"){
                return "IsBank";
            }
            else if(paymentType=="samanBank"){
                return "Shetab Card";
            }
            else if(paymentType=="reservation"){
                return "None";
            }
            return paymentType;
        }

        function getCdListName(bookingRequest,farefamily,pageType,operationType){


            var listname;
            if(bookingRequest&&bookingRequest.deepLink){
                listname = "MetaSearch  – "+farefamily;
                sessionStorageUtil.persistData("cd_listname",listname);
                return listname;
            }
            else if(pageType=="product"){
                listname = "Search Results – "+farefamily;
                sessionStorageUtil.persistData("cd_listname",listname);
                return listname;
            }
            else if(pageType=="payment"&&operationType=='RESERVATION'){
                listname = "Pay&Fly Results – "+farefamily;
                sessionStorageUtil.persistData("cd_listname",listname);
                return listname;
            }

            listname = sessionStorageUtil.getPersistedData("cd_listname");

            if(listname){
                return listname;
            }


            if(farefamily){
                listname = "Search Results – "+farefamily;
                sessionStorageUtil.persistData("cd_listname",listname);
                return listname;
            }
            return "N/A";


        }

        function getPushedParamStatus(){

            var paramInitialStasus={};

            var gtmParamStasus = JSON.parse(storageHelper.getItem({ key: "GTM_PRAM_STATUS", webStorageType: storageHelper.Stores.SESSION_STORAGE }));
            if(!gtmParamStasus){
                gtmParamStasus = paramInitialStasus;
            }
            return gtmParamStasus;
        }

        function setGtmParamStatus(gtmParamStasus){
            storageHelper.setItem({
                key: "GTM_PRAM_STATUS",
                value: JSON.stringify(gtmParamStasus),
                webStorageType: storageHelper.Stores.SESSION_STORAGE
            });
        }

        function removeGtmParamStatus(){
            storageHelper.removeItem({ key: "GTM_PRAM_STATUS", webStorageType: storageHelper.Stores.SESSION_STORAGE });
        }

        function isPageParamPushed(secureAttr){
            var page = underscore.keys(secureAttr)[0];
            return underscore.has(getPushedParamStatus(),page);
        }


        function pushEvent(eventName){
        	 if ((window.location.host.indexOf('localhost') > -1) || (window.location.host.indexOf('127.0.0.1') > -1)) {
                 console.log(eventName)
             }
        	 else{
        		 dataLayer.push({'event': eventName});
        	 }
            
        }

		var getLastPushedDataLayerParam = function(param) {
				for (var j = dataLayer.length - 1; j >= 0; j--) {
					if (typeof dataLayer[j] == "object"
							&& dataLayer[j][param]) {
						return dataLayer[j][param];
					}
				}
				var defaultObj = {};
				return {};
		}
		
		var mergeWithLastDataLayerParam = function(param,obj){
			var previousObj = getLastPushedDataLayerParam(param);
            if(previousObj&&previousObj._meta){
                delete previousObj._meta;
            }
			return $.extend({}, previousObj, obj);
		}
        
        function pushDataToDataLayer(googleTagParams,isGlobal,unwrap,merge){
            if(isGlobal){
                window.google_tag_params = googleTagParams;
            }
            try {
                if ((window.location.host.indexOf('localhost') > -1) || (window.location.host.indexOf('127.0.0.1') > -1)) {
                    console.log(googleTagParams)
                }
                else{
                
                		 if(unwrap){
                             if(googleTagParams && googleTagParams.ecommerce) {
                                 setCustId(googleTagParams.ecommerce);
                             } else {
                                 setCustId(googleTagParams);
                             }
                             dataLayer.push(googleTagParams);
                         }else{
                        	 var obj = mergeWithLastDataLayerParam("google_tag_params",googleTagParams);
                             var pushObj = {'google_tag_params':obj};
                             if(obj._meta&&obj._meta.pushTypeEvent){
                                 pushObj.event = obj._meta.pushTypeEvent;
                             }
                             else if(googleTagParams.pagetype){
                                 pushObj._meta={pushTypeEvent : "page_type"};
                                 pushObj.event = "page_type";
                             }
                             if (pushObj.google_tag_params.pagetype === "profile" && pushObj.event === "page_type") {
                                 pushPassengerInfoView();
                             }
                     		 dataLayer.push(pushObj);
                             if (googleTagParams) {
                                pageInfo = {pagetype: googleTagParams.pagetype, mainPageType: googleTagParams.mainPageType};
                             }
                         }
                	
                   

                    setTimeout(function(){
                        if(googleTagParams.pagetype){
                            (googleTagParams.mainPageType+'-'+googleTagParams.pagetype);
                            if(googleTagParams.mainPageType=="Homepage"){
                                sessionStorageUtil.clearPersistables("initial_flight_search_gtm");
                            }
                        }
                    }, 0);

//                    console.log(googleTagParams)
                }
            } catch (e) {
                console.log(e);
            }
        }

        function gtmSecurePush(gtmParams,secureAttr,isGlobal,unwrap){
            var pushed = isPageParamPushed(secureAttr);
            if(!pushed){
                pushDataToDataLayer(gtmParams,isGlobal,unwrap);
                var defaultParams = getPushedParamStatus();
                gtmParams = underscore.defaults(defaultParams, secureAttr);
                setGtmParamStatus(gtmParams);
            }
        }

        function getInitialSearchData(searchData){
            var persistenceKey="initial_flight_search_gtm";




            var storedData = sessionStorageUtil.getPersistedData(persistenceKey);
            if(!storedData){
                if(!searchData){
                    return;
                }
                var bookingRequest = searchData.bookingRequest;
                var pushSearcData = bookingRequest.bookings[0];
                var data = {};
                data.cd_first_flight_search_date= moment.utc(pushSearcData.originationDateTime).format('YYYY-MM-DD');
                data.cd_searched_cabin_class = capitalizeWithLower(bookingRequest.selectedCabinClass);
                if(pushSearcData.returnDateTime){
                    data.cd_last_flight_search_date =  moment.utc(pushSearcData.returnDateTime).format('YYYY-MM-DD');
                }
                var tripType = getTripTypeSearchData(searchData);
                if(tripType=="MultiCity"||tripType=="OneWay"){
                    data.cd_full_flight_search_dates = underscore.map(underscore.pluck(bookingRequest.bookings,'originationDateTime'),function(d){ return  moment.utc(d).format('YYYY-MM-DD')}).join("|")
                }
                else if(tripType=="RoundTrip"){
                    data.cd_full_flight_search_dates=data.cd_first_flight_search_date+"|"+data.cd_last_flight_search_date;
                }

                sessionStorageUtil.persistData(persistenceKey,data);
                return data;
            }
            else{
                return storedData;
            }

        }


        function getTripTypeSearchData(searchData){
            var isMultiCity = searchData.multiCity;

            if(isMultiCity)
                return "MultiCity";
            else {

                return  searchData.bookingRequest.bookings[0].oneWay ? 'OneWay' : 'RoundTrip';

            }
        }

        function addInitialSearchData(searchData,google_tag_params){
            try{
                var initialSearchData = getInitialSearchData(searchData);
                if(initialSearchData){
                    for(var k in initialSearchData ){
                        google_tag_params[k]  = initialSearchData[k];
                    }
                }
            }
            catch(e){
                console.info(e);
            }
        }

        function clearPassengerCounts() {
            adultCount = 0;
            childCount = 0;
            infantCount = 0;
            veteranCount = 0;
            studentCount = 0;
            seniorCount = 0;
            teacherCount = 0;
            soldierCount = 0;
            disabledCount = 0;
        }

        function setPassengersCount(paxList) {
            totalPassengersCount = 0
            clearPassengerCounts();
            for (var counter = 0; counter < paxList.length; counter++) {
                if (paxList[counter].passengerType === "ADULT") {
                    adultCount++;
                }
                else if (paxList[counter].passengerType === "CHILD") {
                    childCount++;
                }
                else if (paxList[counter].passengerType === "INFANT") {
                    infantCount++;
                }
                else if (paxList[counter].passengerType === "VETERAN") {
                    veteranCount++;
                }
                else if (paxList[counter].passengerType === "STUDENT") {
                    studentCount++;
                }
                else if (paxList[counter].passengerType === "SENIOR") {
                    seniorCount++;
                }
                else if (paxList[counter].passengerType === "TEACHER") {
                    teacherCount++;
                }
                else if (paxList[counter].passengerType === "SOLDIER") {
                    soldierCount++;
                }
                else if (paxList[counter].passengerType === "DISABLED") {
                    disabledCount++;
                }
                totalPassengersCount ++;
            }
        }

        var sortOrders;
        var sortOrder;
        var viewFlights;
        var observer;
        var views = [];
        var pushedViews;
        var skipObserverSetup = false;

        function createFlightSortKey(flight) {
            return flight.originAirport.city.code + "-" + flight.destinationAirport.city.code;
        }

        function getFlightSortOrder(flight) {
            var flightSortKey = createFlightSortKey(flight);
            return sortOrders && sortOrders[flightSortKey] ? sortOrders[flightSortKey] : '';
        }

        function getFlightListSortOrders(flightList) {
            if (!sortOrders) {
                sortOrders = JSON.parse(storageHelper.getItem({ key: "flightSortOrders", webStorageType: storageHelper.Stores.SESSION_STORAGE }));
            }

            if (!sortOrders) {
                return;
            }

            return underscore.uniq(underscore.map(flightList, function (flight) {
                return getFlightSortOrder(flight);
            }).filter(function (sortOrder) {
                return sortOrder;
            })).join("|");
        }

        function setViewItemListGroup(flightList, currSortOrder) {
            try {
                if (currSortOrder !== sortOrder) {
                    pushedViews = {};
                }
                sortOrder = currSortOrder;
                mapViewItemListGroup(flightList);
                if (observer) {
                    setupViewItemListObserver();
                }
            } catch (e) {
                pushServiceError(e);
            }
        }

        function mapViewItemListGroup(flightList) {
            sortOrders = sortOrders || JSON.parse(storageHelper.getItem({ key: "flightSortOrders", webStorageType: storageHelper.Stores.SESSION_STORAGE })) || {};
            viewFlights = viewFlights || {};
            flightList.forEach(function (flight) {
                var flightSortKey = createFlightSortKey(flight);
                viewFlights["flightItem_" + sortOrder + "_" + flightSortKey + "_" + flight.index] = flight;
                sortOrders[flightSortKey] = sortOrder;
            });
            storageHelper.setItem({
                key: "flightSortOrders",
                value: JSON.stringify(sortOrders),
                webStorageType: storageHelper.Stores.SESSION_STORAGE
            });
        }

        var viewItemListProcess;

        function setupViewItemListObserver() {
            try {
                if (observer) {
                    observer.disconnect();
                }
                var targets = document.querySelectorAll('div[id^="flightItem_"]');
                if (targets.length === 0) {
                    return;
                }
                var options = {
                    threshold: 0.5
                }
                viewItemListProcess = debounce(processViewItemList, 1000);
                observer = new IntersectionObserver(observerCallback, options);
                targets.forEach(function (target) {
                    observer.observe(target)
                });
            } catch (e) {
                pushServiceError(e);
            }
        }

        function debounce(func, timeout) {
            var timer;
            return function () {
                var args = arguments;

                clearTimeout(timer);
                timer = setTimeout(function () {
                    func.apply(this, args)
                }, timeout);
            }
        }

        function processViewItemList() {
            if (views.length === 0) {
                return;
            }

            var items = [];

            var currentFlightKeys = views.filter(function (view) {
                return !pushedViews[view];
            });

            currentFlightKeys.forEach(function (view) {
                pushedViews[view] = true;
                items.push(createFlightPushData(viewFlights[view]));
            });

            var flightObjects = currentFlightKeys.map(function (key) {
                return viewFlights[key];
            });

            if (items.length === 0) {
                return;
            }

            var pushItems = [];
            for (var i = 0; i < items.length; i++) {
                pushItems.push(items[i]);
                if (pushItems.length % 7 === 0 || i + 1 === items.length) {
                    var ecommerceData = createEventData(viewFlights[currentFlightKeys[i]], pushItems[0], pushItems);
                    ecommerceData['cd_sort_type'] = getFlightListSortOrders(flightObjects);
                    ecommerceData['item_list_name'] = 'Availability';
                    ecommerceData['items'] = pushItems;
                    pushEcommerceData({event: 'view_item_list', ecommerce: ecommerceData});
                    pushItems = [];
                }
            }
            views = [];
        }

        function observerCallback(entries, observer) {
            try {
                entries.filter(function (entry) {
                    return entry.isIntersecting;
                }).forEach(function (entry) {
                    observer.unobserve(entry.target);
                    var targetInfo = entry.target.id;
                    views.push(targetInfo);
                    viewItemListProcess && viewItemListProcess();
                })
            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushSearcData(searchData,flightList){

            try {
                if (!skipObserverSetup) {
                    setupViewItemListObserver();
                }
                clearTicketCache()
                changeListingType("list")
                var bookingRequest = searchData.bookingRequest;

                if (bookingRequest && bookingRequest.selectedCurrencyCode) {
                    fetchCurrencyConversionRates(bookingRequest.selectedCurrencyCode, null);
                }

                isBusiness = bookingRequest.selectedCabinClass === "BUSINESS"

                var pushSearcData = bookingRequest.bookings[0];
                var domestic = searchData.domestic;
                var lowestData = 0;
                var destIds = [];
                var stopOverType = 'none';

                var tripType=getTripTypeSearchData(searchData);


                var routeType = "";
                if(isBeyond(pushSearcData.originAirport, pushSearcData.destinationAirport)){
                    routeType = 'beyond';
                }else if(isDomestic(pushSearcData.originAirport, pushSearcData.destinationAirport)){
                    routeType ='domestic';
                }else{
                    routeType = pushSearcData.originAirport.domestic ? 'international_outbound':'international_inbound'
                }


                if(!underscore.isUndefined(flightList) || !underscore.isNull(flightList)){
                    if(flightList){
                        var flights = underscore.reduce(flightList, function(memo, panel){ return memo.concat(panel.processedFlightList()); }, []);
                        for (var i = 0; i < flights.length; i++){
                            if(flights[i].lowestPriceOfTheDay === true){
                                lowestData = flights[i].availabilityData.startingPrice.amount;
                            }
                            destIds.push(flights[i].destinationAirport.city.code);
                        }
                        if(underscore.isUndefined(lowestData) || underscore.isNull(lowestData)){
                            lowestData = flights[0].availabilityData.startingPrice.amount;
                        }
                    }
                }

                setPassengersCount(searchData.bookingRequest.bookings[0].paxList);



                var originAirportCode = availabilityGTMUtil.getPortCode(pushSearcData.originAirport);
                var destinationAirportCode = availabilityGTMUtil.getPortCode(pushSearcData.destinationAirport);
                var google_tag_params = {
                    pagetype: 'search', //sayfa tipi
                    mainPageType: 'booking',
                    origindestination: originAirportCode +'-'+destinationAirportCode, //Route O&Ds
                    cd_TripType: tripType, //OneWay, RoundTrip, MultiCity
                    prodid: originAirportCode+'-'+destinationAirportCode,
                    pname: originAirportCode+'-'+destinationAirportCode,
                    cd_fareType : buildFareType(getPaxList(pushSearcData.paxList)),
                    cd_RouteType : routeType, //Domestic, International-Inbound, International-Outbound, Beyond
                    cd_flightOrigin : originAirportCode,
                    cd_flightOriginCity : pushSearcData.originAirport.city.code,
                    cd_flightOriginCountry : pushSearcData.originAirport.country.code,
                    cd_flightDestination : destinationAirportCode,
                    cd_flightDestinationCity : pushSearcData.destinationAirport.city.code,
                    cd_flightDestinationCountry : pushSearcData.destinationAirport.country.code,
                    cd_firstflightDate : moment.utc(pushSearcData.originationDateTime).format('YYYY-MM-DD'),//'20150917',
                    cd_MembershipTier : 'None-Member', //None-Member, M&S Classic, M&S ClassicPlus, M&S Elite, M&S ElitePlus
                    cd_selected_currency_code: searchData.bookingRequest.selectedCurrencyCode,
                    cd_childCount : childCount,
                    cd_infCount : infantCount,
                    cd_adultCount : adultCount,
                    cd_currency: searchData.bookingRequest.selectedCurrencyCode,
                    cd_destinationIds : destIds,
                    cd_price : lowestData

                    };

                for(var i = 0; i < bookingRequest.bookings.length; i++){
                    if(bookingRequest.bookings[i].selectedStopoverPort){
                        storageHelper.setItem({
                            key: "stopover_param",
                            value: JSON.stringify(i+"_"+bookingRequest.bookings[i].selectedStopoverNight),
                            webStorageType: storageHelper.Stores.SESSION_STORAGE
                        });
                        stopOverType = 'stopover_' + (i == 0 ? 'departure' : 'return') + '_'+bookingRequest.bookings[i].selectedStopoverNight;
                    }
                }

                if(stopOverType !== 'none') {
                    var fullRoute = bookingRequest.bookings[0].originAirport.code + '-'
                      + bookingRequest.bookings[0].destinationAirport.code
                      + ","
                      + bookingRequest.bookings[1].originAirport.code + '-'
                      + bookingRequest.bookings[1].destinationAirport.code

                    var isSymetric = routeSymetric(fullRoute);
                }

                if(searchData.multicity){
                    storageHelper.setItem({
                        key: "multiCheck",
                        value: JSON.stringify("true"),
                        webStorageType: storageHelper.Stores.SESSION_STORAGE
                    });
                }


                var bookerSearchType = searchData.bookingRequest.bookerSearchType
                    ? searchData.bookingRequest.bookerSearchType
                    : tripType;

                addInitialSearchData(searchData,google_tag_params);

                removeGtmParamStatus();
                var secureAttr = {'search' : true};
                pushDataToDataLayer(google_tag_params,true);
				
				var obj = { _meta : {pushTypeEvent : "booking-search"}};
                pushDataToDataLayer(obj,true);
				
				//securePush(google_tag_params,secureAttr,true,false)
                prepareEcommerceSearchData(searchData.bookingRequest.bookings, flightList, tripType,bookerSearchType, false);

                var item = {
                    item_id : originAirportCode +'-'+destinationAirportCode,
                    item_list_id: bookerSearchType.toLowerCase() ,
                    item_name : originAirportCode +'-'+destinationAirportCode,
                    affiliation : getAffiliationDevice(),
                    item_category : routeType,
                    item_category3: isSymetric ? isSymetric : tripType,
                    item_category4: bookingRequest.selectedCabinClass === "BUSINESS" ? 'business' : 'economy',
                    cd_stopover_type: stopOverType,
                    cd_item_flight_destination: destinationAirportCode,
                    cd_item_flight_destination_city: pushSearcData.destinationAirport.city.code,
                    cd_item_flight_destination_country: pushSearcData.destinationAirport.country.code,
                    cd_item_flight_origin: originAirportCode,
                    cd_item_flight_origin_city: pushSearcData.originAirport.city.code,
                    cd_item_flight_origin_country: pushSearcData.originAirport.country.code,
                    cm_item_passenger_number: totalPassengersCount,
                    cd_item_passenger_number: String(totalPassengersCount),
                    cm_passenger_count: totalPassengersCount,
                    cd_passenger_count: String(totalPassengersCount),
                    cm_item_passenger_adult: adultCount ,
                    cm_item_passenger_infant: infantCount,
                    cm_item_passenger_student: studentCount,
                    cm_item_passenger_child: childCount,
                    cm_item_passenger_veteran: veteranCount,
                    cm_item_passenger_disabled: disabledCount,
                    cm_item_passenger_soldier: soldierCount,
                    cm_item_passenger_senior: seniorCount,
                    cm_item_passenger_teacher: teacherCount,
                    cd_item_passenger_adult: adultCount.toString() ,
                    cd_item_passenger_infant: infantCount.toString(),
                    cd_item_passenger_student: studentCount.toString(),
                    cd_item_passenger_child: childCount.toString(),
                    cd_item_passenger_veteran: veteranCount.toString(),
                    cd_item_passenger_disabled: disabledCount.toString(),
                    cd_item_passenger_soldier: soldierCount.toString(),
                    cd_item_passenger_senior: seniorCount.toString(),
                    cd_item_passenger_teacher: teacherCount.toString(),
                    cd_item_search_date:  flightSearchData.searchDate,
                    cd_item_flight_date: flightSearchData.flightDate,
                    cd_award_ticket: "no",
                }

                var pushData = {
                    event : "homepage_flight_search",
                    item: item
                }
                pushDataToDataLayer(pushData, false, true)
            } catch (e) {
                console.log(e);
            }
        }

        function getAffiliationDevice() {
            return /iPad/.test(navigator.userAgent) ? "MobileWeb" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "MobileWeb" : "Web"
        }

        function pushMultiCitySearcData(multicitySearchData, baseFareForMulticityData){

            try {

                if(multicitySearchData&&multicitySearchData.multicity&&multicitySearchData.bookingRequest&&multicitySearchData.bookingRequest.bookings&&multicitySearchData.bookingRequest.bookings.length>1){
                    multicitySearchData.multiCity=true;
                }
                else{
                    multicitySearchData.multiCity=false;
                }
                skipObserverSetup = true;
                pushSearcData(multicitySearchData);

                baseFareForMulticity = {
                    currency: baseFareForMulticityData.currency,
                    basePerFlight: baseFareForMulticityData.amount / multicitySearchData.bookingRequest.bookings.length
                };
            } catch (e) {
                console.log(e);
            }
        }

        var flightSearchData = null
        var isBusiness = false
        var adultCount = 0
        var infantCount = 0
        var studentCount = 0
        var childCount = 0
        var veteranCount = 0
        var seniorCount = 0
        var teacherCount = 0
        var soldierCount = 0
        var disabledCount = 0
        var totalPassengersCount = 0
        var gaTargetCurrency = 'EUR';
        var winfluencedTargetCurrency = 'EUR';
        var firstFlightSelected = false;
        var viewCartSent = false;
        var beginCheckoutSent = false;
        var baseFareForMulticity;

        var changeFlightCache = {}

        function createCartFlightKey(flight) {
            return flight.originAirport.city.code + "-" + flight.destinationAirport.city.code + "-" + flight.segments[0].flightNumber
        }

        function prepareEcommerceSearchData(bookings, flightList, tripType, bookerSearchType, forceCacheClear) {
            try {
                flightSearchData = {
                    tripType: tripType,
                    flightRoute: createFlightRoute(bookings),
                    originPort: bookings[0].originAirport.code,
                    destinationPort: bookings[0].destinationAirport.code,
                    originCity: bookings[0].originAirport.city.code,
                    destinationCity: bookings[bookings.length - 1].destinationAirport.city.code,
                    fullCityRoute: createFlightCityRoute(bookings),
                    bookerSearchType: bookerSearchType ? bookerSearchType : tripType,
                }

                var bookingsDate = getBookingsDate(bookings);
                underscore.extend(flightSearchData, bookingsDate);

                if (flightList && flightList.length > 0) {
                    flightSearchData["selectedSortOptions"] = flightList[0].sortData ? flightList[0].sortData.selectedSortKey() : ""
                }

                changeFlightCache = {}
                storageHelper.setItem({
                    key: "flightSearchData",
                    value: JSON.stringify(flightSearchData),
                    webStorageType: storageHelper.Stores.SESSION_STORAGE
                });
                if (!baseFareForMulticity || forceCacheClear) {
                    clearCartFlightCache();
                }
            } catch (e) {
                console.log(e)
            }
        }

        function getBookingsDate(bookings) {
            var bookingsDate = {
                searchDate: getDateInISOFormat(Date.now())
            };
            if (bookings.length === 1) {
                bookingsDate['searchDateStart'] = getDateInISOFormat(bookings[0].originationDateTime);
                bookingsDate['searchDateEnd'] = getDateInISOFormat(bookings[bookings.length - 1].returnDateTime);
                bookingsDate['flightDate'] = bookingsDate['searchDateEnd'] !== "" ? bookingsDate['searchDateStart'] + "|" + bookingsDate['searchDateEnd'] : bookingsDate['searchDateStart'];
            } else {
                var dates = underscore
                    .filter(bookings, function(booking) { return booking.originationDateTime })
                    .map(function(booking) {return getDateInISOFormat(booking.originationDateTime)});
                bookingsDate['searchDateStart'] = dates[0];
                bookingsDate['searchDateEnd'] = dates[dates.length - 1];
                bookingsDate['flightDate'] = dates.join('|');
            }
            return bookingsDate;
        }

        function pushEcommerceData(pushData) {
            pushDataToDataLayer({ecommerce: null}, false, true)
            pushDataToDataLayer(pushData, false, true)
        }

        function getRouteTypeByFlight(flight) {
            var routeType = "";
            if (isBeyond(flight.originAirport, flight.destinationAirport)) {
                routeType = 'beyond';
            } else if (flight.domestic || flight.domesticFlight) {
                routeType = 'domestic';
            } else {
                routeType = flight.originAirport.domestic ? 'international_outbound' : 'international_inbound'
            }
            return routeType;
        }

        function getPlaneTypes(flight) {
            var planeTypes = {plane: "", eType: ""}
            var equipments = flight.segments.map(function(it) {return  it.equipment})
            if (equipments.length === 1 && equipments[0]) {
                planeTypes.plane = equipments[0].airEquipModel
                planeTypes.eType = equipments[0].airEquipType
            }
            else if (equipments.length > 0) {
                equipments = equipments.filter(function(it) {return it})
                planeTypes.plane = equipments.map(function(it) {return it.airEquipModel}).join(",")
                planeTypes.eType = equipments.map(function(it) {return it.airEquipType}).join(",")
            }
            return planeTypes
        }

        function getAirlineCodeByPredicate(flight, predicate) {
            for (var i = 0; i < flight.segments.length; i++) {
                if (predicate(flight.segments[i])) {
                    if (flight.segments[i].anadoluJet) {
                        return "AJ"
                    }
                    return flight.segments[i].carrierAirline.shortName
                }
            }
            return "none"
        }

        function getCodeShare(flight) {
            return getAirlineCodeByPredicate(flight, function(segment) { return segment.codeShare})
        }

        function getSpa(flight) {
            return getAirlineCodeByPredicate(flight, function(segment) { return segment.spa})
        }

        function getPromotion(flight) {
            var promotions = null;
            if(flight.lowestPriceOfTheDay) {
                promotions = ["lowest_price"];
            }

            if (flight.lastSeatCountForEconomy) {
                if (!promotions) {
                    promotions = [];
                }
                promotions.push("eco_last_"+flight.lastSeatCountForEconomy+"_seat");
            }

            if (flight.lastSeatCountForBusiness) {
                if (!promotions) {
                    promotions = [];
                }
                promotions.push("business_last_"+flight.lastSeatCountForBusiness+"_seat");
            }
            return promotions ? promotions.join("|") : "none";
        }

        function getPromotionAfterSelection(flight, selection) {
            var s = selection ? selection.toLowerCase() : ""
            if (s === "economy") {
                if(flight.lowestPriceOfTheDay) {
                    return "lowest_price"
                }
                else if (flight.lastSeatCountForEconomy) {
                    return "eco_last_"+flight.lastSeatCountForEconomy+"_seat"
                }
            } else if (s === "business") {
                if (flight.lastSeatCountForBusiness) {
                    return "business_last_"+flight.lastSeatCountForBusiness+"_seat"
                }
            }
            return "none"
        }
        function getEverymundoTripType(tripType) {
            switch (tripType) {
                case ("OneWay"):
                    return "OW";
                case ("RoundTrip"):
                    return "RT";
                case ("MultiCity"):
                    return "MS";
                default:
                    return tripType;
            }
        }
        /**
         * It creates Everymundo data [Everymundo]
         * @param reservationData
         * @returns {{languageIsoCode: string, returnDate: *, siteEdition: string, journeyType: (string|*), emcid: string, passengerDetails: *[], currency: (string|*), id: string, departureDate: *, flightType: (string), flights: void, device: string}}
         */
        function createEverymundoData(reservationData) {
            try {
                var emcid = cookieHelper.getCookie("emcid");
                if (!emcid) return;
                var mFlightSearchData = JSON.parse(storageHelper.getItem({
                    key: "flightSearchData",
                    webStorageType: storageHelper.Stores.SESSION_STORAGE
                }));
                var firstFlight = reservationData.allFlights[0];
                var lastFlight = reservationData.allFlights[reservationData.allFlights.length - 1];
                var currency = reservationData.totalCharge.currency;
                var locale = getLocaleOptions();
                var tripType = getTripType(reservationData.tripType);
                var data = {
                    id: reservationData.pnr + "-" + mFlightSearchData.searchDateStart.replaceAll("-", ""),
                    currencyCode: currency,
                    departureDate: moment(firstFlight.segments[0].departureDateTime).zone(firstFlight.segments[0].departureDateTimeTimeZone).format('YYYY-MM-DD'),
                    returnDate: tripType !== 'OneWay' ? moment(lastFlight.segments[0].departureDateTime).zone(lastFlight.segments[0].departureDateTimeTimeZone).format('YYYY-MM-DD') : '',
                    journeyType: getEverymundoTripType(tripType),
                    languageIsoCode: locale.languageIsoCode,
                    siteEdition: locale.siteEdition,
                    device: getAffiliationDevice() === 'MobileWeb' ? 'MOBILE' : 'DESKTOP',
                    emcid: emcid,
                    passengerDetails: createEverymundoPassengerData(reservationData.paxTypeAndCount),
                    flights: createEveryMundoFlightData(reservationData),
                }
                pushEcommerceData({event: 'everymundo_purchase', everymundoData: data});
            } catch (e) {

            }
        }

        function getLocaleOptions() {
            if(!cookieHelper.getCookie("Locale")) {
                return {
                    languageIsoCode: '',
                    siteEdition: ''
                }
            }
            var localeData = cookieHelper.getCookie("Locale").split('-');
            return {
                languageIsoCode: localeData[0],
                siteEdition: localeData[0] + (localeData[1] ? ('-' + localeData[1].toUpperCase()): ''),
            }
        }

        /**
         * It creates passengerDetails object for one flight [Everymundo]
         * @param paxTypeAndCount
         * @returns {*[]}
         */
        function createEverymundoPassengerData(paxTypeAndCount) {
            var passengerList = [];
            if(paxTypeAndCount) {
                var passengerData = { adult: 0, child: 0, infant: 0, youngAdult: 0, senior: 0 };
                var paxKeys = Object.keys(paxTypeAndCount);
                paxKeys.forEach(function (key) {
                    if (key === 'ADULT') {
                        passengerData.adult += paxTypeAndCount[key];
                    } else if (key === 'INFANT') {
                        passengerData.infant += paxTypeAndCount[key];
                    } else if (key === 'CHILD') {
                        passengerData.child += paxTypeAndCount[key];
                    } else if (key === 'YOUNGADULT' || key === 'STUDENT') {
                        passengerData.youngAdult += paxTypeAndCount[key];
                    } else {
                        passengerData.senior += paxTypeAndCount[key];
                    }
                });

                var passengerDataKeys = Object.keys(passengerData);
                passengerDataKeys.forEach(function (key) {
                    if (passengerData[key] !== 0) {
                        passengerList.push({
                            category: key + 'Count',
                            count: passengerData[key],
                        });
                    }
                });
            }
            return passengerList
        }
        /**
         * It creates leg object for one flight [Everymundo]
         * @param flight
         * @returns {*[]}
         */
        function createEverymundoLegData(flight) {
            var legs = [];
            for (var i = 0; i < flight.segments.length; i++) {
                var segment = flight.segments[i];
                var legData = {
                    flightNumber: segment.flightNumber,
                    route: segment.originAirport.code + '>' + segment.destinationAirport.code,
                    departureIataCode: segment.originAirport.code,
                    arrivalIataCode: segment.destinationAirport.code,
                    isCodeshare: segment.codeShare
                }
                legs.push(legData)
            }
            return legs;
        }

        /**
         * It calculates total price of one flight [Everymundo]
         * @param priceInfo
         * @param flightCount
         * @returns {number}
         */
        function createEverymundoTotalPriceData(priceInfo, flightCount) {
            if (priceInfo) {
                return priceInfo["grandTotal"] / flightCount
            }
            return 0;
        }

        /**
         * It calculates tax price for one flight [Everymundo]
         * @param priceInfo
         * @param flightCount
         * @returns {number}
         */
        function createEverymundoTotalTaxData(priceInfo, flightCount) {
            if (priceInfo) {
                return priceInfo["grandTaxTotal"] / flightCount
            }
            return 0;
        }

        /**
         * It creates flights data for Everymundo [Everymundo]
         * @param reservationData
         * @returns {*[]}
         */
        function createEveryMundoFlightData(reservationData) {
            var flights = [];
            var flightCount = reservationData.allFlights.length
            for (var i = 0; i < flightCount; i++) {
                var flight = reservationData.allFlights[i];
                var cacheFlight = getFromCartFlightCache(createCartFlightKey(reservationData.allFlights[i]));
                var flightData = {
                    boundType: flight.tripType === 'MULTI_CITY' ? 'OUTBOUND' : ( i == 0 ? 'OUTBOUND' : 'INBOUND'),
                    totalPrice: createEverymundoTotalPriceData(reservationData.priceInfo, flightCount),
                    taxAmount: createEverymundoTotalTaxData(reservationData.priceInfo, flightCount),
                    fareClassInput: cacheFlight['item_category2'],
                    fareClass: flight.cabinClass,
                    legs: createEverymundoLegData(flight)
                }
                flights.push(flightData)
            }
            return flights;
        }

        function getEventScopeItemBrand(pushDataArray) {
            var brandList = (underscore.pluck(pushDataArray, "item_brand")).join('|');
            return (underscore.uniq(brandList.split("|"))).join("|");
        }

        function getItemBrand(airlinesBySegment) {
            return (underscore.pluck(airlinesBySegment, "shortName")).join('|');
        }

        function createFlightPushData(flight,isPurchase) {
            var mFlightSearchData = JSON.parse(storageHelper.getItem({ key: "flightSearchData", webStorageType: storageHelper.Stores.SESSION_STORAGE }))
            var multiCheck = JSON.parse(storageHelper.getItem({ key: "multiCheck", webStorageType: storageHelper.Stores.SESSION_STORAGE }))
            var item_category3Value = mFlightSearchData && mFlightSearchData.bookerSearchType ?  mFlightSearchData.bookerSearchType:  "";
            var itemCategory3Field = getCategory3Data(item_category3Value, multiCheck, flight ? flight.tripType : null, mFlightSearchData);

            var data = {
                item_list_id : getItemListId( multiCheck, mFlightSearchData),
                item_id: mFlightSearchData ? mFlightSearchData.originPort + "-" + mFlightSearchData.destinationPort : "",
                item_name: flight.originAirport.code + "-" + flight.destinationAirport.code,
                affiliation: getAffiliationDevice(),
                coupon: "",
                discount: 0,
                index: flight.index,
                item_brand: getItemBrand(flight.airlinesBySegment),
                item_category: getRouteTypeByFlight(flight),
                item_category2: "",
                item_category3: itemCategory3Field,
                item_category4: isBusiness ? "business" : "",
                item_list_name: "Availability",
                price: 0,
                quantity: totalPassengersCount,
                cd_item_fare_class: "",
                cd_item_codeshare: getCodeShare(flight) || "none",
                cd_item_spa: getSpa(flight) || "none",
                cm_item_flight_duration: flight.totalTravelDurationISO / 60000,
                cd_item_flight_origin_city: flight.originAirport.city.code,
                cd_item_search_date: mFlightSearchData ? mFlightSearchData.searchDate : "",
                cd_item_flight_date: mFlightSearchData ? mFlightSearchData.flightDate : "",
                cd_item_full_flight_route: mFlightSearchData ? mFlightSearchData.flightRoute : "",
                cd_item_promotion: getPromotion(flight),
                cm_item_full_price: 0,
                cm_item_leg_count: 1,
                cd_item_type: 'ticket',
                cd_stopover_type: flight ? stopOverItemScope(flight, isPurchase) : ""
            }
            var planeTypes = getPlaneTypes(flight)
            data.item_variant = planeTypes.plane

            if (flight.segments) {
                data.item_category5 = isConnected(flight.segments.length)
            }

            data["cd_leg_order"] = mFlightSearchData ? getLegOrder(mFlightSearchData, flight) : '';

            return data
        }

        function isConnected(flightLength){
            return flightLength > 1 ? "Connected" : "Direct";
        }

        function getLegOrder(mFlightSearchData, flight) {
            var fullCityRoute = mFlightSearchData.fullCityRoute
            if (fullCityRoute.length === 0) return ""
            var searchRoute = flight.originAirport.city.code + "-" + flight.destinationAirport.city.code
            var foundIndex = fullCityRoute.indexOf(searchRoute)
            if (foundIndex !== -1) {
                return String(foundIndex + 1)
            }
            return ""
        }

        function getDateInISOFormat(timestamp) {
            if (!timestamp) return "";
            return moment(timestamp).format("YYYY-MM-DD");
        }

        function createFlightRoute(bookings) {
            if (bookings.length === 1) {
                var originCode = bookings[0].originAirport.code
                var destinationCode = bookings[0].destinationAirport.code
                if (bookings[0].tripType && bookings[0].tripType === 'ONE_WAY') {
                    return originCode+"-"+destinationCode
                } else {
                    return originCode+"-"+destinationCode+","+destinationCode+"-"+originCode
                }
            }else if (bookings.length !== 0) {
                var routes = []
                for (var i = 0; i < bookings.length; i++) {
                    routes.push(bookings[i].originAirport.code+"-"+bookings[i].destinationAirport.code)
                }
                return routes.join(",")
            }
            return ""
        }

        function createFlightCityRoute(bookings) {
            if (bookings.length === 1) {
                var originCode = bookings[0].originAirport.city.code
                var destinationCode = bookings[0].destinationAirport.city.code
                if (bookings[0].oneWay) {
                    return [originCode+"-"+destinationCode]
                } else {
                    return [originCode+"-"+destinationCode,destinationCode+"-"+originCode]
                }
            }else if (bookings.length !== 0) {
                var routes = []
                for (var i = 0; i < bookings.length; i++) {
                    routes.push(bookings[i].originAirport.city.code+"-"+bookings[i].destinationAirport.city.code)
                }
                return routes
            }
            return []
        }

        function createAllSegmentFlightRoute(bookings) {
            if (bookings.length === 1) {
                return createSegmentsRoute(bookings[0]).join(",")
            }else if (bookings.length !== 0) {
                var routes = []
                for (var i = 0; i < bookings.length; i++) {
                    routes = routes.concat(createSegmentsRoute(bookings[i]))
                }
                return routes.join(",")
            }
            return ""
        }

        function createSegmentsRoute(booking){
            var routes = []
            for (var i = 0; i < booking.segments.length; i++){
                routes.push(booking.segments[i].originAirport.code + "-" + booking.segments[i].destinationAirport.code )
            }
            return routes
        }

        function changeListingType(type) {
            try {
                var listingValue = storageHelper.getItem({ key: "listing", webStorageType: storageHelper.Stores.SESSION_STORAGE })
                if (!listingValue || listingValue === "list") {
                    storageHelper.setItem({
                        key: "listing",
                        value: type,
                        webStorageType: storageHelper.Stores.SESSION_STORAGE
                    });
                    pushDataToDataLayer({
                        event: "listing_change",
                        listingType: type
                    }, false, true)
                }
            }catch (e) {
                console.log(e)
            }
        }

        function pushSelectItemData(flight, selectType) {
            try {
                var preparedFlightData = createFlightPushData(flight)
                if (!preparedFlightData) return
                preparedFlightData["item_category4"] = selectType && selectType !== "mobile" ? selectType.toLowerCase() : "";
                preparedFlightData["cd_item_promotion"] = selectType && selectType !== "mobile" ? getPromotionAfterSelection(flight, selectType) : getPromotion(flight);

                var ecommerceData = createEventData(flight, preparedFlightData)
                ecommerceData['item_list_name'] = "Availability"
                ecommerceData['items'] = [preparedFlightData]

                var data = {
                    event: "select_item",
                    ecommerce: ecommerceData
                }

                pushEcommerceData(data)
            } catch (e) {
                console.log(e)
            }
        }

        function getViewTypeByBrandCode(brandCode) {
            switch (brandCode){
                case ("EF"): return "EcoFly";
                case ("XF"): return "ExtraFly";
                case ("PF"): return "PrimeFly";
                case ("CL"): return "EcoFly";
                case ("LG"): return "ExtraFly";
                case ("FL"): return "PrimeFly";
                case ("BF"): return "BusinessFly";
                case ("BL"): return "BusinessPrime";
                case ("PS"): return "Promo";
                case ("RS"): return "Semi-Flexible";
                case ("FX"): return "Flexible";
                case ("BS"): return "Promo";
                case ("BX"): return "Semi-Flexible";
                case ("BB"): return "Flexible";
                case ("JR"): return "EcoJet";
                case ("JS"): return "ExtraJet";
                case ("JF"): return "ComfortJet";
                case ("BU"): return "Business";
                case ("GN"): return "FlexFly";
                default: return brandCode;
            }
        }

        function pushViewItemData(flight, brandTypeList, selectType) {
            try {
                if(selectType === "detail") return
                var pushFlightData = createFlightPushData(flight)
                pushFlightData["item_category4"] = selectType ? selectType.toLowerCase() : ""

                var subCategories = underscore.filter(brandTypeList(), function(brandType) {
                    return brandType[0].toLowerCase() === selectType || selectType === "mobile";
                });

                subCategories = underscore.map(subCategories, function(brandType) {
                    var types = [];
                    var sType = brandType[0];
                    var promotion = getPromotionAfterSelection(flight, sType);

                    if (!brandType[1] || !brandType[1].subcategories) return null;
                    for (var i = 0; i < brandType[1].subcategories.length; i++) {
                        if (!brandType[1].subcategories[i].fareClasses) continue;
                        types.push({
                            'brandClass': sType,
                            'brandCode':  brandType[1].subcategories[i].brandCode,
                            'promotion': promotion,
                            'amount':   brandType[1].subcategories[i].price.amount,
                            'fareClass': brandType[1].subcategories[i].fareClasses.join("-"),
                            'currency': brandType[1].subcategories[i].price.currency
                        });
                    }

                    return types;
                });

                subCategories = underscore.filter(subCategories, function(subCat) {return subCat !== null});
                subCategories = underscore.flatten(subCategories, true);

                var items = []
                var maxValue = 0
                for (var i = 0; i < subCategories.length; i++) {
                    var cpy = underscore.clone(pushFlightData)
                    cpy["item_category2"] = getViewTypeByBrandCode(subCategories[i].brandCode)
                    cpy["item_category4"] = subCategories[i].brandClass.toLowerCase();
                    cpy["cd_item_fare_class"] = subCategories[i].fareClass;
                    cpy["cd_item_promotion"] = subCategories[i].promotion;
                    cpy["price"] = gaConvertPrice(subCategories[i].currency, subCategories[i].amount);
                    if (cpy.price && cpy.price > maxValue) {
                        maxValue = cpy.price
                    }
                    cpy["cd_item_suggested"] = i === 1 ? "yes" : "no"
                    items.push(cpy)
                }

                var ecommerceData = createEventData(flight, pushFlightData, items);
                ecommerceData['currency'] = hasTargetConversionRate(subCategories[0].currency, gaTargetCurrency) ? gaTargetCurrency : subCategories[0].currency;
                ecommerceData['value'] = maxValue;
                ecommerceData['items'] = items;

                var data = {
                    event: "view_item",
                    ecommerce: ecommerceData
                };

                pushEcommerceData(data);
            } catch (e) {
                console.log(e)
            }
        }

        function pushAddToCartDataGA4(flight, cabinClass, category) {
            try {
                var pushFlightData = createFlightPushData(flight)
                pushFlightData["item_category2"] = getViewTypeByBrandCode(category.brandCode)
                pushFlightData["item_category4"] = cabinClass.toLowerCase()
                pushFlightData["cd_item_fare_class"] = category.fareClasses[0]
                pushFlightData["price"] = gaConvertPrice(category.price.currency, category.price.amount);
                if (baseFareForMulticity) {
                    var baseFare = gaConvertPrice(baseFareForMulticity.currency, baseFareForMulticity.basePerFlight);
                    if (baseFare) {
                        pushFlightData.price += baseFare;
                    }
                }

                pushFlightData["cd_item_promotion"] = getPromotionAfterSelection(flight, cabinClass)

                var ecommerceData = createEventData(flight, pushFlightData);
                ecommerceData['currency'] = hasTargetConversionRate(category.price.currency, gaTargetCurrency) ? gaTargetCurrency : category.price.currency;
                ecommerceData['value'] = pushFlightData.price * pushFlightData.quantity;
                ecommerceData['items'] = [underscore.clone(pushFlightData)];

                var data = {
                    event: "add_to_cart",
                    ecommerce: ecommerceData
                };

                pushEcommerceData(data)
                pushChangeFlightSuccessData(flight)

                var currencyData = {
                    originAmount: category.price.amount,
                    originCurrency: category.price.currency
                };

                if (hasTargetConversionRate(category.price.currency, 'USD')) {
                    currencyData['USD'] = currencyConversionRates['USD'] * currencyData.originAmount;
                }

                if (hasTargetConversionRate(category.price.currency, 'EUR')) {
                    currencyData['EUR'] = currencyConversionRates['EUR'] * currencyData.originAmount;
                }

                pushFlightData['conversion'] = currencyData;
                pushFlightData["cd_item_suggested"] = getIsItemSuggested(flight);
                pushFlightData["cm_item_passenger_number"] = totalPassengersCount;
                addToCartFlightCache(createCartFlightKey(flight), pushFlightData);

                if (!firstFlightSelected) {
                    firstFlightSelected = true;
                    createGAEventDataCache(createEventData(flight, pushFlightData));
                }
            } catch(e) {
                console.log(e)
            }
        }

        function getIsItemSuggested(flight) {
            if (flight.selectedCat) {
                return flight.selectedCat.brandCode === "XF" || flight.selectedCat.brandCode === "LG" ? "yes" : "no"
            } else if (flight.brandCode) {
                return flight.brandCode === "XF" || flight.brandCode === "LG" ? "yes" : "no"
            }
            return "no"
        }

        function pushRemoveFromCartData(flight) {
            try {
                var pushFlightData = createFlightPushData(flight)
                pushFlightData["item_category2"] = getViewTypeByBrandCode(flight.selectedCat.brandCode)
                pushFlightData["item_category4"] = flight.businessClass ? "business" : "economy"
                pushFlightData["cd_item_fare_class"] = flight.selectedCat.fareClasses[0]
                pushFlightData["price"] = gaConvertPrice(flight.selectedCat.price.currency, flight.selectedCat.price.amount);
                pushFlightData["cd_item_suggested"] = getIsItemSuggested(flight)

                var ecommerceData = createEventData(flight, pushFlightData);
                ecommerceData['currency'] = hasTargetConversionRate(flight.selectedCat.price.currency, gaTargetCurrency) ? gaTargetCurrency : flight.selectedCat.price.currency;
                ecommerceData['value'] = pushFlightData.price * pushFlightData.quantity;
                ecommerceData['items'] = [pushFlightData];

                var data = {
                    event: "remove_from_cart",
                    ecommerce: ecommerceData
                };

                pushEcommerceData(data)
                pushChangeFlightClick(flight)
                removeFromCartCache(createCartFlightKey(flight));
                viewCartSent = false;
            } catch (e) {
                console.log(e)
            }
        }

        function addToCartFlightCache(key, value) {
            var cartFlightCache = JSON.parse(storageHelper.getItem({ key: "cartFlightData", webStorageType: storageHelper.Stores.SESSION_STORAGE })) || {};
            cartFlightCache[key] = value
            storageHelper.setItem({
                key: "cartFlightData",
                value: JSON.stringify(cartFlightCache),
                webStorageType: storageHelper.Stores.SESSION_STORAGE
            });
        }

        function removeFromCartCache(key) {
            var cartFlightCache = JSON.parse(storageHelper.getItem({ key: "cartFlightData", webStorageType: storageHelper.Stores.SESSION_STORAGE }));
            var flight = cartFlightCache[key];
            if (!flight) return;

            if (flight['item_category'] !== 'domestic' && flight['item_category3'] === 'RoundTrip' && flight['cd_leg_order'] === '1') {
                clearCartFlightCache();
            } else {
                delete cartFlightCache[key];
                storageHelper.setItem({
                    key: "cartFlightData",
                    value: JSON.stringify(cartFlightCache),
                    webStorageType: storageHelper.Stores.SESSION_STORAGE
                });
            }
        }

        function getFromCartFlightCache(key) {
            var cartFlightCache = JSON.parse(storageHelper.getItem({ key: "cartFlightData", webStorageType: storageHelper.Stores.SESSION_STORAGE }))
            return cartFlightCache ? cartFlightCache[key] : null;
        }

        function clearCartFlightCache() {
            storageHelper.removeItem({ key: "cartFlightData", webStorageType: storageHelper.Stores.SESSION_STORAGE });
        }

        function clearEvisaData() {
            storageHelper.removeItem({ key: "eVisaData", webStorageType: storageHelper.Stores.SESSION_STORAGE });
        }

        var unsupportedCurrencyList = ["MILE", "PTS"];

        function pushAnalyticsPurchaseData(reservationData, purchaseInfo, eVisaStatus, selectedAdditionalServices){
            try {
                if (!gtmThankYouDataAlreadySent && !underscore.contains(unsupportedCurrencyList, reservationData.totalCharge.currency)) {
                    if (!hasTargetConversionRate(reservationData.totalCharge.currency, gaTargetCurrency)) {
                        fetchCurrencyConversionRates(reservationData.totalCharge.currency, function () {
                            pushAnalyticsPurchaseDataAfterCurrencyControl(reservationData, purchaseInfo, eVisaStatus, selectedAdditionalServices);
                        })
                    } else {
                        pushAnalyticsPurchaseDataAfterCurrencyControl(reservationData, purchaseInfo, eVisaStatus, selectedAdditionalServices);
                    }
                }
            } catch (e) {
                console.log(e)
            }
        }
        function pushAnalyticsPurchaseDataAfterCurrencyControl(reservationData, purchaseInfo, eVisaInfo, selectedAdditionalServices) {
            checkRHSFlowActive();
            if (rhsFlowActive) {
                pushRHSHoldPurchase(reservationData);
            } else if (!purchaseInfo.isReservationSale) {
                pushPurchaseDataGA4(reservationData, purchaseInfo, selectedAdditionalServices);
                prepareWinfluencedTransactionData(reservationData);
                createEverymundoData(reservationData);
                try {
                    purchaseCheckinData = createCheckinData({
                                            eventName: 'checkin_start',
                                            reservationData: reservationData,
                                            selectedData: {
                                                passengerLength: reservationData.passengers && reservationData.passengers.length
                                            }
                                        });
                } catch (e) {}
                if(eVisaInfo) {
                    var eVisaData = storageHelper.getItem({ key: "eVisaData", webStorageType: storageHelper.Stores.SESSION_STORAGE })
                    pushEvisaComplete(reservationData.allPassengerCount, eVisaData)
                }
            }
            clearTicketCache();
        }

        function clearTicketCache() {
            storageHelper.setItem({
                key: "flightSearchData",
                value: null,
                webStorageType: storageHelper.Stores.SESSION_STORAGE
            });
            storageHelper.setItem({
                key: "multiCheck",
                value: null,
                webStorageType: storageHelper.Stores.SESSION_STORAGE
            });
            storageHelper.setItem({
                key: "stopover_param",
                value: null,
                webStorageType: storageHelper.Stores.SESSION_STORAGE
            });
            clearCartFlightCache()
            clearGAEventDataCache();
            clearAdditionalServiceCache();
            clearRHSCache();
            clearEvisaData();
        }


        // udevId function
        function getUdevId() {
            try {
                var raw = storageHelper.getItem({
                    key: "bfp",
                    webStorageType: storageHelper.Stores.LOCAL_STORAGE,
                });

                return JSON.parse(raw);
            } catch (e) {
                return null;
            }
        }
        // udevId function 


        function pushPurchaseDataGA4(reservationData, purchaseInfo, selectedAdditionalServices) {
            try{
                var isValidPayment = isValidAncillaryPaymentType(reservationData.paymentInfo.paymentType)
                var mFlightSearchData = JSON.parse(storageHelper.getItem({ key: "flightSearchData", webStorageType: storageHelper.Stores.SESSION_STORAGE }))
                var paxTypeAndCount = reservationData.paxTypeAndCount
                var items = []
                var reservationTripType = reservationData ? reservationData.tripType : "";
                var tripType = "";
                var stopoverType = "";
                var fullRoute;
                if(reservationData.tripType === "MULTI_CITY"){
                    tripType = "MultiCity"
                }
                if(reservationData.tripType === "STOPOVER"){
                    fullRoute = reservationData.allFlights[0].destinationAirport.code +"-"
                        +  reservationData.allFlights[0].originAirport.code + ","
                        + reservationData.allFlights[1].destinationAirport.code + "-"
                        + reservationData.allFlights[1].destinationAirport.code
                    tripType = routeSymetric(fullRoute)
                }
                for (var i = 0; i < reservationData.allFlights.length; i++) {
                    var mItem = createFlightPushData(reservationData.allFlights[i],true)
                    mItem["cd_as_type"] = "";
                    mItem["cd_as_detail_product"] = "";
                    mItem["quantity"] = reservationData.passengers.length
                    mItem["cm_item_passenger_number"] = reservationData.passengers.length;
                    mItem["cd_item_full_flight_route"] = createFlightRoute(reservationData.allFlights)
                    mItem["cd_item_promotion"] = getPromotionAfterSelection(reservationData.allFlights[i], reservationData.allFlights[i].businessClass ? "business" : "economy")
                    if(purchaseInfo) {
                        mItem["item_list_name"] = purchaseInfo.isTicketing ? 'Availability' : 'none'
                    }

                    var cacheFlight = getFromCartFlightCache(createCartFlightKey(reservationData.allFlights[i]));
                    if (cacheFlight) {
                        mItem["cd_item_fare_class"] = cacheFlight["cd_item_fare_class"];
                        mItem["cd_item_promotion"] = cacheFlight["cd_item_promotion"];
                        mItem["price"] = isValidPayment ? cacheFlight["price"] : 0 ;
                        mItem["cd_item_suggested"] = cacheFlight["cd_item_suggested"] ? cacheFlight["cd_item_suggested"] : "no";
                        mItem["index"] = cacheFlight["index"];
                        mItem["cm_item_full_price"] = isValidPayment ? cacheFlight['cm_item_full_price'] : 0 ;
                        mItem["item_category"] = cacheFlight["item_category"];
                        mItem["item_category2"] = cacheFlight["item_category2"];
                        mItem["item_category3"] = cacheFlight["item_category3"];
                        mItem["item_category4"] = cacheFlight["item_category4"];
                        mItem["item_category5"] = cacheFlight["item_category5"];
                        mItem['cd_flight_duration_type'] = cacheFlight['cd_flight_duration_type'];
                        mItem['cd_flight_time_group'] = cacheFlight['cd_flight_time_group'];
                        mItem['cd_layover_duration'] = cacheFlight['cd_layover_duration'];
                        mItem["item_variant"] = mItem["item_variant"] || cacheFlight["item_variant"];
                    } else {
                        var extraParameters = getExtraAvailabilityParameters(reservationData.trips, i+1);

                        mItem["item_id"] = createItemIdFromReservationFlightList(reservationData.allFlights);
                        mItem["cd_item_suggested"] = getIsItemSuggested(reservationData.allFlights[i])
                        mItem["cd_item_fare_class"] = reservationData.allFlights[i].segments[0].fareBase.code;
                        mItem["item_category"] = getRouteTypeByFlight(reservationData.allFlights[i]);
                        mItem["item_category2"] = getViewTypeByBrandCode(reservationData.allFlights[i].brandCode);
                        mItem["item_category3"] = tripType ? tripType : reservationData.allFlights[i].tripType.split("_").map(function (word) {
                            return word[0].toUpperCase() + word.substring(1, word.length).toLowerCase();
                        }).join("");
                        mItem["item_category4"] = reservationData.allFlights[i].segments[0].bookingClass.cabinType.code.toLowerCase();
                        mItem["item_category5"] = isConnected(reservationData.allFlights[i].segments.length);
                        mItem["cd_leg_order"] = String(i + 1);
                        mItem["cd_item_flight_date"] = getDateInISOFormat(reservationData.allFlights[0].segments[0].departureDateTime) + "|"
                            + getDateInISOFormat(reservationData.allFlights[reservationData.allFlights.length - 1].segments[0].departureDateTime);
                        mItem["item_list_id"] = tripType ? tripType.replace("_","").trim().toLowerCase() : mItem["item_category3"].replace("_","").trim().toLowerCase();
                        mItem['cd_flight_duration_type'] = extraParameters['cd_flight_duration_type'];
                        mItem['cd_flight_time_group'] = extraParameters['cd_flight_time_group'];
                        mItem['cd_layover_duration'] = extraParameters['cd_layover_duration'];
                    }


                    if(mItem["item_list_id"] === "stopover" &&
                        (mItem["cd_stopover_type"].search("departure") !== -1
                            || mItem["cd_stopover_type"].search("return") !== -1)){
                        stopoverType = mItem["cd_stopover_type"];
                    }
                    items.push(mItem)
                }

                var ecommerce = createEventData(reservationData.allFlights[0], items[0], items, paxTypeAndCount);
                if(stopoverType !== ""){
                    ecommerce["cd_stopover_type"] = stopoverType;
                }

                if (mFlightSearchData) {
                    ecommerce["transaction_id"] = reservationData.pnr + "-" + mFlightSearchData.searchDateStart.replaceAll("-", "");
                    ecommerce["cd_last_leg"] = String(mFlightSearchData.fullCityRoute.length);
                } else {
                    ecommerce["transaction_id"] = reservationData.pnr + "-" + getDateInISOFormat(reservationData.allFlights[0].segments[0].departureDateTime).replaceAll("-", "");
                    ecommerce["cd_last_leg"] = String(reservationData.allFlights.length);
                }

                 
                if(isValidPayment){
                    ecommerce["value"] = gaConvertPrice(reservationData.totalCharge.currency, reservationData.totalCharge.amount),
                    ecommerce["cm_valueTRY"] = hasTargetConversionRate(reservationData.totalCharge.currency, 'TRY') ? reservationData.totalCharge.amount * currencyConversionRates['TRY']: reservationData.totalCharge.amount,
                    ecommerce["cm_valueUSD"] = hasTargetConversionRate(reservationData.totalCharge.currency, 'USD') ? reservationData.totalCharge.amount * currencyConversionRates['USD']: reservationData.totalCharge.amount,
                    ecommerce["cm_valueEUR"] = hasTargetConversionRate(reservationData.totalCharge.currency, 'EUR') ? reservationData.totalCharge.amount * currencyConversionRates['EUR']: reservationData.totalCharge.amount,
                    ecommerce["cm_valueOriginal"] = reservationData.totalCharge.amount ,
                    ecommerce["cm_netvalueOriginal"] = reservationData.priceInfo.totalBaseAmount ,
                    ecommerce["cm_taxesandfeesvalueOriginal"] = reservationData.priceInfo.totalTax ,
                    ecommerce["cm_fuelsurchargevalueOriginal"] = reservationData.priceInfo.carrierCharges ,
                    ecommerce["cm_ticketingservicefeevalueOriginal"] =   reservationData.priceInfo.totalFee.amount ,
                    ecommerce["cm_netvalueTRY"] = calculateConvertedAmount(
                                                hasTargetConversionRate(reservationData.priceInfo.currencyCode, 'TRY'), 
                                                    currencyConversionRates['TRY'], 
                                                    reservationData.priceInfo.totalBaseAmount 
                                                ),
                    ecommerce["cm_taxesandfeesvalueTRY"] = calculateConvertedAmount(
                                                                hasTargetConversionRate(reservationData.totalOtherTaxesAndFees.currency, 'TRY'), 
                                                                currencyConversionRates['TRY'], 
                                                                reservationData.priceInfo.totalTax
                                                            ),
                    
                    ecommerce["cm_fuelsurchargevalueTRY"] = calculateConvertedAmount(
                                                                hasTargetConversionRate(reservationData.totalCarrierCharges.currency, 'TRY'), 
                                                                currencyConversionRates['TRY'],
                                                                reservationData.priceInfo.carrierCharges
                                                            ),
                    
                    ecommerce["cm_ticketingservicefeevalueTRY"] = calculateConvertedAmount(
                                                                    hasTargetConversionRate(reservationData.totalServiceFee.currency, 'TRY'), 
                                                                    currencyConversionRates['TRY'], 
                                                                    reservationData.priceInfo.totalFee.amount
                                                                ),
                    ecommerce["cm_netvalueUSD"] = calculateConvertedAmount(
                                                    hasTargetConversionRate(reservationData.priceInfo.currencyCode, 'USD'), 
                                                    currencyConversionRates['USD'], 
                                                    reservationData.priceInfo.totalBaseAmount
                                                ),
                    ecommerce["cm_taxesandfeesvalueUSD"] = calculateConvertedAmount(
                                                                hasTargetConversionRate(reservationData.totalOtherTaxesAndFees.currency, 'USD'), 
                                                                currencyConversionRates['USD'], 
                                                                reservationData.priceInfo.totalTax
                                                            ),
                    ecommerce["cm_fuelsurchargevalueUSD"] = calculateConvertedAmount(
                                                                hasTargetConversionRate(reservationData.totalCarrierCharges.currency, 'USD'), 
                                                                currencyConversionRates['USD'],
                                                                reservationData.priceInfo.carrierCharges
                                                            ),

                    ecommerce["cm_netvalue_fuelsurchargeUSD"] = calculateConvertedAmount(
                                                                    hasTargetConversionRate(reservationData.totalCarrierCharges.currency, 'USD'), 
                                                                    currencyConversionRates['USD'],
                                                                    reservationData.priceInfo.totalBaseAmount + reservationData.priceInfo.carrierCharges
                                                                ),

                    ecommerce["cm_ticketingservicefeevalueUSD"] = calculateConvertedAmount(
                                                                    hasTargetConversionRate(reservationData.totalServiceFee.currency, 'USD'), 
                                                                    currencyConversionRates['USD'], 
                                                                    reservationData.priceInfo.totalFee.amount
                                                                ),
                    ecommerce["cm_netvalueEUR"] = calculateConvertedAmount(
                                                    hasTargetConversionRate(reservationData.priceInfo.currencyCode, 'EUR'), 
                                                    currencyConversionRates['EUR'], 
                                                    reservationData.priceInfo.totalBaseAmount
                                                ),
                    ecommerce["cm_taxesandfeesvalueEUR"] =  calculateConvertedAmount(
                                                                hasTargetConversionRate(reservationData.totalOtherTaxesAndFees.currency, 'EUR'), 
                                                                currencyConversionRates['EUR'], 
                                                                reservationData.priceInfo.totalTax
                                                            ),
                    ecommerce["cm_fuelsurchargevalueEUR"] =  calculateConvertedAmount(
                                                                hasTargetConversionRate(reservationData.totalCarrierCharges.currency, 'EUR'), 
                                                                currencyConversionRates['EUR'],
                                                                reservationData.priceInfo.carrierCharges
                                                            ),
                    ecommerce["cm_ticketingservicefeevalueEUR"] = calculateConvertedAmount(
                                                                    hasTargetConversionRate(reservationData.totalServiceFee.currency, 'EUR'), 
                                                                    currencyConversionRates['EUR'], 
                                                                    reservationData.priceInfo.totalFee.amount
                                                                ),
                
                    ecommerce["tax"] = gaConvertPrice(reservationData.totalCharge.currency, reservationData.totalOtherTaxesAndFees.amount) ;
                    ecommerce["shipping"] = gaConvertPrice(reservationData.totalCharge.currency, reservationData.totalServiceFee.amount) ;
                }else{
                    ecommerce["value"] = 0;
                    ecommerce["cm_valueTRY"] = 0;
                    ecommerce["cm_valueUSD"] = 0;
                    ecommerce["cm_valueEUR"] = 0;
                    ecommerce["cm_valueOriginal"] = 0;
                    ecommerce["cm_netvalueOriginal"] = 0;
                    ecommerce["cm_taxesandfeesvalueOriginal"] = 0;
                    ecommerce["cm_fuelsurchargevalueOriginal"] = 0;
                    ecommerce["cm_ticketingservicefeevalueOriginal"] = 0;
                    ecommerce["cm_netvalueTRY"] = 0;
                    ecommerce["cm_taxesandfeesvalueTRY"] = 0;
                    ecommerce["cm_fuelsurchargevalueTRY"] = 0;
                    ecommerce["cm_ticketingservicefeevalueTRY"] = 0;
                    ecommerce["cm_netvalueUSD"] = 0;
                    ecommerce["cm_taxesandfeesvalueUSD"] = 0;
                    ecommerce["cm_fuelsurchargevalueUSD"] = 0;
                    ecommerce["cm_netvalue_fuelsurchargeUSD"] = 0;
                    ecommerce["cm_ticketingservicefeevalueUSD"] = 0;
                    ecommerce["cm_netvalueEUR"] = 0;       
                    ecommerce["cm_taxesandfeesvalueEUR"] = 0;
                    ecommerce["cm_fuelsurchargevalueEUR"] = 0;
                    ecommerce["cm_ticketingservicefeevalueEUR"] = 0;
                    ecommerce["tax"] = 0;
                    ecommerce["shipping"] = 0;
                }   

                ecommerce["cd_originalCurrency"] = reservationData.totalCharge.currency,
                ecommerce["shipping_tier"] = '';
                ecommerce["currency"] = hasTargetConversionRate(reservationData.totalCharge.currency, gaTargetCurrency) ? gaTargetCurrency : reservationData.totalCharge.currency;               
                ecommerce["coupon"] = ""
                ecommerce["cd_ticket_no"] = getTicketNo(reservationData)
                ecommerce["payment_type"] = reservationData.paymentInfo.paymentType;
                ecommerce["cd_installment_type"] = reservationData.paymentInfo.installmentCount && reservationData.paymentInfo.installmentCount > 1 ? reservationData.paymentInfo.installmentCount + '_' + 'installments' : 'in_advance';
                ecommerce["cm_segment_count"] = getSegmentCount(reservationData.allFlights);
                ecommerce["cm_leg_count"] = items.length;
                ecommerce["cm_ticket_count"] = reservationData.tickets.length;
                ecommerce["cd_segment_count"] = String(ecommerce["cm_segment_count"]);
                ecommerce["cd_ticket_count"] = String(ecommerce["cm_ticket_count"]);
                ecommerce["page_type"] = 'purchase';
                                                              
                if(purchaseInfo) {
                   ecommerce["item_list_name"] = purchaseInfo.isTicketing ? 'Availability' : 'none'
                }

                var eventCache = getGAEventDataCache();
                if (eventCache) {
                    ecommerce['cd_sort_type'] = eventCache['cd_sort_type'];
                    ecommerce['cd_flight_duration_type'] = eventCache['cd_flight_duration_type'];
                    ecommerce['cd_flight_time_group'] = eventCache['cd_flight_time_group'];
                    ecommerce['cd_layover_duration'] = eventCache['cd_layover_duration'];
                } else {
                    var extraParameters = getExtraAvailabilityParameters(reservationData.trips);
                    ecommerce['cd_flight_duration_type'] = extraParameters['cd_flight_duration_type'];
                    ecommerce['cd_flight_time_group'] = extraParameters['cd_flight_time_group'];
                    ecommerce['cd_layover_duration'] = extraParameters['cd_layover_duration'];
                }

                var aSCacheItems = getAdditionalServiceCache();
                var mapAs = { 
                    'SAF' :'SUSTAINABLE_AVIATION_FUEL',
                    'Lounge' :'LOUNGE',
                    'Pet' : 'PETC_AVIH',
                    'Sports Equipment' : 'SPORTS_EQUIPMENT',
                    'Extra Baggage' : 'EXCESS_BAGGAGE',
                    'Seat Selection' : 'SEAT_SELECTION'
                }
                var selectedTypes = selectedAdditionalServices.map(function(parameters){  
                    return parameters.type;
                })
                var filteredItems = aSCacheItems.filter(function(item){
                    if(item.cd_item_type === 'Package Offers'){
                        return true ;
                    }  
                    var longType = mapAs[item.cd_item_type];
                    return  selectedTypes.includes(longType);
                })   

                ecommerce['cd_item_contents'] = 'ticket'
                if (filteredItems.length > 0) {
                    var aSItems = underscore.map(filteredItems, function (cacheItem) {
                        var asItem = createAdditionalServiceItemFromCache(items, cacheItem);
                        if(asItem && purchaseInfo) {
                            asItem["item_list_name"] = purchaseInfo.isTicketing ? 'Availability' : 'none';
                        }
                        return asItem;
                    })

                    if (aSItems.length > 0) {
                        ecommerce['cd_item_contents'] = 'mixed'
                        items.push.apply(items, aSItems);
                    }
                }

                ecommerce['items'] = items;
                ecommerce['udevId'] = getUdevId();
                pushEcommerceData({event: "purchase", ecommerce: ecommerce});
                if(isPriceInfoExist(reservationData)) {
                    var priceInfo = {
                        totalFare: reservationData.totalCharge.amount,
                        baseFare: reservationData.priceInfo.totalBaseAmount,
                        currency: reservationData.totalCharge.currency
                    }
                    pushMarketingInfoEvent(priceInfo, {type: 'purchase', name: 'Purchase'})
                }
            } catch (e) {
                console.log(e)
            }
        }

        function createItemIdFromReservationFlightList(flightList) {
            var originAirport = flightList[0].segments[0].originAirport.code;
            var lastFlight = flightList[flightList.length - 1];
            var destinationAirport;
            if (flightList.length === 1) {
                destinationAirport = lastFlight.segments[lastFlight.segments.length - 1].destinationAirport.code;
            } else {
                destinationAirport = lastFlight.segments[0].originAirport.code;
            }
            return originAirport + "-" + destinationAirport;
        }

        function getSegmentCount(flightList) {
            var count = 0;
            for (var i = 0; i < flightList.length; i++) {
                count += flightList[i].segments.length;
            }
            return count;
        }

        function getTicketNo(reservationData){
            var ticketNo = []
            for(var i = 0; i < reservationData.tickets.length; i++){
                ticketNo.push(reservationData.tickets[i].ticketNumber)
            }
            return ticketNo.join("|")
        }

        function pushChangeFlightClick(flight) {
            try {
                var data = {
                    event: "change_flight_click",
                    cd_brand_changed_from: underscore.unique(underscore.pluck(flight.airlinesBySegment, "shortName")).join('|'),
                    cd_type_changed_from: flight.businessClass ? "business" : "economy",
                    cd_fare_brand_from: getViewTypeByBrandCode(flight.selectedCat.brandCode),
                    cd_flight_time_changed_from: moment(flight.segments[0].departureDateTime).zone(flight.segments[0].departureDateTimeTimeZone).format("HH:mm"),
                    cm_item_flight_duration: flight.totalTravelDurationISO / 60000,
                    cd_fare_class_changed_from: flight.selectedCat.fareClasses[0]
                }

                pushDataToDataLayer(data, false, true)

                changeFlightCache[createFlightKey(flight)] = data
            } catch (e) {
                console.log(e)
            }
        }

        function pushChangeFlightSuccessData(flight) {
            try {
                var cache = changeFlightCache[createFlightKey(flight)]
                if (!cache) {
                    return
                }

                var data = {
                    event: "change_flight_success",
                    cd_brand_changed_from: cache.cd_brand_changed_from,
                    cd_brand_changed_to:  underscore.unique(underscore.pluck(flight.airlinesBySegment, "shortName")).join('|'),
                    cd_type_changed_from: cache.cd_type_changed_from,
                    cd_type_changed_to: flight.businessClass ? "business" : "economy",
                    cd_fare_brand_changed_from: cache.cd_fare_brand_from,
                    cd_fare_brand_changed_to: getViewTypeByBrandCode(flight.selectedCat.brandCode),
                    cd_flight_time_changed_from: cache.cd_flight_time_changed_from,
                    cd_flight_time_changed_to: moment(flight.segments[0].departureDateTime).zone(flight.segments[0].departureDateTimeTimeZone).format("HH:mm"),
                }

                pushDataToDataLayer(data, false, true)

                changeFlightCache[createFlightKey(flight)] = null
            } catch (e) {
                console.log(e)
            }
        }

        function createFlightKey(flight) {
            return flight.segments[0].originAirport.city.code + flight.segments[0].destinationAirport.city.code
        }

        function companionTrPassengersCount(bsh) {
            var count = 0;
            var passengers = bsh.passengerProfiles;
            var companions = bsh.companions;
            for (var passengerIndex = 0; passengerIndex < passengers.length; passengerIndex++) {
                var passenger = passengers[passengerIndex];
                if (!passenger.isTurkishCitizen) continue;
                for (var companionIndex = 0; companionIndex < companions.length; companionIndex++) {
                    var companion = companions[companionIndex];
                    if (passenger.identityNumber === companion.identityNumber) {
                        count++;
                        break;
                    }
                }
            }
            return count;
        }

        function trPassengerCount(passengers) {
            var count = 0;
            for (var passengerIndex = 0; passengerIndex < passengers.length; passengerIndex++) {
                var passenger = passengers[passengerIndex];
                if (passenger.isTurkishCitizen) count++;
            }
            return count;
        }

        function calculateUserAge(birthdateTimeStamp) {
            var cur = new Date();
            var diff = cur - birthdateTimeStamp;
            return Math.floor(diff/31557600000);
        }

        function getMSLoginStatusFromBookingSelectionHolder(bsh) {
            if (bsh && bsh.loyaltyData && bsh.loyaltyData.cardType) {
                switch (bsh.loyaltyData.cardType) {
                    case "CC": return "Classic";
                    case "CP": return 'ClassicPlus';
                    case "EC": return "Elite";
                    case "EP": return "ElitePlus";
                    default: return bsh.loyaltyData.cardType;
                }
            }
            return "Guest";
        }

        function createContactInfo(userInfo) {
            return {
                user_citizenship : userInfo["contact_citizenship"],
                user_age : userInfo["contact_age"],
                user_gender : userInfo["contact_gender"],
                user_phone_area_code : userInfo["contact_phone_area_code"]
            }
        }

        function createAccountOwnerInfo(bsh, msLoginStatus) {
            var data = {user_citizenship: "", user_age: "", user_gender: "", user_phone_area_code: "", user_ms_login_type: "", user_ms_login_status: "Guest"};
            if (msLoginStatus !== "Guest") {
                for (var i = 0; i < bsh.companions.length; i++) {
                    if (bsh.companions[i].accountOwner) {
                        var accountOwner = bsh.companions[i];
                        var user_phone_area_code = (accountOwner.regionCode === "90") ? "TR" : countryRegionUtil.findCountryByRegion(countryRegionUtil.countryRegionList(), accountOwner.regionCode);
                        data.user_citizenship = accountOwner.nationality;
                        data.user_age = calculateUserAge(accountOwner.birtDate);
                        data.user_gender = (accountOwner.title === "Mr.") ? "Mr" : "Ms";
                        data.user_phone_area_code = user_phone_area_code
                        data.user_ms_login_type = msLoginStatus;
                        data.user_ms_login_status = "Registered";
                    }
                }
            }
            return data;
        }

        function createUserInfo(bsh, msLoginStatus) {
            var data = createAccountOwnerInfo(bsh, msLoginStatus);
            if (bsh.bookingSelectionContact.passengerIndex === 0) { // account owner is contact & not passenger
                data["contact_citizenship"] = data["user_citizenship"];
                data["contact_age"] = data["user_age"];
                data["contact_gender"] = data["user_gender"];
                data["contact_phone_area_code"] = (bsh.bookingSelectionContact.countryRegion.code === "90") ? "TR" : bsh.bookingSelectionContact.countryRegion.code;
            }
            else {
                var contactPassenger = bsh.passengerProfiles[bsh.bookingSelectionContact.passengerIndex - 1];
                data["contact_citizenship"] = contactPassenger.isTurkishCitizen ? "TR" : "Others";
                data["contact_age"] = calculateUserAge(contactPassenger.birthday);
                data["contact_gender"] = contactPassenger.title;
                data["contact_phone_area_code"] = (bsh.bookingSelectionContact.countryRegion.code === "90") ? "TR" : bsh.bookingSelectionContact.countryRegion.code;
            }
            contactInfo = createContactInfo(data);
            return data;
        }

        function isThereMsPassengersExceptAccountOwner(bsh) {
            var passengers = bsh.passengerProfiles;
            for (var i= 0; i < passengers.length; i++) {
                if (!passengers[i].accountOwner && passengers[i].loyaltyMembershipID) {
                    return true;
                }
            }
            return false;
        }

        function getEventBaseMsLoginStatus(bookingSelectionHolder, userMsLoginType) {
            if (userMsLoginType === "") {
                if (isThereMsPassengersExceptAccountOwner(bookingSelectionHolder)) return "Ms Undefined"
                else return "Guest"
            } else {
                if (isThereMsPassengersExceptAccountOwner(bookingSelectionHolder)) return "Ms Mixed"
                else return userMsLoginType
            }
        }

        var userInfo;
        var contactInfo;
        var eventBaseUserInfo;

        function calculateTotalPassengerCount(eventData) {
            return totalPassengerCountUniversal(
                eventData.cm_item_passenger_adult,
                eventData.cm_item_passenger_infant,
                eventData.cm_item_passenger_child,
                eventData.cm_item_passenger_student,
                eventData.cm_item_passenger_veteran,
                eventData.cm_item_passenger_disabled,
                eventData.cm_item_passenger_soldier,
                eventData.cm_item_passenger_senior,
                eventData.cm_item_passenger_teacher);
        }

        function getTCKNPopupSource(popupSource) {
            switch (popupSource) {
                case 'senior':
                    return 'TCKN Senior Popup';
                default:
                    return 'TCKN Standart Popup'
            }
        }

        function createPopUpData(flight) {
            var eventData = flight ? createEventData(flight, createFlightPushData(flight)) : getGAEventDataCache();
            return {
                event: '',
                item_list_id: eventData.item_list_id,
                cd_passenger_count: eventData.cd_passenger_count,
                cm_passenger_count: calculateTotalPassengerCount(eventData),
                cd_sort_type: eventData.cd_sort_type,
                cd_item_flight_destination: eventData.cd_item_flight_destination,
                cd_item_flight_destination_city: eventData.cd_item_flight_destination_city,
                cd_item_flight_destination_country: eventData.cd_item_flight_destination_country,
                cd_item_flight_origin: eventData.cd_item_flight_origin,
                cd_item_flight_origin_city: eventData.cd_item_flight_origin_city,
                cd_item_flight_origin_country: eventData.cd_item_flight_origin_country,
                cd_item_codeshare: eventData.cd_item_codeshare,
                cd_item_spa: eventData.cd_item_spa,
                cd_item_flight_date: eventData.cd_item_flight_date,
                cd_item_search_date: eventData.cd_item_search_date,
                item_id:  eventData.item_id,
                item_category: eventData.item_category,
                item_category2: eventData.item_category2,
                item_category3: eventData.item_category3,
                item_category4: eventData.item_category4,
                item_category5: eventData.item_category5
            }
        }

        var popupPriceInfo;

        function pushPopUpViewData(flight, priceDiff, sourceCurrency) {
            try {
                var data = createPopUpData(flight);
                data["event"] = "extra_pop_up_view";
                data["cm_item_extra_price"] = gaConvertPrice(sourceCurrency, priceDiff) * (totalPassengersCount > 0 ? totalPassengersCount : 1);
                data["currency"] = hasTargetConversionRate(sourceCurrency, gaTargetCurrency) ? gaTargetCurrency : sourceCurrency;
                delete data.item_category2;
                delete data.item_category4;

                pushDataToDataLayer(data, false, true)
                popupPriceInfo = {
                    cm_item_extra_price: data.cm_item_extra_price,
                    currency: data.currency
                };
            } catch (e) {
                console.log(e)
            }
        }

        function pushPopUpSelectData(flight, selection) {
            try {
                var data = createPopUpData(flight);
                data["event"] = "extra_pop_up_selected";

                var upgradeSelected = false;

                switch(selection) {
                    case "EF": // ajet domestic
                    case "CL": // tk all
                        data["cd_button_name"] = "Stay on EcoFly";
                        break;
                    case "JR": // ajet international
                        data["cd_button_name"] = "Stay on EcoJet";
                        break;
                    case "PF": // ajet domestic
                    case "LG": // tk all
                        data["cd_button_name"] = "Upgrade to PrimeFly";
                        upgradeSelected = true;
                        break;
                    case "JS": // ajet international
                        data["cd_button_name"] = "Upgrade to ExtraJet";
                        upgradeSelected = true;
                        break;
                }

                if (upgradeSelected && popupPriceInfo) {
                    data['cm_item_extra_price'] = popupPriceInfo.cm_item_extra_price;
                    data['currency'] = popupPriceInfo.currency;
                } else {
                    data['cm_item_extra_price'] = 0;
                    if (popupPriceInfo) {
                        data['currency'] = popupPriceInfo.currency;
                    }
                }
                delete data.item_category2;
                delete data.item_category4;

                pushDataToDataLayer(data, false, true)
            } catch (e) {
                console.log(e)
            }
        }

        function pushTcknPopUpButtonClick(buttonName, tcknPopupSource) {
            try {
                var data = underscore.clone(passengerPagePopUpData);
                var gaEventData = getGAEventDataCache();
                var eventCategoryName = getTCKNPopupSource(tcknPopupSource);

                data["event"] = "tckn_popup_button_click";
                data["tckn_button_name"] = buttonName;
                data["page_type"] = "passenger details";
                data["cd_event_category"] = eventCategoryName
                data["cd_item_passenger_senior"] = gaEventData.cd_item_passenger_senior;
				data["cm_item_passenger_senior"] = gaEventData.cm_item_passenger_senior;
                data["user_info"] = contactInfo;
                data["citizenship"] = eventBaseUserInfo.citizenship;
                data["phone_area_code"] = eventBaseUserInfo.phone_area_code;
                data["ms_login_status"] = eventBaseUserInfo.ms_login_status;
                pushDataToDataLayer(data, false, true);
            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushTcknPopUpViewData(tcknPopupSource) {
            try {
                var eventCategoryName = getTCKNPopupSource(tcknPopupSource);
                var gaEventData = getGAEventDataCache();

                tcknViewed = true;
                var data = underscore.clone(passengerPagePopUpData);
                data["event"] = "tckn_popup_view";
                data["cd_event_category"] = eventCategoryName;
				data["cd_item_passenger_senior"] = gaEventData.cd_item_passenger_senior;
				data["cm_item_passenger_senior"] = gaEventData.cm_item_passenger_senior;
                data["page_type"] = "passenger details";
                data["user_info"] = contactInfo;
                data["citizenship"] = eventBaseUserInfo.citizenship;
                data["phone_area_code"] = eventBaseUserInfo.phone_area_code;
                data["ms_login_status"] = eventBaseUserInfo.ms_login_status;
                pushDataToDataLayer(data, false, true);
            } catch (e) {
                pushServiceError(e);
            }
        }

        var passengerPagePopUpData;

        function pushPassengerInfoView() {
            try {
                var data = createPopUpData();
                var gaEventData = getGAEventDataCache();

                passengerPagePopUpData = underscore.clone(data);
                data["event"] = "passenger_info_view";
                data["page_type"] = "passenger details";
				data["cd_item_passenger_senior"] = gaEventData.cd_item_passenger_senior;
				data["cm_item_passenger_senior"] = gaEventData.cm_item_passenger_senior;


                pushDataToDataLayer(data, false, true);
            } catch (e) {
                pushServiceError(e);
            }
        }

        function createPassengerInfoCompleted(bookingSelectionHolder, msLoginStatus) {
            var data = underscore.clone(passengerPagePopUpData);
            var gaEventData = getGAEventDataCache();

            data["event"] = "passenger_info_completed";
            data["page_type"] = "passenger details";
            data["cd_item_passenger_senior"] = gaEventData.cd_item_passenger_senior;
            data["cm_item_passenger_senior"] = gaEventData.cm_item_passenger_senior;

            userInfo = createUserInfo(bookingSelectionHolder, msLoginStatus);
            trPassengers = trPassengerCount(bookingSelectionHolder.passengerProfiles);
            companionTrPassengers = companionTrPassengersCount(bookingSelectionHolder);
            eventBaseUserInfo = {
                citizenship: (trPassengers > 0) ? "TR" : "Others",
                phone_area_code: userInfo.contact_phone_area_code,
                ms_login_status: getEventBaseMsLoginStatus(bookingSelectionHolder, userInfo.user_ms_login_type)
            }
            data["user_info"] = userInfo;
            data["citizenship"] = eventBaseUserInfo.citizenship;
            data["phone_area_code"] = eventBaseUserInfo.phone_area_code;
            data["ms_login_status"] = eventBaseUserInfo.ms_login_status;
            contactInfo["ms_login_status"] = eventBaseUserInfo.ms_login_status;
            sessionStorageUtil.persistData("user_info", contactInfo);
            delete contactInfo.ms_login_status;
            return data;
        }

        function pushPassengerInfoCompleted(bookingSelectionHolder) {
            try {
                etrAjax.get({
                    app: 'app.ms',
                    service: '/miles/memberprofile',
                    callback: function (response) {
                        var msLoginStatus = getMSLoginStatusFromResponse(response);
                        var data = createPassengerInfoCompleted(bookingSelectionHolder, msLoginStatus);
                        pushDataToDataLayer(data, false, true);
                    },
                    preErrorProperties: {
                        preErrorFunction : function() {
                            var data = createPassengerInfoCompleted(bookingSelectionHolder, "Guest");
                            pushDataToDataLayer(data, false, true);
                        }
                    },
                    disableErrorHandling: true,
                    disableLoaderTimeout: true,
                    disableLoader: true,
                });

            } catch (e) {
                pushServiceError(e);
            }
        }

        var tcknViewed = false;
        var trPassengers;
        var companionTrPassengers;

        function pushTcknSuccess() {
            try {
                if (eventBaseUserInfo && (eventBaseUserInfo.citizenship === "TR") && (trPassengers - companionTrPassengers > 0)) {
                    var gaEventData = getGAEventDataCache();
                    var data = underscore.clone(passengerPagePopUpData);

                    data["event"] = "tckn_success";
                    data["page_type"] = "passenger details";
                    data["cd_item_passenger_senior"] = gaEventData.cd_item_passenger_senior;
                    data["cm_item_passenger_senior"] = gaEventData.cm_item_passenger_senior;    
                    data["user_info"] = userInfo;
                    data["citizenship"] = eventBaseUserInfo.citizenship;
                    data["phone_area_code"] = eventBaseUserInfo.phone_area_code;
                    data["tckn_popup_viewed"] = tcknViewed ? "Yes" : "No";
                    data["ms_login_status"] = eventBaseUserInfo.ms_login_status;
                    pushDataToDataLayer(data, false, true);
                }
            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushPassengerInfoSuccess(mernisValidationNeeded) {
            try {
                if (mernisValidationNeeded) {
                    pushTcknSuccess();
                }
                
                var gaEventData = getGAEventDataCache();

                var data = underscore.clone(passengerPagePopUpData);
                data["event"] = "passenger_info_success";
                data["page_type"] = "passenger details";
                data["cd_item_passenger_senior"] = gaEventData.cd_item_passenger_senior;
                data["cm_item_passenger_senior"] = gaEventData.cm_item_passenger_senior;    

                data["user_info"] = userInfo;
                data["citizenship"] = eventBaseUserInfo.citizenship;
                data["phone_area_code"] = eventBaseUserInfo.phone_area_code;
                data["ms_login_status"] = eventBaseUserInfo.ms_login_status;
                pushDataToDataLayer(data, false, true);
            } catch (e) {
                pushServiceError(e);
            }
        }

        var popUpData;

        function pushAjetRedirectionPopUpEvent(flight, event, buttonName) {
            try {
                if (flight) {
                    popUpData = createPopUpData(flight);
                }
                var data = {
                    event: event,
                    page_type: "flight listing",
                    flight_destination_airport: popUpData.cd_item_flight_destination,
                    flight_destination_city: popUpData.cd_item_flight_destination_city,
                    flight_destination_country: popUpData.cd_item_flight_destination_country,
                    flight_origin_airport: popUpData.cd_item_flight_origin,
                    flight_origin_city: popUpData.cd_item_flight_origin_city,
                    flight_origin_country: popUpData.cd_item_flight_origin_country,
                }
                if (buttonName) {
                    data["button_name"] = buttonName;
                }
                pushDataToDataLayer(data, false, true);
            } catch (e) {
                pushServiceError(e);
            }
        }

        function getPageType(activePageNumber) {
            if (rhsOptionViewed) return "rhs option";
            switch(activePageNumber) {
                case 1: return "homepage";
                case 2: return viewCartSent ? "flight summary" : "flight listing";
                case 4: return "passenger details";
                case 5: return "payment";
                case 6: return "purchase";
                case 9: return getCurrentPageType() || "additional services detail";
                case 99: return getCurrentPageType() || "additional services detail";
                default: return activePageNumber;
            }
        }

        var maxTimeoutDuration = 0;

        function pushTimeoutPopUpEvent(maxTimeout, eventName, activePageNumber, buttonName, remainingTime) {
            try {
                var data = {
                    event: eventName,
                    page_type: getPageType(activePageNumber),
                    max_timeout_popup_duration: maxTimeout || maxTimeoutDuration || "300"
                }
                if (buttonName) {
                    data["button_name"] = buttonName;
                }
                if (remainingTime) {
                    data["timeout_popup_duration_left"] = remainingTime;
                }
                pushDataToDataLayer(data, false, true);
                if (maxTimeout) {
                    maxTimeoutDuration = maxTimeout;
                }
            } catch (e) {
                pushServiceError(e);
            }
        }

        function createStandAloneEvisaData(passengerCount, passengersList) {
            var category2 = storageHelper.getItem({ key: "gaEvisa", webStorageType: storageHelper.Stores.LOCAL_STORAGE });
            return {
                event: "",
                page_type: "",
                cd_event_category: "Stand Alone",
                cd_event_category2: category2 ? category2 : "E-Visa Stand Alone",
                cm_passenger_count: passengerCount ? passengerCount : passengersList.length,
                cd_passenger_count: passengerCount ? passengerCount.toString() : passengersList.length.toString(),
                evisa_destination: "AE"
            }
        }

        function pushStandAloneEvisaButtonClick(passengerCount) {
            try {
                var data = createStandAloneEvisaData(passengerCount);
                data["event"] = "evisa_button_click";
                data["page_type"] = "evisa main page";
                pushDataToDataLayer(data, false, true);

            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushStandAloneEvisaInfoView(passengerCount) {
            try {
                var data = createStandAloneEvisaData(passengerCount);
                data["event"] = "evisa_info_view";
                data["page_type"] = "evisa information page";
                pushDataToDataLayer(data, false, true);

            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushStandAloneEvisaInfoClick(passengersList) {
            try {
                var data = createStandAloneEvisaData(null, passengersList);
                data["event"] = "evisa_info_click";
                data["page_type"] = "evisa information page";
                data["cd_button_name"] = "Continue";
                data["evisa_type"] = getEvisaTypeFromCode(passengersList[0].visaType().code);
                data["phone_area_code"] = passengersList[0].phoneNumber.regionCode();

                for (var i = 1; i < passengersList.length; i++) {
                    if (getEvisaTypeFromCode(passengersList[i].visaType().code) !== data["evisa_type"]) {
                        data["evisa_type"] = "mixed";
                        break;
                    }
                }
                for (var i = 1; i < passengersList.length; i++) {
                    if (passengersList[i].phoneNumber.regionCode() !== data["phone_area_code"]) {
                        data["phone_area_code"] = "mixed";
                        break;
                    }
                }
                pushDataToDataLayer(data, false, true);

            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushStandAloneEvisaComplete(passengersList) {
            try {
                var data = createStandAloneEvisaData(null, passengersList);
                data["event"] = "evisa_complete";
                data["page_type"] = "evisa thank you page";
                data["evisa_type"] = getEvisaTypeFromCode(passengersList[0].visaType);
                data["phone_area_code"] = (passengersList[0].phoneNumber).split(" ")[0];

                for (var i = 1; i < passengersList.length; i++) {
                    if (getEvisaTypeFromCode(passengersList[i].visaType) !== data["evisa_type"]) {
                        data["evisa_type"] = "mixed";
                        break;
                    }
                }
                for (var i = 1; i < passengersList.length; i++) {
                    if ((passengersList[i].phoneNumber).split(" ")[0] !== data["phone_area_code"]) {
                        data["phone_area_code"] = "mixed";
                        break;
                    }
                }
                pushDataToDataLayer(data, false, true);

            } catch (e) {
                pushServiceError(e);
            }
        }

        function getEvisaTypeFromCode(evisaCode) {
            switch (evisaCode) {
                case "eVisa.shortTermSingleEntry.title1":
                    return "Single - Short Term";
                case "eVisa.shortTermMultiEntry.title1":
                    return "Multiple - Short Term";
                case "eVisa.longTermSingleEntry.title1":
                    return "Single - Long Term";
                case "eVisa.longTermMultiEntry.title1":
                    return "Multiple - Long Term";
                case "eVisa.serviceVisa.title1":
                    return "Service Visa";
                case "eVisa.twoDaysTransitVisa.title1":
                    return "Transit Visa - 48H";
                case "eVisa.fourDaysTransitVisa.title1":
                    return "Transit Visa - 96H";
                default:
                    return "";
            }

        }

        function getRouteTypeBySegment(segment) {
            var routeType = "";
            if (isBeyond(segment.originAirport, segment.destinationAirport)) {
                routeType = 'beyond';
            } else if (segment.domesticFlight || segment.domestic) {
                routeType = 'domestic';
            } else {
                routeType = segment.originAirport.domestic ? 'international_outbound' : 'international_inbound'
            }
            return routeType;
        }

        var msLoginStatus = null;

        function pushCheckinData(pushArray) {
            try {
                var gaCheckin = JSON.parse(storageHelper.getItem({
                    key: "gaCheckin",
                    webStorageType: storageHelper.Stores.SESSION_STORAGE
                }));
                if (!msLoginStatus) {
                    gaCheckin && gaCheckin.ms_login_status && (msLoginStatus = gaCheckin.ms_login_status);
                }
                if (msLoginStatus) {
                    pushArray.forEach(function (data) {
                        data['ms_login_status'] = msLoginStatus;
                        data['cd_event_category'] = gaCheckin ? gaCheckin.touchpoint : '';
                        pushDataToDataLayer(data, false, true);
                    });
                }
                else {
                    etrAjax.get({
                        app: 'app.ms',
                        service: '/miles/memberprofile',
                        callback: function (response) {
                            msLoginStatus = getMSLoginStatusFromResponse(response);
                            gaCheckin['ms_login_status'] = msLoginStatus;
                            storageHelper.setItem({
                                key: "gaCheckin",
                                value: JSON.stringify(gaCheckin),
                                webStorageType: storageHelper.Stores.SESSION_STORAGE
                            });
                            pushArray.forEach(function (data) {
                                data['ms_login_status'] = msLoginStatus;
                                data['cd_event_category'] = gaCheckin ? gaCheckin.touchpoint : '';
                                pushDataToDataLayer(data, false, true);
                            });
                        },
                        preErrorProperties: {
                            preErrorFunction: function () {
                                pushArray.forEach(function (data) {
                                    data['ms_login_status'] = 'Guest';
                                    data['cd_event_category'] = gaCheckin ? gaCheckin.touchpoint : '';
                                    pushDataToDataLayer(data, false, true);
                                });
                            }
                        },
                        disableErrorHandling: true,
                        disableLoaderTimeout: true,
                        disableLoader: true,
                    });
                }
            } catch (e) {
                pushServiceError(e);
            }
        }

        function getNotCheckedinPassengersCount(passengers) {
            var notCheckedinPassengersCount = 0;
            for(var i = 0; i < passengers.length; i++) {
                if(passengers[i].flightStateInfos[0].checkinState && passengers[i].flightStateInfos[0].checkinState !== 'CHECKEDIN'){
                    notCheckedinPassengersCount++;
                }
            }
            return notCheckedinPassengersCount;
        }

        function shouldSkipCheckinPassengerCompleted(selectedData, flight) {
            if (selectedData.isOutboundFlightChecked && selectedData.isReturnFlightChecked) return false;
            return (selectedData.isOutboundFlightChecked && flight.returnFlight) || (selectedData.isReturnFlightChecked && !flight.returnFlight);
        }

        function createCheckinData(data) {
            var pushArray = [];
            var ticketNo = getTicketNo(data.reservationData);
            var segmentOrder = 0;
        
            for (var i = 0; i < data.reservationData.allFlights.length; i++) { // for each leg
                var flight = data.reservationData.allFlights[i];
                if (data.eventName === 'checkin_passenger_completed' && shouldSkipCheckinPassengerCompleted(data.selectedData, flight)) {
                    continue;
                }
                for (var j = 0; j < flight.segments.length; j++) {
                    var segment = flight.segments[j]; // for each segment
                    var cabinCode = segment.bookingClass.cabinType.code;
                    segmentOrder = segmentOrder + 1;
                    for (var paxCount = data.selectedData.passengerLength; paxCount > 0; paxCount--) {
                        var ga4Data = {
                            event: data.eventName,
                            pnr: data.reservationData.pnr || '',
                            cd_ticket_no: ticketNo,
                            ms_login_status: 'Guest',
                            cd_segment_order: segmentOrder.toString(),
                            cd_event_category: '',
                            cd_segment_count: '1',
                            cd_segment_route: segment.originAirport.code + '-' + segment.destinationAirport.code,
                            item_name: flight.originAirport.code + '-' + flight.destinationAirport.code, // leg bazlı
                            affiliation: 'Web',
                            item_brand: segment.airline.shortName,
                            item_category: getRouteTypeBySegment(segment),
                            item_category4: cabinCode === 'Y' ? 'economy' : cabinCode === 'C' ? 'business' : cabinCode.toLowerCase(),
                            item_category5: flight.segments.length > 1 ? 'Connected' : 'Direct',
                            hour_until_flight: ((segment.departureDateTime - Date.now()) / 1000 / 3600) | 0,
                            cd_item_flight_destination: segment.destinationAirport.code,
                            cd_item_flight_destination_city: segment.destinationAirport.city.code,
                            cd_item_flight_destination_country: segment.destinationAirport.country.code,
                            cd_item_flight_origin: segment.originAirport.code,
                            cd_item_flight_origin_city: segment.originAirport.city.code,
                            cd_item_flight_origin_country: segment.originAirport.country.code,
                            cd_item_flight_date: segment.departureDateTimeISO.dateLocal,
                            cm_item_flight_duration: segment.flightDuration ? segment.flightDuration / 1000 / 60 : 0
                        }
                        pushArray.push(ga4Data);
                    }
                }
            }
            return pushArray;
        }


        var purchaseCheckinData = null;

        function pushCheckinStart(reservationData, touchpoint) {
            try {
                storageHelper.setItem({
                    key: "gaCheckin",
                    value: JSON.stringify({touchpoint: touchpoint}),
                    webStorageType: storageHelper.Stores.SESSION_STORAGE
                });
                if (touchpoint === 'Purchase' && purchaseCheckinData) {
                    pushCheckinData(purchaseCheckinData);
                } else {
                    var pushArray = createCheckinData({
                        eventName: 'checkin_start',
                        reservationData: reservationData,
                        selectedData: {
                            passengerLength: reservationData.passengers.length
                        }
                    });
                    pushCheckinData(pushArray);
                }
            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushCheckinPassengerInfoView(reservationData) {
            try {
                var pushArray = createCheckinData({
                    eventName: 'checkin_passenger_view',
                    reservationData: reservationData,
                    selectedData: {
                        passengerLength: getNotCheckedinPassengersCount(reservationData.passengers),
                    }
                });

                pushCheckinData(pushArray);
            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushCheckinPassengerInfoCompleted(data) {
            try {
                storageHelper.setItem({
                    key: 'checkinPassengerData', 
                    value: JSON.stringify({
                        totalPassenger: data.reservationData.passengers.length,
                        passengerLengthSelectedForCheckin: data.selectedData.passengerLength 
                    }),
                    webStorageType: storageHelper.Stores.SESSION_STORAGE,
                });
    
                var pushArray = createCheckinData({
                    eventName: 'checkin_passenger_completed',
                    reservationData: data.reservationData,
                    selectedData: {
                        passengerLength: data.selectedData.passengerLength,
                        isOutboundFlightChecked: data.selectedData.isOutboundFlightChecked,
                        isReturnFlightChecked: data.selectedData.isReturnFlightChecked,
                    }
                });
                pushCheckinData(pushArray);
            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushCheckinTncCompleted(reservationData, selectedPassengersCount) {
            try {
                var pushArray = createCheckinData({
                    eventName: 'checkin_tnc_completed',
                    reservationData: reservationData,
                    selectedData: {
                        passengerLength: selectedPassengersCount,
                    }
                });

                pushCheckinData(pushArray);
            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushCheckinSeatSelectionViewItemData(flightData) {
            var checkinPassengerData = storageHelper.getItem({ key: 'checkinPassengerData', webStorageType: storageHelper.Stores.SESSION_STORAGE });
            
            if (!checkinPassengerData) return;

            checkinPassengerData = JSON.parse(checkinPassengerData)

            fetchCurrencyConversionRates(flightData[0].baseFareCurrency, null);

            var ga4Items = [];
            flightData.forEach(function(leg) {
                var legFirstSegment = leg.segmentData[0].passengerList[0].passengerFlightStateInfo.segment;

                var brands = [];
                leg.segmentData.forEach(function(segment) {
                    segment.passengerList.forEach(function(passenger) {
                        var shortName = passenger.passengerFlightStateInfo.segment.airline.shortName;
                        if (!brands.includes(shortName)) {
                            brands.push(shortName);
                        }
                    });
                })

                var eventScope = {
                    item_list_name: 'Checkin',
                    item_category: getRouteTypeBySegment(legFirstSegment),
                    item_category4: legFirstSegment.cabinCode === 'Y' ? 'economy' : legFirstSegment.cabinCode === 'C' ? 'business' : legFirstSegment.cabinCode.toLowerCase(),
                    item_category5: leg.segmentData.length > 1 ? 'Connected' : 'Direct',
                    cd_item_flight_destination: leg.destinationAirportCode,
                    cd_item_flight_destination_city: leg.destinationAirportCityCode,
                    cd_item_flight_destination_country: leg.segmentData[leg.segmentData.length - 1].destinationAirportCountryCode,
                    cd_item_flight_origin: leg.originAirportCode,
                    cd_item_flight_origin_city: leg.originAirportCityCode,
                    cd_item_flight_origin_country: leg.segmentData[0].originAirportCountryCode,
                    cd_item_flight_date: legFirstSegment.departureDateTimeISO.dateLocal,
                    cd_chk_passenger: checkinPassengerData.passengerLengthSelectedForCheckin.toString() || '',
                    cm_chk_passenger: checkinPassengerData.passengerLengthSelectedForCheckin || 0,
                    item_id: leg.originAirportCode + '-' + leg.destinationAirportCode,
                    item_brand: brands.join('|') || '',
                    cd_item_codeshare: getCodeShare({ segments: legFirstSegment }) || 'none',
                    cd_item_spa: getSpa({ segments: legFirstSegment }) || 'none',
                    cd_passenger_count: checkinPassengerData.totalPassenger.toString() || '',
                    cm_passenger_count: checkinPassengerData.totalPassenger || 0,
                    cd_stopover_type: 'none',
                    page_type: 'oci seat selection',
                    currency: EURCurrency,
                    value: 0.0,
                }
                
                var items = [{
                    item_id: leg.originAirportCode + '-' + leg.destinationAirportCode,
                    item_name: leg.originAirportCode + '-' + leg.destinationAirportCode,
                    item_category: getRouteTypeBySegment(legFirstSegment),
                    item_category4: legFirstSegment.cabinCode === 'Y' ? 'economy' : legFirstSegment.cabinCode === 'C' ? 'business' : legFirstSegment.cabinCode.toLowerCase(),
                    price: 0.0,
                    quantity: checkinPassengerData.passengerLengthSelectedForCheckin,
                    item_list_name: 'Checkin',
                    cd_item_type: 'Seat Selection',
                    cm_item_passenger_number: checkinPassengerData.totalPassenger,
                    cd_item_flight_date: legFirstSegment.departureDateTimeISO.dateLocal,
                }];

                eventScope["items"] = items;

                ga4Items.push(eventScope);
            })

            underscore.forEach(ga4Items, function(data) {
                pushEcommerceData({ event: 'view_item', ecommerce: data })
            })
        }

        function getSeatType(seatObject) {
            if (seatObject.basinet || seatObject.seatKind === 'BASINET' || seatObject.chargableSeatType === 'BASINET') return 'Basinet';
            if (seatObject.exit || seatObject.seatKind === 'EXIT' || seatObject.chargableSeatType === 'EXIT' || seatObject.hasExitSeat) return 'Exit';
            if (seatObject.largeSpace || seatObject.seatKind === 'LEGROOM' || seatObject.chargableSeatType === 'LEGROOM') return 'Legroom';
            if (seatObject.preferred || seatObject.seatKind === 'PREFERRED' || seatObject.chargableSeatType === 'PREFERRED') return 'Preferred';
            return 'Standart';
        }
        
        function setSelectedSeatsArray(flightDataClient, flightDataBE, planeMaps) {
            var seatArray = [];
            flightDataClient.forEach(function(leg) {
                leg.segments.forEach(function(segmentClient) {
                    var legBEData = flightDataBE.find(function(legBE) { return legBE.flightRph === leg.flightRph()})
                    var segmentBEData = legBEData.segmentData.find(function(segmentBE) { return segmentBE.segmentRph === segmentClient.segmentRph()})
                    
                    var planeMapOfSegment = planeMaps.find(function(map, index) {
                        var isSelectedSegment = segmentClient.segmentRph() === map.segment.toString();
                        var planeMapFlightRph = (map.flight ? map.flight : index + 1).toString();

                        var isMapBelongToTheSegment = (planeMapFlightRph === legBEData.flightRph) && isSelectedSegment;

                        if (isMapBelongToTheSegment) {
                            return map;
                        }
                    })

                    segmentClient.passengers.forEach(function(passenger, passengerIndex) {
                        function pushToSeatArray(seatObj) {
                            var seatType = getSeatType(seatObj);
        
                            var obj = {
                                flightRph: leg.flightRph(),
                                segmentRph: segmentClient.segmentRph(),
                                passenger: {
                                    rph: passenger.passengerRPH(),
                                    fare: passenger.baseFare(),
                                    currency: passenger.baseFareCurrency(),
                                },
                                seatType: seatType,
                                seatNumber: seatObj.seatNumber,
                            }
                            
                            seatArray.push(obj);
                        }

                        var passengerBE = segmentBEData.passengerList[passengerIndex];
                        
                        if (planeMapOfSegment) {
                            var seatNumber = passenger.seatNumber() || passengerBE.seatNumber;
                            if (seatNumber) {
                                var seatObj = planeMapOfSegment.seatMapRow.find(function(row) {
                                    return row.cabinElement.find(function(cabin) {
                                        return cabin.planeSeat.seatNumber === seatNumber;
                                    })
                                })
    
                                if (seatObj) {
                                    seatObj = seatObj.cabinElement.find(function(cabin) {
                                        return cabin.planeSeat.seatNumber === seatNumber
                                    })
    
                                    pushToSeatArray(seatObj.planeSeat)
                                }
                            }
                        } else {
                            if (passengerBE.seatNumber) {
                                pushToSeatArray(passengerBE);
                            }
                        }
                    })
                })
            })
        
            return seatArray;
        }
        
        function setCheckinCdAsType(products) {
            var productArr = [];
        
            products.forEach(function(product) {
                var seatType = product.seatInfo.seatType
        
                if (!productArr.includes(seatType)) {
                    productArr.push(seatType);
                }
            })

            return underscore.sortBy(productArr, function (seat) {return seat}).join('|');
        }
        
        function getSelectedSeatProductType(passenger, process) {
            var seatSelectionAllowed = passenger.seatSelectionAllowed();

            if (process === 'checkin') {
                if (!seatSelectionAllowed) {
                    return passenger.baseFare() > 0 ? 'Paid' : 'Auto Assigned'
                } else {
                    return passenger.baseFare() > 0 ? 'Paid' : 'Free Standart'
                }   
            } else if (process === 'manage booking') {
                if (!passenger.seatNumber()) return;

                return passenger.baseFare() > 0 ? 'Paid' : 'Free Standart';
            }

            return '';
        }

        function setSeatsToSessionStorage(data) {
            var gaItems = {};
            var selectedSeatsGA4Data = storageHelper.getItem({ key: 'selectedSeatsGA4Data', webStorageType: storageHelper.Stores.SESSION_STORAGE });
        
            if (selectedSeatsGA4Data) storageHelper.removeItem({ key: 'selectedSeatsGA4Data', webStorageType: storageHelper.Stores.SESSION_STORAGE });
        
            if (Array.isArray(data)) {
                return storageHelper.setItem({
                    key: 'selectedSeatsGA4Data',
                    value: JSON.stringify(data),
                    webStorageType: storageHelper.Stores.SESSION_STORAGE
                })
            }
        
            data.forEach(function(seat, index) {
                gaItems[index] = seat.items;
            })
        
            storageHelper.setItem({
                key: 'selectedSeatsGA4Data',
                value: JSON.stringify(gaItems),
                webStorageType: storageHelper.Stores.SESSION_STORAGE
            })
        }

        function pushCheckinSeatSelectionAddToCartData(flightDataClient, flightDataBE, planeMaps) {
            var checkinPassengerData = storageHelper.getItem({ key: 'checkinPassengerData', webStorageType: storageHelper.Stores.SESSION_STORAGE });
            
            if (!checkinPassengerData) {
                return;
            }

            checkinPassengerData = JSON.parse(checkinPassengerData)
    
            var seatArray = setSelectedSeatsArray(flightDataClient, flightDataBE, planeMaps);

            var addToCartGA4Data = [];
            flightDataBE.forEach(function(leg, index) {
                ga4PricePerItem = 0;
                quantity = 0;
        
                var legFirstSegment = leg.segmentData[0].passengerList[0].passengerFlightStateInfo.segment;

                var brands = [];
                leg.segmentData.forEach(function(segment) {
                    segment.passengerList.forEach(function(passenger) {
                        var shortName = passenger.passengerFlightStateInfo.segment.airline.shortName;
                        if (!brands.includes(shortName)) {
                            brands.push(shortName);
                        }
                    });
                })

                var eventScopeBase = {
                    item_list_name: "Checkin",
                    page_type: "oci seat selection",
                    cd_item_flight_destination: leg.destinationAirportCode,
                    cd_item_flight_destination_city: leg.destinationAirportCityCode,
                    cd_item_flight_destination_country: leg.segmentData[leg.segmentData.length - 1].destinationAirportCountryCode,
                    cd_item_flight_origin: leg.originAirportCode,
                    cd_item_flight_origin_city: leg.originAirportCityCode,
                    cd_item_flight_origin_country: leg.segmentData[0].originAirportCountryCode,
                    cd_passenger_count: checkinPassengerData.totalPassenger.toString(),
                    cm_passenger_count: checkinPassengerData.totalPassenger, 
                    cd_chk_passenger: checkinPassengerData.passengerLengthSelectedForCheckin.toString(),
                    cm_chk_passenger: checkinPassengerData.passengerLengthSelectedForCheckin,
                    cd_item_codeshare: getCodeShare({ segments: legFirstSegment }) || 'none',
                    cd_item_spa: getSpa({ segments: legFirstSegment }) || 'none',
                    cd_item_flight_date: legFirstSegment.departureDateTimeISO.dateLocal,
                    item_id: leg.originAirportCode + '-' + leg.destinationAirportCode,
                    item_brand: brands.join('|') || '',
                    item_category: getRouteTypeBySegment(legFirstSegment),
                    item_category4: legFirstSegment.cabinCode === 'Y' ? 'economy' : legFirstSegment.cabinCode === 'C' ? 'business' : legFirstSegment.cabinCode.toLowerCase(),
                    item_category5: leg.segmentData.length > 1 ? 'Connected' : 'Direct',
                    cd_stopover_type: "none",
                }
                

                function itemScopeBase() {
                    return {
                        item_list_name: 'Checkin',
                        cd_item_type: 'Seat Selection',
                        cm_item_passenger_number: leg.segmentData[0].passengerCount,
                        cd_item_flight_date: legFirstSegment.departureDateTimeISO.dateLocal,
                        item_id: leg.originAirportCode + '-' + leg.destinationAirportCode,
                        item_name: leg.originAirportCode + '-' + leg.destinationAirportCode,
                        item_category: getRouteTypeBySegment(legFirstSegment),
                        item_category4: legFirstSegment.cabinCode === 'Y' ? 'economy' : legFirstSegment.cabinCode === 'C' ? 'business' : legFirstSegment.cabinCode.toLowerCase(),
                    }
                }
        
                var processingLeg = flightDataClient.find(function(flight) {
                    return Number(flight.flightRph()) === index + 1
                })
        
                if (!processingLeg) return;
        
                var convertedFare = calculateConvertedAmount(
                    hasTargetConversionRate(processingLeg.baseFareCurrency(), EURCurrency), 
                    currencyConversionRates[EURCurrency], 
                    processingLeg.baseFare()
                )
        
                eventScopeBase['value'] = convertedFare;
                eventScopeBase['currency'] = EURCurrency;
        
                var asProductArray = {
                    'Paid': [],
                    'Free Standart': [],
                    'Auto Assigned': []
                };
        
                processingLeg.segments.forEach(function(segment) {
                    segment.passengers.forEach(function(passenger) {
                        var passengerSeat = seatArray.filter(function(seat) {
                            if (seat.flightRph === processingLeg.flightRph() && seat.segmentRph === segment.segmentRph() && seat.seatNumber === passenger.seatNumber()) {
                                return seat;
                            } 
                        })
        
                        if (!passengerSeat.length) return;

                        var asDetailProduct = getSelectedSeatProductType(passenger, 'checkin')
                        var convertedFare = calculateConvertedAmount(
                            hasTargetConversionRate(passenger.baseFareCurrency(), EURCurrency), 
                            currencyConversionRates[EURCurrency], 
                            passenger.baseFare()
                        )
        
                        passengerSeat[0]['asDetailProduct'] = asDetailProduct;
                        passengerSeat[0].passenger['convertedFare'] = convertedFare;
                        passengerSeat[0].passenger['convertedCurrency'] = EURCurrency;
    
                        asProductArray[asDetailProduct].push({
                            leg: processingLeg.flightRph(),
                            segment: segment.segmentRph(),
                            passenger: passenger,
                            fare: convertedFare,
                            fareCurrency: passenger.baseFareCurrency(),
                            seatInfo: passengerSeat.length ? passengerSeat[0] : '',
                        });
                    })
                })
        
                var items = []
                Object.entries(asProductArray).forEach(function(product) {
                    if (!product[1].length) return;
        
                    var itemData = itemScopeBase();

                    var price = product[1].reduce(function(accumulator, productItem) {
                        return accumulator + productItem.fare
                    }, 0);

                    itemData['price'] = price / product[1].length;
                    itemData['quantity'] = product[1].length;
                    itemData['cd_as_detail_product'] = product[0];
                    itemData['cd_as_type'] = setCheckinCdAsType(product[1])
        
                    items.push(itemData)
                })
        
                if (items.length) {
                    eventScopeBase['items'] = items;
                    addToCartGA4Data.push(eventScopeBase)
                }
            });

            setSeatsToSessionStorage(addToCartGA4Data);
            storageHelper.setItem({ 
                key: 'selectedSeatsCheckinData', 
                value: JSON.stringify(seatArray), 
                webStorageType: storageHelper.Stores.SESSION_STORAGE 
            })

            addToCartGA4Data.forEach(function(data) {
                pushEcommerceData({event: 'add_to_cart', ecommerce: data });
            })
        }

        function pushCheckinSeatSelectionSeatSelectionData(flightDataClient, flightDataBE, planeMaps) {
            var gaCheckinData = storageHelper.getItem({ key: 'gaCheckin', webStorageType: storageHelper.Stores.SESSION_STORAGE });
        
            if (!gaCheckinData) return;
        
            gaCheckinData = JSON.parse(gaCheckinData);
            
            function eventScopeBase(index) {
                var leg = flightDataBE[index];
                var legFirstSegment = leg.segmentData[0].passengerList[0].passengerFlightStateInfo.segment;
                var legLastSegment = leg.segmentData[leg.segmentData.length - 1].passengerList[0].passengerFlightStateInfo.segment;

                var brands = [];
                leg.segmentData.forEach(function(segment) {
                    segment.passengerList.forEach(function(passenger) {
                        var shortName = passenger.passengerFlightStateInfo.segment.airline.shortName;
                        if (!brands.includes(shortName)) {
                            brands.push(shortName);
                        }
                    });
                })

                return {
                    event: "checkin_seat_selection",
                    currency: EURCurrency,
                    cm_segment_count: 1,
                    cd_event_category: gaCheckinData.touchpoint ? gaCheckinData.touchpoint : '',
                    ms_login_status: gaCheckinData.ms_login_status ? gaCheckinData.ms_login_status : '',
                    item_name: leg.originAirportCode + '-' + leg.destinationAirportCode,
                    affiliation: 'Web',
                    item_brand: brands.join('|') || '',
                    item_category: getRouteTypeBySegment(legFirstSegment),
                    item_category4: legFirstSegment.cabinCode === 'Y' ? 'economy' : legFirstSegment.cabinCode === 'C' ? 'business' : legFirstSegment.cabinCode.toLowerCase(),
                    item_category5: leg.segmentData.length > 1 ? 'Connected' : 'Direct',
                    hour_until_flight: ((leg.departureDateTime - Date.now()) / 1000 / 3600) | 0,
                    cd_item_flight_destination: leg.destinationAirportCode,
                    cd_item_flight_destination_city: leg.destinationAirportCityCode,
                    cd_item_flight_destination_country: legLastSegment.destinationAirport.country.code,
                    cd_item_flight_origin: leg.originAirportCode,    
                    cd_item_flight_origin_city: leg.originAirportCityCode,
                    cd_item_flight_origin_country: legFirstSegment.originAirport.country.code,
                    cd_item_flight_date: legFirstSegment.departureDateTimeISO.dateLocal,
                }
            }
        
            var events = [];
            var segmentOrder = 0;
            var selectedSeatsArray = setSelectedSeatsArray(flightDataClient, flightDataBE, planeMaps)
        
            flightDataClient.forEach(function(leg, legIndex) {
                var legBE = flightDataBE[legIndex];

                leg.segments.forEach(function(segment, segmentIndex) {
                    segmentOrder = segmentOrder + 1;
                    segment.passengers.forEach(function(passenger, passengerIndex) {
                        var passengerBE = flightDataBE[legIndex].segmentData[segmentIndex].passengerList[passengerIndex];
                        var asDetailProduct = getSelectedSeatProductType(passenger, 'checkin')
        
                        var passengerSeatInfo = selectedSeatsArray.find(function(seat) {
                            return seat.flightRph === leg.flightRph() && seat.segmentRph === segment.segmentRph() && seat.passenger.rph === passenger.passengerRPH() 
                        })
        
                        if (!passengerSeatInfo) return;
        
                        var eventScope = eventScopeBase(legIndex);
        
                        var convertedFare = calculateConvertedAmount(
                            hasTargetConversionRate(passengerSeatInfo.passenger.currency, EURCurrency),
                            currencyConversionRates[EURCurrency],
                            passengerSeatInfo.passenger.fare
                        )
        
                        eventScope['pnr'] = legBE.pnrCode;
                        eventScope['cd_ticket_no'] = passengerBE.passengerFlightStateInfo.ticketNumber;
                        eventScope['price'] = convertedFare;
                        eventScope['cd_as_type'] = passengerSeatInfo.seatType;
                        eventScope['cd_as_detail_product'] = asDetailProduct;
                        eventScope['cd_segment_order'] = segmentOrder.toString();
                        eventScope['cd_segment_route'] = segment.originAirportCode() + '-' + segment.destinationAirportCode();
                        eventScope['cm_item_flight_duration'] = passengerBE.segment.flightDuration ? passengerBE.segment.flightDuration / 1000 / 60 : 0
                        eventScope['hour_until_flight'] = ((passengerBE.segment.departureDateTime - Date.now()) / 1000 / 3600) | 0,
        
                        events.push(eventScope);
                    })
                })
            })
        
            events.forEach(function(event) {
                pushDataToDataLayer(event, false, true);
            })
        }

        /* Check-in Additional Services */

        /* Checkin Extra Baggages */
        function getCheckinExtraBaggages(flightData, extraBaggages, itemIdBase) {
            var extraBaggagesItems = [];
            flightData.forEach(function(leg) {
                var legItemId = leg.originAirport.code + '-' + leg.destinationAirport.code;

                var baggagePushed = false;
                extraBaggages.baggageSelectionItems.forEach(function(item) {
                    baggagePushed = false;
                    leg.segments.find(function(segment) {
                        if (baggagePushed) return;

                        item.segmentRPHList.find(function(segmentRph) {
                            if (segmentRph === segment.rph) {
                                if (itemIdBase === 'leg') {
                                    var itemId = legItemId;
                                    baggagePushed = true;
                                    extraBaggagesItems.push({
                                        itemId: itemId,
                                        baggage: item,
                                        flightRph: leg.rph,
                                        segmentRph: segmentRph,
                                        passengerRph: item.passengerRPH,
                                    });
                                } else if (itemIdBase === 'segment') {
                                    leg.segments.forEach(function(s) {
                                        var segmentItemId = s.originAirport.code + '-' + s.destinationAirport.code;

                                        extraBaggagesItems.push({
                                            legItemId: legItemId,
                                            itemId: segmentItemId,
                                            baggage: item,
                                            flightRph: leg.rph,
                                            segmentRph: segmentRph,
                                            segmentCount: leg.segments.length,
                                            passengerRph: item.passengerRPH,
                                        });
                                    })

                                    baggagePushed = true;
                                }
                            }
                        })
                    })
                })
            });
            
            return extraBaggagesItems;
        }

        function getCheckinExtraBaggagesAddShippingInfoData(flightData, extraBaggages) {
            var baggageQuantity = {};
            var baggagePrice = {};
            var baggageItems = {};

            extraBaggages.forEach(function(eBaggages) {
                var legData = flightData.find(function(leg) { 
                    var itemId = leg.originAirport.code + '-' + leg.destinationAirport.code;
                    return itemId === eBaggages.itemId 
                })

                var price = calculateConvertedAmount(
                    hasTargetConversionRate(eBaggages.baggage.currency, EURCurrency),
                    currencyConversionRates[EURCurrency],
                    eBaggages.baggage.baggagePrice
                );

                baggageQuantity[eBaggages.itemId] = (baggageQuantity[eBaggages.itemId] ? baggageQuantity[eBaggages.itemId] : 0)  + eBaggages.baggage.ancillaryServiceAmount;
                baggagePrice[eBaggages.itemId] = (baggagePrice[eBaggages.itemId] ? baggagePrice[eBaggages.itemId] : 0) + price;

                if (!legData) return;

                baggageItems[eBaggages.itemId] = {
                    item_id: eBaggages.itemId,
                    item_name: legData.originAirport.code + '-' + legData.destinationAirport.code,
                    affiliation: "Web",
                    item_category: getRouteTypeBySegment(legData),
                    item_category4: legData.cabinCode === 'Y' ? 'economy' : legData.cabinCode === 'C' ? 'business' : legData.cabinCode.toLowerCase(),
                    item_list_name: "Checkin",
                    cd_as_type: eBaggages.ancillaryServiceUnit === 'kg' ? 'kg' : 'Piece',
                    cd_as_detail_product: '',
                    cd_item_type: 'Extra Baggage',
                    cm_item_passenger_number: legData.passengers.length || 0,
                    cd_item_flight_date: legData.segments[0].departureDateTimeISO.dateLocal,
                    quantity: baggageQuantity[eBaggages.itemId],
                    price: baggagePrice[eBaggages.itemId],
                }
            })

            return baggageItems;
        }

        function getCheckinExtraBaggagesSelectedAsData(extraBaggages, eventName) {
            var extraBaggagesItems = {};
            var baggageQuantity = {};
            var baggagePrice = {};

            extraBaggages.forEach(function(eBaggages) {
                var filter = eBaggages.legItemId + '_' + eBaggages.itemId;

                var price = calculateConvertedAmount(
                    hasTargetConversionRate(eBaggages.baggage.currency, EURCurrency),
                    currencyConversionRates[EURCurrency],
                    eBaggages.baggage.baggagePrice
                );

                baggageQuantity[filter] = (baggageQuantity[filter] ? baggageQuantity[filter] : 0)  + eBaggages.baggage.ancillaryServiceAmount;
                baggagePrice[filter] = (baggagePrice[filter] ? baggagePrice[filter] : 0) + price;

                extraBaggagesItems[filter] = {
                    event: eventName,
                    price: baggagePrice[filter] / eBaggages.segmentCount,
                    totalPrice: baggagePrice[filter],
                    currency: EURCurrency,
                    quantity: baggageQuantity[filter],
                    cd_item_segment: eBaggages.itemId,
                    cd_item_type: 'Extra Baggage',
                    cd_as_type: eBaggages.baggage.ancillaryServiceUnit === 'kg' ? 'kg' : 'Piece',
                    cd_as_detail_product: '',
                }
            })

            return extraBaggagesItems
        }

        function createCheckinExtraBaggageGa4Items(flightData, extraBaggageData, itemIdBase, eventName) {
            var extraBaggages = getCheckinExtraBaggages(flightData, extraBaggageData, itemIdBase);
            var extraBaggagesItems = [];

            if (eventName === 'add_shipping_info') extraBaggagesItems = getCheckinExtraBaggagesAddShippingInfoData(flightData, extraBaggages)
            if (eventName === 'checkin_selected_as') extraBaggagesItems = getCheckinExtraBaggagesSelectedAsData(extraBaggages, eventName)

            return extraBaggagesItems;
        }
        /* Checkin Extra Baggages */

        /* Checkin Sport Equipments */
        function getCheckinSportEquipments(flightData, sportsEqData, itemIdBase) {
            var sportsEquipments = [];
            flightData.forEach(function(leg) {
                var legItemId = leg.originAirport.code + '-' + leg.destinationAirport.code;

                var sePushed = false;
                sportsEqData.equipmentSelectionItems.forEach(function(item) {
                    sePushed = false;
                    leg.segments.find(function(segment) {
                        if (sePushed) return;

                        item.segmentRPHList.find(function(segmentRph) {
                            if (segmentRph === segment.rph) {
                                if (itemIdBase === 'leg') {
                                    var itemId = legItemId;
                                    sePushed = true;
                                    sportsEquipments.push({
                                        itemId: itemId,
                                        equipment: item,
                                        flightRph: leg.rph,
                                        segmentRph: segmentRph,
                                        passengerRph: item.passengerRPH,
                                    });
                                } else if (itemIdBase === 'segment') {
                                    leg.segments.forEach(function(s) {
                                        var segmentItemId = s.originAirport.code + '-' + s.destinationAirport.code;

                                        sportsEquipments.push({
                                            legItemId: legItemId,
                                            itemId: segmentItemId,
                                            equipment: item,
                                            segmentCount: leg.segments.length,
                                            flightRph: leg.rph,
                                            segmentRph: segmentRph,
                                            passengerRph: item.passengerRPH,
                                        });
                                    })

                                    sePushed = true;
                                }
                            }
                        })
                    })
                })
            });

            return sportsEquipments;
        }

        function getCheckinSportsEquipmentAddShippingInfoData(flightData, sportsEquipments) {
            var sportsEquipmentItemsQuantity = {};
            var sportsEquipmentItems = {};

            sportsEquipments.forEach(function(sEquipment) {
                var legData = flightData.find(function(leg) { 
                    var itemId = leg.originAirport.code + '-' + leg.destinationAirport.code;
                    return itemId === sEquipment.itemId 
                })

                var name = sEquipment.equipment.equipmentName;

                var price = calculateConvertedAmount(
                    hasTargetConversionRate(sEquipment.equipment.currency, EURCurrency),
                    currencyConversionRates[EURCurrency],
                    sEquipment.equipment.equipmentPrice
                );

                sportsEquipmentItemsQuantity[name] = (sportsEquipmentItemsQuantity[name] ? sportsEquipmentItemsQuantity[name] : 0) + sEquipment.equipment.ancillaryServiceAmount;

                if (!legData) return;
                var lookUpKey = { "sportequipmentlookup": name };
                var equipmentName = i18n.getWithArgs('sportEquipment.name', lookUpKey);

                sportsEquipmentItems[name] = {
                    item_id: sEquipment['itemId'],
                    item_name: legData.originAirport.code + '-' + legData.destinationAirport.code,
                    affiliation: "Web",
                    item_category: getRouteTypeBySegment(legData),
                    item_category4: legData.cabinCode === 'Y' ? 'economy' : legData.cabinCode === 'C' ? 'business' : legData.cabinCode.toLowerCase(),
                    item_list_name: "Checkin",
                    cd_as_type: equipmentName,
                    cd_as_detail_product: '',
                    cd_item_type: 'Sports Equipment',
                    cm_item_passenger_number: legData.passengers.length || 0,
                    cd_item_flight_date: legData.segments[0].departureDateTimeISO.dateLocal,
                    quantity: sportsEquipmentItemsQuantity[name],
                    price: price,
                }
            })

            return sportsEquipmentItems;
        }

        function getCheckinSportsEquipmentSelectedAsData(sportEquipments, eventName) {
            var sportEquipmentsItems = {};
            var sportEquipmentsQuantity = {};

            sportEquipments.forEach(function(sEquipments) {
                var name = sEquipments.equipment.equipmentName;
                var filter = sEquipments.itemId + '_' + name;

                var price = calculateConvertedAmount(
                    hasTargetConversionRate(sEquipments.equipment.currency, EURCurrency),
                    currencyConversionRates[EURCurrency],
                    sEquipments.equipment.equipmentPrice
                );

                sportEquipmentsQuantity[filter] = (sportEquipmentsQuantity[filter] || 0) + sEquipments.equipment.ancillaryServiceAmount;

                var lookUpKey = { "sportequipmentlookup": name };
                var equipmentName = i18n.getWithArgs('sportEquipment.name', lookUpKey);

                sportEquipmentsItems[filter] = {
                    event: eventName,
                    price: price / sEquipments.segmentCount,
                    totalPrice: price,
                    currency: EURCurrency,
                    quantity: sportEquipmentsQuantity[filter],
                    cd_item_segment: sEquipments.itemId,
                    cd_item_type: 'Sports Equipment',
                    cd_as_type: equipmentName,
                    cd_as_detail_product: '',
                }
            })

            return sportEquipmentsItems
        }

        function createCheckinSportsEquipmentGa4Data(flightData, sportEqsData, itemIdBase, eventName) {
            var sportEquipments = getCheckinSportEquipments(flightData, sportEqsData, itemIdBase);
            var sportEquipmentsItems = [];

            if (eventName === 'add_shipping_info') sportEquipmentsItems = getCheckinSportsEquipmentAddShippingInfoData(flightData, sportEquipments)
            if (eventName === 'checkin_selected_as') sportEquipmentsItems = getCheckinSportsEquipmentSelectedAsData(sportEquipments, eventName)

            return sportEquipmentsItems;
        }
        /* Checkin Sport Equipments */

        /* Checkin Lounge */
        function getCheckinLounges(flightData, loungeData, itemIdBase) {
            var lounges = [];

            flightData.forEach(function(leg) {
                var legItemId = leg.originAirport.code + '-' + leg.destinationAirport.code;

                var loungePushed = false;
                loungeData.loungeSelectionItems.forEach(function(item) {
                    loungePushed = false;
                    leg.segments.find(function(segment) {
                        if (loungePushed) return;

                        item.segmentRPHList.find(function(segmentRph) {
                            if (segmentRph === segment.rph) {
                                if (itemIdBase === 'leg') {
                                    var itemId = legItemId;
                                    loungePushed = true;
                                    lounges.push({
                                        itemId: itemId,
                                        lounge: item,
                                        flightRph: leg.rph,
                                        segmentRph: segmentRph,
                                        passengerRph: item.passengerRPH,
                                    });
                                } else if (itemIdBase === 'segment') {
                                    leg.segments.forEach(function(s) {
                                        var segmentItemId = s.originAirport.code + '-' + s.destinationAirport.code;

                                        lounges.push({
                                            legItemId: legItemId,
                                            itemId: segmentItemId,
                                            lounge: item,
                                            flightRph: leg.rph,
                                            segmentRph: segmentRph,
                                            passengerRph: item.passengerRPH,
                                            segmentCount: leg.segments.length,
                                        });
                                    })

                                    loungePushed = true;
                                }
                            }
                        })
                    })
                })
            });

            return lounges;
        }

        function getCheckinLoungeAddShippingInfoData(flightData, lounges) {
            var loungeQuantity = {};
            var loungeItems = {};

            lounges.forEach(function(lnge) {
                var legData = flightData.find(function(leg) { 
                    var itemId = leg.originAirport.code + '-' + leg.destinationAirport.code;
                    return itemId === lnge.itemId 
                })
                var airportCode = lnge.lounge.loungePort;
                var portCode = lnge.lounge.portCode;

                var price = calculateConvertedAmount(
                    hasTargetConversionRate(lnge.lounge.currency, EURCurrency),
                    currencyConversionRates[EURCurrency],
                    lnge.lounge.ancillaryServicePrice
                );

                loungeQuantity[portCode] = (loungeQuantity[portCode] ? loungeQuantity[portCode] : 0)  + lnge.lounge.ancillaryServiceAmount;

                if (!legData) return;

                var lookUpKey = { "loungelookup": portCode };
                var loungeName = airportCode + ' - ' + i18n.getWithArgs('lounge.loungeName', lookUpKey);

                loungeItems[portCode] = {
                    item_id: lnge.itemId,
                    item_name: legData.originAirport.code + '-' + legData.destinationAirport.code,
                    affiliation: "Web",
                    item_category: getRouteTypeBySegment(legData),
                    item_category4: legData.cabinCode === 'Y' ? 'economy' : legData.cabinCode === 'C' ? 'business' : legData.cabinCode.toLowerCase(),
                    item_list_name: "Checkin",
                    cd_as_type: airportCode,
                    cd_as_detail_product: loungeName,
                    cd_item_type: 'Lounge',
                    cm_item_passenger_number: legData.passengers.length || 0,
                    cd_item_flight_date: legData.segments[0].departureDateTimeISO.dateLocal,
                    quantity: loungeQuantity[portCode],
                    price: price,
                }
            })

            return loungeItems
        }

        function getCheckinLoungeSelectedAsData(lounges, eventName) {
            var loungeItems = {};
            var loungeQuantity = {};

            lounges.forEach(function(lnge) {
                var airportCode = lnge.lounge.loungePort;
                var portCode = lnge.lounge.portCode;
                var filter = lnge.itemId + '_' + airportCode;

                var price = calculateConvertedAmount(
                    hasTargetConversionRate(lnge.lounge.currency, EURCurrency),
                    currencyConversionRates[EURCurrency],
                    lnge.lounge.ancillaryServicePrice
                );

                loungeQuantity[filter] = (loungeQuantity[filter] || 0) + lnge.lounge.ancillaryServiceAmount;

                var lookUpKey = { "loungelookup": portCode };
                var loungeName = airportCode + ' - ' + i18n.getWithArgs('lounge.loungeName', lookUpKey);

                loungeItems[filter] = {
                    event: eventName,
                    price: price / lnge.segmentCount,
                    totalPrice: price,
                    currency: EURCurrency,
                    quantity: loungeQuantity[filter],
                    cd_item_segment: lnge.itemId,
                    cd_item_type: 'Lounge',
                    cd_as_type: airportCode,
                    cd_as_detail_product: loungeName,
                }
            })

            return loungeItems
        }

        function createCheckinLoungeGa4Data(flightData, loungeData, itemIdBase, eventName) {
            var lounges = getCheckinLounges(flightData, loungeData, itemIdBase);
            var loungeItems = [];

            if (eventName === 'add_shipping_info') loungeItems = getCheckinLoungeAddShippingInfoData(flightData, lounges)
            if (eventName === 'checkin_selected_as') loungeItems = getCheckinLoungeSelectedAsData(lounges, eventName)

            return loungeItems;
        }
        /* Checkin Lounge */

        function createCheckinSeatSelectionGa4Data(data, eventName) {
            var seats = {};

            Object.values(data).forEach(function(ga4Items) {
                if (ga4Items && Array.isArray(ga4Items)) {
                    ga4Items.forEach(function(item) {
                        var filter = item.item_id + '_' + item.cd_as_detail_product + '_' + item.cd_as_type

                        item['affiliation'] = 'Web';
                        item['event'] = eventName;
                        seats[filter] = item
                    })
                }
            })

            return seats;
        }

        function getSelectedServicesData(flightData, selectedServices, itemIdBase) {
            var items = [];
            Object.entries(selectedServices).forEach(function(service) {
                if (service[0] === 'LOUNGE') {
                    var data = getCheckinLounges(flightData, service[1], itemIdBase);
                    items.push({ key: 'LOUNGE', data: data })
                }

                if (service[0] === 'SPORTS_EQUIPMENT') {
                    var data = getCheckinSportEquipments(flightData, service[1], itemIdBase);
                    items.push({key: 'SPORTS_EQUIPMENT', data: data })
                }

                if (service[0] === 'EXCESS_BAGGAGE') {
                    var data = getCheckinExtraBaggages(flightData, service[1], itemIdBase);
                    items.push({key: 'EXCESS_BAGGAGE', data: data })
                }
            })

            return items;
        }

        function getSelectedServicesGA4Data(flightData, selectedServices, itemIdBase, eventName) {
            var items = [];
            Object.entries(selectedServices).forEach(function(service) {
                if (service[0] === 'LOUNGE') {
                    var data = createCheckinLoungeGa4Data(flightData, service[1], itemIdBase, eventName);
                    items.push({ key: 'LOUNGE', data: data })
                }

                if (service[0] === 'SPORTS_EQUIPMENT') {
                    var data = createCheckinSportsEquipmentGa4Data(flightData, service[1], itemIdBase, eventName);
                    items.push({key: 'SPORTS_EQUIPMENT', data: data })
                }

                if (service[0] === 'SEAT_SELECTION')  {
                    var data = createCheckinSeatSelectionGa4Data(service[1], eventName);
                    items.push({key: 'SEAT_SELECTION', data: data })
                }

                if (service[0] === 'EXCESS_BAGGAGE') {
                    var data = createCheckinExtraBaggageGa4Items(flightData, service[1], itemIdBase, eventName);
                    items.push({key: 'EXCESS_BAGGAGE', data: data })
                }
            })

            return items;
        }

        function calculateASExtraPrice(data, flightInfo) {
            function isItemBelongToFlight(item) {
                return (
                    item.segmentRph.toString() === flightInfo.segmentRph && 
                    item.flightRph.toString() === flightInfo.legRph && 
                    item.passengerRph.toString() === flightInfo.passengerRph
                );
            }
            var extraPrice = 0;
            var baseCurrency;
            data.forEach(function(asData) {
                if (asData.key === 'LOUNGE') {
                    asData.data.filter(function(item) {
                        if(isItemBelongToFlight(item)) {
                            baseCurrency = item.lounge.currency
                            extraPrice = extraPrice + item.lounge.ancillaryServicePrice
                        }
                    })
                } else if (asData.key === 'SPORTS_EQUIPMENT') {
                    asData.data.filter(function(item) {
                        if(isItemBelongToFlight(item)) {
                            baseCurrency = item.equipment.currency
                            extraPrice = extraPrice + item.equipment.equipmentPrice
                        }
                    })
                } else if (asData.key === 'EXCESS_BAGGAGE') {
                    asData.data.filter(function(item) {
                        if(isItemBelongToFlight(item)) {
                            baseCurrency = item.baggage.currency
                            extraPrice = extraPrice + item.baggage.baggagePrice
                        }
                    })
                }
            })

            return calculateConvertedAmount(
                hasTargetConversionRate(baseCurrency, EURCurrency), 
                currencyConversionRates[EURCurrency], 
                extraPrice
            )
        }

        function pushCheckinAdditionalServicesAddShippingInfoData(flightData, selectedServices) {
            var checkinPassengerData = storageHelper.getItem({ key: 'checkinPassengerData', webStorageType: storageHelper.Stores.SESSION_STORAGE });
            var selectedSeatsGA4Data = storageHelper.getItem({ key: "selectedSeatsGA4Data", webStorageType: storageHelper.Stores.SESSION_STORAGE })
            
            if (!checkinPassengerData || !selectedSeatsGA4Data) {
                return;
            }

            checkinPassengerData = JSON.parse(checkinPassengerData)
            selectedSeatsGA4Data = JSON.parse(selectedSeatsGA4Data);

            selectedServices['SEAT_SELECTION'] = selectedSeatsGA4Data;

            var items = getSelectedServicesGA4Data(flightData, selectedServices, 'leg', 'add_shipping_info');

            var value = 0;
            var ga4Items = [];
            items.forEach(function(item) {
                var additionalServiceGa4Item = Object.values(item.data)
                ga4Items.push(additionalServiceGa4Item);

                additionalServiceGa4Item.forEach(function(asData) {
                    value = value + (asData.price * asData.quantity)
                })
            })

            ga4Items = underscore.flatten(ga4Items, true);

            var leg = flightData[0];
            var event = {
                currency: EURCurrency,
                shipping: 0.00,
                shipping_tier: '',
                value: value,
                item_list_name: "Checkin",
                cd_item_contents: "additional services",
                page_type: "oci additional services listing",
                item_id: leg.originAirport.code + '-' + leg.destinationAirport.code,
                item_brand: getItemBrand(leg.airlinesBySegment),
                cd_item_flight_destination: leg.destinationAirport.code,
                cd_item_flight_destination_city: leg.destinationAirport.city.code,
                cd_item_flight_destination_country: leg.destinationAirport.country.code,
                cd_item_flight_origin: leg.originAirport.code,
                cd_item_flight_origin_city: leg.originAirport.city.code,
                cd_item_flight_origin_country: leg.originAirport.country.code,
                cd_passenger_count: checkinPassengerData.totalPassenger.toString() || '',
                cm_passenger_count: checkinPassengerData.totalPassenger || 0,
                cd_chk_passenger: checkinPassengerData.passengerLengthSelectedForCheckin.toString(),
                cm_chk_passenger: checkinPassengerData.passengerLengthSelectedForCheckin,
                cd_item_codeshare: getCodeShare(leg) || 'none',
                cd_item_spa: getSpa(leg) || 'none',
                cd_item_flight_date: leg.segments[0].departureDateTimeISO.dateLocal,
                item_category: getRouteTypeBySegment(leg),
                item_category4: leg.cabinCode === 'Y' ? 'economy' : leg.cabinCode === 'C' ? 'business' : leg.cabinCode.toLowerCase(),
                item_category5: leg.segments.length > 1 ? 'Connected' : 'Direct',
                cd_stopover_type: 'none',
            }

            event['items'] = ga4Items

            pushEcommerceData({ event: 'add_shipping_info', ecommerce: event })
        }

        function pushCheckinAdditionalServicesCheckinSelectedtedASData(flightData, selectedServices) {
            var items = getSelectedServicesGA4Data(flightData, selectedServices, 'segment', 'checkin_selected_as');
            items.forEach(function (item) {
                Object.values(item.data).forEach(function(gaItem) {
                    pushDataToDataLayer(gaItem, false, true);
                })
            })
        }

        function pushCheckinAdditionalServicesCheckinASCompletedData(flightData, selectedServices, pnr) {
            var gaCheckin = storageHelper.getItem({ key: "gaCheckin", webStorageType: storageHelper.Stores.SESSION_STORAGE })
            var selectedSeatsCheckinData = storageHelper.getItem({ key: "selectedSeatsCheckinData", webStorageType: storageHelper.Stores.SESSION_STORAGE })

            if (!gaCheckin || !selectedSeatsCheckinData) return;
            
            gaCheckin = JSON.parse(gaCheckin);
            selectedSeatsCheckinData = JSON.parse(selectedSeatsCheckinData);

            var checkinASData = getSelectedServicesData(flightData, selectedServices, 'leg')

            var events = [];
            flightData.forEach(function(leg) {
                leg.segments.forEach(function(segment) {
                    leg.passengers.forEach(function(passenger) {
                        var flightInfo = {
                            legRph: leg.rph.toString(),
                            segmentRph: segment.rph.toString(),
                            passengerRph: passenger.rph.toString(),
                        }
                        
                        var currentSegment = passenger.flightStateInfos.find(function(info) {
                            return info.segment.rph === segment.rph
                        })

                        var passengerSeat = selectedSeatsCheckinData.find(function(seat) {
                            return flightInfo.legRph === seat.flightRph && flightInfo.segmentRph === seat.segmentRph && flightInfo.passengerRph === seat.passenger.rph
                        });

                        var itemExtraPrice = calculateASExtraPrice(checkinASData, flightInfo);
                        
                        var eventParameters = {
                            event: "checkin_as_completed",
                            pnr: pnr,
                            cd_ticket_no: currentSegment.ticketNumber,
                            price: passengerSeat ? passengerSeat.passenger.convertedFare : 0,
                            currency: passengerSeat ? passengerSeat.passenger.convertedCurrency : EURCurrency,
                            cm_item_extra_price: itemExtraPrice,
                            ms_login_status: gaCheckin.ms_login_status,
                            cd_as_type: passengerSeat ? passengerSeat.seatType : '',
                            cd_as_detail_product: passengerSeat ? passengerSeat.asDetailProduct : '',
                            cd_segment_order: segment.rph,
                            cd_event_category: gaCheckin.touchpoint,
                            cm_segment_count: 1,
                            cd_segment_route: segment.originAirport.code + '-' + segment.destinationAirport.code,
                            item_name: leg.originAirport.code + '-' + leg.destinationAirport.code,
                            affiliation: "Web",
                            item_brand: getItemBrand(leg.airlinesBySegment),
                            item_category: getRouteTypeBySegment(leg),
                            item_category4: leg.cabinCode === 'Y' ? 'economy' : leg.cabinCode === 'C' ? 'business' : leg.cabinCode.toLowerCase(),
                            item_category5: leg.segments.length > 1 ? 'Connected' : 'Direct',
                            hour_until_flight: ((segment.departureDateTime - Date.now()) / 1000 / 3600) | 0,
                            cd_item_flight_destination: segment.destinationAirport.code,
                            cd_item_flight_destination_city: segment.destinationAirport.city.code,
                            cd_item_flight_destination_country: segment.destinationAirport.country.code,
                            cd_item_flight_origin: segment.originAirport.code,
                            cd_item_flight_origin_city: segment.originAirport.city.code,
                            cd_item_flight_origin_country: segment.originAirport.country.code,
                            cd_item_flight_date: segment.departureDateTimeISO.dateLocal,
                            cm_item_flight_duration: segment.flightDuration ? segment.flightDuration / 1000 / 60 : 0
                        }

                        events.push(eventParameters)
                    })
                })
            })

            events.forEach(function(event) {
                pushDataToDataLayer(event, false, true);
            })
        }

        function pushCheckinAdditionalServicesViewItemList(flightData, cardData) {
            var checkinPassengerData = storageHelper.getItem({ key: 'checkinPassengerData', webStorageType: storageHelper.Stores.SESSION_STORAGE });
            
            if (!checkinPassengerData) {
                return;
            }

            checkinPassengerData = JSON.parse(checkinPassengerData)

            var firstLeg = flightData[0];
            var gaItems = [];

            var eventScope = {
                item_list_name: "Checkin",
                page_type: "oci additional services listing",
                item_id: firstLeg.originAirport.code + '-' + firstLeg.destinationAirport.code,
                item_brand: getItemBrand(firstLeg.airlinesBySegment),
                cd_item_flight_destination: firstLeg.destinationAirport.code,
                cd_item_flight_destination_city: firstLeg.destinationAirport.city.code,
                cd_item_flight_destination_country: firstLeg.destinationAirport.country.code,
                cd_item_flight_origin: firstLeg.originAirport.code,
                cd_item_flight_origin_city: firstLeg.originAirport.city.code,
                cd_item_flight_origin_country: firstLeg.originAirport.country.code,
                cd_passenger_count: checkinPassengerData.totalPassenger.toString() || '',
                cm_passenger_count: checkinPassengerData.totalPassenger || 0,
                cd_chk_passenger: checkinPassengerData.passengerLengthSelectedForCheckin.toString(),
                cm_chk_passenger: checkinPassengerData.passengerLengthSelectedForCheckin,
                cd_item_codeshare: getCodeShare(firstLeg) || 'none',
                cd_item_spa: getSpa(firstLeg) || 'none',
                cd_item_flight_date: firstLeg.segments[0].departureDateTimeISO.dateLocal,
                item_category: getRouteTypeBySegment(firstLeg),
                item_category4: firstLeg.cabinCode === 'Y' ? 'economy' : firstLeg.cabinCode === 'C' ? 'business' : firstLeg.cabinCode.toLowerCase(),
                item_category5: firstLeg.segments.length > 1 ? 'Connected' : 'Direct',
                cd_stopover_type: 'none',
            }

            cardData.forEach(function(card) {
                var asType = getASType(card.key());
                var item = {
                    item_id: firstLeg.originAirport.code + '-' + firstLeg.destinationAirport.code,
                    item_name: firstLeg.originAirport.code + '-' + firstLeg.destinationAirport.code,
                    item_category: getRouteTypeBySegment(firstLeg),
                    item_category4: firstLeg.cabinCode === 'Y' ? 'economy' : firstLeg.cabinCode === 'C' ? 'business' : firstLeg.cabinCode.toLowerCase(),
                    price: 0.0,
                    quantity: checkinPassengerData.passengerLengthSelectedForCheckin,
                    item_list_name: 'Checkin',
                    cd_item_type: asType,
                    cm_item_passenger_number: firstLeg.passengers.length || 0,
                    cd_item_flight_date: firstLeg.segments[0].departureDateTimeISO.dateLocal,
                }

                gaItems.push(item);
            })

            eventScope['items'] = gaItems;
            pushEcommerceData({ event: 'view_item_list', ecommerce: eventScope })
        }

        function pushCheckinAdditionalServicesSelectItemData(flightData, selectedCardKey) {
            try {
                var checkinPassengerData = storageHelper.getItem({ key: 'checkinPassengerData', webStorageType: storageHelper.Stores.SESSION_STORAGE });
            
                if (!checkinPassengerData) {
                    return;
                }
    
                checkinPassengerData = JSON.parse(checkinPassengerData)
    
                var keysToPushEvent = ['SPORTS_EQUIPMENT', 'LOUNGE', 'EXCESS_BAGGAGE'];

                if (!keysToPushEvent.includes(selectedCardKey)) return;

                var leg = flightData[0];
                var itemType = getASType(selectedCardKey);

                var eventScope = {
                    item_list_name: "Checkin",
                    page_type: "oci additional services listing",
                    item_id: leg.originAirport.code + '-' + leg.destinationAirport.code,
                    item_brand: getItemBrand(leg.airlinesBySegment),
                    cd_item_flight_destination: leg.destinationAirport.code,
                    cd_item_flight_destination_city: leg.destinationAirport.city.code,
                    cd_item_flight_destination_country: leg.destinationAirport.country.code,
                    cd_item_flight_origin: leg.originAirport.code,
                    cd_item_flight_origin_city: leg.originAirport.city.code,
                    cd_item_flight_origin_country: leg.originAirport.country.code,
                    cd_passenger_count: checkinPassengerData.totalPassenger.toString() || '',
                    cm_passenger_count: checkinPassengerData.totalPassenger || 0,
                    cd_chk_passenger: checkinPassengerData.passengerLengthSelectedForCheckin.toString() || '',
                    cm_chk_passenger: checkinPassengerData.passengerLengthSelectedForCheckin || 0,
                    cd_item_codeshare: getCodeShare(leg) || 'none',
                    cd_item_spa: getSpa(leg) || 'none',
                    cd_item_flight_date: leg.segments[0].departureDateTimeISO.dateLocal,
                    item_category: getRouteTypeBySegment(leg),
                    item_category4: leg.cabinCode === 'Y' ? 'economy' : leg.cabinCode === 'C' ? 'business' : leg.cabinCode.toLowerCase(),
                    item_category5: leg.segments.length > 1 ? 'Connected' : 'Direct',
                    cd_stopover_type: 'none'
                };

                var items = [];
                flightData.forEach(function(legData) {
                    items.push({
                        item_id: legData.originAirport.code + '-' + legData.destinationAirport.code,
                        item_name: legData.originAirport.code + '-' + legData.destinationAirport.code,
                        item_category: getRouteTypeBySegment(legData),
                        item_category4: legData.cabinCode === 'Y' ? 'economy' : legData.cabinCode === 'C' ? 'business' : legData.cabinCode.toLowerCase(),
                        price: 0,    
                        quantity: checkinPassengerData.passengerLengthSelectedForCheckin,
                        item_list_name: 'Checkin',
                        cd_item_type: itemType,
                        cm_item_passenger_number: legData.passengers.length || 0,
                        cd_item_flight_date: legData.segments[0].departureDateTimeISO.dateLocal,
                    })
                })
                
                eventScope['items'] = items;
        
                pushEcommerceData({ event: 'select_item', ecommerce: eventScope })    
            } catch (error) {
                console.info(error)
            }
        }

        function pushCheckinAdditionalServicesViewItemData(flightData, type) {
            var checkinPassengerData = storageHelper.getItem({ key: 'checkinPassengerData', webStorageType: storageHelper.Stores.SESSION_STORAGE });
            
            if (!checkinPassengerData) {
                return;
            }

            checkinPassengerData = JSON.parse(checkinPassengerData)

            var firstLeg = flightData[0];

            var eventParameters = {
                    currency: EURCurrency,
                    value: 0.0,
                    item_list_name: "Checkin",
                    page_type: "oci additional services detail",
                    cd_item_flight_destination: firstLeg.destinationAirport.code,
                    cd_item_flight_destination_city: firstLeg.destinationAirport.city.code,
                    cd_item_flight_destination_country: firstLeg.destinationAirport.country.code,
                    cd_item_flight_origin: firstLeg.originAirport.code,
                    cd_item_flight_origin_city: firstLeg.originAirport.city.code,
                    cd_item_flight_origin_country: firstLeg.originAirport.country.code,
                    cd_passenger_count: checkinPassengerData.totalPassenger.toString() || '',
                    cm_passenger_count: checkinPassengerData.totalPassenger || 0,
                    cd_chk_passenger: checkinPassengerData.passengerLengthSelectedForCheckin.toString(),
                    cm_chk_passenger: checkinPassengerData.passengerLengthSelectedForCheckin,
                    cd_item_codeshare: getCodeShare(firstLeg) || 'none',
                    cd_item_spa: getSpa(firstLeg) || 'none',    
                    cd_item_flight_date: firstLeg.segments[0].departureDateTimeISO.dateLocal,
                    item_id: firstLeg.originAirport.code + '-' + firstLeg.destinationAirport.code,
                    item_brand: getItemBrand(firstLeg.airlinesBySegment),
                    item_category: getRouteTypeBySegment(firstLeg),
                    item_category4: firstLeg.cabinCode === 'Y' ? 'economy' : firstLeg.cabinCode === 'C' ? 'business' : firstLeg.cabinCode.toLowerCase(),
                    item_category5: firstLeg.segments.length > 1 ? 'Connected' : 'Direct',
                    cd_stopover_type: 'none',    
            }

            var items = [];
            flightData.forEach(function(leg) {
                items.push({
                    item_id: leg.originAirport.code + '-' + leg.destinationAirport.code,
                    item_name: leg.originAirport.code + '-' + leg.destinationAirport.code,
                    item_category: getRouteTypeBySegment(leg),
                    item_category4: leg.cabinCode === 'Y' ? 'economy' : leg.cabinCode === 'C' ? 'business' : leg.cabinCode.toLowerCase(),
                    price: 0.0,
                    quantity: checkinPassengerData.passengerLengthSelectedForCheckin,
                    item_list_name: 'Checkin',
                    cd_item_type: type,
                    cm_item_passenger_number: checkinPassengerData.totalPassenger,
                    cd_item_flight_date: leg.segments[0].departureDateTimeISO.dateLocal,
                })
            })

            eventParameters['items'] = items;

            pushEcommerceData({ event: 'view_item', ecommerce: eventParameters })
        }

        function pushCheckinAdditionalServicesAddToCartData(flightData, asData, type) {
            var checkinPassengerData = storageHelper.getItem({ key: 'checkinPassengerData', webStorageType: storageHelper.Stores.SESSION_STORAGE });
            
            if (!checkinPassengerData) {
                return;
            }

            checkinPassengerData = JSON.parse(checkinPassengerData)
        
            var leg = flightData[0];
            var baseCurrency = asData.flights[0].currency;
        
            function getEventScope(value) {
                return { 
                    currency: EURCurrency,
                    value: value,
                    item_list_name: 'Checkin',
                    page_type: 'oci additional services detail',
                    item_id: leg.originAirport.code + '-' + leg.destinationAirport.code,
                    item_brand: getItemBrand(leg.airlinesBySegment),
                    cd_item_flight_destination: leg.destinationAirport.code,
                    cd_item_flight_destination_city: leg.destinationAirport.city.code,
                    cd_item_flight_destination_country: leg.destinationAirport.country.code,
                    cd_item_flight_origin: leg.originAirport.code,
                    cd_item_flight_origin_city: leg.originAirport.city.code,
                    cd_item_flight_origin_country: leg.originAirport.country.code,
                    cd_passenger_count: checkinPassengerData.totalPassenger.toString() || '',
                    cm_passenger_count: checkinPassengerData.totalPassenger || 0,
                    cd_chk_passenger: checkinPassengerData.passengerLengthSelectedForCheckin.toString() || '',
                    cm_chk_passenger: checkinPassengerData.passengerLengthSelectedForCheckin || 0,
                    cd_item_codeshare: getCodeShare(leg) || 'none',
                    cd_item_spa: getSpa(leg) || 'none',
                    cd_item_flight_date: leg.segments[0].departureDateTimeISO.dateLocal,
                    item_category: getRouteTypeBySegment(leg),
                    item_category4: leg.cabinCode === 'Y' ? 'economy' : leg.cabinCode === 'C' ? 'business' : leg.cabinCode.toLowerCase(),
                    item_category5: leg.segments.length > 1 ? 'Connected' : 'Direct',
                    cd_stopover_type: 'none',
                    items: [],
                }
            }
        
            var convertedTotal = calculateConvertedAmount(hasTargetConversionRate(baseCurrency, EURCurrency), currencyConversionRates[EURCurrency], asData.selectedGrandTotalFare)
            var eventScope = getEventScope(convertedTotal);
            flightData.forEach(function(leg, index) {
                var groupedItems = [];
                if (type === 'Lounge') {
                    groupedItems = loungeGroupByLegAndType(asData);
                } else {
                    groupedItems = itemGroupByTypes(asData, type)
                }
        
                Object.values(groupedItems).forEach(function(item) {
                    if (item[0].legIndex !== index) return;
        
                    var gaItem = {
                        item_id: leg.originAirport.code + '-' + leg.destinationAirport.code,
                        item_name: leg.originAirport.code + '-' + leg.destinationAirport.code,
                        affiliation: 'Web',
                        item_category: getRouteTypeBySegment(leg),
                        item_category4: leg.cabinCode === 'Y' ? 'economy' : leg.cabinCode === 'C' ? 'business' : leg.cabinCode.toLowerCase(),
                        item_list_name: 'Checkin',
                        cd_item_type: type,
                        cm_item_passenger_number: checkinPassengerData.totalPassenger,
                        cd_item_flight_date: leg.segments[0].departureDateTimeISO.dateLocal,
                    }
        
                    createCartItemDetails(gaItem, item, type);
                    var divisor = type === 'Excess Baggage' ? gaItem.quantity : item.length;
                    var price = item.reduce(function(total, subItem) {
                        return total + subItem.price;
                    }, 0) / divisor;
                    
                    var convertedPrice = calculateConvertedAmount(hasTargetConversionRate(baseCurrency, EURCurrency), currencyConversionRates[EURCurrency], price)
        
                    gaItem["price"] = convertedPrice;
                    eventScope['items'].push(gaItem);
                })
            })
        
            if (eventScope.items.length) {
                pushEcommerceData({ event: 'add_to_cart', ecommerce: eventScope })
            }
        }
        /* Check-in Additional Services */

        /* Check-in Payment */
        function pushCheckinAddPaymentInfoData(flightData, selectedServices, paymentType) {
            var checkinPassengerData = storageHelper.getItem({ key: 'checkinPassengerData', webStorageType: storageHelper.Stores.SESSION_STORAGE });
            var selectedSeatsGA4Data = storageHelper.getItem({ key: "selectedSeatsGA4Data", webStorageType: storageHelper.Stores.SESSION_STORAGE })
            
            if (!checkinPassengerData || !selectedSeatsGA4Data) {
                return;
            }

            checkinPassengerData = JSON.parse(checkinPassengerData)
            selectedSeatsGA4Data = JSON.parse(selectedSeatsGA4Data);

            selectedServices['SEAT_SELECTION'] = selectedSeatsGA4Data;
            
            var selectedServicesGA4Data = getSelectedServicesGA4Data(flightData, selectedServices, 'leg', 'add_shipping_info');

            var value = 0;
            var gaItems = [];
            selectedServicesGA4Data.forEach(function(service) {
                Object.values(service.data).forEach(function(item) {
                    gaItems.push(item);
                    value = value + (item.price * item.quantity)
                })
            })

            var firstLeg = flightData[0];
            var eventScope = {
                currency: EURCurrency,
                shipping: 0.00,
                shipping_tier: '', 
                payment_type: paymentType,
                value: value,
                item_list_name: "Checkin",
                cd_item_contents: "additional services",
                page_type: "oci payment",
                item_id: firstLeg.originAirport.code + '-' + firstLeg.destinationAirport.code,
                item_brand: getItemBrand(firstLeg.airlinesBySegment),
                cd_item_flight_destination: firstLeg.destinationAirport.code,
                cd_item_flight_destination_city: firstLeg.destinationAirport.city.code,
                cd_item_flight_destination_country: firstLeg.destinationAirport.country.code,
                cd_item_flight_origin: firstLeg.originAirport.code,
                cd_item_flight_origin_city: firstLeg.originAirport.city.code,
                cd_item_flight_origin_country: firstLeg.originAirport.country.code,
                cd_passenger_count: checkinPassengerData.totalPassenger.toString() || '',
                cm_passenger_count: checkinPassengerData.totalPassenger || 0,
                cd_chk_passenger: checkinPassengerData.passengerLengthSelectedForCheckin.toString(),
                cm_chk_passenger: checkinPassengerData.passengerLengthSelectedForCheckin,
                cd_item_codeshare: getCodeShare(firstLeg) || 'none',
                cd_item_spa: getSpa(firstLeg) || 'none',    
                cd_item_flight_date: firstLeg.segments[0].departureDateTimeISO.dateLocal,
                item_category: getRouteTypeBySegment(firstLeg),
                item_category4: firstLeg.cabinCode === 'Y' ? 'economy' : firstLeg.cabinCode === 'C' ? 'business' : firstLeg.cabinCode.toLowerCase(),
                item_category5: firstLeg.segments.length > 1 ? 'Connected' : 'Direct',
                cd_stopover_type: 'none',
            }

            eventScope['items'] = gaItems;

            pushEcommerceData({ event: "add_payment_info", ecommerce: eventScope });
        }

        /* Check-in Payment */
        function pushCurrencyChangeButtonClickEvent() {
            try {
                pushDataToDataLayer({event: 'button_click', cId: JSON.parse(storageHelper.getItem({ key: "X-conversationId", webStorageType: storageHelper.Stores.SESSION_STORAGE })), cd_button_name: "currency_change", page_type: 'payment', udevId: getUdevId()}, false, true)
            } catch (e) {
                console.log(e)
            }
        }

        function pushTkWalletTransactionPopupData(eventName, checkedStatus) {
            if (!eventName) return;
    
            var gaEventData = storageHelper.getItem({ key: "gaEventData", webStorageType: storageHelper.Stores.LOCAL_STORAGE });

            if (!gaEventData) return;
            
            try {
                gaEventData = JSON.parse(gaEventData);                
            } catch (error) {
                console.error('Invalid JSON string: ', gaEventData);
                return;
            }

            var eventData = {
                event: eventName,
                item_list_name: gaEventData['item_list_name'],
                cd_item_flight_destination: gaEventData['cd_item_flight_destination'],
                cd_item_flight_destination_city: gaEventData['cd_item_flight_destination_city'],
                cd_item_flight_destination_country: gaEventData['cd_item_flight_destination_country'],
                cd_item_flight_origin: gaEventData['cd_item_flight_origin'],
                cd_item_flight_origin_city: gaEventData['cd_item_flight_origin_city'],
                cd_item_flight_origin_country: gaEventData['cd_item_flight_origin_country'],
                item_category: gaEventData['item_category'],
                item_category2: gaEventData['item_category2'],
                item_category3: gaEventData['item_category3'],
                item_category4: gaEventData['item_category4'],
                item_category5: gaEventData['item_category5'],
            };

            if (eventName === 'tkwallet_transaction_popup_selected' && checkedStatus) {
                eventData['cd_event_category'] = checkedStatus.commercial ? 'Yes' : 'No';
                eventData['cd_event_category2'] = checkedStatus.wallet ? 'Yes' : 'No';
            }

            pushDataToDataLayer(eventData, false, true);
        }

        var currencyConversionRates = null;
        var gaConvertList = ['IRR', 'IDR', 'UZS'];

        function fetchCurrencyConversionRates(sourceCurrency, afterComplete) {
            currencyConversionRates = JSON.parse(localStorage.getItem("currencyConversionRates"));
            if (!currencyConversionRates
                || (currencyConversionRates.timeout && currencyConversionRates.timeout < Date.now())
                || (currencyConversionRates.sourceCurrency && currencyConversionRates.sourceCurrency !== sourceCurrency)) {
                etrAjax.post({
                    app: 'app.ibs',
                    service: '/booking/currencyRateList',
                    disableLoader: true,
                    data: {
                        'sourceCurrency': sourceCurrency,
                        'targetCurrencies': ['usd', 'eur','try']
                    },
                    callback: function (response) {
                        if (response.type === 'SUCCESS' && response.data) {
                            var rates = {};
                            for (var index = 0; index < response.data.length; index++) {
                                rates[response.data[index].pair.counter.code] = response.data[index].rate;
                            }
                            var cache = {
                                sourceCurrency: sourceCurrency,
                                USD: rates['usd'],
                                EUR: rates['eur'],
                                TRY: rates['try'],
                                timeout: Date.now() + (1000 * 60 * 60)
                            };
                            localStorage.setItem("currencyConversionRates", JSON.stringify(cache));
                            currencyConversionRates = cache;
                        }
                    },
                    preErrorProperties: {
                        preErrorFunction : function() {
                            localStorage.setItem("currencyConversionRates", null);
                            currencyConversionRates = null;
                        }
                    },
                    complete: afterComplete,
                    disableErrorHandling: true
                });
            }
        }

        function hasTargetConversionRate(sourceCurrency, targetCurrency) {
            if (!currencyConversionRates) {
                currencyConversionRates = JSON.parse(localStorage.getItem("currencyConversionRates"));
            }
            return currencyConversionRates && currencyConversionRates.sourceCurrency === sourceCurrency && currencyConversionRates[targetCurrency];
        }

        function gaConversionNeeded(sourceCurrency) {
            return gaConvertList.some(function (currency) {
                return currency === sourceCurrency;
            });
        }

        function gaConvertPrice(sourceCurrency, amount) {
            if (hasTargetConversionRate(sourceCurrency, gaTargetCurrency)) {
                return currencyConversionRates[gaTargetCurrency] * amount;
            } else if(gaConversionNeeded(sourceCurrency)){
                return 0;
            } else {
                return amount;
            }
        }

        /**
         * Creates event data for all events which will be sent to Google Tag Manager
         * @param {object} flight the first element in the flight list array
         * @param {object} pushFlightData the first pushed flight data in the pushFlightDataList
         * @param {object} [pushDataArray] all flight data will be pushed to dataLayer if not passed pushFlightData is used
         * @param {object} [paxTypeAndCount] passenger types and counts if not passed local variables are used
         */
        function createEventData(flight, pushFlightData, pushDataArray, paxTypeAndCount,preSendFlights) {
            var hasPushDataArray = pushDataArray && pushDataArray.length > 0;

            return {
                cId: JSON.parse(storageHelper.getItem({ key: "X-conversationId", webStorageType: storageHelper.Stores.SESSION_STORAGE })),
                item_list_id: pushFlightData.item_list_id,
                item_list_name: "Availability",
                cd_sort_type: getFlightSortOrder(flight),
                cd_item_flight_destination: flight.destinationAirport.code,
                cd_item_flight_destination_city: flight.destinationAirport.city.code,
                cd_item_flight_destination_country: flight.destinationAirport.country.code,
                cd_item_flight_origin: flight.originAirport.code,
                cd_item_flight_origin_city: flight.originAirport.city.code,
                cd_item_flight_origin_country: flight.originAirport.country.code,
                cd_passenger_count: passengerCountParamater(totalPassengersCount,paxTypeAndCount),
                cm_passenger_count: Number(passengerCountParamater(totalPassengersCount,paxTypeAndCount)),
                cd_item_passenger_adult: paxTypeAndCount && paxTypeAndCount.ADULT ? paxTypeAndCount.ADULT.toString() : adultCount.toString(),
                cd_item_passenger_infant: paxTypeAndCount && paxTypeAndCount.INFANT ? paxTypeAndCount.INFANT.toString() : infantCount.toString(),
                cd_item_passenger_child: paxTypeAndCount && paxTypeAndCount.CHILD ? paxTypeAndCount.CHILD.toString() : childCount.toString(),
                cd_item_passenger_student: paxTypeAndCount && paxTypeAndCount.STUDENT ? paxTypeAndCount.STUDENT.toString() : studentCount.toString(),
                cd_item_passenger_veteran: paxTypeAndCount && paxTypeAndCount.VETERAN ? paxTypeAndCount.VETERAN.toString() : veteranCount.toString(),
                cd_item_passenger_disabled: paxTypeAndCount && paxTypeAndCount.DISABLED ? paxTypeAndCount.DISABLED.toString() : disabledCount.toString(),
                cd_item_passenger_soldier: paxTypeAndCount && paxTypeAndCount.SOLDIER ? paxTypeAndCount.SOLDIER.toString() : soldierCount.toString(),
                cd_item_passenger_senior: paxTypeAndCount && paxTypeAndCount.SENIOR ? paxTypeAndCount.SENIOR.toString() : seniorCount.toString(),
                cd_item_passenger_teacher: paxTypeAndCount && paxTypeAndCount.TEACHER ? paxTypeAndCount.TEACHER.toString() : teacherCount.toString(),
                cm_item_passenger_adult: paxTypeAndCount && paxTypeAndCount.ADULT ? paxTypeAndCount.ADULT : adultCount,
                cm_item_passenger_infant: paxTypeAndCount && paxTypeAndCount.INFANT ? paxTypeAndCount.INFANT : infantCount,
                cm_item_passenger_child: paxTypeAndCount && paxTypeAndCount.CHILD ? paxTypeAndCount.CHILD : childCount,
                cm_item_passenger_student: paxTypeAndCount && paxTypeAndCount.STUDENT ? paxTypeAndCount.STUDENT : studentCount,
                cm_item_passenger_veteran: paxTypeAndCount && paxTypeAndCount.VETERAN ? paxTypeAndCount.VETERAN : veteranCount,
                cm_item_passenger_disabled: paxTypeAndCount && paxTypeAndCount.DISABLED ? paxTypeAndCount.DISABLED : disabledCount,
                cm_item_passenger_soldier: paxTypeAndCount && paxTypeAndCount.SOLDIER ? paxTypeAndCount.SOLDIER : soldierCount,
                cm_item_passenger_senior: paxTypeAndCount && paxTypeAndCount.SENIOR ? paxTypeAndCount.SENIOR : seniorCount,
                cm_item_passenger_teacher: paxTypeAndCount && paxTypeAndCount.TEACHER ? paxTypeAndCount.TEACHER : teacherCount,
                cd_item_listing_type: storageHelper.getItem({ key: "listing", webStorageType: storageHelper.Stores.SESSION_STORAGE }) || '',
                cd_item_codeshare: (hasPushDataArray ? createPipeForMultipleValues(pushDataArray, 'cd_item_codeshare', 'none') : pushFlightData.cd_item_codeshare) || "none",
                cd_item_spa: (hasPushDataArray ? createPipeForMultipleValues(pushDataArray, 'cd_item_spa', 'none') : pushFlightData.cd_item_spa) || "none",
                cd_item_flight_date: pushFlightData.cd_item_flight_date,
                cd_item_search_date: pushFlightData.cd_item_search_date,
                item_id: pushFlightData.item_id,
                item_category: pushFlightData.item_category,
                item_category2: hasPushDataArray ? decideItemForEventData(pushDataArray, 'item_category2') : pushFlightData.item_category2,
                item_category3: pushFlightData.item_category3,
                item_category4: hasPushDataArray ? decideItemForEventData(pushDataArray, 'item_category4') : pushFlightData.item_category4,
                item_category5: pushFlightData.item_category5,
                cd_stopover_type : hasPushDataArray ? stopoverEventScope(pushDataArray) : stopOverParam(flight),
                item_brand :hasPushDataArray ?  getEventScopeItemBrand(pushDataArray) : (underscore.uniq((pushFlightData.item_brand).split("|"))).join("|")
            };
        }

        function passengerCountParamater(totalPassengerCount, paxTypeAndCount){
            return totalPassengersCount ? totalPassengersCount.toString() : paxTypeAndCount ? totalPassengerPaxType(paxTypeAndCount).toString() : totalPassengerCountUniversal(
                adultCount,
                infantCount,
                childCount,
                studentCount,
                veteranCount,
                disabledCount,
                soldierCount,
                seniorCount,
                teacherCount).toString()
        }

        function getCategory3Data(item_category3Value, isMulticity, tripType, mFlightSearchData){
            if(item_category3Value === "STOPOVER"){
                return routeSymetric(mFlightSearchData.flightRoute);
            }
            if(isMulticity) {
                return "MultiCity";
            }
            var result = item_category3Value ? item_category3Value : tripType;
            if (result.includes("_")) {
                return result.split("_").map(function (word) {
                    return word[0].toUpperCase() + word.substring(1, word.length).toLowerCase();
                }).join("");
            }
            return result;
        }

        function getItemListId (multiCheck, mFlightSearchData){

            if(multiCheck){
                return "multicity";
            }
            if(mFlightSearchData && mFlightSearchData.bookerSearchType){
                return mFlightSearchData.bookerSearchType.replace("_","").toLowerCase();
            }
            return "";
        }

        function routeSymetric(fullRoute){
            var firstPartDestination = fullRoute.substring(0,fullRoute.indexOf(",")).substring(0,fullRoute.indexOf("-"));
            var firstPartArrival = fullRoute.substring(0,fullRoute.indexOf(",")).substring(fullRoute.indexOf("-") + 1, fullRoute.length);
            var secondPartDestination = fullRoute.substring(fullRoute.indexOf(",") + 1,fullRoute.length).substring(0,fullRoute.indexOf("-"));
            var secondPartArrival = fullRoute.substring(fullRoute.indexOf(",") + 1,fullRoute.length).substring(fullRoute.indexOf("-")+1,fullRoute.length);


            return (firstPartDestination === secondPartArrival && firstPartArrival === secondPartDestination) ? "RoundTrip" : "MultiCity";
        }

        function totalPassengerPaxType(paxTypeAndCount){
            var fields = ["ADULT", "INFANT", "CHILD", "STUDENT", "VETERAN", "DISABLED", "SOLDIER", "SENIOR", "TEACHER"];
            var total = 0;
            fields.forEach(function(field) {
                total += paxTypeAndCount[field] || 0;
            });
            return total;
        }

        function totalPassengerCountUniversal(adultCount, infantCount, childCount, studentCount, veteranCount, disabledCount, soldierCount, seniorCount, teacherCount){
            return (adultCount || 0) +
                (infantCount || 0) +
                (childCount || 0) +
                (studentCount || 0) +
                (veteranCount || 0) +
                (disabledCount || 0) +
                (soldierCount || 0) +
                (seniorCount || 0) +
                (teacherCount || 0) ;
        }

        function stopoverEventScope(array){

            try {
                var stopoverFlow = JSON.parse(storageHelper.getItem({ key: "stopover_param", webStorageType: storageHelper.Stores.SESSION_STORAGE }));
                var stopoverFlowLegs = stopoverFlow ? stopoverFlow.split("_") : "";
                var stopoverFlowLeg = stopoverFlowLegs[0]
                var stopoverFlowDay = stopoverFlowLegs[1];

                if(stopoverFlow) {
                   if (array[0].cd_leg_order === "1"){
                       // departure
                       return stopoverFlowLeg === "1" ? "none" : "stopover_departure_".concat(stopoverFlowDay);
                   }
                   if(array[0].cd_leg_order === "2"){
                       // return
                       return stopoverFlowLeg === "0" ? "none" : "stopover_return_".concat(stopoverFlowDay);
                   }
                }
                var stopOverArray = underscore.filter(array, function (item) {
                    return item.cd_stopover_type !== "none";
                }).map(function (item) {
                    return item.cd_stopover_type;
                });

                if (stopOverArray.length === 0) {
                    return "none";
                }

                var hasTourIstanbul = underscore.some(stopOverArray, function (item) {
                    return item.includes('tour_istanbul');
                });
                var sortedArray = underscore.sortBy(stopOverArray, function (item) {
                    return item.match(/(\d+)/)[0];
                });
                sortedArray = underscore.map(sortedArray, function (item) {
                    var index = item.indexOf("|");
                    if (index > 0) {
                        return item.substring(0, index);
                    }
                    return item;
                });
                var stopover = underscore.unique(sortedArray).join("|");

                return hasTourIstanbul ? stopover + "|tour_istanbul" : stopover;
            }
            catch(e){
                pushServiceError(e);
            }

        }


        function stopOverParam(flight){
            try {
                var legType = firstFlightSelected === false ? "departure" : "return";
                var stopOver = "";
                var tourIstanbulFlag = false;
                var stopOverFlag = false;
                var stopoverFlow = JSON.parse(storageHelper.getItem({ key: "stopover_param", webStorageType: storageHelper.Stores.SESSION_STORAGE }));
                var stopoverFlowLeg = stopoverFlow ? stopoverFlow.split("_")[0] : "";
                var stopoverFlowDay = stopoverFlow ? stopoverFlow.split("_")[1] : "";

                if(stopoverFlow){
                    if (flight.routeIndex === 0){
                        // departure
                        return stopoverFlowLeg === "1" ? "none" : "stopover_departure_" + stopoverFlowDay;
                    }
                    if(flight.routeIndex === 1){
                        // return
                        return stopoverFlowLeg === "0" ? "none" : "stopover_return_" + stopoverFlowDay;
                    }
                }
                else{
                    if (legType === "departure") {
                        if (flight.hasAnyStopOverHotel === true) {
                            stopOver = "stopover_departure_" + "1";
                            stopOverFlag = true;
                        }
                        if (flight.hasAnyTourIstanbul) {
                            tourIstanbulFlag = true;
                        }
                    } else {
                        if (flight.hasAnyStopOverHotel === true) {
                            stopOver = "stopover_return_" + "1";
                            stopOverFlag = true;
                        }
                        if (flight.hasAnyTourIstanbul) {
                            tourIstanbulFlag = true;
                        }
                    }
                }
                if (stopOverFlag === false) {
                    return "none";
                }
                if (tourIstanbulFlag === true) {
                    stopOver = stopOver + "|tour_istanbul";
                    return stopOver;
                } else {
                    return stopOver;
                }
            }catch (e){
                pushServiceError(e);
            }
        }

        function createPipeForMultipleValues(pushDataArray, selector, eliminateCase) {
            var arr = [];
            for (var i = 0; i < pushDataArray.length; i++) {
                if (pushDataArray[i][selector] && pushDataArray[i][selector] !== eliminateCase) {
                    arr.push(pushDataArray[i][selector]);
                }
            }
            if (arr.length === 1 && arr[0] === 'none') {
                return 'none'
            }
            var values = underscore.map(arr, function (n) {
                return n.split("|")
            })
            values = underscore.flatten(values, true)
            values = underscore.uniq(values)
            if (values.length === 0) {
                return 'none'
            }
            return values.join("|")
        }

        function decideItemForEventData(pushDataArray, selector) {
            var previous = null
            for (var i = 0; i < pushDataArray.length; i++) {
                var curr = pushDataArray[i][selector]
                if (previous && curr !== previous) {
                    return 'mixed';
                } else {
                    previous = curr;
                }
            }
            return previous;
        }

        function decideSortOrderForEventData(selectedFlights) {
            sortOrders = sortOrders || JSON.parse(storageHelper.getItem({ key: "flightSortOrders", webStorageType: storageHelper.Stores.SESSION_STORAGE })) || {};
            var arr = Array(selectedFlights.length);
            Object.entries(selectedFlights).forEach(function (entry) {
                var index = entry[0].lastIndexOf("-");
                if (index <= 0) {
                    index = entry[0].length;
                }
                var sortKey = entry[0].substring(0, index);
                var legOrder = Number(entry[1].cd_leg_order);
                if (isNaN(legOrder) || legOrder <= 0) {
                    return;
                }
                arr[legOrder - 1] = sortOrders[sortKey];
            })
            return underscore.uniq(arr).join("|");
        }


        function pushViewCartData(fareBreakdown) {
            try {
                if (viewCartSent) return;
                var selectedFlights = JSON.parse(storageHelper.getItem({ key: "cartFlightData", webStorageType: storageHelper.Stores.SESSION_STORAGE }));
                if (!selectedFlights) return;
                var keys = Object.keys(selectedFlights);
                if (keys.length === 0) return;
                var items = [];
                var firstFlight;
                for (var i = 0; i < keys.length; i++) {
                    var selectedFlight = selectedFlights[keys[i]];
                    if (selectedFlight["cd_leg_order"] === "1") {
                        firstFlight = selectedFlight;
                        selectedFlight['cm_item_full_price'] = gaConvertPrice(fareBreakdown.totalAmountConvertedPrices.ORIGINAL_PRICE.currency, fareBreakdown.totalAmountConvertedPrices.ORIGINAL_PRICE.amount);
                        selectedFlights[keys[i]] = selectedFlight;
                        storageHelper.setItem({
                            key: "cartFlightData",
                            value: JSON.stringify(selectedFlights),
                            webStorageType: storageHelper.Stores.SESSION_STORAGE
                        });
                    }
                    items.push(createItemData('ticket', selectedFlight, true));
                }

                var eventData = getGAEventDataCache();
                eventData['cd_sort_type'] = decideSortOrderForEventData(selectedFlights);
                eventData['item_category2'] = decideItemForEventData(items, 'item_category2');
                eventData['item_category4'] = decideItemForEventData(items, 'item_category4');
                eventData['cd_stopover_type'] = stopoverEventViewCart(items);
                eventData['cd_item_codeshare'] = createPipeForMultipleValues(items, 'cd_item_codeshare', 'none')
                eventData['cd_item_spa'] = createPipeForMultipleValues(items, 'cd_item_spa', 'none')

                var cartFlightCache = sessionStorageUtil.getPersistedData("cartFlightData");
                if (cartFlightCache) {
                    eventData['item_brand'] = getEventScopeItemBrand(cartFlightCache);
                }

                createGAEventDataCache(eventData);

                eventData['value'] = firstFlight['cm_item_full_price'];
                eventData['currency'] = hasTargetConversionRate(fareBreakdown.totalAmountConvertedPrices.ORIGINAL_PRICE.currency, gaTargetCurrency) ? gaTargetCurrency : fareBreakdown.totalAmountConvertedPrices.ORIGINAL_PRICE.currency;
                eventData['items'] = items;

                pushEcommerceData({event: "view_cart", ecommerce: eventData});
                viewCartSent = true;
            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushBeginCheckoutData() {
            try {
                if (beginCheckoutSent) return;
                var selectedFlights = JSON.parse(storageHelper.getItem({ key: "cartFlightData", webStorageType: storageHelper.Stores.SESSION_STORAGE }));
                if (!selectedFlights) return;
                var keys = Object.keys(selectedFlights);
                if (keys.length === 0) return;
                var items = [];
                var firstFlight;
                for (var i = 0; i < keys.length; i++) {
                    var selectedFlight = selectedFlights[keys[i]];
                    if (!firstFlight && selectedFlight["cd_leg_order"] === "1") {
                        firstFlight = selectedFlight;
                    }
                    items.push(createItemData('ticket', selectedFlight, true));
                }
                var eventData = getGAEventDataCache();
                eventData["value"] = firstFlight["cm_item_full_price"];
                eventData["currency"] = firstFlight.conversion[gaTargetCurrency] ? gaTargetCurrency : firstFlight.conversion.originCurrency;
                eventData["items"] = items;

                pushEcommerceData({event: "begin_checkout", ecommerce: eventData});
                beginCheckoutSent = true;
            } catch (e) {
                pushServiceError(e);
            }
        }

        function stopoverEventViewCart(items){
            if (!items || items.length === 0){
                return "none";
            }
            var stopoverTypes = underscore.filter(items, function (item){
                return item.cd_stopover_type !== "none";
            }).map(function(item){
                return item.cd_stopover_type.split("|");
            })
            stopoverTypes = underscore.flatten(stopoverTypes, true);
            var filteredTypes = stopoverTypes.filter(function(st){
                return st !== "tour_istanbul";
            });
            var cdStopOverType = filteredTypes.join("|");
            if(filteredTypes.length < stopoverTypes.length){
                cdStopOverType += "|tour_istanbul";
            }
            return cdStopOverType === "" ? "none" : cdStopOverType;
        }

        function getFlightTimeGroup(flights) {
            return flights.map(function(flight) {
                if (flight.flightInfo) flight = flight.flightInfo;
                var dayTimes = flight.segments.map(function(segment) {
                    var formattedDeparture = moment.utc(moment(segment.departureDateTime + segment.departureDateTimeTimeZoneRawOffset)).format('DD-MM-YYYY HH:mm');
                    var formattedArrival = moment.utc(moment(segment.arrivalDateTime + segment.arrivalDateTimeTimeZoneRawOffset)).format('DD-MM-YYYY HH:mm');
                    
                    var departure = formattedDeparture.split(' ')[1];
                    var arrival = formattedArrival.split(' ')[1];
    
                    return [departure, arrival].map(function(time) {
                        return getHourGroupDetails(time);
                    }).join('-');
                }).join('-');
              
                return dayTimes;
            }).join('|')
        }

        function getFlightLayoverDuration(flights) {
            return flights.map(function(flight) {
                if (flight.flightInfo) flight = flight.flightInfo;
                var layoverMinutes = [];

                for (var i = 0; i < flight.segments.length - 1; i++) {
                    var currentSegment = flight.segments[i];
                    var nextSegment = flight.segments[i + 1];

                    var formattedDeparture = moment.utc(moment(nextSegment.departureDateTime + nextSegment.departureDateTimeTimeZoneRawOffset)).format('DD-MM-YYYY HH:mm');
                    var formattedArrival = moment.utc(moment(currentSegment.arrivalDateTime + currentSegment.arrivalDateTimeTimeZoneRawOffset)).format('DD-MM-YYYY HH:mm');

                    var minutes = getMinutesBetween(formattedArrival, formattedDeparture);

                    if (minutes !== null && minutes !== undefined) {
                        layoverMinutes.push(minutes.toString());
                    }
                }

                return layoverMinutes.join('-') || 0;
            }).join('|')
        };

        function getHourGroupDetails(timeInput) {
            var hour;
          
            var time = timeInput.split(':').map(Number);
            
            hour = time[0] === 24 ? 0 : time[0];
            
            var group = '';
            
            if (hour >= 4 && hour < 8) group = 'early_morning';
            else if (hour >= 8 && hour < 12) group = 'morning';
            else if (hour >= 12 && hour < 16) group = 'noon';
            else if (hour >= 16 && hour < 20) group = 'evening';
            else if (hour >= 20 && hour <= 23) group = 'night';
            else group = 'late_night';
          
            return group;
        }

        function getMinutesBetween(datetime1, datetime2) {
            function parse(str) {
              var datetime = str.split(' ');
              var date = datetime[0].split('-').map(Number);
              var time = datetime[1].split(':').map(Number);
              
              return new Date(date[2], date[1] - 1, date[0], time[0], time[1]);
            };
          
            var date1 = parse(datetime1);
            var date2 = parse(datetime2);
          
            return Math.round((date2 - date1) / 60000);
        }

        // GA4 ADDITIONAL SERVICES START

        function createGAEventDataCache(eventData) {
            localStorage.setItem('gaEventData', JSON.stringify(eventData));
        }

        function getGAEventDataCache() {
            return JSON.parse(localStorage.getItem('gaEventData'));
        }

        function clearGAEventDataCache() {
            localStorage.removeItem('gaEventData');
        }

        var pageInfo;

        function pushASViewItemListData(cardArray) {
            try {
                var allCachedFlights = JSON.parse(storageHelper.getItem({ key: "cartFlightData", webStorageType: storageHelper.Stores.SESSION_STORAGE }));
                if (!allCachedFlights) return;
                var keys = Object.keys(allCachedFlights);
                var flights = underscore.map(keys, function (key) {
                    return allCachedFlights[key];
                });
                var aSTypes = underscore.map(cardArray, function (card) {
                    return getASType(card.key());
                });
                var items = [];
                for (var i = 0; i < flights.length; i++) {
                    flights[i]['price'] = 0;
                    for (var j = 0; j < aSTypes.length; j++) {
                        var currentASType = aSTypes[j];
                        if (currentASType === 'SAF' && flights[i].cd_leg_order !== "1") {
                          continue;
                        }
                        items.push(additionalServiceItemScope(currentASType, flights[i]));
                    }
                }

                var eventData = getGAEventDataCache();
                if (!eventData) return;
                eventData['page_type'] = 'additional services listing';
                eventData['items'] = items;
                eventData['udevId'] = getUdevId();
                pushEcommerceData({event: "view_item_list", ecommerce: eventData});
            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushManageBookingViewItemList(ancillaryDataHolder, cardArray) {
            try {
                var eventData = manageBookingEventScope(ancillaryDataHolder.selectedFlights, 'additional services listing', ancillaryDataHolder.tripType);
                var itemData = manageBookingItemScope(ancillaryDataHolder.selectedFlights, ancillaryDataHolder.tripType);
                var cardItems = [];
                underscore.forEach(cardArray, function (card) {
                    var itemType = getASType(card.key())
                    underscore.forEach(itemData, function (item) {
                        var additionalServiceItem = JSON.parse(JSON.stringify(item));
                        additionalServiceItem["cd_item_type"] = itemType;
                        cardItems.push(additionalServiceItem);
                    });
                });

                eventData['items'] = cardItems;
                pushEcommerceData({event: "view_item_list", ecommerce: eventData});
                fetchCurrencyConversionRates(ancillaryDataHolder.paymentCurrency,null);
            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushManageBookingSelectItem(additionalServiceData, selectedCard, pageType) {
            try {
                var eventData = manageBookingEventScope(additionalServiceData.selectedFlights, pageType, additionalServiceData.tripType);
                var itemData = manageBookingItemScope(additionalServiceData.selectedFlights, additionalServiceData.tripType);
                var itemType = getASType(selectedCard);
                underscore.forEach(itemData, function (item) {
                    item["cd_item_type"] = itemType;
                });

                eventData['items'] = itemData;
                pushEcommerceData({event: "select_item", ecommerce: eventData});
            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushManageBookingViewItem(additionalServiceData, itemType) {
            try {
                if(itemType === 'Seat Selection'){
                    var eventData = manageBookingEventScope(additionalServiceData.selectedFlights, 'additional services detail', additionalServiceData.tripType);
                }else{
                    var eventData = manageBookingEventScope(additionalServiceData.selectedFlights, 'additional services listing', additionalServiceData.tripType);
                }
                var itemData = manageBookingItemScope(additionalServiceData.selectedFlights, additionalServiceData.tripType);
                underscore.forEach(itemData, function (item) {
                    item["cd_item_type"] = itemType;
                });
                eventData['items'] = itemData;
                eventData['value'] = 0;
                eventData['currency'] = gaTargetCurrency;
                pushEcommerceData({event: "view_item", ecommerce: eventData});
                fetchCurrencyConversionRates(additionalServiceData.paymentCurrency,null);
            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushManageBookingAddToCart(additionalServiceData, serviceTypeData, itemType) {
            try {
                removePreviousAdditionalServiceItems(itemType);
                if(!serviceTypeData || serviceTypeData.selectedGrandTotalFare === 0) {
                    return;
                }
                var eventData = manageBookingEventScope(additionalServiceData.selectedFlights, 'additional services detail', additionalServiceData.tripType);
                var itemData = manageBookingItemScope(additionalServiceData.selectedFlights, additionalServiceData.tripType);
                switch (itemType) {
                    case 'Extra Baggage':
                        pushManageBookingExcessBaggageAddToCart(serviceTypeData, eventData, itemData);
                        break;
                    case 'Sports Equipment':
                        pushManageBookingSportsEquipmentAddToCart(serviceTypeData, eventData, itemData);
                        break;
                    case 'Pet':
                        pushManageBookingPetAddToCart(serviceTypeData, eventData, itemData);
                        break;
                    case 'Lounge':
                        pushManageBookingLoungeAddToCart(serviceTypeData, eventData, itemData);
                        break;
                    default:
                        return;
                }
            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushManageBookingAddShippingInfo(additionalServiceData, serviceBasketData) {
            try {
                if(!serviceBasketData) {
                    return;
                }
                var eventData = manageBookingEventScope(additionalServiceData.selectedFlights, 'additional services listing', additionalServiceData.tripType);
                var itemData = manageBookingItemScope(additionalServiceData.selectedFlights, additionalServiceData.tripType);
                var cartScope =  createManageBookingCartScope(itemData);
                eventData['items'] = cartScope;
                eventData["cd_item_contents"] = "additional services";
                eventData['shipping'] = gaConvertPrice(additionalServiceData.paymentCurrency, serviceBasketData.totalServiceTaxAmount);
                eventData['shipping_tier'] = '';
                eventData['value'] = gaConvertPrice(additionalServiceData.paymentCurrency,  serviceBasketData.totalBasketPrice);
                eventData['currency'] = gaTargetCurrency;
                pushEcommerceData({event: "add_shipping_info", ecommerce: eventData});
            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushManageBookingAddPaymentInfo(additionalServiceData, paymentType, installmentCount) {
            try {
                if(!isValidAncillaryPaymentType(paymentType)) {
                    clearAdditionalServiceCache();
                    return;
                }
                var shipping = additionalServiceData.ancillaryServiceBasket.totalServiceTaxAmount;
                var eventData = manageBookingEventScope(additionalServiceData.fareInfo.flights, 'payment', additionalServiceData.fareInfo.flightType);
                var itemData = manageBookingItemScope(additionalServiceData.fareInfo.flights, additionalServiceData.fareInfo.flightType);
                eventData['items'] = createManageBookingCartScope(itemData);
                eventData['cd_item_contents'] = "additional services";
                eventData['payment_type'] = paymentType;
                eventData['cd_installment_type'] = installmentCount && installmentCount > 1 ? installmentCount + '_installments' : 'in_advance';
                eventData['shipping'] = gaConvertPrice(additionalServiceData.preferedCurrency, shipping ? shipping : 0);
                eventData['shipping_tier'] = '';
                eventData['value'] = gaConvertPrice(additionalServiceData.preferedCurrency,  additionalServiceData.totalPrice);
                eventData['currency'] = gaTargetCurrency;
                pushEcommerceData({event: "add_payment_info", ecommerce: eventData});
            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushManageBookingPurchase(reservation, ancillaryServiceBasket) {
            try {
                if (!gtmThankYouDataAlreadySent && !underscore.contains(unsupportedCurrencyList, reservation.totalCharge.currency)) {
                    if (!hasTargetConversionRate(reservation.totalCharge.currency, gaTargetCurrency)) {
                        fetchCurrencyConversionRates(reservation.totalCharge.currency, function () {
                            pushManageBookingPurchaseData(reservation, ancillaryServiceBasket);
                        })
                    } else {
                        pushManageBookingPurchaseData(reservation,ancillaryServiceBasket );
                    }
                }
            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushManageBookingPurchaseData(reservation, ancillaryServiceBasket) {
            try {
                var flights = reservation.allFlights;
                var shipping = ancillaryServiceBasket.totalServiceTaxAmount;
                var eventData = manageBookingEventScope(flights, 'purchase', reservation.tripType);
                var itemData = manageBookingItemScope(flights, reservation.tripType);
                var installmentCount = reservation.paymentInfo.installmentCount;
                eventData['items'] = createManageBookingCartScope(itemData);
                eventData['cd_last_leg'] = flights.length;
                eventData['transaction_id'] = reservation.pnr;
                eventData['cd_ticket_no'] = getTicketNo(reservation);
                eventData['cd_item_contents'] = "additional services";
                eventData['payment_type'] = reservation.paymentInfo.paymentType;
                eventData['cd_installment_type'] = installmentCount && installmentCount > 1 ? installmentCount + '_installments' : 'in_advance';
                eventData['shipping'] = gaConvertPrice(reservation.basketPrice.currency, shipping ? shipping : 0);
                eventData['tax'] = gaConvertPrice(reservation.basketPrice.currency, reservation.basketPrice.taxTotalBasket || 0);
                eventData['shipping_tier'] = '';
                eventData['value'] = gaConvertPrice(reservation.basketPrice.currency, reservation.basketPrice.totalBasketPrice);
                eventData['currency'] = gaTargetCurrency;
                pushEcommerceData({event: "purchase", ecommerce: eventData});
                clearAdditionalServiceCache();
            } catch (e) {
                pushServiceError(e);
            }
        }

        function manageBookingEventScope(selectedFlights, pageType, tripType) {
            var firstFlight = selectedFlights[0];
            var flightDates = getManageBookingFlightDates(selectedFlights);
            var spas = underscore.map(selectedFlights, function(flight) { return {cd_item_spa: getSpa(flight)}; });
            var eventSpa = createPipeForMultipleValues(spas,'cd_item_spa','none');
            var manageBookingEventData = storageHelper.getItem({ key: 'manageBookingEventData', webStorageType: storageHelper.Stores.SESSION_STORAGE })
            
            if (manageBookingEventData) manageBookingEventData = JSON.parse(manageBookingEventData);
            else manageBookingEventData = {};

            setPassengersCount(firstFlight.passengers);

            var eventData = {
                cd_event_category: getEventCategory(manageBookingEventData['cd_button_name'] ? manageBookingEventData['cd_button_name'] : 'View all additional services'),
                item_list_name: "Manage Booking",
                page_type: "manage booking" + " " + pageType,
                cd_item_flight_destination: firstFlight.destinationAirport.code,
                cd_item_flight_destination_city: firstFlight.destinationAirport.city.code,
                cd_item_flight_destination_country: firstFlight.destinationAirport.country.code,
                cd_item_flight_origin: firstFlight.originAirport.code,
                cd_item_flight_origin_city: firstFlight.originAirport.city.code,
                cd_item_flight_origin_country: firstFlight.originAirport.country.code,
                cm_item_passenger_adult: adultCount,
                cm_item_passenger_infant: infantCount,
                cm_item_passenger_student: studentCount,
                cm_item_passenger_child: childCount,
                cm_item_passenger_veteran: veteranCount,
                cm_item_passenger_disabled: disabledCount,
                cm_item_passenger_teacher: teacherCount,
                cm_item_passenger_senior: seniorCount,
                cd_item_passenger_adult: adultCount.toString(),
                cd_item_passenger_infant: infantCount.toString(),
                cd_item_passenger_student: studentCount.toString(),
                cd_item_passenger_child: childCount.toString(),
                cd_item_passenger_veteran: veteranCount.toString(),
                cd_item_passenger_disabled: disabledCount.toString(),
                cd_item_passenger_teacher: teacherCount.toString(),
                cd_item_passenger_senior: seniorCount.toString(),
                cd_passenger_count: firstFlight.passengers.length.toString(),
                cm_passenger_count: firstFlight.passengers.length,
                cd_item_codeshare: eventSpa,
                cd_item_spa: eventSpa,
                cd_item_flight_date: flightDates,
                item_id: firstFlight.originAirport.code+"-"+firstFlight.destinationAirport.code,
                item_brand: getManageBookingEventItemBrand(selectedFlights),
                item_category: getRouteTypeByFlight(firstFlight),
                item_category2: getManageBookingEventBrandCode(selectedFlights),
                item_category3: getTripType(tripType),
                item_category4: getManageBookingEventCabinType(selectedFlights),
                item_category5: isConnected(firstFlight.segments.length),
                items:[],
            }
            return eventData;
        }
        function manageBookingItemScope(selectedFlights, tripType) {
            var firstFlight = selectedFlights[0];
            var route = getManageBookingFlightRoute(selectedFlights);
            var flightDates = getManageBookingFlightDates(selectedFlights);

            var items = underscore.map(selectedFlights, function (flight) {
                return {
                    item_id: firstFlight.originAirport.code + "-" + firstFlight.destinationAirport.code,
                    item_name: flight.originAirport.code + "-" + flight.destinationAirport.code,
                    item_category: getRouteTypeByFlight(flight),
                    item_category3: getTripType(tripType),
                    item_category4: flight.cabinClass.toLowerCase(),
                    price: 0.0,
                    quantity: 0,
                    item_list_name: "Manage Booking", // Akış tipi (Biletleme akışı -> Availability, Check-in akışı -> Checkin, Manage Booking akışı -> Manage Booking, diğerleri -> none)
                    cd_item_type: '',
                    cd_leg_order: flight.rph.toString(),
                    cm_item_passenger_number: firstFlight.passengers.length,
                    cd_item_flight_date: flightDates,
                    cd_item_full_flight_route: route,
                };
            });
            return items;
        }

        function createManageBookingCartScope(itemData) {
            var items = [];
            var additionalServiceCache = getAdditionalServiceCache();
            if(additionalServiceCache && additionalServiceCache.length > 0) {
                underscore.forEach(additionalServiceCache, function (cacheItem) {
                    var asItem = underscore.find(itemData, function(item) { return item.cd_leg_order === cacheItem.cd_leg_order; });
                    var keys = Object.keys(cacheItem);
                    if (keys.length === 0 || !asItem) {
                        return ;
                    }
                    underscore.forEach(keys, function (key) {
                        asItem[key] = cacheItem[key];
                    });
                    items.push(JSON.parse(JSON.stringify(asItem)));
                });
            }
            return items;
        }

        function pushManageBookingSeatSelectionAddToCart(flightDataClient, flightDataBE, selectedFlights, planeMaps) {
            var items = [];
            var value = 0;
            var seatArray = setSelectedSeatsArray(flightDataClient, flightDataBE, planeMaps);
            var eventData = manageBookingEventScope(selectedFlights, 'additional services detail', selectedFlights[0].tripType)
            
            flightDataClient.forEach(function(processingLeg) { 
                var asProductArray = {
                    'Paid': [],
                    'Free Standart': [],
                };

                processingLeg.segments.forEach(function(segment) {
                    segment.passengers.forEach(function(passenger) {
                        var passengerSeat = seatArray.filter(function(seat) {
                            if (seat.flightRph === processingLeg.flightRph() && seat.segmentRph === segment.segmentRph() && seat.seatNumber === passenger.seatNumber()) {
                                return seat;
                            }
                        })

                        if (!passengerSeat.length) return;

                        var asDetailProduct = getSelectedSeatProductType(passenger, 'manage booking')

                        if (asDetailProduct) {
                            var convertedFare = calculateConvertedAmount(
                                hasTargetConversionRate(passenger.baseFareCurrency(), EURCurrency), 
                                currencyConversionRates[EURCurrency], 
                                passenger.baseFare()
                            )

                            passengerSeat[0]['asDetailProduct'] = asDetailProduct;
                            passengerSeat[0].passenger['convertedFare'] = convertedFare;
                            passengerSeat[0].passenger['convertedCurrency'] = EURCurrency;
        
                            asProductArray[asDetailProduct].push({
                                leg: processingLeg.flightRph(),
                                segment: segment.segmentRph(),
                                passenger: passenger,
                                fare: convertedFare,
                                fareCurrency: passenger.baseFareCurrency(),
                                seatInfo: passengerSeat.length ? passengerSeat[0] : '',
                            });
                        }
                    })
                })

                Object.entries(asProductArray).forEach(function(product) {
                    if (!product[1].length) return;
    
                    var itemsGA4Data = manageBookingItemScope(selectedFlights, selectedFlights[0].tripType);
                    var itemGA4Data = itemsGA4Data.find(function(item) { return item['cd_leg_order'] === product[1][0].leg })
    
                    var price = product[1].reduce(function(accumulator, productItem) {
                        return accumulator + productItem.fare
                    }, 0);
    
                    itemGA4Data['price'] = price / product[1].length;
                    itemGA4Data['quantity'] = product[1].length;
                    itemGA4Data['cd_as_detail_product'] = product[0];
                    itemGA4Data['cd_as_type'] = setCheckinCdAsType(product[1])
                    itemGA4Data['cd_item_type'] = 'Seat Selection'
        
                    value = value + price;

                    items.push(itemGA4Data)
                })
            })

            eventData['value'] = value;
            eventData['items'] = items;

            pushEcommerceData({ event: 'add_to_cart', ecommerce: eventData });

            removePreviousAdditionalServiceItems('Seat Selection');
            var cacheItems = underscore.map(items, createAdditionalServiceItemCache);
            appendAdditionalServiceCache(cacheItems);
        }

        function pushManageBookingExcessBaggageAddToCart(excessBaggageData, event, items) {
            var baggageUnit = excessBaggageData.flights[0].selectedBaggageMeasureType.toLowerCase();
            var currency = excessBaggageData.flights[0].currency;
            underscore.forEach(items, function (item) {
                var asFlight = underscore.find(excessBaggageData.flights, function (flight) {
                    return item.cd_leg_order === flight.flightRph
                })
                item["cd_item_type"] = 'Extra Baggage';
                item['cd_as_type'] = baggageUnit === 'pc' ? 'Piece' : baggageUnit;
                item['cd_as_detail_product'] = '';
                item['quantity'] = asFlight.selectedItemCount;
                item['price'] = gaConvertPrice(currency, asFlight.selectedTotalFare) / (asFlight.selectedItemCount ? asFlight.selectedItemCount : 1);
            });
            items = underscore.filter(items, function (item) {return item.quantity !== 0});
            if(!items || items.length === 0) {
                return;
            }
            event['items'] = items;
            event['value'] = gaConvertPrice(currency, excessBaggageData.selectedGrandTotalFare);
            event['currency'] = gaTargetCurrency;
            removePreviousAdditionalServiceItems('Extra Baggage');
            pushEcommerceData({event: "add_to_cart", ecommerce: event});
            var cacheItems = underscore.map(items, createAdditionalServiceItemCache);
            appendAdditionalServiceCache(cacheItems);
        }

        function pushManageBookingSportsEquipmentAddToCart(sportsEquipmentData, event, items) {
            var currency = sportsEquipmentData.flights[0].currency;
            var groupedItems =  itemGroupByTypes(sportsEquipmentData, 'Sports Equipment');
            var allItems = []
            var keys = Object.keys(groupedItems);
            underscore.forEach(keys, function createItem(key) {
                var groupItem = groupedItems[key];
                if (groupItem && groupItem.length > 0) {
                    var asItem = underscore.find(items, function (item) {
                        return item.cd_leg_order === (groupItem[0].legIndex + 1).toString();
                    })
                    if(!asItem) {
                        return;
                    }
                    createCartItemDetails(asItem, groupItem, 'Sports Equipment')
                    var price = groupItem.reduce(function getPriceSum(total, subItem) {
                        return total + subItem.price;
                    }, 0) / groupItem.length;
                    asItem["price"] = gaConvertPrice(currency, price);
                    asItem["cd_item_type"] = 'Sports Equipment';
                    allItems.push(JSON.parse(JSON.stringify(asItem)));
                }
            });
            if(!allItems) {
                return;
            }
            event['items'] = allItems;
            event['value'] = gaConvertPrice(currency, sportsEquipmentData.selectedGrandTotalFare);
            event['currency'] = gaTargetCurrency;
            removePreviousAdditionalServiceItems('Sports Equipment');
            pushEcommerceData({event: "add_to_cart", ecommerce: event});
            var cacheItems = underscore.map(allItems, createAdditionalServiceItemCache);
            appendAdditionalServiceCache(cacheItems);
        }

        function pushManageBookingPetAddToCart(petData, event, items) {
            var currency = petData.flights[0].currency;
            var groupedItems = itemGroupByTypes(petData, 'Pet');
            var allItems = [];

            Object.values(groupedItems).forEach(function(pet) {
                var ga4Item = underscore.find(items, function(item) {
                    return item['cd_leg_order'] === (pet[0].legIndex + 1).toString()
                });
                
                if (!ga4Item) return;

                var price = pet.reduce(function getPriceSum(total, subItem) {
                    return total + subItem.price;
                }, 0) / pet.length;

                var convertedPrice = gaConvertPrice(currency, price);

                createCartItemDetails(ga4Item, pet, 'Pet');
                
                ga4Item['cd_item_type'] = 'Pet';
                ga4Item['price'] = convertedPrice;
                ga4Item['quantity'] = pet.length;

                allItems.push(JSON.parse(JSON.stringify(ga4Item)));
            });

            event['items'] = allItems;
            event['value'] = gaConvertPrice(currency, petData.selectedGrandTotalFare);
            event['currency'] = gaTargetCurrency;

            pushEcommerceData({event: "add_to_cart", ecommerce: event});
            
            removePreviousAdditionalServiceItems('Pet');
            var cacheItems = underscore.map(allItems, createAdditionalServiceItemCache);
            appendAdditionalServiceCache(cacheItems);
        }

        function pushManageBookingLoungeAddToCart(loungeData, event, items) {
            var currency = loungeData.flights[0].currency;
            var groupedItems = loungeGroupByLegAndType(loungeData);
            var allItems = [];

            Object.values(groupedItems).forEach(function(lounge) {
                var ga4Item = underscore.find(items, function(item) {
                    return item['cd_leg_order'] === (lounge[0].legIndex + 1).toString()
                });
                
                if (!ga4Item) return;

                var price = lounge.reduce(function getPriceSum(total, subItem) {
                    return total + subItem.price;
                }, 0) / lounge.length;

                var convertedPrice = gaConvertPrice(currency, price);

                createCartItemDetails(ga4Item, lounge, 'Lounge');
                
                ga4Item['cd_item_type'] = 'Lounge';
                ga4Item['price'] = convertedPrice;
                ga4Item['quantity'] = lounge.length;

                allItems.push(JSON.parse(JSON.stringify(ga4Item)));
            });

            event['items'] = allItems;
            event['value'] = gaConvertPrice(currency, loungeData.selectedGrandTotalFare);
            event['currency'] = gaTargetCurrency;

            pushEcommerceData({event: "add_to_cart", ecommerce: event});
            
            removePreviousAdditionalServiceItems('Lounge');
            var cacheItems = underscore.map(allItems, createAdditionalServiceItemCache);
            appendAdditionalServiceCache(cacheItems);
        }

        function getEventCategory(pageType) {
            switch (pageType) {
                case 'View all additional services':
                    return 'View all additional services';
                case 'Passenger Preferences - Seat Selection':
                case 'Passenger Preferences - Extra Baggage':
                    return 'Passenger Preferences';
                default:
                    return ''
            }
        }
        function getManageBookingFlightRoute(selectedFlights) {
            var routes = underscore.map(selectedFlights, function (flight) {
                return flight.originAirport.code + "-" + flight.destinationAirport.code;
            })
            return routes.join(", ");
        }

        function getManageBookingFlightDates(selectedFlights) {
            var dates = underscore.map(selectedFlights, function (flight) {
                return getDateInISOFormat(flight.segments[0].departureDateTime);
            })
            return dates.join("|");
        }

        function getManageBookingEventItemBrand(selectedFlights) {
            var brandList = underscore.map(selectedFlights, function (flight) { return getItemBrand(flight.airlinesBySegment)})
            return underscore.uniq(brandList).join("|");
        }

        function getManageBookingEventCabinType(selectedFlights) {
            var cabinTypes = underscore.map(selectedFlights, function(flight) {return flight.cabinClass;});
            var uniqueCabinTypes = underscore.uniq(cabinTypes);
            if(uniqueCabinTypes && uniqueCabinTypes.length > 1) {
                return "mixed";
            } else if (uniqueCabinTypes && uniqueCabinTypes.length === 1) {
                var cabinType = normalizeCabinTypes(uniqueCabinTypes);
                return cabinType[0];
            } else {
                return '';
            }
        }

        function getManageBookingEventBrandCode(selectedFlights) {
            var brandCodes = underscore.map(selectedFlights, function(flight) {return flight.brandCode;});
            var uniqueBrandNames = underscore.uniq(brandCodes);
            if(uniqueBrandNames && uniqueBrandNames.length > 1) {
                return "mixed";
            } else if (uniqueBrandNames && uniqueBrandNames.length === 1) {
                return getViewTypeByBrandCode(uniqueBrandNames[0]);
            } else {
                return '';
            }
        }

        function createManageBookingDataCache(flightData, buttonName) {
            var manageBookingEventData = storageHelper.getItem({ key: 'manageBookingEventData', webStorageType: storageHelper.Stores.SESSION_STORAGE })

            if (manageBookingEventData) manageBookingEventData = JSON.parse(manageBookingEventData);
            else manageBookingEventData = {};

            if (flightData) {
                var firstLeg = flightData[0];

                var firstSegment = firstLeg.segmentData[0].passengerList[0].segment;
                var lastSegment = firstLeg.segmentData[firstLeg.segmentData.length - 1].passengerList[0].segment;
                
                var passengerCount = flightData[0].segmentData[0].passengerList;
                var cabinCode = firstSegment.bookingClass.cabinCode;

                manageBookingEventData['item_category'] = getRouteTypeByFlight(firstSegment)
                manageBookingEventData['item_category4'] = cabinCode === 'Y' ? 'economy' : cabinCode === 'C' ? 'business' : cabinCode.toLowerCase()
                manageBookingEventData['cd_item_flight_destination'] = lastSegment.destinationAirport.code
                manageBookingEventData['cd_item_flight_destination_city'] = lastSegment.destinationAirport.city.code
                manageBookingEventData['cd_item_flight_destination_country'] = lastSegment.destinationAirport.country.code
                manageBookingEventData['cd_item_flight_origin'] = firstSegment.originAirport.code
                manageBookingEventData['cd_item_flight_origin_city'] = firstSegment.originAirport.city.code
                manageBookingEventData['cd_item_flight_origin_country'] = firstSegment.originAirport.country.code
                manageBookingEventData['cd_passenger_count'] = passengerCount.length.toString() || ''
                manageBookingEventData['cm_passenger_count'] = passengerCount.length
            }

            if (buttonName) {
                manageBookingEventData['cd_button_name'] = buttonName
            }

            if (Object.keys(manageBookingEventData).length > 0) {
                storageHelper.setItem({
                    key: 'manageBookingEventData',
                    value: JSON.stringify(manageBookingEventData),
                    webStorageType: storageHelper.Stores.SESSION_STORAGE,
                })
            }
        }

        function getManageBookingDataCache() {
            var cache = storageHelper.getItem({ key: 'manageBookingEventData', webStorageType: storageHelper.Stores.SESSION_STORAGE })
            if (cache) cache = JSON.parse(cache);
            return cache;
        }

        var manageBoookingPassengerPreferences = ['Seat Selection', 'Extra Baggage'];
        
        function getASType(key) {
            switch (key) {
                case 'EXCESS_BAGGAGE':
                    return 'Extra Baggage';
                case 'LOUNGE':
                    return 'Lounge';
                case 'SPORTS_EQUIPMENT':
                    return 'Sports Equipment';
                case 'E_VISA':
                    return 'E Visa';
                case 'PACKAGE_OFFER':
                    return 'Package Offers';
                case 'PETC_AVIH':
                    return 'Pet';
                case 'TRAVEL_INSURANCE':
                    return 'Travel Insurance';
                case 'PREORDER':
                    return 'PreOrder';
                case 'SUSTAINABLE_AVIATION_FUEL':
                    return 'SAF';
                default:
                    return key;
            }
        }
        
        var isMBViewItemListFired = false;
        function pushMBPassengerPreferencesViewItemList(flights) {
            if (isMBViewItemListFired) return;
        
            window.addEventListener("scroll", checkVisibility);
            window.addEventListener("resize", checkVisibility);
          
            function checkVisibility() {
                var element = document.querySelector('#passengersTabs .nav-tabs')
                var rect = element.getBoundingClientRect()
          
                if (rect.top >= 0 && 
                    rect.left >= 0 && 
                    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && 
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                ) {
                    var eventScope = manageBookingEventScope(flights, 'main page', flights[0].tripType);
                    var itemScopeBase = manageBookingItemScope(flights, flights[0].tripType);

                    var items = [];
                    manageBoookingPassengerPreferences.forEach(function(pp) {
                        itemScopeBase.forEach(function(item) {
                            var asItem = JSON.parse(JSON.stringify(item));
        
                            asItem['cd_item_type'] = pp;
                            asItem['quantity'] = eventScope['cm_passenger_count'];
        
                            items.push(asItem);
                        })
                    })

                    eventScope['items'] = items;
                    pushEcommerceData({event: 'view_item_list', ecommerce: eventScope});
                    window.removeEventListener("scroll", checkVisibility);
                    window.removeEventListener("resize", checkVisibility);
                    isMBViewItemListFired = true;
                }
            }
        }

        function createItemData(itemType, flight, setFullPrice) {
            return {
                cd_item_type: itemType,
                cd_leg_order: flight['cd_leg_order'],
                cm_item_full_price: setFullPrice ? flight['cm_item_full_price'] : 0,
                cm_item_leg_count: 1,
                item_id: flight['item_id'],
                item_name: flight['item_name'],
                affiliation: flight['affiliation'],
                coupon: flight['coupon'],
                discount: flight['discount'],
                index: flight['index'],
                item_brand: flight['item_brand'],
                item_category: flight['item_category'],
                item_category2: flight['item_category2'],
                item_category3: flight['item_category3'],
                item_category4: flight['item_category4'],
                item_category5: flight['item_category5'],
                item_list_id: flight['item_list_id'],
                item_list_name: flight['item_list_name'],
                item_variant: flight['item_variant'],
                price: flight['price'],
                cd_item_suggested: flight['cd_item_suggested'],
                quantity: flight['quantity'],
                cm_item_passenger_number: flight['cm_item_passenger_number'],
                cd_item_fare_class: flight['cd_item_fare_class'],
                cd_item_codeshare: flight['cd_item_codeshare'],
                cd_item_spa: flight['cd_item_spa'],
                cd_item_search_date: flight['cd_item_search_date'],
                cm_item_flight_duration: flight['cm_item_flight_duration'],
                cd_item_flight_origin_city: flight['cd_item_flight_origin_city'],
                cd_item_flight_date: flight['cd_item_flight_date'],
                cd_item_full_flight_route: flight['cd_item_full_flight_route'],
                cd_item_promotion: flight['cd_item_promotion'],
                cd_stopover_type: flight['cd_stopover_type'],
                cd_as_type: '',
                cd_as_detail_product: ''
            };
        }

        /**
         * This method creates base item scope for the additional service events
         * @param itemType
         * @param flight
         * @returns {Object}
         */
        function additionalServiceItemScope(itemType, flight) {
            return {
                item_id: flight['item_id'],
                item_name: flight['item_name'],
                item_category: flight['item_category'],
                item_category3: flight['item_category3'],
                item_category4: flight['item_category4'],
                price: 0,
                quantity: flight['quantity'] || 0,
                item_list_id: flight['item_list_id'],
                item_list_name: flight['item_list_name'],
                cd_item_type: itemType,
                cd_leg_order: flight['cd_leg_order'],
                cm_item_passenger_number: flight['cm_item_passenger_number'],
                cd_item_search_date: flight['cd_item_search_date'],
                cd_item_flight_date: flight['cd_item_flight_date'],
                cd_item_full_flight_route: flight['cd_item_full_flight_route'],
            };
        }

        function stopOverItemScope(flight, isPurchase) {
            var stopoverFlow = JSON.parse(storageHelper.getItem({ key: "stopover_param", webStorageType: storageHelper.Stores.SESSION_STORAGE }));
            var stopoverFlowLegs = stopoverFlow ? stopoverFlow.split("_") : "";
            var stopoverFlowLeg = stopoverFlowLegs[0]
            var stopoverFlowDay = stopoverFlowLegs[1];

            if (!stopoverFlow) {
                if (!flight.hasAnyStopOverHotel) {
                    return "none";
                }
                return "stopover_" + (firstFlightSelected === true || flight.rph === 2 ? "return_" : "departure_")
                    + "1"
                    + (flight.hasAnyTourIstanbul ? "|tour_istanbul" : "");
            }

            if (stopoverFlow) {
                if (flight.routeIndex === 1 || flight.rph === 2 || (isPurchase && flight.id === "1")) { // return
                    if (stopoverFlowLeg === "1") {
                        return "stopover_return_" + stopoverFlowDay;
                    } else {
                        return "none";
                    }
                }
                else { // departure
                    if (stopoverFlowLeg === "0") {
                        return "stopover_departure_" + stopoverFlowDay;
                    } else {
                        return "none";
                    }
                }
            }
        }

        var shownExtraSetFlights = false;
        var shownSeatSelectionFlights = false;

        function pushSeatViewItemData(passengerDetails) {
            try {
                shownExtraSetFlights = shownExtraSetFlights || false;
                shownSeatSelectionFlights = shownSeatSelectionFlights || false;
                var isExtraSeat = false;
                var isSeatSelection = false;
                underscore.forEach(passengerDetails, function (passengerDetail) {
                    if (passengerDetail.extraSeatPrefered()) {
                        isExtraSeat = true;
                    } else {
                        isSeatSelection = true;
                    }
                });

                if (isExtraSeat && !shownExtraSetFlights) {
                    pushAdditionalServiceSeatViewItemData('Extra Seat');
                    shownExtraSetFlights = true;
                }

                if (isSeatSelection && !shownSeatSelectionFlights) {
                    removePreviousAdditionalServiceItems('Seat Selection')
                    pushAdditionalServiceSeatViewItemData('Seat Selection');
                    shownSeatSelectionFlights = true;
                }
            } catch (e) {
                pushServiceError(e);
            }
        }

        /**
         * It triggers when seat selection page is viewed
         * view_item
         * @param flights
         * @param fareBreakdown
         * @param itemType
         */
        function pushAdditionalServiceSeatViewItemData(itemType) {
            try {
                var allCachedFlights = JSON.parse(storageHelper.getItem({ key: "cartFlightData", webStorageType: storageHelper.Stores.SESSION_STORAGE }));
                if (!allCachedFlights) return;
                var items = underscore.map(allCachedFlights, function(flight) {
                    var item = additionalServiceItemScope(itemType, flight);
                    if(itemType === 'Extra Seat') {
                        item['quantity'] = 1;
                    }
                    return item;
                });
                pushAdditionalServiceGenericViewItemData(gaTargetCurrency, 0, items);
            } catch (e) {
                pushServiceError(e);
            }
        }

        /**
         * It triggers when additional service button clicked and page viewed
         * view_item & select_item
         * @param flights
         * @param fareBreakdown
         * @param itemType
         */
        function pushAdditionalServiceItemData(flights, fareBreakdown, itemType) {
            try {
                var items = [];
                underscore.forEach(flights, function (flight) {
                    var legOrder = flight && flight.rph ? flight.rph.toString() : '1'
                    if(itemType === 'Package Offers' && legOrder !== '1') {
                        return;
                    }
                    var adjustedItemType = itemType === "Saf" ? "SAF" : itemType;
                    var flightData = getFlightByLegOrder(legOrder, null);
                    var asItem = additionalServiceItemScope(adjustedItemType, flightData);
                    asItem['price'] = 0;
                    items.push(asItem);
                });

                var currency = hasTargetConversionRate(fareBreakdown.currency, gaTargetCurrency) ? gaTargetCurrency : fareBreakdown.currency;
                pushAdditionalServiceGenericViewItemData(currency, 0, items);
            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushAdditionalServiceGenericViewItemData(currency, value, items) {
            var eventData = getGAEventDataCache();
            eventData['currency'] = currency;
            eventData['value'] = value;
            eventData['items'] = items;
            eventData['page_type'] = 'additional services detail';
            pushEcommerceData({event: "view_item", ecommerce: eventData});
        }

        function getFlightByLegOrder(legOrder, flights) {
            var cacheFlights = flights ? flights : JSON.parse(storageHelper.getItem({ key: "cartFlightData", webStorageType: storageHelper.Stores.SESSION_STORAGE }));
            var keys = Object.keys(cacheFlights);
            if (keys.length < 1) return null;

            for (var i = 0; i < keys.length; i++) {
                var curr = cacheFlights[keys[i]];
                if (curr.cd_leg_order === String(legOrder)) {
                    return curr;
                }
            }
            return null;
        }

        var selectedSeats;

        // segmentIndex is absolute index as shown in seat selection screen
        function saveSelectedSeatData(segmentIndex, seatNumber, seatType, seatAmount, planeSeat) {
            try {
                selectedSeats = selectedSeats || {};
                selectedSeats[segmentIndex] = selectedSeats[segmentIndex] || {};
                selectedSeats[segmentIndex][seatNumber] = {seat: mapSeatType(seatType), price: seatAmount};
                sentSeatSelectionAddToCart = false;
            } catch (e) {
                pushServiceError(e);
            }
        }

        function mapSeatType(seatType) {
            switch (seatType) {
                case 'EXIT':
                    return 'Exit';
                case 'LEGROOM':
                    return 'Legroom';
                case 'PREFERRED':
                    return 'Preferred';
                case null:
                case undefined:
                case 'PAID SEAT':
                    return 'Standard';
                default:
                    return seatType;
            }
        }

        function mapPetCategoryType(categoryType) {
            switch (categoryType) {
                case 'PETC':
                    return 'PetC-Cabin';
                case 'AVIH':
                    return 'Avih-Baggage';
                case null:
                case undefined:
                default:
                    return categoryType;
            }
        }
        function mapPetFamilyType(familyType) {
            switch (familyType) {
                case 'DOG':
                    return 'Dog';
                case 'CAT':
                    return 'Cat';
                case 'BIRD':
                    return 'Bird';
                case null:
                case undefined:
                default:
                    return familyType;
            }
        }
        function mapSafType(safType) {
            switch (safType) {
                case 'LOW':
                    return 'Eco SAF';
                case 'MEDIUM':
                    return 'Extra SAF';
                case 'HIGH':
                    return 'Prime SAF'; 
                default:
                    return safType;
            }
        }   

        var sentSeatSelectionAddToCart = false;
        function pushSeatAddToCartData(flightData, fareBreakdown, isExtraSeatPreferred) {
            try {
                removePreviousAdditionalServiceItems('Seat Selection');
                pushSeatSelectionAddToCartData(flightData);
                sentSeatSelectionAddToCart = true;

                removePreviousAdditionalServiceItems('Extra Seat');
                if (isExtraSeatPreferred && fareBreakdown.totalExtraSeatAmountConvertedPrices) {
                    pushExtraSeatAddToCartData(fareBreakdown);
                }
            } catch (e) {
                pushServiceError(e);
            }
        }

        function getSelectedPassengerSeats (passengers) {
            var selectedSeatData = [];
            underscore.forEach(passengers, function (passenger) {
                if (passenger.seatNumber() && !passenger.extraSeatPrefered()) {
                    var seatData = {
                        seat: mapSeatType(passenger.chargableSeatType()),
                        number: passenger.seatNumber(),
                        price:  passenger.baseFare()
                    }
                    selectedSeatData.push(seatData);
                }
            })
            return selectedSeatData
        }

        function regroupSelectedSeatsAsCacheItem (allSelectedSeat) {
            var cacheSeatItems = [];
            var keys = Object.keys(allSelectedSeat)
            underscore.forEach(keys, function(key) {
                var item = {
                    cd_as_detail_product: [],
                    cd_as_type: [],
                    cd_item_type: 'Seat Selection',
                    cd_leg_order: key,
                    price: 0,
                    quantity: 0,
                }
                underscore.forEach(allSelectedSeat[key], function (seatData) {
                    item.price += seatData.price;
                    item.quantity ++;
                    item.cd_as_type.push(mapSeatType(seatData.seat));
                    item.cd_as_detail_product.push(seatData.price > 0 ? "Paid" : "Free Standard");
                })
                item.cd_as_type = underscore.sortBy(underscore.unique(item.cd_as_type), function (seat) {return seat}).join('|');
                item.cd_as_detail_product =  underscore.unique(item.cd_as_detail_product).join("|");
                item.price = item.price / (item.quantity > 0 ? item.quantity : 1)
                cacheSeatItems.push(item)
            })
            return cacheSeatItems
        }

        function pushSeatSelectionAddToCartData(flightData) {
            try {
                var allCachedFlights = JSON.parse(storageHelper.getItem({ key: "cartFlightData", webStorageType: storageHelper.Stores.SESSION_STORAGE }));
                if (!allCachedFlights) return;
                var keys = Object.keys(allCachedFlights);
                if (keys.length === 0) return;

                var allSeats = [];
                for (var i = 0; i < flightData.length; i++) {
                    var flightSeats = {paid: [], free: []};
                    for (var j = 0; j < flightData[i].segments.length; j++) {
                        var selectedSeatData = getSelectedPassengerSeats(flightData[i].segments[j].passengers);
                        if (selectedSeatData.length <= 0) continue;
                        for (var k = 0; k < selectedSeatData.length; k++) {
                            var currentSelectedSeatData = selectedSeatData[k];
                            currentSelectedSeatData.price > 0 ? flightSeats.paid.push(currentSelectedSeatData) : flightSeats.free.push(currentSelectedSeatData);
                        }
                    }
                    allSeats.push(flightSeats);
                }

                var currency =  flightData[0].baseFareCurrency();
                var totalPrice = 0;
                var items = [];
                for (i = 0; i < keys.length; i++) {
                    var itemIndex = Number(allCachedFlights[keys[i]]['cd_leg_order']);
                    if (isNaN(itemIndex)) continue;
                    itemIndex = itemIndex - 1;

                    var fareTypeKeys = Object.keys(allSeats[itemIndex]);
                    underscore.forEach(fareTypeKeys, function (key) {
                        if (allSeats[itemIndex][key].length === 0) return;
                        var item = additionalServiceItemScope('Seat Selection', allCachedFlights[keys[i]]);
                        itemIndex = Number(item['cd_leg_order']) - 1;
                        if (isNaN(itemIndex)) {
                            return;
                        }
                        var seatTypes = [];
                        var itemPrice = 0;
                        allSeats[itemIndex][key].forEach(function (seatData) {
                            seatTypes.push(seatData.seat);
                            itemPrice += seatData.price;
                        });
                        itemPrice = gaConvertPrice(currency,itemPrice);
                        item['cd_as_type'] = underscore.sortBy(underscore.unique(seatTypes), function (seat) {return seat}).join('|');
                        item['cd_as_detail_product'] = key === 'paid' ? 'Paid' : 'Free Standard';
                        item['price'] = itemPrice / (seatTypes.length > 0 ? seatTypes.length : 1);
                        item['quantity'] = seatTypes.length;
                        totalPrice += itemPrice;
                        items.push(item);
                    });
                }
                if(items && items.length > 0) {
                    pushAdditionalServiceGenericAddToCart(currency, totalPrice, items);
                }
            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushExtraSeatAddToCartData(fareBreakdown) {
            try {
                var allCachedFlights = JSON.parse(storageHelper.getItem({ key: "cartFlightData", webStorageType: storageHelper.Stores.SESSION_STORAGE }));
                if (!allCachedFlights) return;
                var keys = Object.keys(allCachedFlights);
                if (keys.length === 0) return;

                var totalTicketPrice = 0;
                underscore.forEach(keys, function(key) {
                    totalTicketPrice += allCachedFlights[key]['price'];
                });

                var itemType = 'Extra Seat'
                var currency = fareBreakdown.totalExtraSeatAmountConvertedPrices.ORIGINAL_PRICE.currency;
                var value = gaConvertPrice(currency, fareBreakdown.totalExtraSeatAmountConvertedPrices.ORIGINAL_PRICE.amount);

                var items = underscore.map(keys, function(key) {
                   var item = additionalServiceItemScope(itemType, allCachedFlights[key]);
                   item['cd_as_type'] = 'Standard';
                   item['cd_as_detail_product'] = 'Paid';
                   item['price'] = (allCachedFlights[key]['price'] / totalTicketPrice) * value;
                   item['quantity'] = 1;
                   return item;
                });

                pushAdditionalServiceGenericAddToCart(hasTargetConversionRate(currency, gaTargetCurrency) ? gaTargetCurrency : currency, value, items);
            } catch (e) {
                pushServiceError(e);
            }
        }

        function createAdditionalServiceItemCache(item) {
            return {
                cd_as_detail_product: item['cd_as_detail_product'],
                cd_as_type: item['cd_as_type'],
                cd_item_type: item['cd_item_type'],
                cd_leg_order: item['cd_leg_order'],
                price: item['price'],
                quantity: item['quantity']
            };
        }

        function getAdditionalServiceCache() {
            return JSON.parse(localStorage.getItem('asItems')) || [];
        }

        function appendAdditionalServiceCache(items) {
            var asCache = getAdditionalServiceCache();
            asCache.push.apply(asCache, items);
            localStorage.setItem('asItems', JSON.stringify(asCache));
        }

        function clearAdditionalServiceCache() {
            localStorage.removeItem('asItems');
        }

        function getExtraAvailabilityParameters(flights, legOrder) {
            var flightDurationData = parseFlightDurationData(flights);
            var durationType = getFlightDurationType(flightDurationData.segmentDurationsAsHours);

            var params = {
                cd_flight_duration_type: durationType,
                cd_flight_time_group: getFlightTimeGroup(legOrder ? [flights[legOrder - 1]] : flights),
                cd_layover_duration: getFlightLayoverDuration(legOrder ? [flights[legOrder - 1]] : flights),
            }

            return params;
        }
        function pushAddShippingInfo(skipAdditionalServices, fareBreakdown, selectedFlights) {
            try {
                var allCachedFlights = JSON.parse(storageHelper.getItem({ key: "cartFlightData", webStorageType: storageHelper.Stores.SESSION_STORAGE }));
                if (!allCachedFlights) return;
                var keys = Object.keys(allCachedFlights);
                if (keys.length === 0) return;

                var totalPrice = 0;

                var items = underscore.map(keys, function (key) {
                    var flight = allCachedFlights[key];
                    totalPrice += flight.cm_item_full_price;
                    var item = createItemData('ticket', flight, true);
                    var extraParameters = getExtraAvailabilityParameters(selectedFlights, Number(flight['cd_leg_order']));
                    
                    item['cd_flight_duration_type'] = extraParameters['cd_flight_duration_type'];
                    item['cd_flight_time_group'] = extraParameters['cd_flight_time_group'];
                    item['cd_layover_duration'] = extraParameters['cd_layover_duration'];
                    
                    return item;
                });
                var onlyTicketItems = true;
                if (!skipAdditionalServices) {
                    var asCache = getAdditionalServiceCache();
                   if(asCache && asCache.length > 0) {
                       onlyTicketItems = false;
                       underscore.forEach(asCache, function (asItem) {
                           totalPrice += asItem.price * asItem.quantity;
                           items.push(createAdditionalServiceItemFromCache(allCachedFlights, asItem));
                       });
                   }
                } else {
                    clearAdditionalServiceCache();
                }

                var eventData = getGAEventDataCache();
                var eventExtraParameters = getExtraAvailabilityParameters(selectedFlights);

                eventData['value'] = totalPrice;
                eventData['currency'] = hasTargetConversionRate(fareBreakdown.currency, gaTargetCurrency) ? gaTargetCurrency : fareBreakdown.currency;
                eventData['shipping'] = gaConvertPrice(fareBreakdown.currency, fareBreakdown.totalServiceFee);
                eventData['shipping_tier'] = '';
                eventData['items'] = items;
                eventData['page_type'] = 'additional services listing';
                eventData['cd_item_contents'] = onlyTicketItems ? 'ticket' : 'mixed'
                eventData['udevId'] = getUdevId();
                eventData['cd_flight_duration_type'] = eventExtraParameters['cd_flight_duration_type'];
                eventData['cd_flight_time_group'] = eventExtraParameters['cd_flight_time_group'];
                eventData['cd_layover_duration'] = eventExtraParameters['cd_layover_duration'];
                pushEcommerceData({event: "add_shipping_info", ecommerce: eventData});

            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushPaymentMethodView(fareBreakdown, selectedFlights) {
            try {
                var eventData = {};
                var gaEventDataRaw = localStorage.getItem('gaEventData');
                if (gaEventDataRaw) {
                    eventData = JSON.parse(gaEventDataRaw);
                }
                eventData.page_type = 'payment';
                eventData.udevId = getUdevId();

                var dataToPush = { event: "payment_method_view" };
                for (var key in eventData) {
                    if (eventData.hasOwnProperty(key)) {
                        dataToPush[key] = eventData[key];
                    }
                }
                pushEcommerceData(dataToPush);
            } catch (error) {
                pushServiceError(error);
            }
         }
        function pushAddPaymentInfo(paymentType, installmentCount, paymentInfo, shipping, selectedFlights) {
            try {
                if (rhsFlowActive) {
                    clearAdditionalServiceCache();
                    return;
                }
                var allCachedFlights = JSON.parse(storageHelper.getItem({ key: "cartFlightData", webStorageType: storageHelper.Stores.SESSION_STORAGE }));
                if (!allCachedFlights) return;
                var keys = Object.keys(allCachedFlights);
                if (keys.length === 0) return;

                var totalPrice = 0;

                var items = underscore.map(keys, function (key) {
                    var flight = allCachedFlights[key];
                    var extraParameters = getExtraAvailabilityParameters(selectedFlights, Number(flight['cd_leg_order']));
                    var item = createItemData('ticket', flight, true);
                    item['cd_flight_duration_type'] = extraParameters['cd_flight_duration_type'];
                    item['cd_flight_time_group'] = extraParameters['cd_flight_time_group'];
                    item['cd_layover_duration'] = extraParameters['cd_layover_duration'];
                    return item;
                });
                if(isValidAncillaryPaymentType(paymentType)) {
                    var asCache = getAdditionalServiceCache();
                    var onlyTicketItems = true
                    if (asCache && asCache.length > 0) {
                        onlyTicketItems = false
                        underscore.forEach(asCache, function (asItem) {
                            totalPrice += asItem.price * asItem.quantity;
                            items.push(createAdditionalServiceItemFromCache(allCachedFlights, asItem));
                        });
                    }
                } else {
                    var onlyTicketItems = true;
                    clearAdditionalServiceCache();
                }

                var eventData = getGAEventDataCache();
                if (paymentInfo) {
                    eventData['value'] = gaConvertPrice(paymentInfo.currency, paymentInfo.value);
                    eventData['currency'] = hasTargetConversionRate(paymentInfo.currency, gaTargetCurrency) ? gaTargetCurrency : paymentInfo.currency;
                    eventData['shipping'] = shipping && shipping.amount ? gaConvertPrice(paymentInfo.currency, shipping.amount) : 0;
                }
                eventData['shipping_tier'] = '';
                eventData['payment_type'] = paymentType;
                eventData['cd_installment_type'] = installmentCount && installmentCount > 1 ? installmentCount + '_installments' : 'in_advance';
                eventData['items'] = items;
                eventData['page_type'] = 'payment';
                eventData['cd_item_contents'] = onlyTicketItems ? 'ticket' : 'mixed'
                eventData['udevId'] = getUdevId();
                pushEcommerceData({event: "add_payment_info", ecommerce: eventData});
            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushAdditionalServiceSelectItemData(selectedCardKey, pageType) {
            try {
                var allCachedFlights = JSON.parse(storageHelper.getItem({ key: "cartFlightData", webStorageType: storageHelper.Stores.SESSION_STORAGE }));
                if (!allCachedFlights) return;
                var keys = Object.keys(allCachedFlights);
                if (keys.length === 0) return;

                var items = [];
                underscore.forEach(keys, function (key) {
                    var legOrder =  allCachedFlights[key].cd_leg_order;
                    if(selectedCardKey === 'PACKAGE_OFFER'  || selectedCardKey === 'SUSTAINABLE_AVIATION_FUEL' && legOrder && legOrder !== '1') {
                        return;
                    }
                    var item = additionalServiceItemScope(getASType(selectedCardKey), allCachedFlights[key])
                    item['price'] = 0;
                    items.push(item);
                });

                var eventData = getGAEventDataCache();
                eventData['items'] = items;
                eventData['page_type'] = pageType === 'additionalServices' ? 'additional services listing': 'additional services detail'


                pushEcommerceData({event: "select_item", ecommerce: eventData});
            } catch (e) {
                pushServiceError(e);
            }
        }

        function isGroupedAdditionalServiceType(itemType) {
            var ADDITIONAL_SERVICES = ["Pet", "Lounge", "Sports Equipment", "Extra Baggage", "Extra Seat", "Seat Selection"];
            return ADDITIONAL_SERVICES.includes(itemType);
        }
        function createAdditionalServiceItemFromCache(flights, cacheItem) {
            var flight = getFlightByLegOrder(cacheItem['cd_leg_order'], flights);
            if (!flight) return;
            var item = additionalServiceItemScope('', flight);
            var keys = Object.keys(cacheItem);
            if (keys.length === 0) return item;
            underscore.forEach(keys, function (key) {
                item[key] = cacheItem[key];
            });
            return item;
        }
        function pushExcessBaggageAddToCart(excessBaggageDataFn) {
            try {
                var itemType = 'Extra Baggage';
                var excessBaggageData = excessBaggageDataFn();
                var currency = excessBaggageData.flights[0].currency;
                var baggageUnit = excessBaggageData.flights[0].passengerList[0].offerList[0].unit;

                var items = underscore.map(excessBaggageData.flights, function(flight) {
                    if(!flight.selectedItemCount || flight.selectedItemCount === 0) {
                        return;
                    }
                    var flightData = getFlightByLegOrder(String(flight.flightRph), null);
                    var asItem = additionalServiceItemScope(itemType, flightData);
                    asItem['cd_as_type'] = baggageUnit === 'pc' ? 'Piece' : baggageUnit;
                    asItem['cd_as_detail_product'] = '';
                    asItem['quantity'] = flight.selectedItemCount;
                    asItem['price'] = gaConvertPrice(currency, flight.selectedTotalFare) / (flight.selectedItemCount ? flight.selectedItemCount : 1);
                    return asItem;
                });

                removePreviousAdditionalServiceItems(itemType);
                var items = items.filter(function (item) {return item !== undefined; })
                if(items.length === 0) {
                    return;
                }
                var eventCurrency = hasTargetConversionRate(currency, gaTargetCurrency) ? gaTargetCurrency : currency;
                var eventValue = gaConvertPrice(currency, excessBaggageData.selectedGrandTotalFare);
                pushAdditionalServiceGenericAddToCart(eventCurrency, eventValue, items);
            } catch (e) {
                pushServiceError(e);
            }
        }

        /**
         * This method regroup selected pets by their type.
         * event: add_to_cart(PET & SPORTS EQUIPMENT & EXCESS_BAGGAGE)
         * @param additionalServiceData
         * @returns {*}
         */
        function itemGroupByTypes(additionalServiceData, itemType) {
            try {
                var legs = additionalServiceData.flights;
                var itemArray = []
                for(var i = 0; i < legs.length; i++) {
                    var passengers = legs[i].passengerList
                    for (var j = 0; j < passengers.length; j++) {
                        if (itemType === 'Excess Baggage') {
                            underscore.forEach(passengers[j].offerList, function (offer) {
                                if (offer.selectedAmount) {
                                    itemArray.push({ legIndex: i, amount: offer.selectedAmount, price: offer.priceInfo.baseFare, unit: offer.unit })
                                }
                            })
                        } else if (itemType === 'SAF') {
                            underscore.forEach(passengers[j].offerList, function (offer) {
                                if (offer.selected) {
                                    itemArray.push({ legIndex: i, amount: offer.selectedAmount, price: offer.priceInfo.baseFare,  unit: offer.unit, type: offer.type })
                                }
                            });
                        } else {
                            underscore.forEach(passengers[j].selectedOffers, function (offer) {
                                if (itemType === 'Pet' && offer.category && offer.family) {
                                    itemArray.push({legIndex: i, category: offer.category, family: offer.family, price: offer.priceInfo.baseFare ,curreny: offer.priceInfo.currency})
                                } else if (itemType === 'Sports Equipment' && offer.type && offer.selectedAmount !== 0) {
                                    itemArray.push({legIndex: i, type: offer.type, description: offer.typeDescription, price: (offer.priceInfo.baseFare / offer.selectedAmount) ,curreny: offer.priceInfo.currency, amount: offer.selectedAmount})
                                }
                            });
                        }
                    }
                }
                return underscore.groupBy(itemArray, function (item) {
                    if (itemType === 'Pet') {
                        return item.legIndex + '#' + item.category + '#' + item.family;
                    } else if (itemType === 'Sports Equipment') {
                        return item.legIndex + '#' + item.type
                    } else if (itemType === 'Excess Baggage') {
                        return item.legIndex
                    }
                })
            } catch (e) {
                pushServiceError(e)
            }
        }

        /**
         * This method regroup selected lounges by their leg index and type.
         * event: add_to_cart(LOUNGE)
         * @param loungeData
         * @returns {*}
         */
        function loungeGroupByLegAndType(loungeData) {
            try {
                var legs = loungeData.flights;
                var loungeArray = []
                for (var i = 0; i < legs.length; i++) {
                    var lounges = legs[i].loungeList
                    if (lounges) {
                        for (var j = 0; j < lounges.length; j++) {
                            var passengerList = lounges[j].passengerList
                            underscore.forEach(passengerList, function (passenger) {
                                var offer = passenger.offerList ? passenger.offerList[0] : undefined
                                if (offer && offer.selected) {
                                    loungeArray.push({
                                        legIndex: i,
                                        type: legs[i].originAirportCode,
                                        productType: lounges[j].loungePortCode,
                                        price: offer.priceInfo.baseFare,
                                        curreny: offer.priceInfo.currency
                                    })
                                }
                            })

                        }
                    }
                }
                return underscore.groupBy(loungeArray, function (lounge) {
                    return lounge.legIndex + '#' + lounge.productType
                })
            } catch (e) {
                pushServiceError(e)
            }
        }

        /**
         * This method creates cart item data with the item price values
         * event: add_to_cart(PET & LOUNGE & SPORTS EQUIPMENT)
         * @param additionalServiceData
         * @param eventCurrency
         * @param currency
         */
        function createAdditionalServiceCartItemData(additionalServiceData, eventCurrency, currency, itemType) {
            removePreviousAdditionalServiceItems(itemType);
            return createCartItemData(additionalServiceData, eventCurrency, currency, itemType)
        }

        function createCartItemDetails(asItem, item, itemType) {
            switch (itemType) {
                case 'Pet':
                    asItem["cd_as_type"] = mapPetCategoryType(item[0].category);
                    asItem["cd_as_detail_product"] = mapPetFamilyType(item[0].family);
                    asItem["quantity"] = item.length;
                    break
                case 'Lounge':
                    asItem["cd_as_type"] = item[0].type;
                    var lookUpKey = {"loungelookup": item[0].productType,};
                    asItem["cd_as_detail_product"] = item[0].type + ' - ' + i18n.getWithArgs('lounge.loungeName', lookUpKey);
                    asItem["quantity"] = item.length;
                    break
                case 'Sports Equipment':
                    asItem["cd_as_type"] = item[0].description;
                    asItem["cd_as_detail_product"] = '';
                    var quantity = 0;
                    item.forEach(function (subItem) {
                        quantity += subItem.amount;
                    })
                    asItem["quantity"] = quantity;
                    break
                case 'Excess Baggage':
                    asItem["cd_as_type"] = item[0].unit === 'pc' ? 'Piece' : 'kg';
                    asItem["cd_as_detail_product"] = '';
                    var quantity = 0;
                    item.forEach(function (subItem) {
                        quantity += subItem.amount;
                    })
                    asItem["quantity"] = quantity;
                    break
                case 'SAF':
                    asItem["cd_as_detail_product"] = '';
                    asItem["cd_as_type"] = setSafCdAsType(item);
                    asItem["quantity"] = item.length;
                default:
                    return
            }
        }
        function setSafCdAsType(offers) {
            var offerArr = [];
            offers.forEach(function(offer) {
                var safType = mapSafType(offer.type)
                if (!offerArr.includes(safType)) {
                    offerArr.push(safType);
                }
            })
            return underscore.sortBy(offerArr, function (saf) {return saf}).join('|');
        }
        function createCartItemData (additionalServiceData, eventCurrency, currency, itemType) {
            try {
                var groupedItems = []
                if(itemType === 'Lounge') {
                    groupedItems = loungeGroupByLegAndType(additionalServiceData)
                } else {
                    groupedItems = itemGroupByTypes(additionalServiceData, itemType);
                }
                var items = []
                Object.values(groupedItems).forEach(function createItem(item) {
                    if (item && item.length > 0) {
                        var flight = additionalServiceData.flights[item[0].legIndex]
                        var legOrder = flight && flight.flightRph ? flight.flightRph.toString() : '1'
                        var flightData = getFlightByLegOrder(legOrder, null);
                        var asItem = additionalServiceItemScope(itemType, flightData);
                        createCartItemDetails(asItem, item, itemType)
                        var price = item.reduce(function getPriceSum(total, subItem) {
                            return total + subItem.price;
                        }, 0) / item.length;
                        asItem["price"] = gaConvertPrice(currency, price);
                        items.push(asItem)
                    }
                });
                return items
            } catch (e) {

            }
        }

        /**
         * This method trigger when package offer selection completed
         * event: add_to_cart (PACKAGE_OFFER)
         * @param additionalServiceData
         */
        function pushPackageOfferAddToCartData (additionalServiceData) {
            try {
                var items = [];
                var selectedPackage = additionalServiceData.selectedPackage;
                clearPackageOffersCacheByPageType(additionalServiceData.packageCategory)
                if(!selectedPackage) {
                    return;
                }
                var services = underscore.map(selectedPackage.passengers[0].flights[0].services, function (service) {
                    return service;
                })
                if(!services || services.length === 0) {
                    return;
                }

                var currency = selectedPackage.priceInfo.currency;
                var quantity = selectedPackage.passengers.length;
                var item = createPackageOfferItem(services, selectedPackage, quantity);
                items.push(item)
                if(items && items.length > 0) {
                    var eventCurrency = hasTargetConversionRate(currency, gaTargetCurrency) ? gaTargetCurrency : currency;
                    var eventValue = gaConvertPrice(currency, selectedPackage.priceInfo.totalFare);
                    pushAdditionalServiceGenericAddToCart(eventCurrency, eventValue, items);
                }
            } catch (e) {
                pushServiceError(e);
            }
        }

        function clearPackageOffersCacheByPageType(category) {
            if(category === 'SEAT') {
                removePreviousSelectedAdditionalServiceCache("Package Offers", true);
            } else {
                removePreviousSelectedAdditionalServiceCache("Package Offers", false);
            }
        }
        function createPackageOfferItem(services, selectedPackage, quantity) {
            var flightData = getFlightByLegOrder(selectedPackage.passengers[0].flights[0].flightRph, null);
            var item = additionalServiceItemScope('Package Offers', flightData);
            item['quantity'] = quantity;
            item['price'] = gaConvertPrice(selectedPackage.priceInfo.currency, selectedPackage.priceInfo.totalFare) / (quantity > 0 ? quantity : 1);
            item['cd_as_type'] = underscore.sortBy(underscore.map(services, function(service) { return service.category ; }), function (item) { return item }).join('|');
            var productDetails = underscore.sortBy(underscore.map(services, function (service) {
                if(service.category === 'XBAG' && service.amount && service.unit) {
                    return service.amount + service.unit
                } else if (service.category === 'SEAT'){
                    return service.type === 'ANY' ? 'Exit-Legroom' : 'Preferred';
                } else {
                    return ;
                }
            }), function (item) { return item });
            var cd_as_detail_product = productDetails.filter(function(detail) {return detail !== ''}).join('|');
            item['cd_as_detail_product'] = cd_as_detail_product || 'none';
            return item;
        }

        /**
         * This method triggers when pet & lounge selections completed and added to the cart
         * event: add_to_cart (PET & LOUNGE & SPORTS EQUIPMENT)
         * @param additionalServiceData
         */
        function pushAdditionalServiceAddToCartData(additionalServiceData,itemType) {
            try {
                var currency = additionalServiceData.flights[0].currency
                var eventCurrency = hasTargetConversionRate(currency, gaTargetCurrency) ? gaTargetCurrency : currency;
                var eventValue = gaConvertPrice(currency, additionalServiceData.selectedGrandTotalFare);
                var items = createAdditionalServiceCartItemData(additionalServiceData, eventCurrency, currency, itemType)
                if(items && items.length > 0) {
                    pushAdditionalServiceGenericAddToCart(eventCurrency, eventValue, items);
                }
            } catch (e) {
                pushServiceError(e)
            }
        }

        function removePreviousAdditionalServiceItems(itemType) {
            var cacheItems = getAdditionalServiceCache();
            if (cacheItems.length === 0) return;
            cacheItems = underscore.filter(cacheItems, function(item) {
                return item.cd_item_type !== itemType;
            })
            localStorage.setItem('asItems', JSON.stringify(cacheItems));
        }

        function removePreviousSelectedAdditionalServiceCache(itemType, isSeat) {
            var cacheItems = getAdditionalServiceCache();
            if (cacheItems.length === 0) return;
            cacheItems = underscore.filter(cacheItems, function (item) {
                if (item.cd_item_type !== itemType) {
                    return true;
                } else {
                    return isSeat ? !item.cd_as_type.includes('SEAT') : item.cd_as_type.includes('SEAT');
                }
            });
            storageHelper.setItem({
                key: "asItems",
                value: JSON.stringify(cacheItems),
                webStorageType: storageHelper.Stores.LOCAL_STORAGE
            });
        }

        function hasAdditionalServiceItem(itemType) {
            var items = getAdditionalServiceCache();
            if (items.length === 0) return false;
            return underscore.some(items, function(item) {
                return item.cd_item_type === itemType;
            })
        }

        /**
         * Generic add to cart event for additional services
         * @param currency will be passed directly
         * @param value will be passed directly
         * @param items are selected on additional service screen
         */
        function pushAdditionalServiceGenericAddToCart(currency, value, items) {
            var eventData = getGAEventDataCache();
            eventData['value'] = value;
            eventData['currency'] = currency;
            eventData['items'] = items;
            eventData['page_type'] = 'additional services detail';

            pushEcommerceData({event: "add_to_cart", ecommerce: eventData});
            var cacheItems = underscore.map(items, createAdditionalServiceItemCache);
            appendAdditionalServiceCache(cacheItems);
        }
        // GA4 ADDITIONAL SERVICES END

        // GA4 RHS START
        var rhsFlowActive = false;
        function pushRHSHoldButtonClick(reservationBaseOptionResponse, rhsDetail) {
            try {
                var rhsData = extractRHSDataFromEventCache();
                if (!rhsData) {
                    return;
                }

                var priceData = unwrapReservationBaseOptionResponseFare(reservationBaseOptionResponse);
                underscore.extend(rhsData, priceData);

                var pageType = rhsDetail['pageType'] || getCurrentPageType();

                rhsData['widget_name'] = rhsDetail['widgetName'] + '|' + pageType;
                rhsData['page_type'] = pageType;

                var msLogin = getMSLoginStatusFromTagParams();
                if (msLogin) {
                    pushRHSHoldButtonClickEvent(rhsData, msLogin);
                    rhsDetail['showsBanner'] && pushRHSPopupInfoView(pageType);
                } else {
                    etrAjax.get({
                        app: 'app.ms',
                        service: '/miles/memberprofile',
                        callback: function (response) {
                            pushRHSHoldButtonClickEvent(rhsData, getMSLoginStatusFromResponse(response));
                            rhsDetail['showsBanner'] && pushRHSPopupInfoView(pageType);
                        },
                        preErrorProperties: {
                            preErrorFunction : function() {
                                pushRHSHoldButtonClickEvent(rhsData, null);
                                rhsDetail['showsBanner'] && pushRHSPopupInfoView(pageType);
                            }
                        },
                        disableErrorHandling: true
                    });
                }
            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushRHSLeaveIntentionView(reservationBaseOptionResponse) { // widget_name leave_intention
            try {
                var priceData = unwrapReservationBaseOptionResponseFare(reservationBaseOptionResponse);
                var pageType = getCurrentPageType();

                var additionalData = {
                    price: priceData.price,
                    currency: priceData.currency,
                    widget_name: 'Leave Intention' + '|' + pageType,
                    page_type: pageType
                }
                pushRHSData(additionalData, 'rhs_leave_intention_view')

            } catch (e) {
                pushServiceError(e);
            }
        }

        function getCurrentPageType() {
            if (!pageInfo) {
                return '';
            }

            var mainPageType = pageInfo.mainPageType;
            var pageType = pageInfo.pagetype;

            if (pageType === 'profile') {
                return 'passenger details';
            } else if (pageType === 'additional-services' && mainPageType === 'booking') {
                return 'additional services listing';
            } else if (mainPageType === 'AncillaryServices') {
                return 'additional services detail';
            } else if (pageType) {
                return pageType;
            } else {
                return '';
            }
        }

        function pushRHSHoldButtonClickEvent(rhsData, msLogin) {
            rhsData['ms_login_status'] = msLogin;
            localStorage.setItem('garhs', JSON.stringify({
                widget_name: rhsData['widget_name'],
                ms_login_status: rhsData['ms_login_status']
            }));
            pushEcommerceData({event: 'rhs_hold_button_click', hold_info: rhsData});
        }

        function pushRHSPopupInfoView(pageType) {
            try {
                pushRHSData({page_type: pageType || getCurrentPageType()}, 'rhs_popup_info_view');
            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushRHSData(additionalData, eventName, collection) {
            var rhsData = extractRHSDataFromEventCache();
            if (additionalData) {
                underscore.extend(rhsData, additionalData);
            }

            var storageData = JSON.parse(localStorage.getItem('garhs'));
            if (storageData) {
                underscore.extend(rhsData, storageData);
            }

            if (!rhsData['ms_login_status']) {
                var msLoginStatus = getMSLoginStatusFromTagParams();
                if (msLoginStatus) {
                    rhsData['ms_login_status'] = msLoginStatus;
                }
            }

            if (rhsData['ms_login_status']) {
                pushRHSDataDriver(eventName, rhsData, collection);
            } else {
                etrAjax.get({
                    app: 'app.ms',
                    service: '/miles/memberprofile',
                    callback: function (response) {
                        rhsData['ms_login_status'] = getMSLoginStatusFromResponse(response);
                        storageData = storageData || {};
                        storageData['ms_login_status'] = rhsData['ms_login_status'];
                        localStorage.setItem("garhs", JSON.stringify(storageData));
                        pushRHSDataDriver(eventName, rhsData, collection);
                    },
                    preErrorProperties: {
                        preErrorFunction : function() {
                            rhsData['ms_login_status'] = null;
                            pushRHSDataDriver(eventName, rhsData, collection);
                        }
                    }
                });
            }
        }

        function pushRHSDataDriver(eventName, rhsData, collection) {
            if (collection && collection.length > 0) {
                underscore.forEach(collection, function(item) {
                    pushEcommerceData({event: eventName, hold_info: merge([rhsData, item])})
                });
            } else {
                pushEcommerceData({event: eventName, hold_info: rhsData});
            }
        }

        /**
         * a util function merges multiple objects on a newly created object, next object's keys will override previous ones
         * @param objects an array of objects to be merged
         * @returns a newly created merged object
         */
        function merge(objects) {
            var mergedObj = {};
            underscore.forEach(objects, function(obj) {
                underscore.extend(mergedObj, obj);
            })
            return mergedObj;
        }

        function getMSLoginStatusFromTagParams() {
            var google_tag_params = window.google_tag_params;
            if (google_tag_params && google_tag_params.cd_MembershipTier) {
                if (google_tag_params.cd_MembershipTier === 'None-Member') {
                    return 'Guest';
                }
                return google_tag_params.cd_MembershipTier.split('_').map(function(word) {
                    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                }).join('');
            }
            return null;
        }

        function getMSLoginStatusFromResponse(response) {
            if (response && response.data && response.data.milesProgramInfo && response.data.milesProgramInfo.cardType) {
                switch (response.data.milesProgramInfo.cardType) {
                    case "CC": return "Classic";
                    case "CP": return 'ClassicPlus';
                    case "EC": return "Elite";
                    case "EP": return "ElitePlus";
                    default: return response.data.milesProgramInfo.cardType;
                }
            }
            return "Guest";
        }

        function clearRHSCache() {
            localStorage.removeItem('garhs');
        }

        function extractRHSDataFromEventCache() {
            var eventData = getGAEventDataCache();
            if (!eventData) {
                return;
            }
            return {
                flight_destination_airport: eventData.cd_item_flight_destination,
                flight_destination_city: eventData.cd_item_flight_destination_city,
                flight_destination_country: eventData.cd_item_flight_destination_country,
                flight_origin_airport: eventData.cd_item_flight_origin,
                flight_origin_city: eventData.cd_item_flight_origin_city,
                flight_origin_country: eventData.cd_item_flight_origin_country,
                item_category: eventData.item_category,
                item_category2: eventData.item_category2,
                item_category3: eventData.item_category3,
                item_category4: eventData.item_category4,
                item_category5: eventData.item_category5
            };
        }

        function pushRHSFareData(reservationBaseOptionResponse, pageType, eventName) {
            var priceData = unwrapReservationBaseOptionResponseFare(reservationBaseOptionResponse);
            pushRHSData({
                page_type: pageType,
                price: priceData.price,
                currency: priceData.currency
            }, eventName);
        }

        function pushRHSPassengerDetailClick(reservationBaseOptionResponse) {
            try {
                if (!rhsFlowActive) {
                    return;
                }
                pushRHSFareData(reservationBaseOptionResponse, 'passenger details', 'rhs_passenger_detail_click');
            } catch (e) {
                pushServiceError(e);
            }
        }

        var rhsCancelSent = false;

        function pushRHSPassengerDetailCancelClick(reservationBaseOptionResponse) {
            try {
                if (!rhsFlowActive || rhsCancelSent) {
                    return;
                }
                pushRHSFareData(reservationBaseOptionResponse, 'passenger details', 'rhs_passenger_detail_cancel_click');
                rhsCancelSent = true;
            } catch (e) {
                pushServiceError(e);
            }
        }

        function checkRHSFlowActive() {
            try {
                rhsFlowActive = JSON.parse(storageHelper.getItem({ key: "RHS_Selected", webStorageType: storageHelper.Stores.SESSION_STORAGE })) === true;
            } catch (e) {
                pushServiceError(e);
            }
        }

        function unwrapReservationBaseOptionResponseFare(reservationBaseOptionResponse) {
            if (!reservationBaseOptionResponse) {
                return {
                    price: 0,
                    currency: null
                };
            }
            var totalFare = reservationBaseOptionResponse().fareBreakdown.totalFare;
            return {
                price: gaConvertPrice(totalFare.currency, totalFare.amount),
                currency:  hasTargetConversionRate(totalFare.currency, gaTargetCurrency) ? gaTargetCurrency : totalFare.currency
            };
        }

        function getSelectedRHSFare(optionList, selectedOptionId) {
            var selectedOption = underscore.find(optionList, function(option) {
                return option.offerItemID === selectedOptionId;
            });

            return {
                price: selectedOption ? gaConvertPrice(selectedOption.totalFare.currency, selectedOption.totalFare.amount) : '',
                currency: selectedOption ? (hasTargetConversionRate(selectedOption.totalFare.currency, gaTargetCurrency) ? gaTargetCurrency : selectedOption.totalFare.currency) : ''
            }
        }

        function getSelectedRHSDuration(optionList, selectedOptionId) {
            for (var i = 0; i < optionList.length; i++) {
                if (optionList[i].offerItemID === selectedOptionId) {
                    var duration = getHoldingDurationInDays(optionList[i].optionDuration);
                    if (duration) {
                        return duration;
                    }
                }
            }
            return '';
        }

        function pushRHSPopupInfoClick() {
            try {
                pushRHSData({page_type: 'flight summary'}, 'rhs_popup_info_click');
            } catch (e) {
                pushServiceError(e);
            }
        }

        var rhsOptionViewed = false;

        function pushRHSOptionView(optionList) {
            try {
                rhsOptionViewed = true;
                var collection = underscore.map(optionList, function(option) {
                    return {
                        price: gaConvertPrice(option.totalFare.currency, option.totalFare.amount),
                        currency: hasTargetConversionRate(option.totalFare.currency, gaTargetCurrency) ? gaTargetCurrency : option.totalFare.currency,
                        holding_duration: getHoldingDurationInDays(option.optionDuration)
                    };
                });

                pushRHSData({page_type: 'rhs_option'}, 'rhs_option_view', collection);
            } catch (e) {
                pushServiceError(e);
            }
        }

        function getHoldingDurationInDays(optionDuration) {
            if (optionDuration && !isNaN(optionDuration)) {
                var durationInDays = Math.floor(optionDuration / (60 * 60 * 1000 * 24));
                return String(durationInDays);
            }
        }

        function getHoldingDurationInHours(optionDuration) {
            if (optionDuration && !isNaN(optionDuration)) {
                var durationInDays = Math.floor(optionDuration / (60 * 60 * 1000));
                return String(durationInDays);
            }
        }

        function pushRHSOptionClick(optionList, selectedOptionId) {
            try {
                var priceData = getSelectedRHSFare(optionList, selectedOptionId);
                var duration = getSelectedRHSDuration(optionList, selectedOptionId);

                pushRHSData({
                    page_type: 'rhs option',
                    price: priceData.price,
                    currency: priceData.currency,
                    holding_duration: duration
                }, 'rhs_option_click');
            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushRHSOptionCancelClick(reservationBaseOptionResponse) {
            try {
                pushRHSFareData(reservationBaseOptionResponse, 'rhs option', 'rhs_option_cancel_click');
            } catch (e) {
                pushServiceError(e);
            }
        }

        function baseRHSPaymentData (paymentInfo, reservationTime) {
            var eventData = getGAEventDataCache();
            var duration = reservationTime ? String(reservationTime / 24) : '';
            var base = {
                page_type: 'payment',
                widget_name: 'Payment Method',
                price: gaConvertPrice(paymentInfo.currency, paymentInfo.value),
                currency: hasTargetConversionRate(paymentInfo.currency, gaTargetCurrency) ? gaTargetCurrency : paymentInfo.currency,
                holding_duration: duration,
                item_category: eventData.item_category,
                item_category2: eventData.item_category2,
                item_category3: eventData.item_category3,
                item_category4: eventData.item_category4,
                item_category5: eventData.item_category5
            };
            if(duration) {
                base["holding_duration"] = duration;
            }
            return base;
        }
        function pushRHSPaymentMethodView(paymentInfo, reservationTime) {
            try {
                checkRHSFlowActive();
                if (!rhsFlowActive) {
                    return;
                }
                pushRHSData(baseRHSPaymentData(paymentInfo, reservationTime), 'rhs_payment_method_view');
            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushRHSPaymentMethodClick(paymentInfo, paymentType, reservationTime) {
            try {
                checkRHSFlowActive();
                if (!rhsFlowActive) {
                    return;
                }
                var RHSPaymentData = baseRHSPaymentData(paymentInfo, reservationTime)
                RHSPaymentData["payment_type"] = paymentType;
                pushRHSData(RHSPaymentData, 'rhs_payment_method_click');
            } catch (e) {
                pushServiceError(e)
            }

        }
        function pushRHSPaymentClick(paymentInfo, paymentType, reservationTime) {
            try {
                if (!rhsFlowActive) {
                    return;
                }

                var duration = reservationTime ? String(reservationTime / 24) : '';

                pushRHSData({
                    page_type: 'payment',
                    price: gaConvertPrice(paymentInfo.currency, paymentInfo.value),
                    currency: hasTargetConversionRate(paymentInfo.currency, gaTargetCurrency) ? gaTargetCurrency : paymentInfo.currency,
                    holding_duration: duration,
                    payment_type: paymentType
                }, 'rhs_payment_click');

                var rhsData = JSON.parse(storageHelper.getItem({ key: "garhs", webStorageType: storageHelper.Stores.SESSION_STORAGE }));
                rhsData['payment_type'] = paymentType;
                storageHelper.setItem({
                    key: "garhs",
                    value: JSON.stringify(rhsData),
                    webStorageType: storageHelper.Stores.SESSION_STORAGE
                });
            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushRHSHoldPurchase(reservationData) {
            try {
                var firstFlightTimestamp = reservationData.closestFlightToCheckin.firstSegment.departureDateTime;
                var firstFlightDate = moment(firstFlightTimestamp).format("YYYYMMDD");
                var pnr = reservationData.pnr + '-' + firstFlightDate;
                var price = gaConvertPrice(reservationData.totalCharge.currency, reservationData.totalCharge.amount);
                var currency = hasTargetConversionRate(reservationData.totalCharge.currency, gaTargetCurrency) ? gaTargetCurrency : reservationData.totalCharge.currency;
                var holdingDuration = !isNaN(reservationData.remainTimeToTicketing) ? String(Math.round(reservationData.remainTimeToTicketing / (60 * 60 * 1000 * 24))) : '';
                var timeToFirstFlight = firstFlightTimestamp - Date.now();
                var segmentCount = getSegmentCount(reservationData.allFlights);

                var rhsData = {
                    page_type: 'purchase',
                    price: price,
                    currency: currency,
                    day_until_flight: getHoldingDurationInDays(timeToFirstFlight),
                    hour_until_flight: getHoldingDurationInHours(timeToFirstFlight),
                    holding_duration: holdingDuration,
                    cm_ticket_count: reservationData.tickets.length,
                    cm_passenger_count: reservationData.passengers.length,
                    cm_coupon_count: segmentCount,
                    cd_segment_count: segmentCount,
                    cm_segment_count: segmentCount,
                    cm_leg_count: reservationData.allFlights.length,
                    pnr: pnr
                }

                rhsData['cd_ticket_count'] = rhsData['cm_ticket_count'] ? String(rhsData['cm_ticket_count']) : '';
                rhsData['cd_passenger_count'] = rhsData['cm_passenger_count'] ? String(rhsData['cm_passenger_count']) : '';
                rhsData['cd_coupon_count'] = rhsData['cm_coupon_count'] ? String(rhsData['cm_coupon_count']) : '';
                rhsData['cd_leg_count'] = rhsData['cm_leg_count'] ? String(rhsData['cm_leg_count']) : '';

                pushRHSData(rhsData, 'rhs_hold_purchase');
            } catch (e) {
                pushServiceError(e);
            }
        }

        var TRYCurrency = "TRY";
        var EURCurrency = "EUR";
        var IRRCurrency = "IRR";
        var originalPrice = "ORIGINAL_PRICE";

        function fillLowestPrices(google_tag_params, data, paymentCurrency) {
            if (paymentCurrency == IRRCurrency && fareBreakdown.totalAmountConvertedPrices[EURCurrency]) {
                paymentCurrency = EURCurrency;
            }

            var lowestPrices;
            if(data && data.lowestPrices) {
                lowestPrices = data.lowestPrices;
                sessionStorageUtil.persistData("lowestPrices", data.lowestPrices);
            } else {
                lowestPrices = sessionStorageUtil.getPersistedData("lowestPrices");
            }

            if(lowestPrices) {
                google_tag_params.cd_week_starting_bprice = lowestPrices.lowestPriceOfWeek && lowestPrices.lowestPriceOfWeek[paymentCurrency] ? lowestPrices.lowestPriceOfWeek[paymentCurrency].amount : "";
                google_tag_params.cd_dates_starting_bprice = lowestPrices.lowestPriceOfSelectedDates && lowestPrices.lowestPriceOfSelectedDates[paymentCurrency] ? lowestPrices.lowestPriceOfSelectedDates[paymentCurrency].amount : "";
                google_tag_params.cd_best_price_eco = lowestPrices.economyBestPrice && lowestPrices.economyBestPrice[paymentCurrency] ? lowestPrices.economyBestPrice[paymentCurrency].amount : "";
                google_tag_params.cd_best_price_bus = lowestPrices.businessBestPrice && lowestPrices.businessBestPrice[paymentCurrency] ? lowestPrices.businessBestPrice[paymentCurrency].amount : "";
            }
        }

        function extractLowestPricesFromImpression(impressions){
           return  impressions.filter(function (x) {
                return x.variant && x.price && x.category;
            }).map(function (x) {
                var variant = x.variant;
                var cabin = x.category.indexOf("Business") > -1 ? "bus" : "eco";
                var key = variant + "_" + cabin;
                var obj = {};
                obj[key] = [x.price];
                return [obj];
            }).reduce(function (x, y) {
                var obj = {}; //console.info(a,b)

                var priceValue1 = x[0];
                var priceValue2 = y[0];

                for (var k in priceValue1) {
                    obj[k] = priceValue1[k];
                }

                for (var k in priceValue2) {
                    obj[k] = obj[k] || priceValue2[k];
                    obj[k] = Math.min(obj[k], priceValue2[k]);
                } //console.log("obj",obj)


                return [obj];
            }).map(function (obj) {

                var root = {};

                for (var i in obj) {
                    var cabinType = i.split("_")[1];
                    root[cabinType] = (root[cabinType] || 0) + obj[i];

                }

                return root;
            });
        }

        var fillLowestPricesBranded=function (impressions,data) {

            try {
                var dailyLowestPrices = extractLowestPricesFromImpression(impressions);
                if (dailyLowestPrices&&dailyLowestPrices[0]) {
                    data.lowestPrices==data.lowestPrices||{};
                    data.lowestPrices.economyBestPrice={};
                    data.lowestPrices.economyBestPrice[data.currency]={amount : safeToFixed(dailyLowestPrices[0].eco)};
                    data.lowestPrices.businessBestPrice={};
                    data.lowestPrices.businessBestPrice[data.currency]={amount:safeToFixed(dailyLowestPrices[0].bus)};
                }
            }catch (e){
                console.log(e);
            }
        }


        function safeToFixed(amount){
           return  amount ? toFixedNumber(amount) : amount;
        }

        function fillGTMFareBreakdownParameters(google_tag_params, fareBreakdown, paymentCurrency, data) {
        	if(paymentCurrency == IRRCurrency && fareBreakdown.totalAmountConvertedPrices[EURCurrency]) {
            	paymentCurrency = EURCurrency;
            }
        	
        	google_tag_params.currency = paymentCurrency; //seçili currency kodu
        	google_tag_params.TotalValue = safeToFixed(fareBreakdown.totalAmountConvertedPrices[paymentCurrency].amount);
        	google_tag_params.TotalValueLCC = safeToFixed(fareBreakdown.totalAmountConvertedPrices[paymentCurrency].amount);
        	google_tag_params.TotalValueTRY = fareBreakdown.totalAmountConvertedPrices[TRYCurrency] && toFixedNumber(fareBreakdown.totalAmountConvertedPrices[TRYCurrency].amount);
        	google_tag_params.FuelSurchargeValueLCC = safeToFixed(fareBreakdown.totalCarrierChargeConvertedPrices[paymentCurrency].amount);
        	google_tag_params.FuelSurchargeValueTRY = fareBreakdown.totalCarrierChargeConvertedPrices[TRYCurrency] && toFixedNumber(fareBreakdown.totalCarrierChargeConvertedPrices[TRYCurrency].amount);
        	google_tag_params.TaxesandFeesValueLCC = safeToFixed(fareBreakdown.totalTaxAmountConvertedPrices[paymentCurrency].amount);
        	google_tag_params.TaxesandFeesValueTRY = fareBreakdown.totalTaxAmountConvertedPrices[TRYCurrency] && toFixedNumber(fareBreakdown.totalTaxAmountConvertedPrices[TRYCurrency].amount);
        	google_tag_params.TicketingServiceFeeValueLCC = safeToFixed(fareBreakdown.totalServiceFeeConvertedPrices[paymentCurrency].amount);
        	google_tag_params.TicketingServiceFeeValueTRY = fareBreakdown.totalServiceFeeConvertedPrices[TRYCurrency] && toFixedNumber(fareBreakdown.totalServiceFeeConvertedPrices[TRYCurrency].amount);

            fillLowestPrices(google_tag_params,data,paymentCurrency);
        }
        
        function fillGTMAwardTicketFareBreakdownParameters(google_tag_params, fareBreakdown, paymentCurrency, data) {
        	var lowestPrices;
        	if(data && data.lowestPrices) {
        		lowestPrices = data.lowestPrices;
        		sessionStorageUtil.persistData("lowestPrices", data.lowestPrices);
        	} else {
        		lowestPrices = sessionStorageUtil.getPersistedData("lowestPrices");
        	}

        	if(paymentCurrency == null)
        		paymentCurrency = originalPrice;
        	
        	if(fareBreakdown.grandTotalCurrency){
	        	google_tag_params.currency = fareBreakdown.grandTotalCurrency;
	        	google_tag_params.miles = fareBreakdown.grandTotalForAwardTicket;
	        	google_tag_params.TaxesandFeesValueLCC = fareBreakdown.convertedTotalTaxPrices[paymentCurrency].amount;
	        	google_tag_params.TaxesandFeesValueTRY = fareBreakdown.convertedTotalTaxPrices[TRYCurrency] && toFixedNumber(fareBreakdown.convertedTotalTaxPrices[TRYCurrency].amount);
        	}
        	
        	
        	if(lowestPrices) {
        		google_tag_params.cd_week_starting_milesbprice = lowestPrices.lowestPriceOfWeek && lowestPrices.lowestPriceOfWeek[paymentCurrency] ? lowestPrices.lowestPriceOfWeek[paymentCurrency].amount : "";
        		google_tag_params.cd_dates_starting_milesbprice = lowestPrices.lowestPriceOfSelectedDates && lowestPrices.lowestPriceOfSelectedDates[paymentCurrency] ? lowestPrices.lowestPriceOfSelectedDates[paymentCurrency].amount : "";
        		google_tag_params.cd_best_milesprice_eco = lowestPrices.economyBestPrice && lowestPrices.economyBestPrice[paymentCurrency] ? lowestPrices.economyBestPrice[paymentCurrency].amount : "";
        		google_tag_params.cd_best_milesprice_bus  = lowestPrices.businessBestPrice && lowestPrices.businessBestPrice[paymentCurrency] ? lowestPrices.businessBestPrice[paymentCurrency].amount : "";
        	}
        }
        
        var availabilityGTMUtil = {
        	getTotalPaxCount : function(bookingRequest) {
        		return underscore.reduce(bookingRequest.bookings[0].paxList, function(memo, pax){ return memo + pax.count; }, 0);
        	},
        	getPortCode : function(port) {
    			return (port.multi && port.city) ? port.city.code + "_ALL" : port.code;
    		},
    		isMultiCity : function(tripType) {
    			return tripType == 'MULTI_CITY';
    		},
        	getVariant: function(panelIndex, tripType) {
    			if(availabilityGTMUtil.isMultiCity(tripType)) {
    				return 'outbound flights ' + (panelIndex +1);
    			} else {
    				return panelIndex == 0 ? 'outbound flights' : 'inbound flights';
    			}
    		},
    		prepareFlightData: function(product, data, flight){
    			
    			var flightData = parseFlightData([flight]);
    			var flightDurationData = parseFlightDurationData([flight]);
                
                product.name = flight.segments[0].originAirport.code + '-' + flight.segments[flight.segments.length -1].destinationAirport.code;
                product.brand = underscore.unique(flightData.operatingAirlines).join('|');
                
                if(flight.index > -1) {
                	product.position = flight.index + 1;
                } else if(flight.routeIndex > -1) {
                	var indices = sessionStorageUtil.getPersistedData("availabilityFlightIndices");
                	if(indices && flight.routeIndex < indices.length && indices[flight.routeIndex]>-1) {
                		product.position = indices[flight.routeIndex] + 1;
                	}
                }
                if(data.quantity) {
                	product.quantity = data.quantity;
                }
                product.id = flightData.flightNumberArray.join('|');
                product.cd_aircraft = flightData.equipments.join('|');
                product.cd_operating_carrier = flightData.operatingAirlines.join('|');
                product.cd_rev_book_designator = flightData.flightClasses.join('|');
                product.cd_takeoff_time = moment.utc(flight.segments[0].departureDateTime).format('YYYYMMDD-HHmm-dddd', 'en');
                product.cd_landing_time = moment.utc(flight.segments[flight.segments.length - 1].arrivalDateTime).format('YYYYMMDD-HHmm-dddd', 'en');
                product.cd_flight_duration = flightDurationData.flightDurationsAsHumanized[0];
                product.cd_flight_conn_status = flight.countOfStops > 0 ? 'Yes' : 'No';
                product.cd_flight_conn_point = flightData.connectionPoints.join('|');
                product.cd_flight_number_list = flightData.flightNumberArray.join('|');
                product.cd_flight_route_list = flightData.routeArray.join('|');

    		},
    		prepareSummaryFlightData: function(product, data, flight){
    			
                product.name = flight.segments[0].originAirport.code + '-' + flight.segments[flight.segments.length -1].destinationAirport.code;
                product.id = underscore.pluck(flight.segments, "flightNumber").join('|');
                product.brand = underscore.unique(underscore.pluck(flight.airlinesBySegment, "shortName")).join('|');
                product.position = flight.index + 1;
                if(data.productListActive)
                	product.list = availabilityGTMUtil.getSearchResultDefinitionAttribute(data, flight);

    		},
    		prepareFlightPriceData: function(product, data, flight){
    			if(!availabilityGTMUtil.isMultiCity(data.tripType) || data.domestic) {
	    			var priceHolder = availabilityGTMUtil.getPriceHolder(flight);

	            	if(priceHolder) {
	            		availabilityGTMUtil.updateCurrency(data, priceHolder);
	            		product.price = priceHolder.convertedPrices[data.currency].amount;
	            	} else {
	            		var brandCard = availabilityGTMUtil.getSelectedBrandCard(flight);
	            		if(brandCard) {
	            			product.price = brandCard.price.amount;
	            		}
	            	}
    			}
    		},
    		getSelectedBrandCard : function(flight) {
    			if(flight.availabilityData && flight.availabilityData.selectedFareInfo) {
    				for(var cc in flight.availabilityData.fareCategories){
    					var category = flight.availabilityData.fareCategories[cc];
    					for(var j = 0; j< category.subcategories.length; j++) {
    						var subcategory = category.subcategories[j];
    						if(subcategory.brandCode == flight.availabilityData.selectedFareInfo.brandCode) {
    							return subcategory;
    						}
    					}
                    }
    			}
    			return '';
    		},
    		getPriceHolder : function(flight){
    			var priceHolder;
            	if(flight.hasPriceForSelectedFareBasisCode) {

                	if(flight.hasPriceForSelectedFareBasisCode() && flight.priceForSelectedFareBasisCode()){
                		priceHolder = flight.priceForSelectedFareBasisCode();
                	}

                } else if(flight.bookingPriceTagForSelectedFareBasisCode) {
                	priceHolder = flight.bookingPriceTagForSelectedFareBasisCode;
                }
            	return priceHolder;
    		},
    		updateCurrency : function(data, priceHolder){
    			if(data.currency == IRRCurrency && priceHolder.convertedPrices[EURCurrency]) {
        			data.currency = EURCurrency;
        		}
    		},
    		getFlightProduct : function(data, flight) {
    			var product = {};
    			availabilityGTMUtil.prepareFlightData(product, data, flight);
				availabilityGTMUtil.prepareFlightPriceData(product, data, flight);
				availabilityGTMUtil.prepareAdditionalProductFields(product, data, flight);
				return product;
    		},
    		getSummaryFlightProduct : function(data, flight) {
                var product = {};
                availabilityGTMUtil.prepareSummaryFlightData(product, data, flight);
                availabilityGTMUtil.prepareFlightPriceData(product, data, flight);
                availabilityGTMUtil.prepareAdditionalProductFields(product, data, flight);
                return product;
            },
    		prepareAdditionalProductFields: function(product, data, flight) {
    			var tripType = getTripType(data.tripType);
                var routeType = getRouteType(data.domestic, data.selectedFlights, data.bookingRequest);
                
                var mainCabinType;
                if(flight) {
                	mainCabinType = availabilityGTMUtil.getFareFamily(flight);
                } else {
                	 var cabinTypes = underscore.map(data.selectedFlights, function(flight) {return flight.cabinClass;});
                     mainCabinType = getMainCabinType(normalizeCabinTypes(cabinTypes));
                }

                product.category = routeType + '/' + mainCabinType + '/' + tripType;
                product.variant = availabilityGTMUtil.getVariant(flight.routeIndex, data.tripType);

    		},
    		prepareSummaryFlightDatas : function(data) {
    			return underscore.map(data.selectedFlights, function(flight) {
    				return availabilityGTMUtil.getSummaryFlightProduct(data, flight);
    			});
    		},
            prepareSummaryUnSelectedFlightDatas : function(data,prepareFunction){

                var flights = data.selectedFlights;
                flights = underscore.filter(flights,function(f){return f.availabilityData;});

                var preparedFlights =  underscore.map(flights,function(flight){


                    return prepareFunction.apply(availabilityGTMUtil,[flight,data]);

                });


                return underscore.flatten(preparedFlights,true);

            },

            prepareMinSubCategBrand : function(data,flight,fareCategName){
                var fareCategory =  flight.availabilityData.fareCategories;
                if(fareCategory[fareCategName]){

                    if(fareCategory[fareCategName].status=="AVAILABLE"&&fareCategory[fareCategName].minPriceSubcategory){
                        fareCategory[fareCategName].minPriceSubcategory.cabinClass = fareCategName;
                        return availabilityGTMUtil.getProductForBrand(flight,data,fareCategory[fareCategName].minPriceSubcategory)
                    }
                    else if(fareCategory[fareCategName].status=="SOLDOUT"){

                        return availabilityGTMUtil.getProductForBrand(flight,data,{
                            cabinClass :fareCategName,
                            status : "SOLDOUT"
                        });

                    }

                }

                return false;
            },

            prepareSubCategBrand:  function(data,flight,fareCategName){
                var fareCategory =  flight.availabilityData.fareCategories;
                if(fareCategory[fareCategName]){
                    if(fareCategory[fareCategName].status=="AVAILABLE"){
                        return  underscore.map(fareCategory[fareCategName].subcategories,function(category){
                            return availabilityGTMUtil.getProductForBrand(flight,data,category);
                        });
                    }

                }
            },

            prepareMinSubCategBrandMobile : function(data,flight){
                return  availabilityGTMUtil.prepareMinSubCategBrand(data,flight,"ECONOMY") || availabilityGTMUtil.prepareMinSubCategBrand(data,flight,"BUSINESS");
            },


            prepareSummaryUnSelectedFlightDataList : function(flight,data){

                var preparedFlights=[];

                var checkAndPush = function(item){
                    if(item){
                        preparedFlights.push(item);
                    }
                }

                if(window.isMobile){
                    checkAndPush(availabilityGTMUtil.prepareMinSubCategBrandMobile(data,flight));
                }
                else{
                    checkAndPush(availabilityGTMUtil.prepareMinSubCategBrand(data,flight,"ECONOMY"));
                    checkAndPush(availabilityGTMUtil.prepareMinSubCategBrand(data,flight,"BUSINESS"));

                }

                return preparedFlights;

            },


            prepareSummaryUnSelectedFlightDataListOpened : function(flight,data){
                var preparedFlights=[];
                var checkAndPush = function(items){
                    var list = underscore.filter(items,function(item){return item});
                    underscore.each(list, function(item) {
                        preparedFlights.push(item);
                    })
                }

                if(data.openedItemType=="economy"){
                    checkAndPush(availabilityGTMUtil.prepareSubCategBrand(data,flight,"ECONOMY"));
                }
                else if(data.openedItemType=="business"){
                    checkAndPush(availabilityGTMUtil.prepareSubCategBrand(data,flight,"BUSINESS"));
                }
                else if(data.openedItemType=="mobile"){
                    checkAndPush(availabilityGTMUtil.prepareSubCategBrand(data,flight,"ECONOMY"));
                    checkAndPush(availabilityGTMUtil.prepareSubCategBrand(data,flight,"BUSINESS"));

                }

                return preparedFlights;
            },


            getProductForBrand: function(flight,data,fareSubCategory){
                var product = {};
                availabilityGTMUtil.prepareSummaryFlightData(product, data, flight);
                availabilityGTMUtil.prepareFlightPriceDataForBrand(product, fareSubCategory);
                availabilityGTMUtil.prepareAdditionalProductFieldsForBranded(product,flight,fareSubCategory, data);
                return product;

            },

            prepareFlightPriceDataForBrand : function(product,fareSubCategory){
                if(fareSubCategory&&fareSubCategory.price){
                    product.price = fareSubCategory.price.amount;
                }


            },
            prepareAdditionalProductFieldsForBranded : function(product,flight,fareSubCategory,data){
                var tripType = getTripType(data.tripType);
                var routeType = getRouteType(data.domestic, data.selectedFlights, data.bookingRequest);
                product.variant = availabilityGTMUtil.getVariant(flight.routeIndex, data.tripType);
                product.list = availabilityGTMUtil.getSearchResultDefinitionAttributeForBranded(data,fareSubCategory);
                var fareFamily = availabilityGTMUtil.getFareFamilyFromBrandMap(fareSubCategory.brandCode,fareSubCategory.cabinClass);
                var isSoldout = availabilityGTMUtil.isBrandSoldout(fareSubCategory);
                product.category = routeType + '/' + fareFamily + isSoldout+ '/' + tripType;
            },
    		prepareFlightDatas: function(data){
    			return underscore.map(data.selectedFlights, function(flight) {
    				return availabilityGTMUtil.getFlightProduct(data, flight);
    			});
    		},
    		prepareAvailabilityFlightData: function(data){
    			return availabilityGTMUtil.getFlightProduct(data, data.currentFlight);
    		},
    		getAwardTicketFlightProduct : function(data, flight) {
    			var product = {};
    			availabilityGTMUtil.prepareFlightData(product, data, flight);
				availabilityGTMUtil.prepareAdditionalProductFields(product, data, flight);
				availabilityGTMUtil.prepareAwardTicketProductFields(product, data, flight);
				return product;
    		},
    		getAwardTicketSummaryFlightProduct : function(data, flight) {
    			var product = {};
    			availabilityGTMUtil.prepareSummaryFlightData(product, data, flight);
				availabilityGTMUtil.prepareAdditionalProductFields(product, data, flight);
				availabilityGTMUtil.prepareAwardTicketProductFields(product, data, flight);
				return product;
    		},
    		prepareAwardTicketSummaryFlightDatas : function(data) {
    			return underscore.map(data.selectedFlights, function(flight) {
    				return availabilityGTMUtil.getAwardTicketSummaryFlightProduct(data, flight);
    			});
    		},
    		prepareAwardTicketProductFields: function(product, data, flight) {
    			var priceHolder = availabilityGTMUtil.getPriceHolder(flight);
            	
            	if(priceHolder) {
            		availabilityGTMUtil.updateCurrency(data, priceHolder);
            		product.miles = priceHolder.convertedPrices[originalPrice].amount;
            	}
    		},
    		prepareAwardTicketFlightDatas: function(data){
    			return underscore.map(data.selectedFlights, function(flight) {
    				return availabilityGTMUtil.getAwardTicketFlightProduct(data, flight);
    			});
    		},
    		prepareAwardTicketAvailabilityFlightData: function(data){
    			return availabilityGTMUtil.getAwardTicketFlightProduct(data, data.currentFlight);
    		},
    		getSearchResultDefinitionAttribute : function(data, flight) {
    			var multicity = availabilityGTMUtil.isMultiCity(data.tripType) ? "|MC" : "";
    			return 'Search Results' + multicity + ' – ' + availabilityGTMUtil.getFareFamily(flight);
    		},
            getSearchResultDefinitionAttributeForBranded : function(data,fareSubCategory ) {
                var multicity = availabilityGTMUtil.isMultiCity(data.tripType) ? "|MC" : "";
                var isSoldOut =availabilityGTMUtil.isBrandSoldout(fareSubCategory);
                return 'Search Results' + multicity + ' – ' + availabilityGTMUtil.getFareFamilyFromBrandMap(fareSubCategory.brandCode,fareSubCategory.cabinClass) + isSoldOut;;
            },
            isBrandSoldout : function(fareSubCategory){
                return   fareSubCategory.status!="AVAILABLE" ? " SoldOut":"";
            },
            getFareFamilyFromMap : function(code){
                var mainKeys = {
                    "EP" :"Economy Promotion",
                    "EYE":"Economy Semi Flex",
                    "EE" :"Economy Flex",
                    "BYE":"Business Semi Flex",
                    "BP":"Business Promotion",
                    "BE":"Business Flex",
                    "EG":"Economy General",
                    "BG":"Business General",
                    "ESG":"Economy Seat Guaranteed",
                    "BSG":"Business Seat Guaranteed",
                    "ENG":"Economoy Seat Not Guaranteed",
                    "BNG":"Bussiness Seat Not Guaranteed"
                };
                var keys = {
                    "TREUPRO" : "EP",
                    "TRFENFLEX": "EP",
                    "TRMEAFREST":"EP",
                    "TRUSEF3" :"EP",
                    "TRZANFLEX":"EP",
                    "RES_SL9000":"EP",
                    "ER": "EP",
                    "TREUSEMFL2": "EYE",
                    "TRFESF":"EYE",
                    "TRMEAFSFX1":"EYE",
                    "TRUSEF2":"EYE",
                    "TRZASFLEX2":"EYE",
                    "RES_SL8000":"EYE",
                    "TREUFULFLX":"EE",
                    "TRFEF":"EE",
                    "TRMEAFFFX":"EE",
                    "TRUSEFF":"EE",
                    "TRZAFFLEX":"EE",
                    "RES_SL7000":"EE",
                    "EU":"EE",
                    "BUSPROMO":"BP",
                    "RES_SL3000":"BP",
                    "TREUBR":"BYE",
                    "TRFEBIZPRO":"BYE",
                    "TRMEASBR":"BYE",
                    "TRUSBPRO":"BYE",
                    "TRZARBIZ":"BYE",
                    "RES_SL2000":"BYE",
                    "TREUBUS":"BE",
                    "TRFEBIZ":"BE",
                    "TRMEAFBUSS":"BE",
                    "TRUSBFF":"BE",
                    "TRZABIZ":"BE",
                    "RES_SL1000":"BE",
                    "BU":"BE",
                    "ECOGLOBAL":"EG",
                    "STUPEX":"EG",
                    "BUSGLOBAL":"BG",
                    "FREEECONOMYG" : "ESG",
                    "FREEECONOMYNG":"ENG",
                    "FREEBUSINESSG" : "BSG",
                    "FREEBUSINESSNG": "BNG"
                };
                if(keys[code]){

                    return  mainKeys[keys[code]];
                }
                return  i18n.get('farefamilylookup.'+ code);
            },
            getFareFamilyFromBrandMap : function(brandCode, cabinClass){
                var keys = {
                    "BA": "Economy Promotion",
                    "RE": "Economy Semi Flex",
                    "FL": "Economy Flex",
                    "BU": "Business Flex",
                    "EF": "Economy Promotion",
                    "XF": "Economy Semi Flex",
                    "PF": "Economy Flex"
                };
                if(keys[brandCode]){
                    return keys[brandCode];
                }
                
                var cc = (cabinClass == "ECONOMY") ? "Economy" : (cabinClass == "BUSINESS" ? "Business" : '');
                if(brandCode){
                    return  cc + ' ' + i18n.get('brandnamelookup.'+ brandCode);
                }
                else{
                    return cc ? cc : cabinClass;
                }
            },
    		getFareFamily : function(flight) {
    			if(flight.full) {
    				return "SoldOut";
    			}
    			var fareFamily = availabilityGTMUtil.getFareFamilyOfSelectedFlight(flight);
    			return fareFamily ? fareFamily : "None";
    		},
    		getFareFamilyOfSelectedFlight : function(flight) {
    			if(flight.hasPriceForSelectedFareBasisCode && flight.hasPriceForSelectedFareBasisCode()) {
                    return availabilityGTMUtil.getFareFamilyFromMap(flight.priceForSelectedFareBasisCode().code)
    			} 
    			if(flight.availableFlightFare && flight.availableFlightFare.preferedFareBasisCode) {
    				return availabilityGTMUtil.getFareFamilyFromMap(flight.availableFlightFare.preferedFareBasisCode);
    			}
    			if(flight.availabilityData && flight.availabilityData.selectedFareInfo){
    				return availabilityGTMUtil.getFareFamilyFromBrandMap(flight.availabilityData.selectedFareInfo.brandCode, flight.availabilityData.selectedFareInfo.cabinClass);

    			}
    			if(flight.brandCode){
    				return availabilityGTMUtil.getFareFamilyFromBrandMap(flight.brandCode, flight.cabinClass);
    			}
    			if(flight.cabinClasses){
    				return availabilityGTMUtil.getFareFamilyFromMap(flight.cabinClasses);
    			}
    			return '';
    		},
            getCabinClassOfSelectedFlight:function(flight){
                var farefamily = availabilityGTMUtil.getFareFamilyOfSelectedFlight(flight);
                if(farefamily){
                    return farefamily.split(" ")[0];
                }
                return '';

            },
    		prepareAddToCartData : function(data) {
    			data.quantity = availabilityGTMUtil.getTotalPaxCount(data.bookingRequest);
            	var products = availabilityGTMUtil.prepareFlightDatas(data);

    			return params = {
    				products : products,
    				eventCallback : data.eventCallback,
    				currencyCode : data.currency
    			}
            },
            prepareAwardTicketAddToCartData : function(data) {
            	data.quantity = availabilityGTMUtil.getTotalPaxCount(data.bookingRequest);
            	var products = availabilityGTMUtil.prepareAwardTicketFlightDatas(data);

    			return params = {
    				products : products,
    				eventCallback : data.eventCallback,
    				currencyCode : data.currency
    			}
            }
        }





        var onlineTicketing = {

            pushAvailabilityBestPricesBranded:function(data,params){

                fillLowestPricesBranded(params.impressions,data);

                var obj = { _meta : {pushTypeEvent : "availability_best_prices"}};
                fillLowestPrices(obj,data,data.currency);
                pushDataToDataLayer(obj,true);
            },
        	pushAvailabilityResponse : function(data) {
        		data.productListActive = true;
    			var impressions = availabilityGTMUtil.prepareSummaryFlightDatas(data);
    			
    			var params = {
    				impressions : impressions,
    				currencyCode : data.currency
    			}

                if(data.lowestPrices){
                    var obj = { _meta : {pushTypeEvent : "availability_best_prices"}};
                    fillLowestPrices(obj,data,data.currency);
                    pushDataToDataLayer(obj,true);
                }

    			ecommerceModels.bookingImpTracking(params);

        	},
            pushAvailabilityResponseBrandedDometicList : function(data){

                var prepareFunction  = availabilityGTMUtil.prepareSummaryUnSelectedFlightDataList;
                var impressions = availabilityGTMUtil.prepareSummaryUnSelectedFlightDatas(data,prepareFunction);
                var params = {
                    impressions : impressions,
                    currencyCode : data.currency
                };


                onlineTicketing.pushAvailabilityBestPricesBranded(data,params);

                ecommerceModels.bookingImpTracking(params);
            },
            pushAvailabilityResponseBrandedDometicListOpened: function(data){
                var prepareFunction  = availabilityGTMUtil.prepareSummaryUnSelectedFlightDataListOpened;
                var impressions = availabilityGTMUtil.prepareSummaryUnSelectedFlightDatas(data,prepareFunction);
                if(window.onlyUniqImpressionsAllowed){

                    var previouslySentImpressions = dataLayer.filter(function (x) {
                        return x && x.event == "impressions";
                    }).map(function (x) {
                        return x.ecommerce.impressions;
                    }).reduce(function (x, y) {
                        return x.concat(y);
                    }, []);

                    impressions = impressions.filter(function(x){ return !underscore.findWhere(previouslySentImpressions, x); });

                    if(impressions.length<=0){
                        return;
                    }
                }

                var params = {
                    impressions : impressions,
                    currencyCode : data.currency
                }
                ecommerceModels.bookingImpTracking(params);
            },
        	pushAvailabilityFlightSelectionClick : function(data) {
        		var product = availabilityGTMUtil.prepareAvailabilityFlightData(data);
    			
    			var flight = data.currentFlight ? data.currentFlight : data.selectedFlights[0];
    			
    			var action = {'list': availabilityGTMUtil.getSearchResultDefinitionAttribute(data, flight)};
    			
    			var params = {
    				products : [product],
    				action : action,
    				currencyCode : data.currency
    			}
    			ecommerceModels.flightClickTracking(params);
        	},
        	pushAvailabilityFlightDetailsView : function(data) {
        		var params = {
    				products : availabilityGTMUtil.prepareSummaryFlightDatas(data),
    				action : {'list': availabilityGTMUtil.getSearchResultDefinitionAttribute(data, data.selectedFlights[0])},
    				currencyCode : data.currency
        		}
        		ecommerceModels.flightDetailTracking(params);
        	},
        	pushSeatSelectCheckout : function(data){
        		data.quantity = availabilityGTMUtil.getTotalPaxCount(data.bookingRequest);
                
                var params = {
        				products : availabilityGTMUtil.prepareFlightDatas(data),
        				eventCallback : data.eventCallback,
        				action : {step:1 , option :"seat-selected"}
        			}
                ecommerceModels.seatSelectCheckout(params);
            },
            pushAddToCartData : function(data) {
             	var params =  availabilityGTMUtil.prepareAddToCartData(data);
     			ecommerceModels.flightAddToCartClick(params);
            },
            pushAvailabilitySelectedFlightData : function(data, memberProfile){

                try {

                    var searchData = data.bookingRequest.bookings[0];

                    var cabinFareFamily = availabilityGTMUtil.getFareFamily(data.selectedFlights[0]);

                    var cabinFareFullFamily = data.selectedFlights.map(function(x){
                        return availabilityGTMUtil.getFareFamily(x);
                    }).join("|");

                    var cabinClass = availabilityGTMUtil.getCabinClassOfSelectedFlight(data.selectedFlights[0]);

                    var flightData = parseFlightData(data.selectedFlights);

                    var flightFullRoute = getTripFullRoute(data.selectedFlights);

                    var flightOrigin  = getFirstFlightOrigin(data.selectedFlights);

                    var flightArrival = getFirstFlightArrival(data.selectedFlights);

                    var flightDurationData = parseFlightDurationData(data.selectedFlights);

                    var durationType = getFlightDurationType(flightDurationData.segmentDurationsAsHours);

                    var tripType = getTripType(data.tripType);

                    var routeType = getRouteType(data.domestic,data.selectedFlights);

                    var remainingSeatList = getRemainingSeats(data.selectedFlights);

                    var loyaltyInfo = getLoyaltyData(memberProfile);

                    var adultCount = 0;
                    var childCount = 0;
                    var infCount = 0;
                        for (var counter = 0; counter < searchData.paxList.length; counter++) {
                            if (searchData.paxList[counter].code === "ADULT") {
                                adultCount = searchData.paxList[counter].count
                            }
                            if (searchData.paxList[counter].code === "CHILD") {
                                childCount = searchData.paxList[counter].count
                            }
                            if (searchData.paxList[counter].code === "INFANT") {
                                infCount = searchData.paxList[counter].count
                            }
                        }


                    var google_tag_params = {
                        pagetype: 'product',
                        mainPageType: 'booking',
                        origindestination: flightOrigin+'-'+flightArrival,
                        cd_TripType: tripType,
                        prodid: flightOrigin+'-'+flightArrival,
                        pname: flightOrigin+'-'+flightArrival,
                        cd_cabinClass: cabinClass,//'Economy', //cabin class (Economy, Comfort, Business)
                        cd_fareFamily: cabinFareFamily,//'Promotion|Flex', //Fare Family (Promotion, Flex, Semi Flex)
                        cd_RBD: flightData.flightClasses.join('|'),//'Y|W', //Revenue Booked Designator (F,W,P,V,L,T,Q,E,S,H…)
                        pcategory : routeType+'/'+cabinFareFamily+'/'+tripType,
                        cd_OperatingCarrier : flightData.operatingAirlines.join('|'),//'TK|AJ|LH',
                        cd_fareType : buildFareType(getPaxList(data.airTravelers)),
                        cd_RouteType : routeType,
                        cd_flightOrigin : flightOrigin,
                        cd_flightOriginCity : searchData.originAirport.city.code,
                        cd_flightOriginCountry : searchData.originAirport.country.code,
                        cd_flightDestination : flightArrival,
                        cd_flightDestinationCity : searchData.destinationAirport.city.code,
                        cd_flightDestinationCountry : searchData.destinationAirport.country.code,
                        cd_flightFullRoute :  flightFullRoute,//'IST-ESB, ESB-IST', //Dönüş anında virgule ile ayrılması gerekmektedir. International için örnek: ‘ESB-IST-JFK, JFK-IST-ESB’
                        cd_firstflightDate : flightData.firstFlightDate,
                        cd_lastflightDate : flightData.lastFlightDate,
                        cd_flightDurationType : durationType,
                        cd_flightDuration : flightDurationData.flightDurationsAsHumanized.join('|'),//'1h5m|1h15m',
                        cd_flightDurationMinutes : flightDurationData.flightDurationsAsMin.join('|'),//'65|75',
                        cd_flightDeparture : flightData.departureTimeArray.join('|'),//'06:10|05:40',
                        cd_flightArrival : flightData.arrivalTimeArray.join('|'),//'07:15|06:45',
                        cd_flightSeatsLeft : remainingSeatList.join('|'),
                        cd_flightAircraft : flightData.equipments.join('|'),//'Boeing 737-800|Airbus A330-300',
                        cd_IsSPA : flightData.spa,
                        cd_IsCodeShare : flightData.codeShare,
                        cd_MembershipTier : loyaltyInfo.cardType,
                        cd_flight_search_dates : flightData.departureDates.join('|'),
                        cd_listname : getCdListName( data.bookingRequest,cabinFareFamily,'product'),
                        cd_fullfareFamily : cabinFareFullFamily,
                        cd_childCount : childCount,
                        cd_infCount : infCount,
                        cd_adultCount : adultCount,
                        cd_currency: data.selectedFlights[0].availabilityData.startingPrice.currency,
                        cd_destinationIds : data.selectedFlights[0].destinationAirport.code,
                        cd_price : data.selectedFlights[0].availabilityData.startingPrice.amount
                    };
                    
                    fillGTMFareBreakdownParameters(google_tag_params, data.fareBreakdown, data.currency, data);
                    
                    pushDataToDataLayer(google_tag_params,true);

                } catch (e) {
                    console.log(e);
                }

            },
            pushProfilePageData : function(data){
                try {

                    var searchData = data.bookingRequest.bookings[0];

                    var  cabinFareFamily = availabilityGTMUtil.getFareFamily(data.selectedFlights[0]);

                    var cabinFareFullFamily = data.selectedFlights.map(function(x){
                        return availabilityGTMUtil.getFareFamily(x);
                    }).join("|");

                    var cabinClass = availabilityGTMUtil.getCabinClassOfSelectedFlight(data.selectedFlights[0]);

                    var flightData = parseFlightData(data.selectedFlights);

                    var flightFullRoute = getTripFullRoute(data.selectedFlights);

                    var flightOrigin  = getFirstFlightOrigin(data.selectedFlights);

                    var flightArrival = getFirstFlightArrival(data.selectedFlights);

                    var flightDurationData = parseFlightDurationData(data.selectedFlights);

                    var durationType = getFlightDurationType(flightDurationData.segmentDurationsAsHours);

                    var tripType = getTripType(data.tripType);

                    var routeType = getRouteType(data.domestic,data.selectedFlights);

                    var cardType = getMSLevel(data.loyaltyData && data.loyaltyData.cardType);

                    var adultCount = 0;
                    var childCount = 0;
                    var infCount = 0;

                        for (var counter = 0; counter < searchData.paxList.length; counter++) {
                            if (searchData.paxList[counter].code === "ADULT") {
                                adultCount = searchData.paxList[counter].count
                            }
                            if (searchData.paxList[counter].code === "CHILD") {
                                childCount = searchData.paxList[counter].count
                            }
                            if (searchData.paxList[counter].code === "INFANT") {
                                infCount = searchData.paxList[counter].count
                            }
                        }


                    var google_tag_params = {
                        pagetype: 'profile',
                        mainPageType: 'booking',
                        origindestination:  flightOrigin+'-'+flightArrival,
                        cd_TripType: tripType,
                        prodid: flightOrigin+'-'+flightArrival,
                        pname: flightOrigin+'-'+flightArrival,
                        cd_cabinClass: cabinClass,//'Economy', //cabin class (Economy, Comfort, Business)
                        cd_fareFamily: cabinFareFamily,//'Promotion|Flex', //Fare Family (Promotion, Flex, Semi Flex)
                        cd_RBD: flightData.flightClasses.join('|'),//'Y|W', //Revenue Booked Designator (F,W,P,V,L,T,Q,E,S,H…)
                        pcategory : routeType+'/'+cabinFareFamily+'/'+tripType,
                        cd_OperatingCarrier : flightData.operatingAirlines.join('|'),//'TK|AJ|LH',
                        cd_fareType :  buildFareType(getPaxList(data.airTravelers)),
                        cd_RouteType : routeType,
                        cd_flightOrigin : flightOrigin,
                        cd_flightOriginCity : searchData.originAirport.city.code,
                        cd_flightOriginCountry : searchData.originAirport.country.code,
                        cd_flightDestination : flightArrival,
                        cd_flightDestinationCity : searchData.destinationAirport.city.code,
                        cd_flightDestinationCountry : searchData.destinationAirport.country.code,
                        cd_flightFullRoute : flightFullRoute,//'IST-ESB, ESB-IST', //Dönüş anında virgule ile ayrılması gerekmektedir. International için örnek: ‘ESB-IST-JFK, JFK-IST-ESB’
                        cd_firstflightDate : flightData.firstFlightDate,
                        cd_lastflightDate : flightData.lastFlightDate,
                        cd_flightDurationType : durationType,
                        cd_flightDuration : flightDurationData.flightDurationsAsHumanized.join('|'),//'1h5m|1h15m',
                        cd_flightDurationMinutes : flightDurationData.flightDurationsAsMin.join('|'),//'65|75',
                        cd_flightDeparture : flightData.departureTimeArray.join('|'),//'06:10|05:40',
                        cd_flightArrival : flightData.arrivalTimeArray.join('|'),//'07:15|06:45',
                        cd_flightSeatsLeft : '-',
                        cd_flightAircraft : flightData.equipments.join('|'),//'Boeing 737-800|Airbus A330-300',
                        cd_IsSPA : flightData.spa,
                        cd_IsCodeShare : flightData.codeShare,
                        cd_MembershipTier : cardType,
                        cd_listname:getCdListName(data.bookingRequest,cabinFareFamily),
                        cd_fullfareFamily: cabinFareFullFamily,
                        cd_childCount : childCount,
                        cd_infCount : infCount,
                        cd_adultCount : adultCount,
                        cd_currency: data.selectedFlights[0].availabilityData.startingPrice.currency,
                        cd_destinationIds : data.selectedFlights[0].destinationAirport.code,
                        cd_price : data.selectedFlights[0].availabilityData.startingPrice.amount
                    };
                    
                    fillGTMFareBreakdownParameters(google_tag_params, data.fareBreakdown, data.paymentCurrency);
                    addInitialSearchData(undefined,google_tag_params);
                    pushDataToDataLayer(google_tag_params,true);

                } catch (e) {
                    console.log(e);
                }
            },

			pushAdditionalPageClick : function(data) {
				try {
					var additionalServiceType = data.key;
					
					var google_tag_params = {
						"cd_additional_service_type":  additionalServiceType 
					};
					pushDataToDataLayer(google_tag_params,false);
					pushEvent("additional_service_click");
				} catch(e){
					console.log(e);
				}
			},

			pushAdditionalPageInsurance : function(data) {
				
				if(data){
					var insuranceClicked =  'Yes';
				}else {
					var insuranceClicked = 'No';
				}
				try {
					var google_tag_params = {
						"cd_travelInsuranceClicked":  insuranceClicked,
					};
					pushDataToDataLayer(google_tag_params,false);
					
					
				} catch(e){
					console.log(e);
				}
			},
			
			pushAdditionalPageInsuranceComplete : function(data) {
				
			
				try {
					if(data.travelGuardPrefered){
						var travelGuardPrefered =  'Travel insurance';
						var google_tag_params = {
						"cd_additional_service_type":  travelGuardPrefered,
						};
						pushDataToDataLayer(google_tag_params,false);
						pushEvent("additional_service_completed");
					}
					
					
					
				} catch(e){
					console.log(e);
				}
			},
			
			pushAdditionalPageData : function(data, ancillarystatus){
				            
							
			    try {
				
					if(!ancillarystatus) {
						var bookingSelectionHolderData =  data.bookingSelectionHolder;
				        var searchData = bookingSelectionHolderData.bookingRequest.bookings[0];
				
				        var  cabinFareFamily = availabilityGTMUtil.getFareFamily(bookingSelectionHolderData.selectedFlights[0]);
				
				        var cabinFareFullFamily = bookingSelectionHolderData.selectedFlights.map(function(x){
				            return availabilityGTMUtil.getFareFamily(x);
				        }).join("|");
				
				        var cabinClass = availabilityGTMUtil.getCabinClassOfSelectedFlight(bookingSelectionHolderData.selectedFlights[0]);
				
				        var flightData = parseFlightData(bookingSelectionHolderData.selectedFlights);
				
				        var flightFullRoute = getTripFullRoute(bookingSelectionHolderData.selectedFlights);
				
				        var flightOrigin  = getFirstFlightOrigin(bookingSelectionHolderData.selectedFlights);
				
				        var flightArrival = getFirstFlightArrival(bookingSelectionHolderData.selectedFlights);
				
				        var flightDurationData = parseFlightDurationData(bookingSelectionHolderData.selectedFlights);
				
				        var durationType = getFlightDurationType(flightDurationData.segmentDurationsAsHours);
				
				        var tripType = getTripType(bookingSelectionHolderData.tripType);
				
				        var routeType = getRouteType(bookingSelectionHolderData.domestic,bookingSelectionHolderData.selectedFlights);
				
				        var cardType = getMSLevel(bookingSelectionHolderData.loyaltyData && bookingSelectionHolderData.loyaltyData.cardType);
				
				        var google_tag_params = {
				            pagetype: 'additional-services',
				            mainPageType: 'booking',
				            origindestination:  flightOrigin+'-'+flightArrival,
				            cd_TripType: tripType,
				            prodid: flightOrigin+'-'+flightArrival,
				            pname: flightOrigin+'-'+flightArrival,
				            cd_fareType :  buildFareType(getPaxList(bookingSelectionHolderData.airTravelers)),
				            cd_RouteType : routeType,                       
				            cd_fareFamily: cabinFareFamily,//'Promotion|Flex', //Fare Family (Promotion, Flex, Semi Flex)                                         
				            cd_flightOrigin : flightOrigin,
				            cd_flightOriginCity : searchData.originAirport.city.code,
				            cd_flightOriginCountry : searchData.originAirport.country.code,
				            cd_flightDestination : flightArrival,
				            cd_flightDestinationCity : searchData.destinationAirport.city.code,
				            cd_flightDestinationCountry : searchData.destinationAirport.country.code,
				            cd_firstflightDate : flightData.firstFlightDate,
				            cd_MembershipTier : cardType,
				            cd_selected_currency_code: bookingSelectionHolderData.bookingRequest.selectedCurrencyCode,
							cd_travelInsuranceClicked:  'No',
				        };

				        addInitialSearchData(searchData,google_tag_params);
				        pushDataToDataLayer(google_tag_params,true);
					}else{
						var bookingSelectionHolderData =  data.bookingSelectionHolder;

				
				        var google_tag_params = {
				            pagetype: 'additional-services',
				            mainPageType: 'booking',
							cd_travelInsuranceClicked:  'No',

				        };


				        pushDataToDataLayer(google_tag_params,true);
						var google_tag_params = sessionStorageUtil.getPersistedData("clientInfoGTM");
					  
						pushDataToDataLayer(google_tag_params,true);

						pushEvent("client_information");
					}
				

			         

			
			    } catch (e) {
			        console.log(e);
			    }
			}
        }

		var checkinStage = {
			
			pushSelectPassengerData : function(data) {
				try {
					var selectPassengerLog = console.log(data);
					var allData = data;
					var passengers = allData.passengers;
					var selectedFlights = allData.allFlights;
					var isDomestic = selectedFlights[0].segments[0].domesticFlight;
					var originDestination = getFirstFlightOrigin(selectedFlights);
					var arrivalDestination = getFirstFlightArrival(selectedFlights);
					var cabinClass = allData.trips[0].flightInfo.cabinClass;
					var flightData = parseFlightData(selectedFlights);
					var routeType = getRouteType(isDomestic, selectedFlights);
					var cabinFareFamily = availabilityGTMUtil.getFareFamily(selectedFlights[0]);
					var tripType = getTripType(allData.tripType);
					var flightOrigin  = getFirstFlightOrigin(selectedFlights);
					var flightArrival = getFirstFlightArrival(selectedFlights);
					var flightOriginCountry = getFirstFlightOriginCountry(selectedFlights);
					var flightArrivalCountry = getFirstFlightArrivalCountry(selectedFlights);
 					var flightDurationData = parseFlightDurationData(selectedFlights);
				 	var durationType = getFlightDurationType(flightDurationData.segmentDurationsAsHours);
					var remainingSeatList = getRemainingSeats(selectedFlights);
					var tickets = underscore.pluck(data.tickets, "ticketNumber");
					
					console.log(originDestination);
					console.log(arrivalDestination);
					
					var google_tag_params = {
						selectPassenger:  allData.contactEmail, /** !! KVKK ihlali **/
						PNR :  '', //!! KVKK
						ck_user_id :allData.contactEmail,
						origindestination: originDestination +'-'+ arrivalDestination,
						cd_tripType: getTripType(allData.tripType),
						prodid: originDestination+'-'+arrivalDestination,
						pname: originDestination+'-'+arrivalDestination,
						cd_cabinClass: cabinClass,
						cd_fareFamily: cabinClass,
						cd_RBD : flightData.flightClasses.join('|'),
						pcategory: routeType+'/'+cabinFareFamily+'/'+tripType,
						cd_OperatingCarrier : flightData.operatingAirlines.join('|'),//'TK|AJ|LH',
						cd_RouteType : routeType,
						cd_flightOrigin : flightOrigin,
						cd_flightOriginCity : flightOrigin,
						cd_flightOriginCountry : flightOriginCountry,
						cd_flightDestination : flightArrival,
						cd_flightDestinationCity : flightArrival,
						cd_flightDestinationCountry : flightArrivalCountry,
						cd_flightFullRoute: getTripFullRoute(selectedFlights),
					    cd_firstflightDate: flightData.firstFlightDate,
					    cd_lastflightDate:flightData.lastFlightDate,
					    cd_flightDurationType: durationType,
					    cd_flightDuration: flightDurationData.flightDurationsAsHumanized.join('|'),//'1h5m|1h15m',
					    cd_flightDurationMinutes: flightDurationData.flightDurationsAsMin.join('|'),//'65|75',
					    cd_flightDeparture: flightData.departureTimeArray.join('|'),
					    cd_flightArrival : flightData.arrivalTimeArray.join('|'),
					    cd_flightSeatsLeft: remainingSeatList.join('|'),
					    cd_flightAircraft: flightData.equipments.join('|'),//'Boeing 737-800|Airbus A330-300',
					    cd_IsSPA: flightData.spa,
					    cd_IsCodeShare: flightData.codeShare,
					    cd_MembershipTier: '',
					    Ticket_No:"",// !! KVKK 
					    cm_ticketCount: underscore.size(tickets), //satılan bilet adedi (integer olarak)
					    cm_couponCount: 4,  //toplam biletlerdeki kupon adedi (integer olarak)

					};
					pushDataToDataLayer(google_tag_params,false);
					pushEvent("check-in.selectPassenger");
				} catch(e){
					console.log(e);
				}
			}
			
			
		}
        
        var awardTicketing = {
    		pushAwardTicketAvailabilityResponse : function(data) {
    			data.productListActive = true;
    			var impressions = availabilityGTMUtil.prepareAwardTicketSummaryFlightDatas(data);
    			
    			var params = {
    				impressions : impressions,
    				currencyCode : data.currency
    			}
    			ecommerceModels.MSbookingImpTracking(params);
    		},
    		pushAwardTicketAvailabilityFlightSelectionClick : function(data) {
    			var product = availabilityGTMUtil.prepareAwardTicketAvailabilityFlightData(data);
    			var action = {'list': awardTicketing.getListValue()};
    			
    			var params = {
    				products : [product],
    				action : action
    			}
    			ecommerceModels.MSflightClickTracking(params);
    		},
    		pushAwardTicketAvailabilityFlightDetailsView : function(data) {
    			var params = {
					products : availabilityGTMUtil.prepareAwardTicketSummaryFlightDatas(data),
					action : {'list': awardTicketing.getListValue()}
				}
				ecommerceModels.MSflightDetailTracking(params);
    		},
    		pushAwardTicketAddToCartData : function(data) {
    			var params = availabilityGTMUtil.prepareAwardTicketAddToCartData(data);
    			ecommerceModels.MSflightAddToCartClick(params);
    		},
    		getListValue : function() {
    			return 'Search Results – Award Ticket';
    		},
    		pushAwardTicketAvailabilitySelectedFlightData : function(data, memberProfile){

                try {

                    var searchData = data.bookingRequest.bookings[0];

                    var  cabinFareFamily = availabilityGTMUtil.getFareFamilyFromMap( data.selectedFlights[0].priceForSelectedFareBasisCode().code);

                    var flightData = parseFlightData(data.selectedFlights);

                    var flightFullRoute = getTripFullRoute(data.selectedFlights);

                    var flightDurationData = parseFlightDurationData(data.selectedFlights);

                    var durationType = getFlightDurationType(flightDurationData.segmentDurationsAsHours);

                    var tripType = getTripType(data.tripType);

                    var routeType = getRouteType(data.domestic,data.selectedFlights);

                    var remainingSeatList = getRemainingSeats(data.selectedFlights);

                    var loyaltyInfo = getLoyaltyData(memberProfile);
                    
                    var google_tag_params = {
                        pagetype: 'ms-product',
                        mainPageType: 'ms-booking',
                        origindestination: searchData.originAirport.code+'-'+searchData.destinationAirport.code,
                        cd_TripType: tripType,
                        prodid: searchData.originAirport.code+'-'+searchData.destinationAirport.code,
                        pname: searchData.originAirport.code+'-'+searchData.destinationAirport.code,
                        cd_cabinClass: cabinFareFamily,//'Economy', //cabin class (Economy, Comfort, Business)
                        cd_fareFamily: cabinFareFamily,//'Promotion|Flex', //Fare Family (Promotion, Flex, Semi Flex)
                        cd_RBD: flightData.flightClasses.join('|'),//'Y|W', //Revenue Booked Designator (F,W,P,V,L,T,Q,E,S,H…)
                        pcategory : routeType+'/'+cabinFareFamily+'/'+tripType,
                        cd_OperatingCarrier : flightData.operatingAirlines.join('|'),//'TK|AJ|LH',
                        cd_fareType : buildFareType(getPaxList(data.airTravelers)),
                        cd_RouteType : routeType,
                        cd_flightOrigin : searchData.originAirport.code,
                        cd_flightOriginCity : searchData.originAirport.city.code,
                        cd_flightOriginCountry : searchData.originAirport.country.code,
                        cd_flightDestination : searchData.destinationAirport.code,
                        cd_flightDestinationCity : searchData.destinationAirport.city.code,
                        cd_flightDestinationCountry : searchData.destinationAirport.country.code,
                        cd_flightFullRoute :  flightFullRoute,//'IST-ESB, ESB-IST', //Dönüş anında virgule ile ayrılması gerekmektedir. International için örnek: ‘ESB-IST-JFK, JFK-IST-ESB’
                        cd_firstflightDate : flightData.firstFlightDate,
                        cd_lastflightDate : flightData.lastFlightDate,
                        cd_flightDurationType : durationType,
                        cd_flightDuration : flightDurationData.flightDurationsAsHumanized.join('|'),//'1h5m|1h15m',
                        cd_flightDurationMinutes : flightDurationData.flightDurationsAsMin.join('|'),//'65|75',
                        cd_flightDeparture : flightData.departureTimeArray.join('|'),//'06:10|05:40',
                        cd_flightArrival : flightData.arrivalTimeArray.join('|'),//'07:15|06:45',
                        cd_flightSeatsLeft : remainingSeatList.join('|'),
                        cd_flightAircraft : flightData.equipments.join('|'),//'Boeing 737-800|Airbus A330-300',
                        cd_IsSPA : flightData.spa,
                        cd_IsCodeShare : flightData.codeShare,
                        cd_MembershipTier : loyaltyInfo.cardType,
                        cd_flight_search_dates : flightData.departureDates.join('|'),
                        cd_total_miles :  loyaltyInfo.totalMiles,
                        cd_card_level : loyaltyInfo.cardType,
                    };
                    
                    fillGTMAwardTicketFareBreakdownParameters(google_tag_params, data.fareBreakdown, data.currency, data);
                    
                    pushDataToDataLayer(google_tag_params,true);

                } catch (e) {
                    console.log(e);
                }

            },
            pushAwardTicketSearchData : function(bookings, domestic, memberProfile, flightList){

                try {
                    clearTicketCache()
                    changeListingType("list")
                    var pushSearcData = bookings[0]

                    var tripType = pushSearcData.oneWay ? 'OneWay' : 'RoundTrip';
                    var loyaltyInfo = getLoyaltyData(memberProfile);
                    
                    var routeType = "";
                    if(isBeyond(pushSearcData.originAirport, pushSearcData.destinationAirport)){
                        routeType = 'Beyond';
                    }else if(domestic){
                        routeType ='Domestic';
                    }else{
                        routeType = pushSearcData.originAirport.domestic ? 'International-Outbound':'International-Inbound'
                    }

                    var originAirportCode = availabilityGTMUtil.getPortCode(pushSearcData.originAirport);
                    var destinationAirportCode = availabilityGTMUtil.getPortCode(pushSearcData.destinationAirport);
                    var google_tag_params = {
                        pagetype: 'ms-search', //sayfa tipi
                        mainPageType: 'ms-booking',
                        origindestination: originAirportCode+'-'+destinationAirportCode, //Route O&Ds
                        cd_TripType: tripType, //OneWay, RoundTrip, MultiCity
                        prodid: originAirportCode+'-'+destinationAirportCode,
                        pname: originAirportCode+'-'+destinationAirportCode,
                        cd_fareType : buildFareType(getPaxList(pushSearcData.paxList)),
                        cd_RouteType : routeType, //Domestic, International-Inbound, International-Outbound, Beyond
                        cd_flightOrigin : originAirportCode,
                        cd_flightOriginCity : pushSearcData.originAirport.city.code,
                        cd_flightOriginCountry : pushSearcData.originAirport.country.code,
                        cd_flightDestination : destinationAirportCode,
                        cd_flightDestinationCity : pushSearcData.destinationAirport.city.code,
                        cd_flightDestinationCountry : pushSearcData.destinationAirport.country.code,
                        cd_firstflightDate : moment.utc(pushSearcData.originationDateTime).format('YYYY-MM-DD'),//'20150917',
                        cd_total_miles :  loyaltyInfo.totalMiles,
                        cd_MembershipTier : loyaltyInfo.cardType
                    };

                    removeGtmParamStatus();
                    var secureAttr = {'search' : true};
                    pushDataToDataLayer(google_tag_params,true);
//                    securePush(google_tag_params,secureAttr,true,false)
                    prepareEcommerceSearchData(bookings, flightList, tripType, "", true);
                } catch (e) {
                    console.log(e);
                }
            },
            pushAwardTicketProfilePageData : function(data){
                try {

                    var searchData = data.bookingRequest.bookings[0];

                    var  cabinFareFamily = availabilityGTMUtil.getFareFamilyFromMap(data.selectedFlights[0].availableFlightFare.preferedFareBasisCode);

                    var flightData = parseFlightData(data.selectedFlights);

                    var flightFullRoute = getTripFullRoute(data.selectedFlights);

                    var flightDurationData = parseFlightDurationData(data.selectedFlights);

                    var durationType = getFlightDurationType(flightDurationData.segmentDurationsAsHours);

                    var tripType = getTripType(data.tripType);

                    var routeType = getRouteType(data.domestic,data.selectedFlights);

                    var cardType = getMSLevel(data.loyaltyData && data.loyaltyData.cardType);
     
                    var google_tag_params = {
                        pagetype: 'ms-booking-profile',
                        mainPageType: 'ms-booking',
                        origindestination: searchData.originAirport.code+'-'+searchData.destinationAirport.code,
                        cd_TripType: tripType,
                        prodid: searchData.originAirport.code+'-'+searchData.destinationAirport.code,
                        pname: searchData.originAirport.code+'-'+searchData.destinationAirport.code,
                        cd_cabinClass: cabinFareFamily,//'Economy', //cabin class (Economy, Comfort, Business)
                        cd_fareFamily: cabinFareFamily,//'Promotion|Flex', //Fare Family (Promotion, Flex, Semi Flex)
                        cd_RBD: flightData.flightClasses.join('|'),//'Y|W', //Revenue Booked Designator (F,W,P,V,L,T,Q,E,S,H…)
                        pcategory : routeType+'/'+cabinFareFamily+'/'+tripType,
                        cd_OperatingCarrier : flightData.operatingAirlines.join('|'),//'TK|AJ|LH',
                        cd_fareType :  buildFareType(getPaxList(data.airTravelers)),
                        cd_RouteType : routeType,
                        cd_flightOrigin : searchData.originAirport.code,
                        cd_flightOriginCity : searchData.originAirport.city.code,
                        cd_flightOriginCountry : searchData.originAirport.country.code,
                        cd_flightDestination : searchData.destinationAirport.code,
                        cd_flightDestinationCity : searchData.destinationAirport.city.code,
                        cd_flightDestinationCountry : searchData.destinationAirport.country.code,
                        cd_flightFullRoute : flightFullRoute,//'IST-ESB, ESB-IST', //Dönüş anında virgule ile ayrılması gerekmektedir. International için örnek: ‘ESB-IST-JFK, JFK-IST-ESB’
                        cd_firstflightDate : flightData.firstFlightDate,
                        cd_lastflightDate : flightData.lastFlightDate,
                        cd_flightDurationType : durationType,
                        cd_flightDuration : flightDurationData.flightDurationsAsHumanized.join('|'),//'1h5m|1h15m',
                        cd_flightDurationMinutes : flightDurationData.flightDurationsAsMin.join('|'),//'65|75',
                        cd_flightDeparture : flightData.departureTimeArray.join('|'),//'06:10|05:40',
                        cd_flightArrival : flightData.arrivalTimeArray.join('|'),//'07:15|06:45',
                        cd_flightSeatsLeft : '-',
                        cd_flightAircraft : flightData.equipments.join('|'),//'Boeing 737-800|Airbus A330-300',
                        cd_IsSPA : flightData.spa,
                        cd_IsCodeShare : flightData.codeShare,
                        cd_MembershipTier : cardType
                    };
                    
                    fillGTMAwardTicketFareBreakdownParameters(google_tag_params, data.fareBreakdown, data.paymentCurrency, data);
                    
                    pushDataToDataLayer(google_tag_params,true);

                } catch (e) {
                    console.log(e);
                }
            }
        }

        var manageBookingUtils = {
            pushPageInfo: function pushPageInfo(data) {
                var mbu = manageBookingUtils;
                var action = mbu.detectMBAction(data);
                var labelKey = mbu.detectMBLabel(data);
                var label = labelKey && action ? action[labelKey] : null;

                if (label && label.pushFunction) {
                    label.pushFunction({
                        category: directDataLayerData.manageBooking,
                        action: action,
                        label: label,
                        data: data
                    });
                }
            },
            detectMBLabel: function detectMBLabel(data) {
                if(data.label){
                    return data.label;
                }
                var _getUrlVars = getUrlVars(),
                    thanktype = _getUrlVars.thanktype,
                    operationType = _getUrlVars.operationType;

                if (thanktype == "dashboard") {}
                else if (thanktype == "reissue"||thanktype=="addbaby" || thanktype=="refund") {
                    return "thankYou";
                }
            },
            detectMBAction: function detectMBAction(data) {
                if(data.action){
                    var action =  directDataLayerData.manageBooking.actions[data.action];
                    if(action){
                        return action;
                    }
                }
                var _getUrlVars2 = getUrlVars(),
                    thanktype = _getUrlVars2.thanktype,
                    operationType = _getUrlVars2.operationType,
                    refundType =_getUrlVars2.refundtype;

                if (thanktype == "reissue" && operationType == "ADD_A_FLIGHT") {
                    return directDataLayerData.manageBooking.actions.addAFlight;
                }

                if (thanktype == "addbaby") {
                    return directDataLayerData.manageBooking.actions.addBaby;
                }
                if(thanktype =="refund" || refundType=="partial"){
                    return directDataLayerData.manageBooking.actions.cancel;
                }
                if (thanktype == "reissue") {
                    return directDataLayerData.manageBooking.actions.changeFlight;
                }
            },
            pushDataLayer: function pushDataLayer(directDataLayerData) {
                var category = directDataLayerData.category,
                    action = directDataLayerData.action,
                    label = directDataLayerData.label,
                    data = directDataLayerData.data;
                var google_tag_params = label.prepareGoogleTagParams(data);
                var directDataLayerPushData = directDatalayerObjBuilder(category, action, label)
                    .withGoogleTagParams(google_tag_params)
                    .interaction(typeof label.interaction == "undefined" ? true : label.interaction)
                    .event(label.event ? label.event : "gaEvent")
                    .build();

                if (label.beforePush) {
                    directDataLayerPushData = label.beforePush(directDataLayerData,directDataLayerPushData);
                }

                if (directDataLayerPushData) {
                    pushDataToDataLayer(directDataLayerPushData, false, true);
                }
            },
            putdata: function(root, obj) {
                for (var i in obj) {
                    var putdata = obj[i];

                    if (putdata) {
                        root[i] = putdata;
                    }
                }
            },


            prepareGoogleTagParamsForReissue : function(reservation,parsedReservation,google_tag_params){
                var flightData = parsedReservation.util.flightData;
                var parsedFlightData = prepareParsedFlightData(flightData);
                var paymentInfo = reservation.paymentInfoList ? reservation.paymentInfoList[0] : {};
                var parsedPaymentData = parsePaymentData(paymentInfo);
                manageBookingUtils.putdata(google_tag_params, parsedReservation.google_tag_params);
                manageBookingUtils.putdata(google_tag_params, parsedFlightData.google_tag_params);
                manageBookingUtils.putdata(google_tag_params, parsedPaymentData.google_tag_params);
            },

            findFlightsByFlightNumberPattern : function(flights,flightNumbers){
                if(!flightNumbers){
                    return null;
                }
                var _map={};

                        var mapFlattedFlightNumber=function () {
                            flights.forEach(function(flight){
                                _map[underscore.pluck(flight.segments,"flightNumber").join("")]=flight;
                            });
                        }

                        var flatSearchFlights=function(){
                            return flightNumbers.map(function(x){
                                return x.join();
                            });
                        }



                        var doSearch=function(){
                            mapFlattedFlightNumber();
                            var fs = flatSearchFlights();
                            var newFs=[];
                            for(var i = 0;i<fs.length;i++){
                                var c = _map[fs[i]];
                                if(c){
                                    newFs.push(c);
                                }
                            }

                            return newFs;
                        }

                return doSearch();


            },
            findFlighByRph:function(flights,rph){

               var match = function (flightRph) {
                   return  rph.filter(function(x){
                       return x===flightRph;
                   })>0;
               };



               return flights.filter(function (flight) {
                      return match(flight.rph);
                });
            },

            pluckFlightInfosOfReservation:function (trips) {
                return underscore.pluck(trips,"flightInfo");
            },
            pluckFlightNumbers :function(flights){
                return underscore.map(flights,function(flight){
                    var segments = flight.segments;
                    var flightNumbers = underscore.pluck(segments,'flightNumber');
                    return flightNumbers;

                });
            },

            prepareReissuePriceData :function(reissueStatusData){

                if(reissueStatusData){
                    var _reissuePriceData={};
                    if(reissueStatusData.totalAdditionalAmount&&reissueStatusData.totalAdditionalAmount.currency){
                        _reissuePriceData.totalAdditionalAmount=reissueStatusData.totalAdditionalAmount.amount;
                        _reissuePriceData.currency=reissueStatusData.totalAdditionalAmount.currency;
                    }
                    if(reissueStatusData.totalRefundAmount&&reissueStatusData.totalRefundAmount.currency){
                        _reissuePriceData.totalRefundAmount=reissueStatusData.totalRefundAmount.amount;
                        _reissuePriceData.currency=reissueStatusData.totalRefundAmount.currency;
                    }
                    return _reissuePriceData;

                }
            },

            cache:function(key,value){
                if(key&&value){
                    manageBookingUtils._cache[key]=value;
                }
                else if(key){
                    return manageBookingUtils._cache[key];
                }
            },
            _cache:{},
        };
        window.testmb = manageBookingUtils;

        var newDirectDatalayerObj = function newDirectDatalayerObj(category, action, label) {
            var interaction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
            var event = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "gaEvent";
            return {
                gaCategory: category,
                gaAction: action,
                gaLabel: label,
                gaNonInteraction: interaction,
                event: event
            };
        };

        var directDatalayerObjBuilder = function directDatalayerObjBuilder(category, action, label) {
            var data = newDirectDatalayerObj(category.gaCategory, action.gaAction, label.gaLabel);
            var buildObj = {
                build: function build() {
                    return data;
                },
                withGoogleTagParams: function withGoogleTagParams(google_tag_params) {
                    data.google_tag_params = google_tag_params;
                    return buildObj;
                },
                interaction: function interaction(_interaction) {
                    data.gaNonInteraction = _interaction;
                    return buildObj;
                },
                event: function event(_event) {
                    data.event = _event;
                    return buildObj;
                }
            };
            return buildObj;
        };

        var directDataLayerData = {
            manageBooking: {
                gaCategory: "Manage Booking",
                actions: {
                    addAFlight: {
                        gaAction: "addAFlight",
                            thankYou: {
                                gaLabel: "Transaction Complete",
                                pushFunction: function pushFunction(directDataLayerData) {
                                manageBookingUtils.pushDataLayer(directDataLayerData);
                            },
                                prepareGoogleTagParams: function(reservationInfo) {
                                var ri = reservationInfo;
                                var parsedReservation = parseReservation(reservationInfo);
                                var selectedFlights = parsedReservation.util.selectedFlights;

                                var detailData =  sessionStorageUtil.getPersistedData("addAFlight_detail_persisted");

                                var findAddedFlight=function(){

                                    if(detailData&&detailData.added_flights){
                                        var added_flights = detailData.added_flights.split("_");
                                        loop_flights:for(var i = 0;i<selectedFlights.length;i++){
                                            loop_segments:for(var j = 0;j<selectedFlights[i].segments.length;j++){
                                                var flightNumber = selectedFlights[i].segments[j].flightNumber;
                                                if(added_flights[j]!=flightNumber){
                                                    continue loop_flights;
                                                }
                                            }
                                            return selectedFlights[i];
                                        }
                                    }
                                }






                                var google_tag_params = {
                                    'mainPageType': "manage-booking",
                                    'pagetype': "add-flight-transaction-complete",
                                    "add_flight_revenue": ri.totalCharge.amount,
                                    "action": "purchase"
                                };

                                manageBookingUtils.prepareGoogleTagParamsForReissue(ri,parsedReservation,google_tag_params);

                                var selectedFlight = findAddedFlight();
                                if(selectedFlight){
                                    var root = {};
                                    var parseAsFlightData = parseFlightData([selectedFlight]);
                                    parseAsFlightData = prepareParsedFlightData(parseAsFlightData);
                                    var parsedSelectedFlight = parseSelectedFlightData(selectedFlight);
                                    manageBookingUtils.putdata(root, parsedSelectedFlight.google_tag_params);
                                    manageBookingUtils.putdata(root, parseAsFlightData.google_tag_params);
                                    google_tag_params.newFlights = [root];
                                }


                                return google_tag_params;
                                 }
                            },
                            detail:{
                                gaLabel:"detail",
                                pushFunction:function(directDataLayerData){
                                    var data= directDataLayerData.data;
                                    var bookingRequest = data.bookingRequest;
                                    var flight = bookingRequest.flight;
                                    var segments = flight.segments;
                                    var flightNumbers = underscore.pluck(segments,'flightNumber').join("_");
                                    sessionStorageUtil.persistData(directDataLayerData.action.gaAction+"_"+directDataLayerData.label.gaLabel+"_persisted",{added_flights:flightNumbers});

                                },
                                prepareGoogleTagParams:function(data){

                                }
                            }
                        },

                    changeFlight: {
                        gaAction: "changeFlight",
                        thankYou: {
                            gaLabel: "TransactionComplete",
                            pushFunction: function(directDataLayerData) {
                                manageBookingUtils.pushDataLayer(directDataLayerData);
                            },
                            prepareGoogleTagParams: function(reservationInfo) {
                                var ri = reservationInfo;
                                var parsedReservation = parseReservation(reservationInfo);
                                var selectedFlights = parsedReservation.util.selectedFlights;

                                var detailData =  sessionStorageUtil.getPersistedData("changeFlight_detail_persisted");


                                var google_tag_params = {
                                    'mainPageType': "manage-booking",
                                    'pagetype': "change-flight-transaction-complete",

                                    "action": "purchase"
                                };

                                manageBookingUtils.prepareGoogleTagParamsForReissue(ri,parsedReservation,google_tag_params);

                                var selectedFlight =manageBookingUtils.findFlightsByFlightNumberPattern(selectedFlights,detailData&&detailData.newFlights);
                                if(selectedFlight&&selectedFlight.length>0){
                                    var root = {};
                                    var parseAsFlightData = parseFlightData(selectedFlight);
                                    parseAsFlightData = prepareParsedFlightData(parseAsFlightData);
                                    var parsedSelectedFlight = parseSelectedFlightData(selectedFlight[0]);
                                    manageBookingUtils.putdata(root, parsedSelectedFlight.google_tag_params);
                                    manageBookingUtils.putdata(root, parseAsFlightData.google_tag_params);
                                    google_tag_params.newFlights = [root];
                                }
                                if(detailData.reissuePriceData){
                                    manageBookingUtils.putdata(google_tag_params,detailData.reissuePriceData);
                                }

                                return google_tag_params;
                            }
                        },
                        detail:{
                            gaLabel:"detail",
                            beforePushPersist : function (directDataLayerData) {
                                var data = directDataLayerData.data;
                                var validateChangeFlightRequest = data.validateChangeFlightRequest;
                                var validateChangeFlightResponse= data.validateChangeFlightResponse;
                                var removedFlightsRph = validateChangeFlightRequest.removedFlights;
                                var newFlights = validateChangeFlightRequest.newFlights;



                                var flightNumbersArr=manageBookingUtils.pluckFlightNumbers(newFlights)
                                var persistData = {
                                    newFlights : flightNumbersArr
                                };
                                if(removedFlightsRph&&removedFlightsRph.length>0){
                                    var oldReservationFlights= manageBookingUtils.pluckFlightInfosOfReservation(data.oldreservation.trips);
                                    var removedFlights= manageBookingUtils.findFlighByRph(oldReservationFlights,removedFlightsRph).filter(function(f){return f});

                                    if(removedFlights&&removedFlights.length>0){
                                        persistData.removedFlights= manageBookingUtils.pluckFlightNumbers(removedFlights);
                                    }
                                }

                                var reissueStatusData = validateChangeFlightResponse&&validateChangeFlightResponse.reissueStatusData;
                                persistData.reissuePriceData = manageBookingUtils.prepareReissuePriceData(reissueStatusData);

                                sessionStorageUtil.persistData(directDataLayerData.action.gaAction+"_"+directDataLayerData.label.gaLabel+"_persisted",persistData);
                            },
                            beforePushCache:function (directDataLayerData,directDataLayerPushData) {
                                var cacheData = {
                                    directDataLayerData:{
                                        data : directDataLayerData.data
                                    },
                                    directDataLayerPushData:directDataLayerPushData
                                };
                                manageBookingUtils.cache(directDataLayerData.action.gaAction+"_"+directDataLayerData.label.gaLabel+"_cached",cacheData);
                            },
                            beforePush:function (directDataLayerData,directDataLayerPushData) {
                                directDataLayerData.label.beforePushPersist(directDataLayerData);
                                directDataLayerData.label.beforePushCache(directDataLayerData,directDataLayerPushData);
                                return directDataLayerPushData;
                            },
                            pushFunction:function(directDataLayerData){

                                manageBookingUtils.pushDataLayer(directDataLayerData);
                            },
                            prepareGoogleTagParams:function(data){

                                    var google_tag_params = {
                                            'mainPageType': "manage-booking",
                                            'pagetype': "change-flight-summary",
                                    };
                                    var newFlights = data.validateChangeFlightRequest.newFlights;

                                var parsedReservation = parseReservation(data.oldreservation);
                                manageBookingUtils.putdata(google_tag_params,parsedReservation.google_tag_params);

                                 if(newFlights){
                                    var root=[];
                                    for(var i = 0;i<newFlights.length;i++){
                                        var item={};
                                        var parseAsFlightData = parseFlightData([newFlights[i]]);
                                        parseAsFlightData = prepareParsedFlightData(parseAsFlightData);
                                        var parsedSelectedFlight = parseSelectedFlightData(newFlights[i]);
                                        manageBookingUtils.putdata(item, parsedSelectedFlight.google_tag_params);
                                        manageBookingUtils.putdata(item, parseAsFlightData.google_tag_params);
                                        root.push(item);
                                    }

                                    google_tag_params.newFlights = root;
                                    return google_tag_params;
                                }

                            }
                        },
                        payment:{
                            "gaLabel":"payment",
                            pushFunction:function (directDataLayerData) {
                                manageBookingUtils.pushDataLayer(directDataLayerData);
                            },
                            prepareGoogleTagParams:function (directDataLayerData) {
                                var cachedData = manageBookingUtils.cache("changeFlight_detail"+"_cached");
                                var google_tag_params={};
                                if(cachedData&&cachedData.directDataLayerPushData&&cachedData.directDataLayerPushData.google_tag_params){
                                    manageBookingUtils.putdata(google_tag_params,cachedData.directDataLayerPushData.google_tag_params);
                                }
                                if(cachedData&&cachedData.directDataLayerData){
                                    var _oldDl = cachedData.directDataLayerData.data
                                    if(_oldDl&&_oldDl.validateChangeFlightResponse){
                                        var reissueStatusData = _oldDl.validateChangeFlightResponse.reissueStatusData
                                        var pricedata = manageBookingUtils.prepareReissuePriceData(reissueStatusData);
                                        if(pricedata){
                                            manageBookingUtils.putdata(google_tag_params,pricedata);
                                        }
                                    }
                                }

                                google_tag_params.pagetype="change-flight-payment";
                                google_tag_params.mainPageType="manage-booking";
                                return google_tag_params;
                            }
                        },
                        findFlight:{
                            gaLabel:"findFlight",
                            pushFunction:function(directDataLayerData){
                                manageBookingUtils.pushDataLayer(directDataLayerData);
                            },
                            prepareGoogleTagParams:function(data) {
                                var google_tag_params = {
                                    'mainPageType': "manage-booking",
                                    'pagetype': "change-flight-find-flight",
                                };

                                var changeFlightRequest= data.validateChangeFlightRequest;
                                var ri = data.oldreservation;
                                var newFlights =changeFlightRequest.newFlights;

                                var selectedFlights =manageBookingUtils.findFlighByRph(manageBookingUtils.pluckFlightInfosOfReservation(ri.trips),changeFlightRequest.removedFlights);

                                var parsedReservation = parseReservation(ri);
                                manageBookingUtils.putdata(google_tag_params,parsedReservation.google_tag_params);

                                var putFlights = function (flights) {
                                    var root=[];
                                    for(var i = 0;i<flights.length;i++){
                                        var item={};
                                        var parseAsFlightData = parseFlightData([flights[i]]);
                                        parseAsFlightData = prepareParsedFlightData(parseAsFlightData);
                                        var parsedSelectedFlight = parseSelectedFlightData(flights[i]);
                                        manageBookingUtils.putdata(item, parsedSelectedFlight.google_tag_params);
                                        manageBookingUtils.putdata(item, parseAsFlightData.google_tag_params);
                                        root.push(item);
                                    }
                                    return root;

                                }



                                if(newFlights){
                                    google_tag_params.newFlights = putFlights(newFlights);
                                }
                                if(selectedFlights){
                                    google_tag_params.selectedFlights=putFlights(selectedFlights);
                                }
                                return google_tag_params;

                            }
                        },
                       selectFlight : {
                            gaLabel: "selectFlight",
                            pushFunction : function(directDataLayerData){
                                manageBookingUtils.pushDataLayer(directDataLayerData);
                            },
                           prepareGoogleTagParams:function(data){
                               var google_tag_params = {
                                   'mainPageType': "manage-booking",
                                   'pagetype': "change-flight-select-flight",
                               };
                               var parsedReservation = parseReservation(data.reservation);
                               manageBookingUtils.prepareGoogleTagParamsForReissue(data.reservation,parsedReservation,google_tag_params);
                               var avFlights = manageBookingUtils.pluckFlightInfosOfReservation(data.reservation.trips);

                               if(avFlights){
                                   var root=[];
                                   for(var i = 0;i<avFlights.length;i++){
                                       var item={};
                                       var parseAsFlightData = parseFlightData([avFlights[i]]);
                                       parseAsFlightData = prepareParsedFlightData(parseAsFlightData);
                                       var parsedSelectedFlight = parseSelectedFlightData(avFlights[i]);
                                       manageBookingUtils.putdata(item, parsedSelectedFlight.google_tag_params);
                                       manageBookingUtils.putdata(item, parseAsFlightData.google_tag_params);
                                       root.push(item);
                                   }

                                   google_tag_params.availableFlights = root;
                                   return google_tag_params;
                               }

                               return google_tag_params;
                            }
                       }
                    },
                    addBaby: {
                        gaAction: "addBaby",
                        thankYou: {
                            gaLabel: "TransactionComplete",
                            pushFunction:function(directDataLayerData) {
                                manageBookingUtils.pushDataLayer(directDataLayerData);
                            },
                            prepareGoogleTagParams:function(reservationInfo) {
                                var ri = reservationInfo;
                                var parsedReservation = parseReservation(ri);
                                var selectedFlights = parsedReservation.util.selectedFlights;
                                var google_tag_params = {
                                    'mainPageType': "manage-booking",
                                    'pagetype': "addbaby-transaction-complete",
                                    "action": "purchase"
                                };

                                manageBookingUtils.prepareGoogleTagParamsForReissue(ri,parsedReservation,google_tag_params);
                                return google_tag_params;
                            }
                        }
                    },
                cancel:{
                    gaAction:"cancel",
                    thankYou:{
                        gaLabel:"TransactionComplete",
                        pushFunction:function(directDataLayerData){
                            manageBookingUtils.pushDataLayer(directDataLayerData);
                        },
                        prepareGoogleTagParams:function(reservationInfo){
                            var ri =reservationInfo;

                            var parsedReservation = parseReservation(ri);


                            var selectedFlights = parsedReservation.util.selectedFlights;
                            var parsedSelectedFlight = parseSelectedFlightData(selectedFlights[0]);


                            var google_tag_params = {
                                'mainPageType': "manage-booking",
                                'pagetype': "cancel-flight-cancel-complete",
                                "cancel_flight_amount": ri.totalCharge.amount,
                                "action": "cancel"
                            };

                            manageBookingUtils.prepareGoogleTagParamsForReissue(ri,parsedReservation,google_tag_params);


                            var root = {};
                            manageBookingUtils.putdata(root, parsedSelectedFlight.google_tag_params);


                            google_tag_params.cancelFlights = [root];
                            return google_tag_params;
                         }
                        }
                    }
                }
            }
        };



        var getCurrencyRate = function(currencyConversionRateList, fromCurrency, toCurrency) {
        	return underscore.find(currencyConversionRateList, function(currencyConversionRate) {
                return currencyConversionRate.sourceCurrencyCode == fromCurrency && currencyConversionRate.targetCurrencyCode == toCurrency;
            });
        }
        
        var updateFareInfo = function(fareInfo, currencyConversionRateList) {
        	
        	if(fareInfo.currency == "TRY") {
                fareInfo.totalFareTRY 							= fareInfo.totalFare;
                fareInfo.fareTaxes.fuelSurchargeValueTRY 		= fareInfo.fareTaxes.fuelSurchargeValueLCC;
                fareInfo.fareTaxes.taxesandFeesValueTRY 		= fareInfo.fareTaxes.taxesandFeesValueLCC;
                fareInfo.fareTaxes.ticketingServiceFeeValueTRY 	= fareInfo.fareTaxes.ticketingServiceFeeValueLCC;

        	} else if(currencyConversionRateList){

        		var currencyRateFromFareCurrencyToTRY = getCurrencyRate(currencyConversionRateList, fareInfo.currency, "TRY");
        		
        		if(currencyRateFromFareCurrencyToTRY && currencyRateFromFareCurrencyToTRY.currencyRate) {
        			var currencyRateToTRY = currencyRateFromFareCurrencyToTRY.currencyRate;
        			fareInfo.totalFareTRY 							= toFixedNumber(fareInfo.totalFare * currencyRateToTRY);
                    fareInfo.fareTaxes.fuelSurchargeValueTRY 		= toFixedNumber(fareInfo.fareTaxes.fuelSurchargeValueLCC * currencyRateToTRY);
                    fareInfo.fareTaxes.taxesandFeesValueTRY 		= toFixedNumber(fareInfo.fareTaxes.taxesandFeesValueLCC * currencyRateToTRY);
                    fareInfo.fareTaxes.ticketingServiceFeeValueTRY 	= toFixedNumber(fareInfo.fareTaxes.ticketingServiceFeeValueLCC * currencyRateToTRY);
        		}

        		if(fareInfo.currency == IRRCurrency) {
            		var currencyRateFromIRRToEUR = getCurrencyRate(currencyConversionRateList, fareInfo.currency, EURCurrency);
            		if(currencyRateFromIRRToEUR && currencyRateFromIRRToEUR.currencyRate) {
            			var currencyRateToEUR = currencyRateFromIRRToEUR.currencyRate;
            			fareInfo.totalFare    = toFixedNumber(fareInfo.totalFare * currencyRateToEUR);
                        fareInfo.taxPrice     = toFixedNumber(fareInfo.taxPrice * currencyRateToEUR);
                        fareInfo.productPrice = toFixedNumber(fareInfo.productPrice * currencyRateToEUR);
                        fareInfo.currency 	  = currencyRateFromIRRToEUR.targetCurrencyCode;

                        fareInfo.fareTaxes.fuelSurchargeValueLCC 		= toFixedNumber(fareInfo.fareTaxes.fuelSurchargeValueLCC * currencyRateToEUR);
                        fareInfo.fareTaxes.taxesandFeesValueLCC  		= toFixedNumber(fareInfo.fareTaxes.taxesandFeesValueLCC * currencyRateToEUR);
                        fareInfo.fareTaxes.ticketingServiceFeeValueLCC  = toFixedNumber(fareInfo.fareTaxes.ticketingServiceFeeValueLCC * currencyRateToEUR);
            		}
            	}
        	}
        }
        
        function fillGTMPaymentFareParameters(google_tag_params, fareInfo) {
        	google_tag_params.currency = fareInfo.currency;
        	google_tag_params.TotalValue = fareInfo.totalFare;
        	google_tag_params.TotalValueLCC = fareInfo.totalFare;
        	google_tag_params.TotalValueTRY = fareInfo.totalFareTRY;
        	google_tag_params.FuelSurchargeValueLCC = fareInfo.fareTaxes.fuelSurchargeValueLCC;
        	google_tag_params.FuelSurchargeValueTRY = fareInfo.fareTaxes.fuelSurchargeValueTRY;
        	google_tag_params.TaxesandFeesValueLCC = fareInfo.fareTaxes.taxesandFeesValueLCC;
        	google_tag_params.TaxesandFeesValueTRY = fareInfo.fareTaxes.taxesandFeesValueTRY;
        	google_tag_params.TicketingServiceFeeValueLCC = fareInfo.fareTaxes.ticketingServiceFeeValueLCC;
        	google_tag_params.TicketingServiceFeeValueTRY = fareInfo.fareTaxes.ticketingServiceFeeValueTRY;

        }

        function winfluencedProductId(flights,i) {
            return flights[i].originAirport.code + "-" + flights[i].destinationAirport.code
        }

        var prepWinfluencedTicketItemsData = function (reservationData) {
            try {
                var items = []
                var allCachedFlights =  JSON.parse(storageHelper.getItem({ key: "cartFlightData", webStorageType: storageHelper.Stores.SESSION_STORAGE }));
                var mFlightSearchData = JSON.parse(storageHelper.getItem({ key: "flightSearchData", webStorageType: storageHelper.Stores.SESSION_STORAGE }));
                var hasConversion = true;
                for (var i = 0; i < reservationData.allFlights.length; i++) {
                    var ticketItem = {}

                    ticketItem["productId"] = winfluencedProductId(reservationData.allFlights,i)
                    ticketItem["fullRoute"] = createAllSegmentFlightRoute(reservationData.allFlights)
                    ticketItem["cabinClass"] = reservationData.allFlights[i].cabinClass.toLowerCase()
                    ticketItem["routeType"] = getWinfluencedRouteType(reservationData.allFlights[i])
                    ticketItem["companyName"] = underscore.unique(underscore.pluck(reservationData.allFlights[i].airlinesBySegment, "shortName")).join('|')
                    ticketItem["quantity"] = reservationData.passengers.length

                    var cacheFlight = allCachedFlights[createCartFlightKey(reservationData.allFlights[i])]
                    ticketItem["fareFamily"] = cacheFlight["cd_item_fare_class"]
                    ticketItem["unitePrice"] = cacheFlight["conversion"][winfluencedTargetCurrency] || cacheFlight["conversion"]["originAmount"];
                    ticketItem["unitCurrency"] = cacheFlight["conversion"][winfluencedTargetCurrency] ? winfluencedTargetCurrency : cacheFlight["conversion"]["originCurrency"];
                    hasConversion = cacheFlight["conversion"][winfluencedTargetCurrency];
                    ticketItem["originPrice"] = cacheFlight["conversion"]["originAmount"];
                    ticketItem["originCurrency"] = cacheFlight["conversion"]["originCurrency"];
                    ticketItem["tripType"] = cacheFlight["item_category3"];
                    ticketItem["firstFlightDate"] = getDateInISOFormat(reservationData.allFlights[i].segments[0].departureDateTime)
                    items.push(ticketItem)
                }
                return {items: items, hasConversion: hasConversion};
            } catch (e) {
                console.log(e)
            }
        }

        function getOriginDestination(flight) {
            var origin = flight.segments[0].originAirport
            var destination = flight.segments[flight.segments.length - 1].destinationAirport
            return [origin, destination]
        }

        function getWinfluencedRouteType(flight) {
            var ports = getOriginDestination(flight)
            return !(ports[0].domestic && ports[1].domestic) ? "international" : "domestic"
        }

        function calculateConvertedAmount(condition, conversionRate, amount) {
            return condition ? conversionRate * amount : amount;
        }
        function prepareWinfluencedTransactionData(reservationData) {
            try {
                var ticketItemsData = prepWinfluencedTicketItemsData(reservationData);
                var hasConversion = {
                  winfluence: ticketItemsData.hasConversion && hasTargetConversionRate(reservationData.totalCharge.currency, winfluencedTargetCurrency),
                  usd:hasTargetConversionRate(reservationData.totalCharge.currency, 'USD'),
                  eur:hasTargetConversionRate(reservationData.totalCharge.currency, 'EUR'),
                  try:hasTargetConversionRate(reservationData.totalCharge.currency, 'TRY'),
                }

                var data = {
                    customer_no: "",
                    pnr: reservationData.pnr,
                    ticket_no: getTicketNo(reservationData),
                    origin_destination: reservationData.allFlights[0].originAirport.code + "-" + reservationData.allFlights[0].destinationAirport.code,
                    ticket_items: ticketItemsData.items,
                    total_discount: 0,
                    shipping_amount: calculateConvertedAmount(hasConversion.winfluence, currencyConversionRates[winfluencedTargetCurrency], reservationData.totalServiceFee.amount),
                    total_tax: calculateConvertedAmount(hasConversion.winfluence, currencyConversionRates[winfluencedTargetCurrency], reservationData.priceInfo.totalTax),
                    total_amount: calculateConvertedAmount(hasConversion.winfluence, currencyConversionRates[winfluencedTargetCurrency], reservationData.priceInfo.totalBaseAmount),
                    total_paid_amount_in_payment_currency:  reservationData.priceInfo.grandTotal,
                    total_paid_amount_in_eur: calculateConvertedAmount(hasConversion.eur, currencyConversionRates['EUR'],  reservationData.priceInfo.grandTotal),
                    total_paid_amount_in_usd: calculateConvertedAmount(hasConversion.usd, currencyConversionRates['USD'],  reservationData.priceInfo.grandTotal),
                    total_paid_amount_in_try: calculateConvertedAmount(hasConversion.try, currencyConversionRates['TRY'],  reservationData.priceInfo.grandTotal),
                    base_amount_in_eur: calculateConvertedAmount(hasConversion.eur, currencyConversionRates['EUR'], reservationData.priceInfo.totalBaseAmount),
                    base_amount_in_usd: calculateConvertedAmount(hasConversion.usd, currencyConversionRates['USD'], reservationData.priceInfo.totalBaseAmount),
                    base_amount_in_try: calculateConvertedAmount(hasConversion.try, currencyConversionRates['TRY'], reservationData.priceInfo.totalBaseAmount),
                    payment_currency: hasConversion.winfluence ? winfluencedTargetCurrency : reservationData.totalCharge.currency,
                    origin_currency: reservationData.totalCharge.currency,
                    voucher_code: "",
                    user_type: "new",
                    sales_channel: getAffiliationDevice(),

                }

                pushDataToDataLayer({
                        event: "winfluencedDataPushEvent",
                        winfluencedData: data
                    }, false, true
                )
            } catch (e) {
                console.log(e)
            }
        }

        function getFareTaxes(priceInfo) {
        	return {
        		fuelSurchargeValueLCC : priceInfo.carrierCharges,
        		taxesandFeesValueLCC  : priceInfo.totalTax,
        		ticketingServiceFeeValueLCC : priceInfo.totalFee.amount
            }
        }

        function getFareFamilyListFromSessionStorage(flights){
        	
        	if(flights && availabilityGTMUtil.getFareFamilyOfSelectedFlight(flights[0])) {
        		return underscore.map(flights, function(flight) { return availabilityGTMUtil.getFareFamilyOfSelectedFlight(flight);});
        	}

        	var flightFareFamilyList = sessionStorageUtil.getPersistedData("availabilityFlightFareFamily");
            if(flightFareFamilyList && flightFareFamilyList instanceof Array) {
            	return underscore.map(flightFareFamilyList, function(ff) { return availabilityGTMUtil.getFareFamilyFromMap(ff)});
            }
            return [];
        }

        function pushPaymentPageData(paymentDataHolder){

            try{
                var paymentDetail=paymentDataHolder.paymentDetail;
                var memberProfile = paymentDataHolder.profileData;
                var currencyConversionRateList= paymentDataHolder.currencyConversionRateList;
                var paymentPreferences = paymentDataHolder.paymentPreferences;
                var ccsp = paymentPreferences&&paymentPreferences.creditcards&&paymentPreferences.creditcards.length>0 ? 1 : "-";
                var tripType = getTripType(paymentDetail.fareInfo.flightType);

                var selectedFlights = paymentDetail.fareInfo.flights;

                var flightData = parseFlightData(selectedFlights);
                var cabinTypes = underscore.reduce(selectedFlights, function(memo, flight) { return memo.concat(getCabinTypeOfFlight(flight)); }, []);
                var mainCabinType = getMainCabinType(cabinTypes);
                
                
                var fareFamilyList = getFareFamilyListFromSessionStorage(selectedFlights);
                var fareFamily = fareFamilyList.length ? fareFamilyList[0]: mainCabinType;
                var fullfarefamily = fareFamilyList.length ? fareFamilyList.join("|") : "";

                var flightFullRoute = getTripFullRoute(selectedFlights);

                var flightDurationData = parseFlightDurationData(selectedFlights);

                var durationType = getFlightDurationType(flightDurationData.segmentDurationsAsHours);

                var isPrueDomestic = checkFlightRouteType(selectedFlights);

                var routeType = getRouteType(isPrueDomestic,selectedFlights);

                var paxList = underscore.countBy(underscore.pluck(paymentDetail.fareInfo.passengers,'personalInfo'), 'passengerTypeCode');

                var loyaltyInfo = getLoyaltyData(memberProfile);
                
                var priceInfo = paymentDetail.fareInfo.priceInfo;
                var fareInfo={};
                fareInfo.totalFare = priceInfo.grandTotal;
                fareInfo.currency = priceInfo.currencyCode;
                fareInfo.baseFare = priceInfo.totalBaseAmount;
                fareInfo.fareTaxes = getFareTaxes(priceInfo);
                var adultCount = 0;
                var childCount = 0;
                var infCount = 0;

                if(!underscore.isUndefined(paxList.ADULT)){
                    adultCount = paxList.ADULT
                }
                if(!underscore.isUndefined(paxList.CHILD)){
                    childCount = paxList.CHILD
                }
                if(!underscore.isUndefined(paxList.INFANT)){
                    infCount = paxList.INFANT
                }




                var google_tag_params = {
                    pagetype: 'payment',
                    mainPageType: 'booking',
                    origindestination: selectedFlights[0].originAirport.code+'-'+selectedFlights[0].destinationAirport.code,
                    cd_TripType: tripType,
                    prodid: selectedFlights[0].originAirport.code+'-'+selectedFlights[0].destinationAirport.code,
                    pname: selectedFlights[0].originAirport.code+'-'+selectedFlights[0].destinationAirport.code,
                    cd_cabinClass: mainCabinType,//'Economy', //cabin class (Economy, Comfort, Business)
                    cd_fareFamily:fareFamily,//'Promotion|Flex', //Fare Family (Promotion, Flex, Semi Flex)
                    cd_RBD: flightData.flightClasses.join('|'),//'Y|W', //Revenue Booked Designator (F,W,P,V,L,T,Q,E,S,H…)
                    pcategory : routeType+'/'+ fareFamily +'/'+tripType,
                    cd_OperatingCarrier : flightData.operatingAirlines.join('|'),//'TK|AJ|LH',
                    cd_fareType :  buildFareType(paxList),
                    cd_RouteType : routeType,
                    cd_flightOrigin : selectedFlights[0].originAirport.code,
                    cd_flightOriginCity : selectedFlights[0].originAirport.city.code,
                    cd_flightOriginCountry : selectedFlights[0].originAirport.country.code,
                    cd_flightDestination : selectedFlights[0].destinationAirport.code,
                    cd_flightDestinationCity : selectedFlights[0].destinationAirport.city.code,
                    cd_flightDestinationCountry : selectedFlights[0].destinationAirport.country.code,
                    cd_flightFullRoute : flightFullRoute,//'IST-ESB, ESB-IST', //Dönüş anında virgule ile ayrılması gerekmektedir. International için örnek: ‘ESB-IST-JFK, JFK-IST-ESB’
                    cd_firstflightDate : flightData.firstFlightDate,
                    cd_lastflightDate : flightData.lastFlightDate,
                    cd_flightDurationType : durationType,
                    cd_flightDuration : flightDurationData.flightDurationsAsHumanized.join('|'),//'1h5m|1h15m',
                    cd_flightDurationMinutes : flightDurationData.flightDurationsAsMin.join('|'),//'65|75',
                    cd_flightDeparture : flightData.departureTimeArray.join('|'),//'06:10|05:40',
                    cd_flightArrival : flightData.arrivalTimeArray.join('|'),//'07:15|06:45',
                    cd_flightSeatsLeft : '-',
                    cd_flightAircraft : flightData.equipments.join('|'),//'Boeing 737-800|Airbus A330-300',
                    cd_IsSPA : flightData.spa,
                    cd_IsCodeShare : flightData.codeShare,
                    cd_MembershipTier : loyaltyInfo.cardType,
                    cd_listname: getCdListName(null,fareFamily,"payment",paymentDetail.operationType),
                    cd_payOperation : paymentDetail.operationType,
                    cd_fullfareFamily: fullfarefamily,
                    cd_ccsp : ccsp,
                    cd_childCount : childCount,
                    cd_infCount : infCount,
                    cd_adultCount : adultCount,
                    cd_currency: paymentDetail.fareInfo.priceInfo.currencyCode,
                    cd_destinationIds : selectedFlights[0].destinationAirport.code,
                    cd_price : paymentDetail.fareInfo.priceInfo.grandTotal,
                };

                
                updateFareInfo(fareInfo, currencyConversionRateList);
                fillGTMPaymentFareParameters(google_tag_params, fareInfo);
                fillLowestPrices(google_tag_params,null,fareInfo.currency );
                addInitialSearchData(undefined,google_tag_params);
                pushDataToDataLayer(google_tag_params,true);
                removeGtmParamStatus();
                prepateChargableSeatData(paymentDetail);
                setExitSeatVariable();
                if(hasTargetConversionRate(priceInfo.currencyCode, 'EUR')) {
                    pushMarketingInfoEvent(fareInfo, {type: 'payment', name: 'Payment'});
                }
                fetchCurrencyConversionRates(priceInfo.currencyCode, function () { pushMarketingInfoEvent(fareInfo, {type: 'payment', name: 'Payment'}); });
            } catch (e) {
                console.log(e);
            }

        }

        var setExitSeatVariable  = function(){
        	var cd_exitSeats = sessionStorageUtil.getPersistedData("gtm-exit-seat");
            if(cd_exitSeats){
            	window.cd_exit_seats = cd_exitSeats;
            	pushEvent("seat-selection-data-available");
            }
        }
        
        var setSoldExitSeatVariable = function(sold_cd_exitSeats){
        	var cd_exitSeats = sold_cd_exitSeats || sessionStorageUtil.getPersistedData("gtm-exit-seat");
        	if(cd_exitSeats){
        		window.cd_exit_seats = cd_exitSeats;
        		pushEvent("seats-sold");
        	}
        }
        
        var setSoldInsuranceVariable = function(insuranceParams){
        	window.google_tag_params = window.google_tag_params || {};
        	for(var k in insuranceParams){
        		window.google_tag_params[k] = insuranceParams[k];
        	}
            var obj = mergeWithLastDataLayerParam("google_tag_params",insuranceParams);
            dataLayer.push({'google_tag_params':obj});
            pushEvent("ob-insurance-sold");
        }
        
        function getAffiliation(operationType, unPaidFlight){

            if(operationType=='TICKETING'){
                if(unPaidFlight){
                    return 'Online-Reservation';
                }else {
                    return 'Online-Direct';
                }

            }else if(operationType=='RESERVATION'){
                return 'Online-PayFly';
            }

            return '-';

        }

        function getInsuranceDetails(travelGuardPriceInfo){
            if(travelGuardPriceInfo){
                var insurance = {};
                insurance.cd_insurance_price  = travelGuardPriceInfo.baseAmount;
                insurance.cd_insurance_currency = travelGuardPriceInfo.currencyCode;
                return insurance;
            }
        }

        function prepareParsedFlightData(flightData){
            return {
                google_tag_params:{
                    cd_flightDeparture : flightData.departureTimeArray.join('|'),//'06:10|05:40',
                    cd_flightArrival : flightData.arrivalTimeArray.join('|'),//'07:15|06:45',
                    cd_flightSeatsLeft : '-',
                    cd_flightAircraft : flightData.equipments.join('|'),//'Boeing 737-800|Airbus A330-300',
                    cd_IsSPA : flightData.spa,
                    cd_firstflightDate : flightData.firstFlightDate,
                    cd_lastflightDate : flightData.lastFlightDate,
                    cd_RBD:flightData.flightClasses.join('|'),
                    cd_OperatingCarrier : flightData.operatingAirlines.join('|')
                }
            };
        }

        function parsePaymentData(paymentInfo){
            var paymentType = paymentInfo.paymentType ?  paymentInfo.paymentType : '';

            var subPaymentType;

            var cardDetail = {
                cd_cardCountry  :"None",
                cd_cardBank     :"None",
                cd_cardBrand    :"None",
                cd_cardProgram  :"None"
            };

            if(paymentType=='creditCard'){
                cardDetail = getCreditCardType(paymentInfo.cardInfo,cardDetail);
                subPaymentType = cardDetail.cd_cardBrand;
            }else{
                subPaymentType = getSubPaymentType(paymentType);
            }


            return {
                util :{
                    cardDetail: cardDetail
                },
                google_tag_params:{
                    'cd_cardCountry': cardDetail.cd_cardCountry, // "International
                    'cd_cardBank': cardDetail.cd_cardBank?cardDetail.cd_cardBank:"None", // "Akbank", "Yapı Kredi" vb actionField
                    'cd_cardBrand': cardDetail.cd_cardBrand?cardDetail.cd_cardBrand:"None", // "Mastercard" actionField
                    'cd_cardProgram': cardDetail.cd_cardProgram?cardDetail.cd_cardProgram:"None",
                    'cd_paymentType' : paymentType,
                    'cd_paymentSubType':subPaymentType?subPaymentType:"None",
                    'cd_noOfInstallments': paymentInfo.installmentCount,

                }

            }
        }

        function parseReservation(reservationInfo){

            var util={};
            var gtp={};

            var returnObj = {
                google_tag_params:gtp,
                util:util

            };



            var selectedFlights = underscore.pluck(reservationInfo.trips,"flightInfo");
            util.selectedFlights = selectedFlights;

            var firstFlightData = parseSelectedFlightData(selectedFlights[0]);
            for(var i in firstFlightData.google_tag_params){
                gtp[i]= firstFlightData.google_tag_params[i];
            }
            util.flightData = parseFlightData(selectedFlights);
            gtp.cd_TripType = getTripType(reservationInfo.tripType);

            util.cabinTypes = underscore.reduce(selectedFlights, function(memo, flight) { return memo.concat(getCabinTypeOfFlight(flight)); }, []);

            gtp.cd_cabinClass = getMainCabinType(util.cabinTypes);
            util.fareFamilyList = getFareFamilyListFromSessionStorage(selectedFlights);
            gtp.cd_fareFamily = util.fareFamilyList.length ? util.fareFamilyList[0]: gtp.cd_cabinClass;;
            gtp.cd_fullfareFamily = util.fareFamilyList.length ? util.fareFamilyList.join("|") : "";

            gtp.cd_flightFullRoute = getTripFullRoute(selectedFlights);

            util.flightDurationData = parseFlightDurationData(selectedFlights);

            gtp.cd_flightDurationType = getFlightDurationType(util.flightDurationData.segmentDurationsAsHours);

            gtp.cd_flightDuration=util.flightDurationData.flightDurationsAsHumanized.join('|');
            gtp.cd_flightDurationMinutes = util.flightDurationData.flightDurationsAsMin.join('|');
            util.isPrueDomestic = checkFlightRouteType(selectedFlights);

            gtp.cd_RouteType = getRouteType(util.isPrueDomestic,selectedFlights);
            gtp.pcategory=gtp.cd_RouteType+'/'+gtp.cd_fareFamily+'/'+gtp.cd_TripType;
            util.paxList = underscore.countBy(underscore.pluck(reservationInfo.passengers,'personalInfo'), 'passengerTypeCode');
            gtp.cd_fareType=buildFareType(util.paxList);

            util.contactDetail  = getContactDetail(reservationInfo.contactPassenger);
            gtp.cd_Title=util.contactDetail.title,//'Mr',
                gtp.cd_Demographics =util.contactDetail.age+'-'+util.contactDetail.gender,//'31-M',

                util.tickets = underscore.pluck(reservationInfo.tickets, "ticketNumber");
            var fareInfo={};
            fareInfo.totalFare = reservationInfo.totalFare.amount;
            fareInfo.currency = reservationInfo.totalFare.currency;
            fareInfo.productPrice = reservationInfo.totalFare.amount / underscore.size(util.tickets);
            fareInfo.taxPrice = reservationInfo.totalOtherTaxesAndFees.amount;

            util.fareInfo=fareInfo;
            gtp.currencyCode=util.fareInfo.currency;
            gtp.cd_agencyPnr= reservationInfo.agencyPNR ? "Yes" :"No";
            gtp.ck_user_id=reservationInfo.contactEmail;
            gtp.pnr=reservationInfo.pnr;
            gtp.cd_isReserved=reservationInfo.paid? "Yes" :"No";
            gtp.cm_ticketCount= underscore.size(util.tickets),
            gtp.cm_couponCount= underscore.size(util.flightData.routeArray);
            return returnObj;

        }

        function parseSelectedFlightData(selectedFlight){
            return {
                google_tag_params:{
                    origindestination: selectedFlight.originAirport.code+'-'+selectedFlight.destinationAirport.code,
                    prodid: selectedFlight.originAirport.code+'-'+selectedFlight.destinationAirport.code,
                    pname: selectedFlight.originAirport.code+'-'+selectedFlight.destinationAirport.code,
                    cd_flightOrigin : selectedFlight.originAirport.code,
                    cd_flightOriginCity : selectedFlight.originAirport.city.code,
                    cd_flightOriginCountry : selectedFlight.originAirport.country.code,
                    cd_flightDestination : selectedFlight.destinationAirport.code,
                    cd_flightDestinationCity : selectedFlight.destinationAirport.city.code,
                    cd_flightDestinationCountry : selectedFlight.destinationAirport.country.code
                }
            };

        }

        var gtmThankYouDataAlreadySent = false;

        function pushThankyouPageData(reservationDataHolder, pType, mpType, ecType){
            var pageType =pType ||  "purchase";
            var mainPageType =mpType ||  "booking";
            var ecommerceType =ecType ||  "ecommerce";


            var reservationInfo = reservationDataHolder.reservation;

            if(!window._ignoreThankYouSendDataOnce&&reservationDataHolder.gtmThankYouDataSent){
                pushEvent("duplicate-thankyou-"+reservationInfo.pnr);
                gtmThankYouDataAlreadySent = true;
                return;
            }

            var unPaidFlight =  reservationDataHolder.unPaidFlight;
            var priceInfo = reservationDataHolder.priceInfo;
            
            try {

                var selectedFlights = underscore.pluck(reservationInfo.trips,"flightInfo");
                var flightData = parseFlightData(selectedFlights);

                var tripType = getTripType(reservationInfo.tripType);

                var cabinTypes = underscore.reduce(selectedFlights, function(memo, flight) { return memo.concat(getCabinTypeOfFlight(flight)); }, []);

                var mainCabinClass = getMainCabinType(cabinTypes);
                var fareFamilyList = getFareFamilyListFromSessionStorage(selectedFlights);
                var fareFamily = fareFamilyList.length ? fareFamilyList[0]: mainCabinClass;
                var fullfarefamily = fareFamilyList.length ? fareFamilyList.join("|") : "";

                var flightFullRoute = getTripFullRoute(selectedFlights);

                var flightDurationData = parseFlightDurationData(selectedFlights);

                var durationType = getFlightDurationType(flightDurationData.segmentDurationsAsHours);

                var isPrueDomestic = checkFlightRouteType(selectedFlights);

                var routeType = getRouteType(isPrueDomestic,selectedFlights);

                var paxList = underscore.countBy(underscore.pluck(reservationInfo.passengers,'personalInfo'), 'passengerTypeCode');

                var loyaltyInfo = getLoyaltyData(reservationDataHolder.profileData);

                var contactDetail  = getContactDetail(reservationInfo.contactPassenger);

                var tickets = underscore.pluck(reservationInfo.tickets, "ticketNumber");

                var fareInfo={};
                fareInfo.totalFare = reservationInfo.totalCharge.amount;
                fareInfo.currency = reservationInfo.totalCharge.currency;
                fareInfo.productPrice = reservationInfo.totalFare.amount / underscore.size(tickets);
                fareInfo.taxPrice = reservationInfo.totalOtherTaxesAndFees.amount;
                fareInfo.fareTaxes = getFareTaxes(priceInfo);



				
				var google_tag_params = {};


                
                google_tag_params.pagetype = pageType;
                google_tag_params.mainPageType = mainPageType;
                google_tag_params.pnr= reservationInfo.pnr +'-'+ moment.utc().format('YYYYMMDD');
                google_tag_params.origindestination= selectedFlights[0].originAirport.code+'-'+selectedFlights[0].destinationAirport.code;
                google_tag_params.cd_TripType= tripType;
                google_tag_params.prodid= selectedFlights[0].originAirport.code+'-'+selectedFlights[0].destinationAirport.code;
                google_tag_params.pname= selectedFlights[0].originAirport.code+'-'+selectedFlights[0].destinationAirport.code,
                google_tag_params.cd_cabinClass= mainCabinClass;//'Economy', //cabin class (Economy, Comfort, Business)
                google_tag_params.cd_fareFamily= fareFamily;//'Promotion|Flex', //Fare Family (Promotion, Flex, Semi Flex)
                google_tag_params.cd_RBD= flightData.flightClasses.join('|');//'Y|W', //Revenue Booked Designator (F,W,P,V,L,T,Q,E,S,H…)
                google_tag_params.pcategory = routeType+'/'+fareFamily+'/'+tripType;
                google_tag_params.cd_OperatingCarrier = flightData.operatingAirlines.join('|');//'TK|AJ|LH',
                google_tag_params.cd_fareType =  buildFareType(paxList);
                google_tag_params.cd_RouteType = routeType;
                google_tag_params.cd_flightOrigin = selectedFlights[0].originAirport.code;
                google_tag_params.cd_flightOriginCity = selectedFlights[0].originAirport.city.code;
                google_tag_params.cd_flightOriginCountry = selectedFlights[0].originAirport.country.code;
                google_tag_params.cd_flightDestination = selectedFlights[0].destinationAirport.code;
                google_tag_params.cd_flightDestinationCity = selectedFlights[0].destinationAirport.city.code;
                google_tag_params.cd_flightDestinationCountry = selectedFlights[0].destinationAirport.country.code;
                google_tag_params.cd_flightFullRoute = flightFullRoute;//'IST-ESB, ESB-IST', //Dönüş anında virgule ile ayrılması gerekmektedir. International için örnek: ‘ESB-IST-JFK, JFK-IST-ESB’
                google_tag_params.cd_firstflightDate = flightData.firstFlightDate;
                google_tag_params.cd_lastflightDate = flightData.lastFlightDate;
                google_tag_params.cd_flightDurationType = durationType;
                google_tag_params.cd_flightDuration = flightDurationData.flightDurationsAsHumanized.join('|');//'1h5m|1h15m',
                google_tag_params.cd_flightDurationMinutes = flightDurationData.flightDurationsAsMin.join('|');//'65|75',
                google_tag_params.cd_flightDeparture = flightData.departureTimeArray.join('|');//'06:10|05:40',
                google_tag_params.cd_flightArrival = flightData.arrivalTimeArray.join('|');//'07:15|06:45',
                google_tag_params.cd_flightSeatsLeft = '-';
                google_tag_params.cd_flightAircraft = flightData.equipments.join('|');//'Boeing 737-800|Airbus A330-300',
                google_tag_params.cd_IsSPA = flightData.spa;
                google_tag_params.cd_IsCodeShare = flightData.codeShare;
                google_tag_params.cd_PromoCode = reservationDataHolder.promoCode || 'None';
                google_tag_params.cd_MembershipTypeTier = loyaltyInfo.cardType;
                google_tag_params.cd_MembershipTier = loyaltyInfo.cardType;
                google_tag_params.cd_Title = contactDetail.title;//'Mr',
                google_tag_params.cd_Demographics = contactDetail.age+'-'+contactDetail.gender;//'31-M',
                google_tag_params.cd_listname = getCdListName(null,fareFamily);
                google_tag_params.cd_fullfareFamily= fullfarefamily;
  


				if(unPaidFlight){
					//Reservation
					var reservationOption = reservationDataHolder.selectedReservationOptionData.optionData;
		            var reservationSelectionMethod =  reservationDataHolder.reservationSaleSelectionMethod;
					var offerTitleLabel = i18n.get(reservationOption.offerTitleLabel);
					var reservationPeriod = timeToHours(reservationOption.optionDuration);
					var isFromReservation = reservationDataHolder.comingFromManageBooking;
					var reservationPriceTotal = priceInfo.grandTotal;
					
					google_tag_params.cd_reservedFrom = reservationSelectionMethod;  
		            google_tag_params.cm_reservationFee = reservationPriceTotal;  
					google_tag_params.cd_isFromReservation= isFromReservation;
					google_tag_params.cd_reservationOption= offerTitleLabel;
					google_tag_params.cd_reservationPeriod= reservationPeriod;
				} else{
					//Transaction				
					var isFromReservation = reservationDataHolder.comingFromManageBooking; 
					var travelInsuranceSelected = reservationDataHolder.travelGuardPrefered ? 'Yes' :'No';
					var seatSelected = reservationDataHolder.seatSelected == true ? 'Yes' :'No';

					
					google_tag_params.cd_isFromReservation= isFromReservation;
					google_tag_params.cd_travelInsuranceSelected = travelInsuranceSelected;
					google_tag_params.cd_seatSelected = seatSelected;

					if(reservationInfo.totalSeatPrice !== null) {
						var seatSelectionValueLCC = reservationInfo.totalSeatPrice.amount; //null
						var seatSelectionValueTRY = reservationInfo.totalSeatPrice.amount; //null 
						
						google_tag_params.SeatSelectionValueLCC = seatSelectionValueLCC;  
		            	google_tag_params.SeatSelectionValueTRY = seatSelectionValueTRY; 
					}else {
						google_tag_params.SeatSelectionValueLCC = 0;  //null
		            	google_tag_params.SeatSelectionValueTRY = 0;  //null
					}
					
					if(reservationDataHolder.travelGuardPriceInfo !== null) {
						    var travelInsuranceValueLCC = reservationDataHolder.travelGuardPriceInfo.grandTotal; //!null
							var travelInsuranceValueTRY = reservationDataHolder.travelGuardPriceInfo.grandTotal; //!null
							
							google_tag_params.TravelInsuranceValueLCC= travelInsuranceValueLCC; 
							google_tag_params.TravelInsuranceValueTRY= travelInsuranceValueTRY;
					} else {
							google_tag_params.TravelInsuranceValueLCC= 0; 	//null
							google_tag_params.TravelInsuranceValueTRY= 0;	//null
					}
				}

                updateFareInfo(fareInfo, reservationDataHolder.currencyConversionRateList);
                fillGTMPaymentFareParameters(google_tag_params, fareInfo);
                fillLowestPrices(google_tag_params,null,fareInfo.currency );
                addInitialSearchData(undefined,google_tag_params);
                var purchaseSecureAttr = {'purchase' : true};
                gtmSecurePush(google_tag_params,purchaseSecureAttr,true,false);

                if(reservationDataHolder.exitSeatSold){
                    setSoldExitSeatVariable();
                }

                if(reservationDataHolder.travelGuardSelled){
                    var insuranceDetails = getInsuranceDetails(reservationDataHolder.travelGuardPriceInfo);
                    if(insuranceDetails){
                        insuranceDetails.cd_insuranceTransactionId=reservationDataHolder.travelGuardPolicyNumber;
                        setSoldInsuranceVariable(insuranceDetails);
                    }

                }

                var products = [];

                underscore.each(reservationInfo.tickets, function(ticket){
                    var passangerIndex = ticket.rph-1;
                    ticket.passengerTypeCode = reservationInfo.passengers[passangerIndex].personalInfo.passengerTypeCode;
                });


                var affiliation = getAffiliation(reservationDataHolder.operationType, unPaidFlight);

                underscore.each(reservationInfo.passengers, function(passenger){
                    var t =0;
                    var product= { //ürün array’i – burada satılan tekil farklı biletleri gönderiyoruz
                        'name': selectedFlights[0].originAirport.code+'-'+selectedFlights[0].destinationAirport.code,
                        'id': selectedFlights[0].originAirport.code+'-'+selectedFlights[0].destinationAirport.code, //Ürün ID’si
                        'price': fareInfo.productPrice, //Ürün tutarı
                        'category': routeType+'/'+fareFamily+'/'+tripType,//'Domestic/Economy/RoundTrip', //Ürün Kategorisi. Örnekteki mantıkla 3 seviyeli
                        'cd_OperatingCarrier': flightData.operatingAirlines.join('|'), //Ürün Markası (Borajet, Anadolujet vb. de eğer varsa kullanılabilir)
                        'cd_cabinClassProduct': mainCabinClass,//'Economy', //Economy, Business, Mixed – Tek basılacak
                        'cd_cabinClass': cabinTypes.join('|'),//'Economy|Economy|Business', //cabin class Economy, Business
                        'cd_fareFamily': fareFamilyList.join('|'),//'Promotion|Flex', //Fare Family (Promotion, Flex, Semi Flex)
                        'cd_RBD': flightData.flightClasses.join('|'), //Revenue Booked Designator (F,W,P,V,L,T,Q,E,S,H…)
                        'cd_fareType' : passenger.passengerType,//'adult', //fareType
                        'quantity': 1, //Bilet Adedi
                        'cd_RouteType': routeType, // Domestic, International-Inbound, International-Outbound, Beyond
                        'cd_flightOrder' : t+1, //uçuşun PNR’daki sırası
                        'cd_flightOriginCity' : selectedFlights[0].originAirport.city.code,
                        'cd_flightOriginCountry' : selectedFlights[0].originAirport.country.code,
                        'cd_flightDestination' : selectedFlights[0].destinationAirport.code,
                        'cd_flightDestinationCity' : selectedFlights[0].destinationAirport.city.code,
                        'cd_flightDestinationCountry' : selectedFlights[0].destinationAirport.country.code,
                        'cd_flightFullRoute' : flightFullRoute, //Dönüş anında virgule ile ayrılması gerekmektedir. International için örnek: ‘ESB-IST-JFK, JFK-IST-ESB’
                        'cd_firstflightDate' : flightData.firstFlightDate,
                        'cd_lastflightDate' : flightData.lastFlightDate,
                        'cd_flightDurationType':durationType, //flight duration type
                        'cd_flightDuration' : flightDurationData.flightDurationsAsHumanized.join('|'), //Uçuş süresi (front-end’de gösterildiği gibi)
                        'cd_flightDurationMinutes': flightDurationData.flightDurationsAsMin.join('|'), //Uçuş süresi – dakika (int formatında)
                        'cd_flightDeparture' : flightData.departureTimeArray.join('|'), //uçuş kalkış saati
                        'cd_flightArrival' : flightData.arrivalTimeArray.join('|'), //uçuş varış saati
                        'cd_flightSeatsLeft' : '-', //uçuşta kalan koltuk sayısı
                        'cd_flightAircraft' : flightData.equipments.join('|') //uçak tipi
                    };
                    products.push(product);
                    t++;
                });

                var paymentType =  reservationInfo.paymentInfo ? reservationInfo.paymentInfo.paymentType : '';

                var subPaymentType;

                var cardDetail = {
                    cd_cardCountry  :"None",
                    cd_cardBank		:"None",
                    cd_cardBrand	:"None",
                    cd_cardProgram	:"None"
                };

                if(paymentType=='creditCard'){
                    cardDetail = getCreditCardType(reservationInfo.paymentInfo.cardInfo,cardDetail);
                    subPaymentType = cardDetail.cd_cardBrand;
                }else{
                    subPaymentType = getSubPaymentType(paymentType);
                }


                var productGoogleTagParam = {
	
                    'event': unPaidFlight ? 'reservation' : 'transaction'
                };
				
                productGoogleTagParam[ecommerceType]=  {
                    'purchase': {
                        'actionField': {
                            'id': reservationInfo.pnr +'-'+ moment.utc().format('YYYYMMDD'),  //PNR
                            'affiliation': affiliation,
                            'currencyCode' : fareInfo.currency,
                            'revenue': fareInfo.totalFare,  //Toplam ciro (ürün + KDV + Kargo) – EUR gönderilmeli
                            'tax': fareInfo.taxPrice,        //KDV toplamı – EUR Gönderilmeli
                            'shipping': '0',   //Kargo Tutarı – EUR Gönderilmeli
                            'promocode': '', //Kullanılan kupon/indirim adı, yoksa boş gönderilebilir
                            'cd_PromoCode': reservationDataHolder.promoCode || 'None',
                            'cd_TripType': tripType, //Uçuş tipi. Round-Trip, One-Way, Multi-City vb
                            'cd_pnrMainOriginDestination': selectedFlights[0].originAirport.code+'-'+selectedFlights[0].destinationAirport.code, //pnr’ın ilk ve en son bacakları
                            'cm_ticketCount': underscore.size(tickets), //satılan bilet adedi (integer olarak)
                            'cm_couponCount': underscore.size(products) * underscore.size(flightData.operatingAirlines), //toplam biletlerdeki kupon adedi (integer olarak)
                            'cd_ticketNo': tickets.join('|'), //bilet kodları (, ile birleştirilmiş tek bir string)
                            'cd_paymentType': paymentType,//'Credit Card', //Ödeme opsiyonu 1. seviye
                            'cd_paymentSubType': subPaymentType, //Ödeme opsiyonu 2. seviye (eğer varsa)
                            'cd_paymentTypeCountry': 'Turkey', //Ödeme opsiyonunun ait olduğu ülke (eğer varsa)
                            'cd_noOfInstallments': reservationInfo.paymentInfo.installmentCount,//'6', //taksit sayısı (taksit yoksa 0 gelecek)
                            'cd_fareType' :  buildFareType(paxList),
                            'cd_isReserved': unPaidFlight ? 'Yes' : 'No', //Rezervasyonlu mu Rezervasyonsuz mu (Yes/No)
                            'cd_cardCountry': cardDetail.cd_cardCountry, // "International
                            'cd_cardBank': cardDetail.cd_cardBank, // "Akbank", "Yapı Kredi" vb actionField
                            'cd_cardBrand': cardDetail.cd_cardBrand, // "Mastercard" actionField
                            'cd_cardProgram': cardDetail.cd_cardProgram, // "BONUS" actionField
                            'cd_IsSPA' : flightData.spa,
                            'cd_IsCodeShare' : flightData.codeShare,
                        },
                        'products': products
                    }
                }

                var secureAttr = {'ecommerce' : true};
                gtmSecurePush(productGoogleTagParam,secureAttr,false,true);


            } catch (e) {
                console.log(e);
            }

        }
        var prepateChargableSeatData = function(paymentInfo){
        	var extraPricesChargeableSeat = underscore.find(paymentInfo.extraPrices, function(extraPrice) {
 				return extraPrice.priceType == "CHARGEABLE_SEAT_PRICE";
 			});
        	
        	if(paymentInfo && paymentInfo.extraPrices && extraPricesChargeableSeat){
            	var data = {};
            	var purchasedSeatCount=0;
            	   ko.utils.arrayForEach(paymentInfo.fareInfo.flights, function(flight) { 		 
            		  var flights = {};
            		  flights[flight.originAirport.city.code + "-" + flight.destinationAirport.city.code] = {};
                      var fsegment={};
                      var fsegmentseat = [];
                       ko.utils.arrayForEach(flight.segments, function(segment) {
                    	   var seat_details = {};
                           fsegment.flight_number = segment.flightNumber;
                           ko.utils.arrayForEach(extraPricesChargeableSeat.emdFareDetail.passengerEmdFares, function(passengerEmdFare) {
                        	   ko.utils.arrayForEach(passengerEmdFare.segmentFares, function(segmentFare) {
                        		   if(segment.rph == segmentFare.segmentIndex){
                        			   var segmentSeatInfo = segmentFare;
                        			   purchasedSeatCount++;
                        			   seat_details.price = segmentSeatInfo.amount;
                                       seat_details.seat_type = segmentSeatInfo.seatRequest.chargableSeatType + "-" + segmentSeatInfo.seatRequest.seatPreference;
                                       fsegmentseat.push(seat_details);
                                       flights[flight.originAirport.city.code + "-" + flight.destinationAirport.city.code].seat_details = fsegmentseat;
                                       flights[flight.originAirport.city.code + "-" + flight.destinationAirport.city.code].flight_number = segment.flightNumber;
                        		   }
                        	   });
                           });
                           
                       });
                       data.total_value = paymentInfo.extraPrices[0].totalPrice.amount;
                       data.currency = paymentInfo.extraPrices[0].totalPrice.currency;
                       data.available_person=extraPricesChargeableSeat.emdFareDetail.passengerEmdFares.length;
                       data.purchased_seats=purchasedSeatCount;
                       data[flight.originAirport.city.code + "-" + flight.destinationAirport.city.code] = flights[flight.originAirport.city.code + "-" + flight.destinationAirport.city.code];
                   });
            	   
            	   sessionStorageUtil.persistData("gtm-exit-seat", data);
        	}
        }
        
        var pushGenericPageData  = function(pushData){
        	if(pushData&&pushData.mainPageType&&pushData.pagetype&&pushData.language){
        		pushDataToDataLayer(pushData,false);
        	}
        }

        var pushCurrencyData  = function(data){
            var obj = {
                old_currency : data.oldCurrency,
                new_currency : data.newCurrency,
                _meta:{ pushTypeEvent:"currency_changed" }
            }

            data = {
                event: "currency_change",
                cId: JSON.parse(storageHelper.getItem({ key: "X-conversationId", webStorageType: storageHelper.Stores.SESSION_STORAGE })),
                cd_currency_changed_from: data.oldCurrency,
                cd_currency_changed_to: data.newCurrency,
                page_type: 'payment',
                udevId: getUdevId(),
            }

            pushDataToDataLayer(data, false, true)
            pushDataToDataLayer(obj,false);
        }
        
        var pushInsuranceData = function(reservationResult){
            if(!reservationResult){
                return;
            }
        	if(reservationResult.priceInfo){
        		var priceInfo = reservationResult.priceInfo;
        		if(priceInfo.totalAmount&& !isNaN(priceInfo.totalAmount) && priceInfo.totalAmount > 0){
        			var obj = {
        					cd_Insurance  : "Yes",
        					cd_TotalRevenueInsuranceLCC:priceInfo.totalAmount,
        					cd_PolicyIssuedCountry : "TR",
        					cd_startPageInsurance : "Homepage",
        					cd_NumberOfPassengersForInsurance :  priceInfo.totalAmount / priceInfo.perPassangerAmount,
        				
        			}
        			if(priceInfo.currencyCode==="TRY"){
        				obj.cd_TotalRevenueInsuranceTRY = priceInfo.totalAmount;
        			}
        			if(reservationResult.request){
        				var request = reservationResult.request;
        				
        				obj.cd_CountryOfInsurance = request.countryName;
        				
        				var ageIntervalInsurance = [];
        				underscore.each(request.paxList, function(pax){
        					 for(var i =0;i<pax.count;i++){
        						 ageIntervalInsurance.push(pax.description);
                             }
        				 });
        				
        				obj.cd_AgeIntervalInsurance=ageIntervalInsurance.join('|');
        				
        				if(request.inceptionDate){
        					obj.cd_firstFlightDateInsurance = moment(request.inceptionDate).format("YYYY-MM-DD");
        				}
        				if(request.returnDate){
        					obj.cd_lastFlightDateInsurance = moment(request.returnDate).format("YYYY-MM-DD");
        				}
        				
        			}
                    if(reservationResult.reservationInfo){
                        obj.cd_insuranceTransactionId=reservationResult.reservationInfo.policyNumber;
                    }
        			pushDataToDataLayer(obj,false);
        			pushEvent("home-insurance-sold");
        		}
        	}
        }
        
        var  _pushLoginData = function(loginResponse,clientInfo){
            
            if(!loginResponse || typeof dataLayer!="object"){
                return;
            }

            var logined = loginResponse.loggedIn ?   true : false;

            var findLastSentGtmParam = function(param){
                for(var i = dataLayer.length-1;i>0;i--){
                    var pushedParam = dataLayer[i];
                    if(pushedParam&&pushedParam.google_tag_params&&pushedParam.google_tag_params[param]){
                        return  pushedParam.google_tag_params[param];
                    }
                }
            }
            var getSessionId = function(){
                try{
                    var session = $("head").contents().filter(function() {
                        return this.nodeType === 8 && this.nodeValue&&this.nodeValue.indexOf("Start Session Info")>-1;
                    })[0].nodeValue;

                    return    JSON.parse(session.split('Start Session Info:')[1].trim()).SessionId;
                }
                catch(e){
                    console.log(e);
                }
            }
            var obj  = {};
            if(logined){

                var profileIdKey  =findLastSentGtmParam("profileIdKey");
                if(profileIdKey&&profileIdKey==loginResponse.profileIdKey){
                    return;
                }
                obj.profileIdKey=loginResponse.profileIdKey;

            }
            else{
                var pushedSessionId = findLastSentGtmParam("sessionId");
                var currentSessionId = getSessionId();
                if(pushedSessionId&&currentSessionId&&pushedSessionId==currentSessionId){
                    return;
                }
                obj.sessionId=currentSessionId;

            }

            if(!window.ucis&&typeof clientInfo=="object"&&clientInfo){
                for(var key in clientInfo){
                    obj[key] = clientInfo[key];
                }
                window.ucis=true;
            }
            
            if(logined){
                 obj.is_logged_in=true;

            }
            else{
                obj.is_logged_in = false;
            }
            obj._meta = {pushTypeEvent : "client_information"};
            var extraInfo = loginResponse.extraInfos;
            if(!extraInfo){
                pushDataToDataLayer(obj,false);
                return;
            }
           
            var age = extraInfo.age ? extraInfo.age : "-";
            var gender = extraInfo.gender ? extraInfo.gender : "-";
            obj.cd_Demographics  = age+"-"+gender;
            
            if(extraInfo.firstFlightDate){
                obj.first_flight_ts = extraInfo.firstFlightDate;
            }
            if(extraInfo.firstTicketingDate){
                obj.first_ticket_ts = extraInfo.firstTicketingDate;
            }
            if(extraInfo.startAlianceFfp){
                obj.cd_membershipType = extraInfo.startAlianceFfp;
            }
            
            if(extraInfo.cardType){
                obj.cd_MembershipTier = getMSLevel(extraInfo.cardType);
            }
            
            if(extraInfo.nationality){
                obj.cd_nationality  =extraInfo.nationality;
            }
            pushDataToDataLayer(obj,false);
            if(logined){
            	pushEvent("logged in");            	
            }
        }

        var pushLoginData = function(loginResponse,clientinfoGetter){
            var clientinfo;
            if(typeof clientinfoGetter=="object"){
                clientinfo  = clientinfoGetter;
            }
            if(!clientinfo){
                clientinfo = sessionStorageUtil.getPersistedData("x-clientInfo");
            }
            if(clientinfo){
                _pushLoginData(loginResponse,clientinfo)
            }
            else if(!clientinfo&&typeof clientinfoGetter=="function"){
                clientinfoGetter().done(function(newlyRetrivedClientinfo){
                    if(newlyRetrivedClientinfo){
                        _pushLoginData(loginResponse,clientinfo);
                        sessionStorageUtil.persistData("x-clientInfo",newlyRetrivedClientinfo);
                    }
                    else{
                        _pushLoginData(loginResponse);
                    }

                }).fail(function(){
                    _pushLoginData(loginResponse);
                });
            }
            else{
                _pushLoginData(loginResponse);
            }
			
			
			if (typeof dataLayer !== 'undefined') {
				var newData = dataLayer.find(function(c) {
				if(c.event === 'client_information')
					return true;
				});
	
				var sessiontoClientInfo = newData["google_tag_params"];
				
				var targetProps = [
						"sessionId", 
						"cd_OS", 
						"cd_Browser",
						"cd_GeoCountry", 
						"cd_DeviceType",
						"cd_GeoCity", 
						"is_logged_in", 
						"profileIdKey", 
						"cd_Demographics",
						"first_flight_ts",
						"first_ticket_ts",
						"cd_membershipType", 
						"cd_MembershipTier", 
						"cd_nationality" 
						];
				
						
				function checkTarget(arr, obj) {
				  var newClientInfo = {};		
				  arr.forEach(function(key) {
				  if(obj.hasOwnProperty(key)){
				  	 newClientInfo[key] = obj[key];
				  }
				   
				  });
				  return newClientInfo;
				}
                storageHelper.setItem({
                    key: "clientInfoGTM",
                    value: JSON.stringify(checkTarget(targetProps,sessiontoClientInfo)),
                    webStorageType: storageHelper.Stores.SESSION_STORAGE
                });
			}				
        }

        var pushServiceError = function(error){
            var obj = {
                err_validationMessages : error.validationMessages,
                err_serverTID : error.serverTID,
                err_clientID:  error.clientTID,
                err_requestID: error.requestID,
                err_code : error.code,
                err_subCode: error.subCode,
                messages: error.messages,
                api_url:error.apiUrl,
                validationMessages : error.validationMessages,
                _meta:{ pushTypeEvent:"service-error" }
            }

            var codes=[];
            var ids=[];
            var msgs=[];
            var reasons=[];
            var types=[];
            var fields=[];


            var pushMessageContents = function(messages,type){
                if(!messages){
                    return;
                }
                for(var m = 0;m<messages.length;m++){
                    var message = messages[m];
                    codes.push(message.code?message.code:"-");
                    ids.push(message.id?message.id:"-");
                    msgs.push(message.msg?message.msg:"-");
                    reasons.push(message.reason?message.reason:"-");
                    fields.push(message.fields?message.fields:"-");
                    types.push(type);
                }

            }
            pushMessageContents(error.messages,"message");
            pushMessageContents(error.validationMessages,"validation");

            obj.err_codes = codes.join("|");
            obj.err_ids = ids.join("|");
            obj.err_msgs = msgs.join("|");
            obj.err_reasons = reasons.join("|");
            obj.err_types = types.join("|");
            obj.err_fields = fields.join("|");

            pushDataToDataLayer(obj,false);
        }
        
        var EcommerceHelper  = function(){

        	var EcommerceBuilder = function(rootNam){
                var root = {};
                var rootName =rootNam ||  "ecommerce";
                var _ecommerceRoot;
                var obj = {
                	rootName : function(){ return rootName},
                    ecommerce : function(ecommerceRoot,ecommerceItemsKey,values){
                    	root  = {};
                        root[rootName] = {};
                        root[rootName][ecommerceRoot] = {};
                        if(!ecommerceItemsKey){
                             root[rootName][ecommerceRoot]= values;
                        }
                        else{
                             root[rootName][ecommerceRoot][ecommerceItemsKey] = values;
                        }
                       	_ecommerceRoot  = ecommerceRoot;
                        return obj;
                    },
                    withEvent : function(eventName){
                        root["event"]  = eventName;
                        return obj;
                    },
                    
                    withEventCallback : function(eventCallback,timeout){
                        if(!timeout){
                             root["eventCallback"] = eventCallback;
                        }
                        else{
                            var _fired=false;
                            var oneFireFunc  = function(){
                                console.info("event callback");
                                if(!_fired){
                                    _fired  = true;
                                    eventCallback();
                                }
                            };
                            
                            setTimeout(oneFireFunc,timeout);
                            
                            root["eventCallback"] = oneFireFunc.bind();
                        }
                        return obj;
                    },
                    actionField : function(action){
                    	root[rootName][_ecommerceRoot]["actionField"]  = action;
                    	return obj;	
                    },
                     set:function(path, value) {
                    		if (typeof path !== 'string') {
                    			return obj;
                    		}
                    		
                    		var pathArr = path.split(".");
                            var temp = root;
                    		for (var i = 0; i < pathArr.length; i++) {
                    			var p = pathArr[i];
                    
                    			if (typeof temp[p]!=="object") {
                    				temp[p] = {};
                    			}
                    
                    			if (i === pathArr.length - 1) {
                    				temp[p] = value;
                    			}
                    
                    			temp = temp[p];
                    		}
                    
                    		return obj;
    	            },
                    build: function(){
                    	var o = {};
                        return $.extend(true,o,root);
                    }
                 
                }
                return obj;
            }

            	 var ModelFactory = function(){
    			

    			 	var getEcommerceModels = function(builder) {

                        var checkoutOption = function(action,eventCallback){
                            return builder.ecommerce("checkout_option","actionField",action)
                                .withEvent("checkoutOption")
                                .withEventCallback(eventCallback,100).build();
                        }
    			 		
    			 		return {
    						promotionImpTracking : function(promotionsList){
    							return builder.ecommerce("promoView","promotions",promotionsList)
                                    .withEvent("promoView")
                                    .build();
    						},
    						promotionClickTracking:function(promotionsList,eventCallback){
    							return builder.ecommerce("promoClick","promotions",promotionsList)
    							.withEvent("promotionClick")
    							.withEventCallback(eventCallback)
    							.build();
    						},


    			 			bookingImpTracking : function(impressions,currencyCode,event){
    			 							return builder.ecommerce("impressions",null,impressions)
                                                .set(builder.rootName()+".currencyCode",currencyCode)
                                                .withEvent(event)
                                                .build();
    			 			},
    			 			flightClickTracking : function(products,action,currencyCode,event){
    										return builder
    										.ecommerce("click","products",products)
    										.set(builder.rootName()+".currencyCode",currencyCode)
    										.actionField(action)
    										.withEvent(event)
    										.build();
    						},

    						flightDetailTracking : function(products,action,currencyCode){
    							return builder
    							.ecommerce("detail","products",products)
    							.set(builder.rootName()+".currencyCode",currencyCode)
    							.actionField(action)
    							.build();
    						 },

    						  flightAddToCartClick: function(products,currencyCode,eventCallback,event){
    							return builder.ecommerce("add","products",products)
    							.set(builder.rootName()+".currencyCode",currencyCode)
    							.withEvent(event)
    							.withEventCallback(eventCallback, 100).build();
    						 },
                             seatSelectCheckout: function(products,action,callback){
                                return builder.ecommerce("checkout","products",products)
                                    .actionField(action)
                                    .withEvent("checkout")
                                    .withEventCallback(callback,100)
                                    .build();
                             },
    						 seatSelectOnCheckoutOption : function(action,eventCallback){
    							 return checkoutOption(action,eventCallback);
    						 },
    						 insuranceSelectOnCheckoutOption : function(action,eventCallback){
    							 return checkoutOption(action,eventCallback);
    						 },
    						 paymentOnCheckoutOption : function(action,eventCallback){
    							 return checkoutOption(action,eventCallback);
    						 }
    			 		}
    			 }
    			 return {
    			 	ecommerceModels : getEcommerceModels(EcommerceBuilder()),
    			 	msEcommerceModels : getEcommerceModels(EcommerceBuilder("ms-ecommerce"))
    			 }
    		}
            	 
 
    	
    		var Models = {
    			push : function(data){
    					pushDataToDataLayer(data,false,true);
    					
    			},
    			factory : ModelFactory(),
    			ms : function(){
    				return Models.factory.msEcommerceModels;
    			},

    			ob : function(){
    				return Models.factory.ecommerceModels;
    			},

    			promotionImpTracking : function(promotionsList){
    				Models.push(Models.ob().promotionImpTracking(promotionsList));
    			},
    			promotionClickTracking : function(promotionsList,eventCallback){
    				Models.push(Models.ob().promotionClickTracking(promotionsList,eventCallback));
    			},
    			bookingImpTracking : function(params){
    				Models.push(Models.ob().bookingImpTracking(params.impressions,params.currencyCode,"impressions"));
    			},
    			MSbookingImpTracking : function(params){
    				Models.push(Models.ms().bookingImpTracking(params.impressions,"","ms-impressions"));
    			},
    			flightClickTracking: function(params){
    				Models.push(Models.ob().flightClickTracking(params.products,params.action,params.currencyCode, "productClick"));
    			},
    			MSflightClickTracking : function(params){
    				Models.push(Models.ms().flightClickTracking(params.products,params.action,"","ms-productClick"));
    			},
    			flightDetailTracking : function(params){
    				Models.push(Models.ob().flightDetailTracking(params.products,params.action,params.currencyCode));
    			},
    			MSflightDetailTracking : function(params){
    				Models.push(Models.ms().flightDetailTracking(params.products,params.action,""));
    			},
    			flightAddToCartClick : function(params){
    				Models.push(Models.ob().flightAddToCartClick(params.products,params.currencyCode,params.eventCallback,"addToCart"));
    			},
    			MSflightAddToCartClick : function(params){
    				Models.push(Models.ms().flightAddToCartClick(params.products,"",params.eventCallback,"ms-addToCart"));
    			},
    			seatSelectCheckout: function(params){
                    Models.push(Models.ob().seatSelectCheckout(params.products,params.action,params.eventCallback));
    			},
    			seatSelectOnCheckoutOption : function(params){
    				Models.push(Models.ob().seatSelectOnCheckoutOption(params.action,params.eventCallback));
    			},
    			insuranceSelectOnCheckoutOption : function(params){
    				Models.push(Models.ob().insuranceSelectOnCheckoutOption(params.action,params.eventCallback));
    			},
    			paymentOnCheckoutOption : function(params){
    				Models.push(Models.ob().paymentOnCheckoutOption(params.action,params.eventCallback));
    			}
    						
    		}
    		



    		return {
    			models : Models,
    			builder  :  EcommerceBuilder,
    			factory :  ModelFactory,
    		}

    	}
        var ecommerceModels  = EcommerceHelper().models;
        

        var sessionStorageUtil = {
			persistData : function(key, data) {
				if (data) {
                    storageHelper.setItem({
                        key: key,
                        value: JSON.stringify(data),
                        webStorageType: storageHelper.Stores.SESSION_STORAGE
                    });
				}
			},
			getPersistedData : function(key) {
				var item = storageHelper.getItem({ key: key, webStorageType: storageHelper.Stores.SESSION_STORAGE });
				if (item) {
					try {
						return JSON.parse(item);
					} catch (e) {
						return undefined;
					}
				}
				return item;
			},
			clearPersistables : function(key) {
                storageHelper.removeItem({ key: key, webStorageType: storageHelper.Stores.SESSION_STORAGE });
			},
			sendPersistables : function(key, data) {
				if (data) {
                    storageHelper.setItem({
                        key: key,
                        value: JSON.stringify(data),
                        webStorageType: storageHelper.Stores.SESSION_STORAGE
                    });
					pushDataToDataLayer(data, false);
				} else {
					var item = sessionStorageUtil.getPersistedData(key);
					if (item) {
						pushDataToDataLayer(item, false);
					}
				}
			}
		}


        var hooks = [];


        hooks.push({
            match: function(e, result, settings) {
                if (settings && settings.url &&
                    (settings.url.indexOf("com.thy.web.online.miles/ms/login") > -1)) {
                    return true;
                }
            },
            fire: function(event, result, settings) {
                if (result && result.responseJSON && result.responseJSON.type == "SUCCESS") {
                    pushLoginData(result.responseJSON.data);
                }

            }
        }, {
            match: function(e, result, settings) {
                if (settings && settings.url &&
                    (settings.url.indexOf("com.thy.web.online.ibs/ibs/booking/loadprofilepage") > -1)) {
                    return true;
                }
            },
            fire: function(e, result, settings) {

                etrAjax.get({
                    app: 'app.ms',
                    service: '/login',
                    disableLoader: true,
                    callback: function(response) {

                    },
                    disableErrorHandling: true
                });


            }
        },{
            match:function(e,result,settings){
                if(result && result.responseJSON && result.responseJSON.type == "ERROR"&&result.responseJSON.error){
                    return true;
                }
            },
            fire:function(e,result,settings){
                var error = result.responseJSON.error;
                error.apiUrl=settings.url;
                pushServiceError(error);

            }
        });

        $(document).ajaxComplete(function(event,result,ajaxSettings){
                var matchedHooks =  underscore.filter(hooks,function(hook){
                    if(hook&&hook.match&&hook.match(event,result,ajaxSettings)){
                        return hook;
                    }
                });


                underscore.each(matchedHooks,function(hook){

                    if(hook.fire){
                        try{
                            hook.fire(event,result,ajaxSettings);
                        }
                        catch (e){
                            console.log(e);
                        }

                    }
                });
        });

        function pushEvisaButtonClick(passengerCount, phoneCode) {
            try {
                var evisaData = baseEvisaData(passengerCount, phoneCode, "additional services listing");
                evisaData["event"] = "evisa_button_click"
                pushDataToDataLayer(evisaData, false, true);
            } catch (e) {
            }
        }

        function pushEvisaInfoView(passengerCount, phoneCode) {
            try {
                var evisaData = baseEvisaData(passengerCount, phoneCode, "additional services listing");
                evisaData["event"] = "evisa_info_view"
                pushDataToDataLayer(evisaData, false, true);
            } catch (e) {
            }
        }

        function pushEvisaInfoClick(passengerCount, phoneCode, buttonName, eVisaStatus) {
            try {
                var evisaData = baseEvisaData(passengerCount, phoneCode, "additional services listing");
                evisaData["event"] = "evisa_info_click"
                evisaData["cd_button_name"] = buttonName || ''
                storageHelper.setItem({
                    key: "eVisaData",
                    value: phoneCode,
                    webStorageType: storageHelper.Stores.SESSION_STORAGE
                });
                pushDataToDataLayer(evisaData, false, true);
            } catch (e) {
            }
        }

        function pushEvisaComplete(passengerCount, phoneCode) {
            try {
                var evisaData = baseEvisaData(passengerCount, phoneCode, "purchase");
                evisaData["event"] = "evisa_complete"
                pushDataToDataLayer(evisaData, false, true);
            } catch (e) {
            }
        }

        function baseEvisaData (passengerCount, phoneCode, pageType) {
            var eventData = getGAEventDataCache()
            return {
                event: "",
                page_type: pageType,
                phone_area_code: phoneCode ? phoneCode.toString() : '',
                cd_event_category: "Availability",
                cd_event_category2: "Additional Services Listing",
                cm_passenger_count: passengerCount || 0,
                cd_passenger_count: passengerCount ? passengerCount.toString() : '0',
                evisa_destination: eventData ? eventData.cd_item_flight_destination_country : '',
                flight_destination_airport: eventData ? eventData.cd_item_flight_destination : '',
                flight_destination_city: eventData ? eventData.cd_item_flight_destination_city : '',
                flight_destination_country: eventData ? eventData.cd_item_flight_destination_country : '',
                flight_origin_airport: eventData ? eventData.cd_item_flight_origin : '',
                flight_origin_city: eventData ? eventData.cd_item_flight_origin_city : '',
                flight_origin_country: eventData ? eventData.cd_item_flight_origin_country : ''
            }
        }

        function itemFareClasses (items) {
            var fareClasses = underscore.map(items, function(item) {return item ? item.cd_item_fare_class : '' })
            return underscore.unique(fareClasses).join("|");
        }

        function pushMarketingInfoEvent (priceInfo, page) {
            try {
                var eventData = getGAEventDataCache();
                var items = convertCartFlightDataToItemList();
                var totalFare = priceInfo.totalFare;
                var baseFare = priceInfo.baseFare;
                if(!totalFare || !baseFare) {
                    return;
                }
                var marketingObject = {
                    page_type: page.type,
                    marketing_info_step: page.name,
                    item_id: eventData.item_id,
                    cd_item_flight_origin: eventData.cd_item_flight_origin,
                    cd_item_flight_destination: eventData.cd_item_flight_destination,
                    item_category: eventData.item_category,
                    item_category2: eventData.item_category2,
                    item_category3: eventData.item_category3,
                    item_category4: eventData.item_category4,
                    item_brand: eventData.item_brand,
                    cd_item_fare_class: items ? itemFareClasses(items) : '',
                    cd_item_flight_date: eventData.cd_item_flight_date,
                    cd_originalCurrency: priceInfo.currency, //
                    cm_valueOriginal: totalFare, // Toplam Ücret Orjinal yani seçilen kur cinsinden yazılmalıdır.
                    cm_valueTRY: calculateConvertedAmount(hasTargetConversionRate(priceInfo.currency, 'TRY'), currencyConversionRates['TRY'], totalFare), // Toplam Ücret TRY cinsinden yazılmalıdır.
                    cm_valueUSD: calculateConvertedAmount(hasTargetConversionRate(priceInfo.currency, 'USD'), currencyConversionRates['USD'], totalFare), // Toplam Ücret USD cinsinden yazılmalıdır.
                    cm_valueEUR: calculateConvertedAmount(hasTargetConversionRate(priceInfo.currency, 'EUR'), currencyConversionRates['EUR'], totalFare),  // Toplam Ücret EUR cinsinden yazılmalıdır.
                    cm_netvalueOriginal: baseFare, // Net (Base) Ücret Orjinal seçilen kur cinsinden yazılmalıdır.
                    cm_netvalueTRY: calculateConvertedAmount(hasTargetConversionRate(priceInfo.currency, 'TRY'), currencyConversionRates['TRY'], baseFare),// Net (Base) Ücret TRY cinsinden yazılmalıdır.
                    cm_netvalueUSD: calculateConvertedAmount(hasTargetConversionRate(priceInfo.currency, 'USD'), currencyConversionRates['USD'], baseFare), // Net (Base) Ücret USD cinsinden yazılmalıdır.
                    cm_netvalueEUR: calculateConvertedAmount(hasTargetConversionRate(priceInfo.currency, 'EUR'), currencyConversionRates['EUR'], baseFare) // Net (Base) Ücret EUR cinsinden yazılmalıdır.
                };
                pushDataToDataLayer({event: 'marketing_info', marketingobject: marketingObject}, false, true);
            } catch (e) {
                console.log(e)
            }
        }

        function convertCartFlightDataToItemList() {
            var items = []
            var flights = JSON.parse(storageHelper.getItem({ key: "cartFlightData", webStorageType: storageHelper.Stores.SESSION_STORAGE }));
            if(flights) {
                 underscore.forEach(flights, function(flight) {
                     items.push(flight)
                });
            }
            return items
        }

        function isPriceInfoExist (reservationData) {
            return reservationData && reservationData.totalCharge && reservationData.totalCharge.amount && reservationData.priceInfo && reservationData.priceInfo.totalBaseAmount
        }

        function mapMarketingPageType (page) {
            switch (page) {
                case 'additional_service':
                    return {type: 'additional services listing', name: 'Additional Services Hub'}
                case 'seat_selection':
                    return {type: 'additional services detail', name: 'Seat Selection'}
                default:
                    return {type: '', name: ''}
            }
        }
        function pushGenericMarketingInfo (data, page) {
            if(data) {
                try {
                    var priceInfo = {
                        totalFare: data.totalAmount,
                        baseFare: data.totalBaseAmount,
                        currency: data.currency
                    }
                    pushMarketingInfoEvent(priceInfo, mapMarketingPageType(page));
                } catch (e) {
                    console.log(e)
                }
            }
        }

        function pushCheckinBoardingPassShare (type) {
            pushDataToDataLayer({event: 'checkin_bpass_share', cd_share_type: type}, false, true);
        }

        function pushManageBookingButtonClick(buttonName, reservation) {
            var data = {
                event: 'button_click',
                cd_event_category: 'manage_booking_buttons',
                cd_event_category2: 'Manage Booking',
                cd_button_name: buttonName
            };
            pushDataToDataLayer(data, false, true);
            if(reservation) {
                var additionalServiceData = {
                    selectedFlights: reservation.allFlights,
                    tripType: reservation.tripType,
                };
                var asType = buttonName.split('-')[1];
                if(asType) {
                    pushManageBookingSelectItem(additionalServiceData, asType.trim(), 'main page');
                }
            }
            createManageBookingDataCache(undefined, buttonName);
            clearAdditionalServiceCache();
        }

         function isValidAncillaryPaymentType(paymentType) {
            var PAYMENT_TYPE = ["eft", "internetBanking", "EFT", "InternetBanking"];
            return !PAYMENT_TYPE.includes(paymentType);
        }

        // ---------- begin - M&S Events ----------

        function pushMSLogin(data, pageData, loginType) {
            try {
                var cardName = data.cardName;
                var payload = {
                    event: 'login',
                    page_type: pageData.page,
                    cd_event_category: pageData.category ? pageData.category : "Passenger M&S Banner",
                    cd_event_category2: getEventCategory2(loginType),
                    method: '',
                    user_info: {
                        user_id: '',
                        user_citizenship: data.nationality,
                        user_age: moment().diff(moment(data.birthDate, "DD.MM.YYYY"), 'year'),
                        user_gender: data.gender === "M" ? "Mr" : "Mrs",
                        user_phone_area_code: data.mobilePhoneCountryCode === "90" ? "TR" : "other",
                        user_ms_login_type: cardName ? cardName.split(" ").map(function (word) {
                            return word[0].toUpperCase() + word.substring(1, word.length).toLowerCase();
                        }).join("") : "Classic",
                        user_ms_login_status: "Registered",
                    }
                };
                if(data && data.custId) {
                    storageHelper.setItem({
                        key: "custId",
                        value: JSON.stringify({value: data.custId, type: "sign-in"}),
                        webStorageType: storageHelper.Stores.LOCAL_STORAGE
                    });
                }
                pushDataToDataLayer(payload, false, true);
            } catch (e) {
                pushServiceError(e);
            }
        }

        function pushMSSignUp(data) {
            try {
                var payload = {
                    event: 'sign_up',
                    page_type: '',
                    method: '',
                    user_info: {
                        user_id: '',
                        user_citizenship: data.personalInfo.nationality,
                        user_age: moment().diff(moment(data.personalInfo.birthDate, "DD.MM.YYYY"), 'year'),
                        user_gender: data.personalInfo.gender === "M" ? "Mr" : "Mrs",
                        user_phone_area_code: data.addressInfo.mobilePhoneCountryCode === "90" ? "TR" : "other",
                        user_ms_login_type: "Classic",
                        user_ms_login_status: "Registered",
                    }
                };
                pushDataToDataLayer(payload, false, true);
            } catch (e) {
               pushServiceError(e);
            }
        }

        function pushMSLogout () {
            try {
                var payload = {
                    event: 'logout',
                    page_type: '',
                    method: '',
                    user_info: {
                        user_id: '',
                        user_citizenship: '',
                        user_age: '',
                        user_gender: '',
                        user_phone_area_code: '',
                        user_ms_login_type: '',
                        user_ms_login_status: "Guest",
                    }
                };
                pushDataToDataLayer(payload, false, true);
                try {
                    if (storageHelper && storageHelper.Stores && storageHelper.Stores.LOCAL_STORAGE) {
                        storageHelper.removeItem({
                            key: "custId",
                            webStorageType: storageHelper.Stores.LOCAL_STORAGE
                        });
                    }
                } catch (error) {
                }
            } catch (e) {
                pushServiceError(e);
            }
        }


        function getEventCategory2(loginType) {
            switch (loginType) {
                case '1':
                    return "Membership number"
                case '4':
                    return "Turkish ID number"
                case '2':
                    return "Email address"
                case "3":
                    return "Mobile number"
                default:
                    return "Membership number";
            }
        }

        // ---------- end - M&S Events ----------

        function getCustId() {
            var cache = storageHelper.getItem({ key: "custId", webStorageType: storageHelper.Stores.LOCAL_STORAGE });
            if(cache !== undefined) {
                return JSON.parse(cache);
            }
            return "";
        }
        function setCustId(payload) {
            try {
                var custId = getCustId();
                payload['custId'] = (custId && custId.value) ? custId.value : '';
            } catch (e) {
                pushServiceError(e);
            }
        }

        return {
            pushSearcData : pushSearcData,
            pushMultiCitySearcData : pushMultiCitySearcData,
            pushPaymentPageData : pushPaymentPageData,
            pushThankyouPageData : pushThankyouPageData,
            pushGenericPageData: pushGenericPageData,
            pushPromotionsImpData  : ecommerceModels.promotionImpTracking,
            pushPromotionClickData: ecommerceModels.promotionClickTracking,
            seatSelectOnCheckoutOption : ecommerceModels.seatSelectOnCheckoutOption,
            insuranceSelectOnCheckoutOption : ecommerceModels.insuranceSelectOnCheckoutOption,
            paymentOnCheckoutOption : ecommerceModels.paymentOnCheckoutOption,
            pushInsuranceData : pushInsuranceData,
            pushLoginData:pushLoginData,
            setExitSeatVariable : setExitSeatVariable,
            setSoldExitSeatVariable : setSoldExitSeatVariable,
            setSoldInsuranceVariable : setSoldInsuranceVariable,
            pushEvent : pushEvent,
            sessionStorageUtil : sessionStorageUtil,
            pushAvailabilityResponse: onlineTicketing.pushAvailabilityResponse,
            pushAvailabilityFlightSelectionClick : onlineTicketing.pushAvailabilityFlightSelectionClick,
            pushAvailabilityFlightDetailsView : onlineTicketing.pushAvailabilityFlightDetailsView,
            pushAvailabilitySelectedFlightData : onlineTicketing.pushAvailabilitySelectedFlightData,
            pushAddToCartData: onlineTicketing.pushAddToCartData,
            pushProfilePageData : onlineTicketing.pushProfilePageData,
			pushAdditionalPageClick: onlineTicketing.pushAdditionalPageClick,
			pushAdditionalPageInsurance: onlineTicketing.pushAdditionalPageInsurance,
			pushAdditionalPageInsuranceComplete: onlineTicketing.pushAdditionalPageInsuranceComplete,
			pushAdditionalPageData : onlineTicketing.pushAdditionalPageData,
			pushSelectPassengerData : checkinStage.pushSelectPassengerData,
            pushSeatSelectCheckout: onlineTicketing.pushSeatSelectCheckout,
            pushAwardTicketSearchData : awardTicketing.pushAwardTicketSearchData,
            pushAwardTicketAvailabilityFlightSelectionClick : awardTicketing.pushAwardTicketAvailabilityFlightSelectionClick,
            pushAwardTicketAvailabilityFlightDetailsView : awardTicketing.pushAwardTicketAvailabilityFlightDetailsView,
            pushAwardTicketAvailabilityResponse : awardTicketing.pushAwardTicketAvailabilityResponse,
            pushAwardTicketAvailabilitySelectedFlightData : awardTicketing.pushAwardTicketAvailabilitySelectedFlightData,
            pushAwardTicketAddToCartData: awardTicketing.pushAwardTicketAddToCartData,
            pushAwardTicketProfilePageData : awardTicketing.pushAwardTicketProfilePageData,
            pushAvailabilityResponseBrandedDometicList: onlineTicketing.pushAvailabilityResponseBrandedDometicList,
            pushAvailabilityResponseBrandedDometicListOpened:    onlineTicketing.pushAvailabilityResponseBrandedDometicListOpened,
            pushMBPageInfo:manageBookingUtils.pushPageInfo,
            pushCurrencyData: pushCurrencyData,
            changeListingType: changeListingType,
            pushSelectItemData: pushSelectItemData,
            pushViewItemData: pushViewItemData,
            pushAddToCartDataGA4: pushAddToCartDataGA4,
            pushRemoveFromCartData: pushRemoveFromCartData,
            pushAnalyticsPurchaseData: pushAnalyticsPurchaseData,
            pushPopUpViewData: pushPopUpViewData,
            pushPopUpSelectData: pushPopUpSelectData,
            pushTcknPopUpButtonClick: pushTcknPopUpButtonClick,
            pushTcknPopUpViewData: pushTcknPopUpViewData,
            pushPassengerInfoSuccess: pushPassengerInfoSuccess,
            pushPassengerInfoCompleted: pushPassengerInfoCompleted,
            pushTimeoutPopUpEvent: pushTimeoutPopUpEvent,
            pushAjetRedirectionPopUpEvent: pushAjetRedirectionPopUpEvent,
            pushCurrencyChangeButtonClickEvent: pushCurrencyChangeButtonClickEvent,
            pushASViewItemListData: pushASViewItemListData,
            pushViewCartData: pushViewCartData,
            pushBeginCheckoutData: pushBeginCheckoutData,
            pushSeatViewItemData: pushSeatViewItemData,
            saveSelectedSeatData: saveSelectedSeatData,
            pushSeatAddToCartData: pushSeatAddToCartData,
            pushAddShippingInfo: pushAddShippingInfo,
            pushAddPaymentInfo: pushAddPaymentInfo,
            pushAdditionalServiceSelectItemData: pushAdditionalServiceSelectItemData,
            pushExcessBaggageAddToCart: pushExcessBaggageAddToCart,
            pushRHSHoldButtonClick: pushRHSHoldButtonClick,
            pushRHSPopupInfoView: pushRHSPopupInfoView,
            pushRHSPassengerDetailClick: pushRHSPassengerDetailClick,
            pushRHSPassengerDetailCancelClick: pushRHSPassengerDetailCancelClick,
            pushRHSPaymentMethodClick: pushRHSPaymentMethodClick,
            pushRHSPaymentMethodView: pushRHSPaymentMethodView,
            checkRHSFlowActive: checkRHSFlowActive,
            pushRHSPopupInfoClick: pushRHSPopupInfoClick,
            pushRHSOptionView: pushRHSOptionView,
            pushRHSOptionClick: pushRHSOptionClick,
            pushRHSOptionCancelClick: pushRHSOptionCancelClick,
            pushRHSPaymentClick: pushRHSPaymentClick,
            setViewItemListGroup: setViewItemListGroup,
            setupViewItemListObserver: setupViewItemListObserver,
            pushStandAloneEvisaButtonClick: pushStandAloneEvisaButtonClick,
            pushStandAloneEvisaInfoView: pushStandAloneEvisaInfoView,
            pushStandAloneEvisaInfoClick: pushStandAloneEvisaInfoClick,
            pushStandAloneEvisaComplete: pushStandAloneEvisaComplete,
            pushEvisaButtonClick: pushEvisaButtonClick,
            pushEvisaInfoView: pushEvisaInfoView,
            pushEvisaInfoClick: pushEvisaInfoClick,
            pushEvisaComplete: pushEvisaComplete,
            pushRHSLeaveIntentionView: pushRHSLeaveIntentionView,
            pushRHSHoldButtonClickEvent: pushRHSHoldButtonClickEvent,
            pushAdditionalServiceItemData: pushAdditionalServiceItemData,
            pushAdditionalServiceAddToCartData: pushAdditionalServiceAddToCartData,
            pushCheckinStart: pushCheckinStart,
            pushCheckinPassengerInfoView: pushCheckinPassengerInfoView,
            pushCheckinPassengerInfoCompleted: pushCheckinPassengerInfoCompleted,
            pushCheckinTncCompleted: pushCheckinTncCompleted,
            pushCheckinSeatSelectionViewItemData: pushCheckinSeatSelectionViewItemData,
            pushCheckinSeatSelectionAddToCartData: pushCheckinSeatSelectionAddToCartData,
            pushCheckinSeatSelectionSeatSelectionData: pushCheckinSeatSelectionSeatSelectionData,
            pushCheckinAdditionalServicesAddShippingInfoData: pushCheckinAdditionalServicesAddShippingInfoData,
            pushCheckinAdditionalServicesCheckinSelectedtedASData: pushCheckinAdditionalServicesCheckinSelectedtedASData,
            pushCheckinAdditionalServicesCheckinASCompletedData: pushCheckinAdditionalServicesCheckinASCompletedData,
            pushCheckinAdditionalServicesViewItemList: pushCheckinAdditionalServicesViewItemList,
            pushCheckinAdditionalServicesSelectItemData: pushCheckinAdditionalServicesSelectItemData,
            pushCheckinAdditionalServicesViewItemData: pushCheckinAdditionalServicesViewItemData,
            pushCheckinAdditionalServicesAddToCartData: pushCheckinAdditionalServicesAddToCartData,
            pushCheckinAddPaymentInfoData: pushCheckinAddPaymentInfoData,
            pushTkWalletTransactionPopupData: pushTkWalletTransactionPopupData,
            pushGenericMarketingInfo: pushGenericMarketingInfo,
            pushCheckinBoardingPassShare: pushCheckinBoardingPassShare,
            pushPackageOfferAddToCartData: pushPackageOfferAddToCartData,
            pushManageBookingButtonClick: pushManageBookingButtonClick,
            pushManageBookingViewItemList: pushManageBookingViewItemList,
            pushManageBookingSelectItem: pushManageBookingSelectItem,
            pushManageBookingViewItem: pushManageBookingViewItem,
            pushManageBookingAddToCart: pushManageBookingAddToCart,
            pushManageBookingSeatSelectionAddToCart: pushManageBookingSeatSelectionAddToCart,
            pushManageBookingAddShippingInfo: pushManageBookingAddShippingInfo,
            pushManageBookingAddPaymentInfo: pushManageBookingAddPaymentInfo,
            pushManageBookingPurchase: pushManageBookingPurchase,
            createManageBookingDataCache: createManageBookingDataCache,
            getManageBookingDataCache: getManageBookingDataCache,
            pushMBPassengerPreferencesViewItemList: pushMBPassengerPreferencesViewItemList,
            pushMSSignUp: pushMSSignUp,
            pushMSLogin: pushMSLogin,
            pushMSLogout: pushMSLogout,
            getGAEventDataCache: getGAEventDataCache,
            pushDataToDataLayer: pushDataToDataLayer,
            debounce: debounce,
            pushPaymentMethodView:pushPaymentMethodView
        };
    });
